
      var $parcel$global = globalThis;
    /* eslint-disable no-undef */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $c38e0f42709c826a$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $c38e0f42709c826a$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $c38e0f42709c826a$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $c38e0f42709c826a$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $c38e0f42709c826a$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $c38e0f42709c826a$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $c38e0f42709c826a$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($c38e0f42709c826a$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $c38e0f42709c826a$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $c38e0f42709c826a$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $c38e0f42709c826a$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $c38e0f42709c826a$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $c38e0f42709c826a$var$stringToByteArray$1(str);
    return $c38e0f42709c826a$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $c38e0f42709c826a$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $c38e0f42709c826a$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $c38e0f42709c826a$export$c62426fdd000a97e = function(str) {
    try {
        return $c38e0f42709c826a$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $c38e0f42709c826a$export$6c40052bed430212(value) {
    return $c38e0f42709c826a$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $c38e0f42709c826a$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$c38e0f42709c826a$var$isValidKey(prop)) continue;
        target[prop] = $c38e0f42709c826a$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $c38e0f42709c826a$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $c38e0f42709c826a$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c38e0f42709c826a$var$getDefaultsFromGlobal = ()=>$c38e0f42709c826a$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $c38e0f42709c826a$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $c38e0f42709c826a$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $c38e0f42709c826a$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $c38e0f42709c826a$export$212bb2fc580a90a8 = ()=>{
    try {
        return $c38e0f42709c826a$var$getDefaultsFromGlobal() || $c38e0f42709c826a$var$getDefaultsFromEnvVariable() || $c38e0f42709c826a$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $c38e0f42709c826a$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $c38e0f42709c826a$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $c38e0f42709c826a$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $c38e0f42709c826a$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $c38e0f42709c826a$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c38e0f42709c826a$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(header)),
        $c38e0f42709c826a$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $c38e0f42709c826a$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $c38e0f42709c826a$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($c38e0f42709c826a$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $c38e0f42709c826a$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $c38e0f42709c826a$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $c38e0f42709c826a$export$4e09c449d6c407f7() {
    return typeof self === 'object' && self.self === self;
}
function $c38e0f42709c826a$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $c38e0f42709c826a$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $c38e0f42709c826a$export$f2f6a8999f8ebd30() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $c38e0f42709c826a$export$7e7b1a9668aaed8() {
    const ua = $c38e0f42709c826a$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $c38e0f42709c826a$export$202944b2d2824246() {
    return $c38e0f42709c826a$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $c38e0f42709c826a$export$5d1d834fbbf8bab7() {
    return $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_CLIENT === true || $c38e0f42709c826a$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $c38e0f42709c826a$export$95df08bae54cb4df() {
    return !$c38e0f42709c826a$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $c38e0f42709c826a$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $c38e0f42709c826a$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $c38e0f42709c826a$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $c38e0f42709c826a$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $c38e0f42709c826a$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $c38e0f42709c826a$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c38e0f42709c826a$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $c38e0f42709c826a$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $c38e0f42709c826a$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $c38e0f42709c826a$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $c38e0f42709c826a$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $c38e0f42709c826a$var$replaceTemplate(template, data) {
    return template.replace($c38e0f42709c826a$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $c38e0f42709c826a$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $c38e0f42709c826a$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $c38e0f42709c826a$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[0]) || '');
        claims = $c38e0f42709c826a$export$c5a53ce6a17cf18d($c38e0f42709c826a$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$5f870fcca7ae6a88 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$701c661ec91095f2 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $c38e0f42709c826a$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $c38e0f42709c826a$export$fc970ed23da99565 = function(token) {
    const claims = $c38e0f42709c826a$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $c38e0f42709c826a$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $c38e0f42709c826a$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $c38e0f42709c826a$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $c38e0f42709c826a$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($c38e0f42709c826a$var$isObject(aProp) && $c38e0f42709c826a$var$isObject(bProp)) {
            if (!$c38e0f42709c826a$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $c38e0f42709c826a$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $c38e0f42709c826a$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $c38e0f42709c826a$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $c38e0f42709c826a$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $c38e0f42709c826a$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $c38e0f42709c826a$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $c38e0f42709c826a$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $c38e0f42709c826a$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $c38e0f42709c826a$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $c38e0f42709c826a$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($c38e0f42709c826a$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $c38e0f42709c826a$var$noop;
        if (observer.error === undefined) observer.error = $c38e0f42709c826a$var$noop;
        if (observer.complete === undefined) observer.complete = $c38e0f42709c826a$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c38e0f42709c826a$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $c38e0f42709c826a$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $c38e0f42709c826a$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $c38e0f42709c826a$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $c38e0f42709c826a$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $c38e0f42709c826a$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $c38e0f42709c826a$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $c38e0f42709c826a$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($c38e0f42709c826a$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $c38e0f42709c826a$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $c38e0f42709c826a$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $c38e0f42709c826a$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $c38e0f42709c826a$export$abe4376e1bf796d6 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $c38e0f42709c826a$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $c38e0f42709c826a$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $c38e0f42709c826a$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $c38e0f42709c826a$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $c38e0f42709c826a$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($c38e0f42709c826a$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $c38e0f42709c826a$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $c38e0f42709c826a$var$indicator(i);
}
function $c38e0f42709c826a$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c38e0f42709c826a$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $a83e7ccd68ca8d4e$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $c38e0f42709c826a$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($a83e7ccd68ca8d4e$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $a83e7ccd68ca8d4e$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $a83e7ccd68ca8d4e$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $a83e7ccd68ca8d4e$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $a83e7ccd68ca8d4e$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $45b460d9de9b230f$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $45b460d9de9b230f$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($45b460d9de9b230f$export$243e62d78d3b544d || ($45b460d9de9b230f$export$243e62d78d3b544d = {}));
const $45b460d9de9b230f$var$levelStringToEnum = {
    'debug': $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG,
    'verbose': $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE,
    'info': $45b460d9de9b230f$export$243e62d78d3b544d.INFO,
    'warn': $45b460d9de9b230f$export$243e62d78d3b544d.WARN,
    'error': $45b460d9de9b230f$export$243e62d78d3b544d.ERROR,
    'silent': $45b460d9de9b230f$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $45b460d9de9b230f$var$defaultLogLevel = $45b460d9de9b230f$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $45b460d9de9b230f$var$ConsoleMethod = {
    [$45b460d9de9b230f$export$243e62d78d3b544d.DEBUG]: 'log',
    [$45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$45b460d9de9b230f$export$243e62d78d3b544d.INFO]: 'info',
    [$45b460d9de9b230f$export$243e62d78d3b544d.WARN]: 'warn',
    [$45b460d9de9b230f$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $45b460d9de9b230f$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $45b460d9de9b230f$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $45b460d9de9b230f$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $45b460d9de9b230f$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $45b460d9de9b230f$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $45b460d9de9b230f$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $45b460d9de9b230f$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $45b460d9de9b230f$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $45b460d9de9b230f$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $45b460d9de9b230f$export$c622e99c0ce7b1c9(level) {
    $45b460d9de9b230f$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $45b460d9de9b230f$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $45b460d9de9b230f$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $45b460d9de9b230f$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $45b460d9de9b230f$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $da032767b57a4aa4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($57d436074e210fb5$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $57d436074e210fb5$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $57d436074e210fb5$var$name$o = "@firebase/app";
const $57d436074e210fb5$var$version$1 = "0.9.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$logger = new (0, $45b460d9de9b230f$export$efa9a398d6368992)('@firebase/app');
const $57d436074e210fb5$var$name$n = "@firebase/app-compat";
const $57d436074e210fb5$var$name$m = "@firebase/analytics-compat";
const $57d436074e210fb5$var$name$l = "@firebase/analytics";
const $57d436074e210fb5$var$name$k = "@firebase/app-check-compat";
const $57d436074e210fb5$var$name$j = "@firebase/app-check";
const $57d436074e210fb5$var$name$i = "@firebase/auth";
const $57d436074e210fb5$var$name$h = "@firebase/auth-compat";
const $57d436074e210fb5$var$name$g = "@firebase/database";
const $57d436074e210fb5$var$name$f = "@firebase/database-compat";
const $57d436074e210fb5$var$name$e = "@firebase/functions";
const $57d436074e210fb5$var$name$d = "@firebase/functions-compat";
const $57d436074e210fb5$var$name$c = "@firebase/installations";
const $57d436074e210fb5$var$name$b = "@firebase/installations-compat";
const $57d436074e210fb5$var$name$a = "@firebase/messaging";
const $57d436074e210fb5$var$name$9 = "@firebase/messaging-compat";
const $57d436074e210fb5$var$name$8 = "@firebase/performance";
const $57d436074e210fb5$var$name$7 = "@firebase/performance-compat";
const $57d436074e210fb5$var$name$6 = "@firebase/remote-config";
const $57d436074e210fb5$var$name$5 = "@firebase/remote-config-compat";
const $57d436074e210fb5$var$name$4 = "@firebase/storage";
const $57d436074e210fb5$var$name$3 = "@firebase/storage-compat";
const $57d436074e210fb5$var$name$2 = "@firebase/firestore";
const $57d436074e210fb5$var$name$1 = "@firebase/firestore-compat";
const $57d436074e210fb5$var$name = "firebase";
const $57d436074e210fb5$var$version = "9.23.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $57d436074e210fb5$export$9f30fa0c10967f7f = '[DEFAULT]';
const $57d436074e210fb5$var$PLATFORM_LOG_STRING = {
    [$57d436074e210fb5$var$name$o]: 'fire-core',
    [$57d436074e210fb5$var$name$n]: 'fire-core-compat',
    [$57d436074e210fb5$var$name$l]: 'fire-analytics',
    [$57d436074e210fb5$var$name$m]: 'fire-analytics-compat',
    [$57d436074e210fb5$var$name$j]: 'fire-app-check',
    [$57d436074e210fb5$var$name$k]: 'fire-app-check-compat',
    [$57d436074e210fb5$var$name$i]: 'fire-auth',
    [$57d436074e210fb5$var$name$h]: 'fire-auth-compat',
    [$57d436074e210fb5$var$name$g]: 'fire-rtdb',
    [$57d436074e210fb5$var$name$f]: 'fire-rtdb-compat',
    [$57d436074e210fb5$var$name$e]: 'fire-fn',
    [$57d436074e210fb5$var$name$d]: 'fire-fn-compat',
    [$57d436074e210fb5$var$name$c]: 'fire-iid',
    [$57d436074e210fb5$var$name$b]: 'fire-iid-compat',
    [$57d436074e210fb5$var$name$a]: 'fire-fcm',
    [$57d436074e210fb5$var$name$9]: 'fire-fcm-compat',
    [$57d436074e210fb5$var$name$8]: 'fire-perf',
    [$57d436074e210fb5$var$name$7]: 'fire-perf-compat',
    [$57d436074e210fb5$var$name$6]: 'fire-rc',
    [$57d436074e210fb5$var$name$5]: 'fire-rc-compat',
    [$57d436074e210fb5$var$name$4]: 'fire-gcs',
    [$57d436074e210fb5$var$name$3]: 'fire-gcs-compat',
    [$57d436074e210fb5$var$name$2]: 'fire-fst',
    [$57d436074e210fb5$var$name$1]: 'fire-fst-compat',
    'fire-js': 'fire-js',
    [$57d436074e210fb5$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $57d436074e210fb5$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $57d436074e210fb5$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $57d436074e210fb5$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $57d436074e210fb5$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $57d436074e210fb5$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $57d436074e210fb5$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($57d436074e210fb5$export$9566bce3835c0f28.has(componentName)) {
        $57d436074e210fb5$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $57d436074e210fb5$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $57d436074e210fb5$export$b4e3c36c855b14b5.values())$57d436074e210fb5$export$fa5244b94c62d36a(app, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $57d436074e210fb5$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $57d436074e210fb5$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    $57d436074e210fb5$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $57d436074e210fb5$export$3685d89b9c3cdfaf() {
    $57d436074e210fb5$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.'
};
const $57d436074e210fb5$var$ERROR_FACTORY = new (0, $c38e0f42709c826a$export$3fa6e1b18a3b2d40)('app', 'Firebase', $57d436074e210fb5$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $57d436074e210fb5$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $57d436074e210fb5$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $57d436074e210fb5$export$31499a9cd224b78c = $57d436074e210fb5$var$version;
function $57d436074e210fb5$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $57d436074e210fb5$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $57d436074e210fb5$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $c38e0f42709c826a$export$3dfb6827a9f89756)());
    if (!options) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $57d436074e210fb5$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $a83e7ccd68ca8d4e$export$436a80eea5d5c0c5)(name);
    for (const component of $57d436074e210fb5$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $57d436074e210fb5$var$FirebaseAppImpl(options, config, container);
    $57d436074e210fb5$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $57d436074e210fb5$export$f9962582c9e66d99(name = $57d436074e210fb5$export$9f30fa0c10967f7f) {
    const app = $57d436074e210fb5$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $57d436074e210fb5$export$9f30fa0c10967f7f && (0, $c38e0f42709c826a$export$3dfb6827a9f89756)()) return $57d436074e210fb5$export$c55cfd413944906d();
    if (!app) throw $57d436074e210fb5$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $57d436074e210fb5$export$68ddedf7d44b3bdf() {
    return Array.from($57d436074e210fb5$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $57d436074e210fb5$export$6eec44aa53d5ea34(app) {
    const name = app.name;
    if ($57d436074e210fb5$export$b4e3c36c855b14b5.has(name)) {
        $57d436074e210fb5$export$b4e3c36c855b14b5.delete(name);
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $57d436074e210fb5$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $57d436074e210fb5$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $57d436074e210fb5$var$logger.warn(warning.join(' '));
        return;
    }
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $57d436074e210fb5$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $57d436074e210fb5$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $45b460d9de9b230f$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $57d436074e210fb5$export$c622e99c0ce7b1c9(logLevel) {
    (0, $45b460d9de9b230f$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$DB_NAME = 'firebase-heartbeat-database';
const $57d436074e210fb5$var$DB_VERSION = 1;
const $57d436074e210fb5$var$STORE_NAME = 'firebase-heartbeat-store';
let $57d436074e210fb5$var$dbPromise = null;
function $57d436074e210fb5$var$getDbPromise() {
    if (!$57d436074e210fb5$var$dbPromise) $57d436074e210fb5$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($57d436074e210fb5$var$DB_NAME, $57d436074e210fb5$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($57d436074e210fb5$var$STORE_NAME);
            }
        }
    }).catch((e)=>{
        throw $57d436074e210fb5$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $57d436074e210fb5$var$dbPromise;
}
async function $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const result = await db.transaction($57d436074e210fb5$var$STORE_NAME).objectStore($57d436074e210fb5$var$STORE_NAME).get($57d436074e210fb5$var$computeKey(app));
        return result;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
async function $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $57d436074e210fb5$var$getDbPromise();
        const tx = db.transaction($57d436074e210fb5$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($57d436074e210fb5$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $57d436074e210fb5$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $c38e0f42709c826a$export$dd24e9cd51226c56)) $57d436074e210fb5$var$logger.warn(e.message);
        else {
            const idbGetError = $57d436074e210fb5$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $57d436074e210fb5$var$logger.warn(idbGetError.message);
        }
    }
}
function $57d436074e210fb5$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57d436074e210fb5$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $57d436074e210fb5$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $57d436074e210fb5$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        const platformLogger = this.container.getProvider('platform-logger').getImmediate();
        // This is the "Firebase user agent" string from the platform logger
        // service, not the browser user agent.
        const agent = platformLogger.getPlatformInfoString();
        const date = $57d436074e210fb5$var$getUTCDateString();
        if (this._heartbeatsCache === null) this._heartbeatsCache = await this._heartbeatsCachePromise;
        // Do not store a heartbeat if one is already stored for this day
        // or if a header has already been sent today.
        if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
        else // There is no entry for this date. Create one.
        this._heartbeatsCache.heartbeats.push({
            date: date,
            agent: agent
        });
        // Remove entries older than 30 days.
        this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
            const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
            const now = Date.now();
            return now - hbTimestamp <= $57d436074e210fb5$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
        });
        return this._storage.overwrite(this._heartbeatsCache);
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
        // If it's still null or the array is empty, there is no data to send.
        if (this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0) return '';
        const date = $57d436074e210fb5$var$getUTCDateString();
        // Extract as many heartbeats from the cache as will fit under the size limit.
        const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $57d436074e210fb5$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
        const headerString = (0, $c38e0f42709c826a$export$4b5284a3025a455)(JSON.stringify({
            version: 2,
            heartbeats: heartbeatsToSend
        }));
        // Store last sent date to prevent another being logged/sent for the same day.
        this._heartbeatsCache.lastSentHeartbeatDate = date;
        if (unsentEntries.length > 0) {
            // Store any unsent entries if they exist.
            this._heartbeatsCache.heartbeats = unsentEntries;
            // This seems more likely than emptying the array (below) to lead to some odd state
            // since the cache isn't empty and this will be called again on the next request,
            // and is probably safest if we await it.
            await this._storage.overwrite(this._heartbeatsCache);
        } else {
            this._heartbeatsCache.heartbeats = [];
            // Do not wait for this, to reduce latency.
            this._storage.overwrite(this._heartbeatsCache);
        }
        return headerString;
    }
}
function $57d436074e210fb5$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $57d436074e210fb5$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $57d436074e210fb5$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($57d436074e210fb5$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $57d436074e210fb5$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return false;
        else return (0, $c38e0f42709c826a$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $57d436074e210fb5$var$readHeartbeatsFromIndexedDB(this.app);
            return idbHeartbeatObject || {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $57d436074e210fb5$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $57d436074e210fb5$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $c38e0f42709c826a$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $57d436074e210fb5$var$registerCoreComponents(variant) {
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('platform-logger', (container)=>new $57d436074e210fb5$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $57d436074e210fb5$export$c930050e7bb63965(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)('heartbeat', (container)=>new $57d436074e210fb5$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $57d436074e210fb5$export$d29d5299a7137abc($57d436074e210fb5$var$name$o, $57d436074e210fb5$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $57d436074e210fb5$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $57d436074e210fb5$var$registerCoreComponents('');


var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "9.23.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $57d436074e210fb5$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, 'app');






var $f4a7ee607ae1ef78$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $f4a7ee607ae1ef78$export$2e2bcd8739ae039 = {};
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $f4a7ee607ae1ef78$var$k, $f4a7ee607ae1ef78$var$goog = $f4a7ee607ae1ef78$var$goog || {}, $f4a7ee607ae1ef78$var$l = $f4a7ee607ae1ef78$var$commonjsGlobal || self;
function $f4a7ee607ae1ef78$var$aa(a) {
    var b = typeof a;
    b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $f4a7ee607ae1ef78$var$p(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $f4a7ee607ae1ef78$var$ba(a) {
    return Object.prototype.hasOwnProperty.call(a, $f4a7ee607ae1ef78$var$ca) && a[$f4a7ee607ae1ef78$var$ca] || (a[$f4a7ee607ae1ef78$var$ca] = ++$f4a7ee607ae1ef78$var$da);
}
var $f4a7ee607ae1ef78$var$ca = "closure_uid_" + (1E9 * Math.random() >>> 0), $f4a7ee607ae1ef78$var$da = 0;
function $f4a7ee607ae1ef78$var$ea(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $f4a7ee607ae1ef78$var$fa(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $f4a7ee607ae1ef78$var$q(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $f4a7ee607ae1ef78$var$q = $f4a7ee607ae1ef78$var$ea : $f4a7ee607ae1ef78$var$q = $f4a7ee607ae1ef78$var$fa;
    return $f4a7ee607ae1ef78$var$q.apply(null, arguments);
}
function $f4a7ee607ae1ef78$var$ha(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
function $f4a7ee607ae1ef78$var$r(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.$ = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.ac = function(d, e, f) {
        for(var h = Array(arguments.length - 2), n = 2; n < arguments.length; n++)h[n - 2] = arguments[n];
        return b.prototype[e].apply(d, h);
    };
}
function $f4a7ee607ae1ef78$var$v() {
    this.s = this.s;
    this.o = this.o;
}
var $f4a7ee607ae1ef78$var$ia = 0;
$f4a7ee607ae1ef78$var$v.prototype.s = !1;
$f4a7ee607ae1ef78$var$v.prototype.sa = function() {
    if (!this.s && (this.s = !0, this.N(), 0 != $f4a7ee607ae1ef78$var$ia)) $f4a7ee607ae1ef78$var$ba(this);
};
$f4a7ee607ae1ef78$var$v.prototype.N = function() {
    if (this.o) for(; this.o.length;)this.o.shift()();
};
const $f4a7ee607ae1ef78$var$ka = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(let c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
};
function $f4a7ee607ae1ef78$var$ma(a) {
    const b = a.length;
    if (0 < b) {
        const c = Array(b);
        for(let d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $f4a7ee607ae1ef78$var$na(a, b) {
    for(let c = 1; c < arguments.length; c++){
        const d = arguments[c];
        if ($f4a7ee607ae1ef78$var$aa(d)) {
            const e = a.length || 0, f = d.length || 0;
            a.length = e + f;
            for(let h = 0; h < f; h++)a[e + h] = d[h];
        } else a.push(d);
    }
}
function $f4a7ee607ae1ef78$var$w(a, b) {
    this.type = a;
    this.g = this.target = b;
    this.defaultPrevented = !1;
}
$f4a7ee607ae1ef78$var$w.prototype.h = function() {
    this.defaultPrevented = !0;
};
var $f4a7ee607ae1ef78$var$oa = function() {
    if (!$f4a7ee607ae1ef78$var$l.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $f4a7ee607ae1ef78$var$l.addEventListener("test", ()=>{}, b), $f4a7ee607ae1ef78$var$l.removeEventListener("test", ()=>{}, b);
    } catch (c) {}
    return a;
}();
function $f4a7ee607ae1ef78$var$x(a) {
    return /^[\s\xa0]*$/.test(a);
}
function $f4a7ee607ae1ef78$var$pa() {
    var a = $f4a7ee607ae1ef78$var$l.navigator;
    return a && (a = a.userAgent) ? a : "";
}
function $f4a7ee607ae1ef78$var$y(a) {
    return -1 != $f4a7ee607ae1ef78$var$pa().indexOf(a);
}
function $f4a7ee607ae1ef78$var$qa(a) {
    $f4a7ee607ae1ef78$var$qa[" "](a);
    return a;
}
$f4a7ee607ae1ef78$var$qa[" "] = function() {};
function $f4a7ee607ae1ef78$var$ra(a, b) {
    var c = $f4a7ee607ae1ef78$var$sa;
    return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
}
var $f4a7ee607ae1ef78$var$ta = $f4a7ee607ae1ef78$var$y("Opera"), $f4a7ee607ae1ef78$var$z = $f4a7ee607ae1ef78$var$y("Trident") || $f4a7ee607ae1ef78$var$y("MSIE"), $f4a7ee607ae1ef78$var$ua = $f4a7ee607ae1ef78$var$y("Edge"), $f4a7ee607ae1ef78$var$va = $f4a7ee607ae1ef78$var$ua || $f4a7ee607ae1ef78$var$z, $f4a7ee607ae1ef78$var$wa = $f4a7ee607ae1ef78$var$y("Gecko") && !(-1 != $f4a7ee607ae1ef78$var$pa().toLowerCase().indexOf("webkit") && !$f4a7ee607ae1ef78$var$y("Edge")) && !($f4a7ee607ae1ef78$var$y("Trident") || $f4a7ee607ae1ef78$var$y("MSIE")) && !$f4a7ee607ae1ef78$var$y("Edge"), $f4a7ee607ae1ef78$var$xa = -1 != $f4a7ee607ae1ef78$var$pa().toLowerCase().indexOf("webkit") && !$f4a7ee607ae1ef78$var$y("Edge");
function $f4a7ee607ae1ef78$var$ya() {
    var a = $f4a7ee607ae1ef78$var$l.document;
    return a ? a.documentMode : void 0;
}
var $f4a7ee607ae1ef78$var$za;
a: {
    var $f4a7ee607ae1ef78$var$Aa = "", $f4a7ee607ae1ef78$var$Ba = function() {
        var a = $f4a7ee607ae1ef78$var$pa();
        if ($f4a7ee607ae1ef78$var$wa) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($f4a7ee607ae1ef78$var$ua) return /Edge\/([\d\.]+)/.exec(a);
        if ($f4a7ee607ae1ef78$var$z) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($f4a7ee607ae1ef78$var$xa) return /WebKit\/(\S+)/.exec(a);
        if ($f4a7ee607ae1ef78$var$ta) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $f4a7ee607ae1ef78$var$Ba && ($f4a7ee607ae1ef78$var$Aa = $f4a7ee607ae1ef78$var$Ba ? $f4a7ee607ae1ef78$var$Ba[1] : "");
    if ($f4a7ee607ae1ef78$var$z) {
        var $f4a7ee607ae1ef78$var$Ca = $f4a7ee607ae1ef78$var$ya();
        if (null != $f4a7ee607ae1ef78$var$Ca && $f4a7ee607ae1ef78$var$Ca > parseFloat($f4a7ee607ae1ef78$var$Aa)) {
            $f4a7ee607ae1ef78$var$za = String($f4a7ee607ae1ef78$var$Ca);
            break a;
        }
    }
    $f4a7ee607ae1ef78$var$za = $f4a7ee607ae1ef78$var$Aa;
}
var $f4a7ee607ae1ef78$var$Da;
if ($f4a7ee607ae1ef78$var$l.document && $f4a7ee607ae1ef78$var$z) {
    var $f4a7ee607ae1ef78$var$Ea = $f4a7ee607ae1ef78$var$ya();
    $f4a7ee607ae1ef78$var$Da = $f4a7ee607ae1ef78$var$Ea ? $f4a7ee607ae1ef78$var$Ea : parseInt($f4a7ee607ae1ef78$var$za, 10) || void 0;
} else $f4a7ee607ae1ef78$var$Da = void 0;
var $f4a7ee607ae1ef78$var$Fa = $f4a7ee607ae1ef78$var$Da;
function $f4a7ee607ae1ef78$var$A(a, b) {
    $f4a7ee607ae1ef78$var$w.call(this, a ? a.type : "");
    this.relatedTarget = this.g = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.state = null;
    this.pointerId = 0;
    this.pointerType = "";
    this.i = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        if (b = a.relatedTarget) {
            if ($f4a7ee607ae1ef78$var$wa) {
                a: {
                    try {
                        $f4a7ee607ae1ef78$var$qa(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $f4a7ee607ae1ef78$var$Ga[a.pointerType] || "";
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && $f4a7ee607ae1ef78$var$A.$.h.call(this);
    }
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$A, $f4a7ee607ae1ef78$var$w);
var $f4a7ee607ae1ef78$var$Ga = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$f4a7ee607ae1ef78$var$A.prototype.h = function() {
    $f4a7ee607ae1ef78$var$A.$.h.call(this);
    var a = this.i;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var $f4a7ee607ae1ef78$var$Ha = "closure_listenable_" + (1E6 * Math.random() | 0);
var $f4a7ee607ae1ef78$var$Ia = 0;
function $f4a7ee607ae1ef78$var$Ja(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.la = e;
    this.key = ++$f4a7ee607ae1ef78$var$Ia;
    this.fa = this.ia = !1;
}
function $f4a7ee607ae1ef78$var$Ka(a) {
    a.fa = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.la = null;
}
function $f4a7ee607ae1ef78$var$Na(a, b, c) {
    for(const d in a)b.call(c, a[d], d, a);
}
function $f4a7ee607ae1ef78$var$Oa(a, b) {
    for(const c in a)b.call(void 0, a[c], c, a);
}
function $f4a7ee607ae1ef78$var$Pa(a) {
    const b = {};
    for(const c in a)b[c] = a[c];
    return b;
}
const $f4a7ee607ae1ef78$var$Qa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $f4a7ee607ae1ef78$var$Ra(a, b) {
    let c, d;
    for(let e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(let f = 0; f < $f4a7ee607ae1ef78$var$Qa.length; f++)c = $f4a7ee607ae1ef78$var$Qa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $f4a7ee607ae1ef78$var$Sa(a) {
    this.src = a;
    this.g = {};
    this.h = 0;
}
$f4a7ee607ae1ef78$var$Sa.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.g[f];
    a || (a = this.g[f] = [], this.h++);
    var h = $f4a7ee607ae1ef78$var$Ta(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.ia = !1)) : (b = new $f4a7ee607ae1ef78$var$Ja(b, this.src, f, !!d, e), b.ia = c, a.push(b));
    return b;
};
function $f4a7ee607ae1ef78$var$Ua(a, b) {
    var c = b.type;
    if (c in a.g) {
        var d = a.g[c], e = $f4a7ee607ae1ef78$var$ka(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($f4a7ee607ae1ef78$var$Ka(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
    }
}
function $f4a7ee607ae1ef78$var$Ta(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.fa && f.listener == b && f.capture == !!c && f.la == d) return e;
    }
    return -1;
}
var $f4a7ee607ae1ef78$var$Va = "closure_lm_" + (1E6 * Math.random() | 0), $f4a7ee607ae1ef78$var$Wa = {};
function $f4a7ee607ae1ef78$var$Ya(a, b, c, d, e) {
    if (d && d.once) return $f4a7ee607ae1ef78$var$Za(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$f4a7ee607ae1ef78$var$Ya(a, b[f], c, d, e);
        return null;
    }
    c = $f4a7ee607ae1ef78$var$$a(c);
    return a && a[$f4a7ee607ae1ef78$var$Ha] ? a.O(b, c, $f4a7ee607ae1ef78$var$p(d) ? !!d.capture : !!d, e) : $f4a7ee607ae1ef78$var$ab(a, b, c, !1, d, e);
}
function $f4a7ee607ae1ef78$var$ab(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $f4a7ee607ae1ef78$var$p(e) ? !!e.capture : !!e, n = $f4a7ee607ae1ef78$var$bb(a);
    n || (a[$f4a7ee607ae1ef78$var$Va] = n = new $f4a7ee607ae1ef78$var$Sa(a));
    c = n.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $f4a7ee607ae1ef78$var$cb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $f4a7ee607ae1ef78$var$oa || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($f4a7ee607ae1ef78$var$db(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $f4a7ee607ae1ef78$var$cb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    const b = $f4a7ee607ae1ef78$var$eb;
    return a;
}
function $f4a7ee607ae1ef78$var$Za(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$f4a7ee607ae1ef78$var$Za(a, b[f], c, d, e);
        return null;
    }
    c = $f4a7ee607ae1ef78$var$$a(c);
    return a && a[$f4a7ee607ae1ef78$var$Ha] ? a.P(b, c, $f4a7ee607ae1ef78$var$p(d) ? !!d.capture : !!d, e) : $f4a7ee607ae1ef78$var$ab(a, b, c, !0, d, e);
}
function $f4a7ee607ae1ef78$var$fb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$f4a7ee607ae1ef78$var$fb(a, b[f], c, d, e);
    else (d = $f4a7ee607ae1ef78$var$p(d) ? !!d.capture : !!d, c = $f4a7ee607ae1ef78$var$$a(c), a && a[$f4a7ee607ae1ef78$var$Ha]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = $f4a7ee607ae1ef78$var$Ta(f, c, d, e), -1 < c && ($f4a7ee607ae1ef78$var$Ka(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = $f4a7ee607ae1ef78$var$bb(a)) && (b = a.g[b.toString()], a = -1, b && (a = $f4a7ee607ae1ef78$var$Ta(b, c, d, e)), (c = -1 < a ? b[a] : null) && $f4a7ee607ae1ef78$var$gb(c));
}
function $f4a7ee607ae1ef78$var$gb(a) {
    if ("number" !== typeof a && a && !a.fa) {
        var b = a.src;
        if (b && b[$f4a7ee607ae1ef78$var$Ha]) $f4a7ee607ae1ef78$var$Ua(b.i, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($f4a7ee607ae1ef78$var$db(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $f4a7ee607ae1ef78$var$bb(b)) ? ($f4a7ee607ae1ef78$var$Ua(c, a), 0 == c.h && (c.src = null, b[$f4a7ee607ae1ef78$var$Va] = null)) : $f4a7ee607ae1ef78$var$Ka(a);
        }
    }
}
function $f4a7ee607ae1ef78$var$db(a) {
    return a in $f4a7ee607ae1ef78$var$Wa ? $f4a7ee607ae1ef78$var$Wa[a] : $f4a7ee607ae1ef78$var$Wa[a] = "on" + a;
}
function $f4a7ee607ae1ef78$var$eb(a, b) {
    if (a.fa) a = !0;
    else {
        b = new $f4a7ee607ae1ef78$var$A(b, this);
        var c = a.listener, d = a.la || a.src;
        a.ia && $f4a7ee607ae1ef78$var$gb(a);
        a = c.call(d, b);
    }
    return a;
}
function $f4a7ee607ae1ef78$var$bb(a) {
    a = a[$f4a7ee607ae1ef78$var$Va];
    return a instanceof $f4a7ee607ae1ef78$var$Sa ? a : null;
}
var $f4a7ee607ae1ef78$var$hb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $f4a7ee607ae1ef78$var$$a(a) {
    if ("function" === typeof a) return a;
    a[$f4a7ee607ae1ef78$var$hb] || (a[$f4a7ee607ae1ef78$var$hb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$f4a7ee607ae1ef78$var$hb];
}
function $f4a7ee607ae1ef78$var$B() {
    $f4a7ee607ae1ef78$var$v.call(this);
    this.i = new $f4a7ee607ae1ef78$var$Sa(this);
    this.S = this;
    this.J = null;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$B, $f4a7ee607ae1ef78$var$v);
$f4a7ee607ae1ef78$var$B.prototype[$f4a7ee607ae1ef78$var$Ha] = !0;
$f4a7ee607ae1ef78$var$B.prototype.removeEventListener = function(a, b, c, d) {
    $f4a7ee607ae1ef78$var$fb(this, a, b, c, d);
};
function $f4a7ee607ae1ef78$var$C(a, b) {
    var c, d = a.J;
    if (d) for(c = []; d; d = d.J)c.push(d);
    a = a.S;
    d = b.type || b;
    if ("string" === typeof b) b = new $f4a7ee607ae1ef78$var$w(b, a);
    else if (b instanceof $f4a7ee607ae1ef78$var$w) b.target = b.target || a;
    else {
        var e = b;
        b = new $f4a7ee607ae1ef78$var$w(d, a);
        $f4a7ee607ae1ef78$var$Ra(b, e);
    }
    e = !0;
    if (c) for(var f = c.length - 1; 0 <= f; f--){
        var h = b.g = c[f];
        e = $f4a7ee607ae1ef78$var$ib(h, d, !0, b) && e;
    }
    h = b.g = a;
    e = $f4a7ee607ae1ef78$var$ib(h, d, !0, b) && e;
    e = $f4a7ee607ae1ef78$var$ib(h, d, !1, b) && e;
    if (c) for(f = 0; f < c.length; f++)h = b.g = c[f], e = $f4a7ee607ae1ef78$var$ib(h, d, !1, b) && e;
}
$f4a7ee607ae1ef78$var$B.prototype.N = function() {
    $f4a7ee607ae1ef78$var$B.$.N.call(this);
    if (this.i) {
        var a = this.i, c;
        for(c in a.g){
            for(var d = a.g[c], e = 0; e < d.length; e++)$f4a7ee607ae1ef78$var$Ka(d[e]);
            delete a.g[c];
            a.h--;
        }
    }
    this.J = null;
};
$f4a7ee607ae1ef78$var$B.prototype.O = function(a, b, c, d) {
    return this.i.add(String(a), b, !1, c, d);
};
$f4a7ee607ae1ef78$var$B.prototype.P = function(a, b, c, d) {
    return this.i.add(String(a), b, !0, c, d);
};
function $f4a7ee607ae1ef78$var$ib(a, b, c, d) {
    b = a.i.g[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.fa && h.capture == c) {
            var n = h.listener, t = h.la || h.src;
            h.ia && $f4a7ee607ae1ef78$var$Ua(a.i, h);
            e = !1 !== n.call(t, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $f4a7ee607ae1ef78$var$jb = $f4a7ee607ae1ef78$var$l.JSON.stringify;
class $f4a7ee607ae1ef78$var$kb {
    constructor(a, b){
        this.i = a;
        this.j = b;
        this.h = 0;
        this.g = null;
    }
    get() {
        let a;
        0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
        return a;
    }
}
function $f4a7ee607ae1ef78$var$lb() {
    var a = $f4a7ee607ae1ef78$var$mb;
    let b = null;
    a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
    return b;
}
class $f4a7ee607ae1ef78$var$nb {
    constructor(){
        this.h = this.g = null;
    }
    add(a, b) {
        const c = $f4a7ee607ae1ef78$var$ob.get();
        c.set(a, b);
        this.h ? this.h.next = c : this.g = c;
        this.h = c;
    }
}
var $f4a7ee607ae1ef78$var$ob = new $f4a7ee607ae1ef78$var$kb(()=>new $f4a7ee607ae1ef78$var$pb, (a)=>a.reset());
class $f4a7ee607ae1ef78$var$pb {
    constructor(){
        this.next = this.g = this.h = null;
    }
    set(a, b) {
        this.h = a;
        this.g = b;
        this.next = null;
    }
    reset() {
        this.next = this.g = this.h = null;
    }
}
function $f4a7ee607ae1ef78$var$qb(a) {
    var b = 1;
    a = a.split(":");
    const c = [];
    for(; 0 < b && a.length;)c.push(a.shift()), b--;
    a.length && c.push(a.join(":"));
    return c;
}
function $f4a7ee607ae1ef78$var$rb(a) {
    $f4a7ee607ae1ef78$var$l.setTimeout(()=>{
        throw a;
    }, 0);
}
let $f4a7ee607ae1ef78$var$sb, $f4a7ee607ae1ef78$var$tb = !1, $f4a7ee607ae1ef78$var$mb = new $f4a7ee607ae1ef78$var$nb, $f4a7ee607ae1ef78$var$vb = ()=>{
    const a = $f4a7ee607ae1ef78$var$l.Promise.resolve(void 0);
    $f4a7ee607ae1ef78$var$sb = ()=>{
        a.then($f4a7ee607ae1ef78$var$ub);
    };
};
var $f4a7ee607ae1ef78$var$ub = ()=>{
    for(var a; a = $f4a7ee607ae1ef78$var$lb();){
        try {
            a.h.call(a.g);
        } catch (c) {
            $f4a7ee607ae1ef78$var$rb(c);
        }
        var b = $f4a7ee607ae1ef78$var$ob;
        b.j(a);
        100 > b.h && (b.h++, a.next = b.g, b.g = a);
    }
    $f4a7ee607ae1ef78$var$tb = !1;
};
function $f4a7ee607ae1ef78$var$wb(a, b) {
    $f4a7ee607ae1ef78$var$B.call(this);
    this.h = a || 1;
    this.g = b || $f4a7ee607ae1ef78$var$l;
    this.j = $f4a7ee607ae1ef78$var$q(this.qb, this);
    this.l = Date.now();
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$wb, $f4a7ee607ae1ef78$var$B);
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$wb.prototype;
$f4a7ee607ae1ef78$var$k.ga = !1;
$f4a7ee607ae1ef78$var$k.T = null;
$f4a7ee607ae1ef78$var$k.qb = function() {
    if (this.ga) {
        var a = Date.now() - this.l;
        0 < a && a < .8 * this.h ? this.T = this.g.setTimeout(this.j, this.h - a) : (this.T && (this.g.clearTimeout(this.T), this.T = null), $f4a7ee607ae1ef78$var$C(this, "tick"), this.ga && ($f4a7ee607ae1ef78$var$xb(this), this.start()));
    }
};
$f4a7ee607ae1ef78$var$k.start = function() {
    this.ga = !0;
    this.T || (this.T = this.g.setTimeout(this.j, this.h), this.l = Date.now());
};
function $f4a7ee607ae1ef78$var$xb(a) {
    a.ga = !1;
    a.T && (a.g.clearTimeout(a.T), a.T = null);
}
$f4a7ee607ae1ef78$var$k.N = function() {
    $f4a7ee607ae1ef78$var$wb.$.N.call(this);
    $f4a7ee607ae1ef78$var$xb(this);
    delete this.g;
};
function $f4a7ee607ae1ef78$var$yb(a, b, c) {
    if ("function" === typeof a) c && (a = $f4a7ee607ae1ef78$var$q(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $f4a7ee607ae1ef78$var$q(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $f4a7ee607ae1ef78$var$l.setTimeout(a, b || 0);
}
function $f4a7ee607ae1ef78$var$zb(a) {
    a.g = $f4a7ee607ae1ef78$var$yb(()=>{
        a.g = null;
        a.i && (a.i = !1, $f4a7ee607ae1ef78$var$zb(a));
    }, a.j);
    const b = a.h;
    a.h = null;
    a.m.apply(null, b);
}
class $f4a7ee607ae1ef78$var$Ab extends $f4a7ee607ae1ef78$var$v {
    constructor(a, b){
        super();
        this.m = a;
        this.j = b;
        this.h = null;
        this.i = !1;
        this.g = null;
    }
    l(a) {
        this.h = arguments;
        this.g ? this.i = !0 : $f4a7ee607ae1ef78$var$zb(this);
    }
    N() {
        super.N();
        this.g && ($f4a7ee607ae1ef78$var$l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
    }
}
function $f4a7ee607ae1ef78$var$Bb(a) {
    $f4a7ee607ae1ef78$var$v.call(this);
    this.h = a;
    this.g = {};
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Bb, $f4a7ee607ae1ef78$var$v);
var $f4a7ee607ae1ef78$var$Cb = [];
function $f4a7ee607ae1ef78$var$Db(a, b, c, d) {
    Array.isArray(c) || (c && ($f4a7ee607ae1ef78$var$Cb[0] = c.toString()), c = $f4a7ee607ae1ef78$var$Cb);
    for(var e = 0; e < c.length; e++){
        var f = $f4a7ee607ae1ef78$var$Ya(b, c[e], d || a.handleEvent, !1, a.h || a);
        if (!f) break;
        a.g[f.key] = f;
    }
}
function $f4a7ee607ae1ef78$var$Fb(a) {
    $f4a7ee607ae1ef78$var$Na(a.g, function(b, c) {
        this.g.hasOwnProperty(c) && $f4a7ee607ae1ef78$var$gb(b);
    }, a);
    a.g = {};
}
$f4a7ee607ae1ef78$var$Bb.prototype.N = function() {
    $f4a7ee607ae1ef78$var$Bb.$.N.call(this);
    $f4a7ee607ae1ef78$var$Fb(this);
};
$f4a7ee607ae1ef78$var$Bb.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $f4a7ee607ae1ef78$var$Gb() {
    this.g = !0;
}
$f4a7ee607ae1ef78$var$Gb.prototype.Ea = function() {
    this.g = !1;
};
function $f4a7ee607ae1ef78$var$Hb(a, b, c, d, e, f) {
    a.info(function() {
        if (a.g) {
            if (f) {
                var h = "";
                for(var n = f.split("&"), t = 0; t < n.length; t++){
                    var m = n[t].split("=");
                    if (1 < m.length) {
                        var u = m[0];
                        m = m[1];
                        var L = u.split("_");
                        h = 2 <= L.length && "type" == L[1] ? h + (u + "=" + m + "&") : h + (u + "=redacted&");
                    }
                }
            } else h = null;
        } else h = f;
        return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
}
function $f4a7ee607ae1ef78$var$Ib(a, b, c, d, e, f, h) {
    a.info(function() {
        return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
}
function $f4a7ee607ae1ef78$var$D(a, b, c, d) {
    a.info(function() {
        return "XMLHTTP TEXT (" + b + "): " + $f4a7ee607ae1ef78$var$Jb(a, c) + (d ? " " + d : "");
    });
}
function $f4a7ee607ae1ef78$var$Kb(a, b) {
    a.info(function() {
        return "TIMEOUT: " + b;
    });
}
$f4a7ee607ae1ef78$var$Gb.prototype.info = function() {};
function $f4a7ee607ae1ef78$var$Jb(a, b) {
    if (!a.g) return b;
    if (!b) return null;
    try {
        var c = JSON.parse(b);
        if (c) {
            for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                var d = c[a];
                if (!(2 > d.length)) {
                    var e = d[1];
                    if (Array.isArray(e) && !(1 > e.length)) {
                        var f = e[0];
                        if ("noop" != f && "stop" != f && "close" != f) for(var h = 1; h < e.length; h++)e[h] = "";
                    }
                }
            }
        }
        return $f4a7ee607ae1ef78$var$jb(c);
    } catch (n) {
        return b;
    }
}
var $f4a7ee607ae1ef78$var$E = {}, $f4a7ee607ae1ef78$var$Lb = null;
function $f4a7ee607ae1ef78$var$Mb() {
    return $f4a7ee607ae1ef78$var$Lb = $f4a7ee607ae1ef78$var$Lb || new $f4a7ee607ae1ef78$var$B;
}
$f4a7ee607ae1ef78$var$E.Ta = "serverreachability";
function $f4a7ee607ae1ef78$var$Nb(a) {
    $f4a7ee607ae1ef78$var$w.call(this, $f4a7ee607ae1ef78$var$E.Ta, a);
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Nb, $f4a7ee607ae1ef78$var$w);
function $f4a7ee607ae1ef78$var$Ob(a) {
    const b = $f4a7ee607ae1ef78$var$Mb();
    $f4a7ee607ae1ef78$var$C(b, new $f4a7ee607ae1ef78$var$Nb(b));
}
$f4a7ee607ae1ef78$var$E.STAT_EVENT = "statevent";
function $f4a7ee607ae1ef78$var$Pb(a, b) {
    $f4a7ee607ae1ef78$var$w.call(this, $f4a7ee607ae1ef78$var$E.STAT_EVENT, a);
    this.stat = b;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Pb, $f4a7ee607ae1ef78$var$w);
function $f4a7ee607ae1ef78$var$F(a) {
    const b = $f4a7ee607ae1ef78$var$Mb();
    $f4a7ee607ae1ef78$var$C(b, new $f4a7ee607ae1ef78$var$Pb(b, a));
}
$f4a7ee607ae1ef78$var$E.Ua = "timingevent";
function $f4a7ee607ae1ef78$var$Qb(a, b) {
    $f4a7ee607ae1ef78$var$w.call(this, $f4a7ee607ae1ef78$var$E.Ua, a);
    this.size = b;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Qb, $f4a7ee607ae1ef78$var$w);
function $f4a7ee607ae1ef78$var$Rb(a, b) {
    if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
    return $f4a7ee607ae1ef78$var$l.setTimeout(function() {
        a();
    }, b);
}
var $f4a7ee607ae1ef78$var$Sb = {
    NO_ERROR: 0,
    rb: 1,
    Eb: 2,
    Db: 3,
    yb: 4,
    Cb: 5,
    Fb: 6,
    Qa: 7,
    TIMEOUT: 8,
    Ib: 9
};
var $f4a7ee607ae1ef78$var$Tb = {
    wb: "complete",
    Sb: "success",
    Ra: "error",
    Qa: "abort",
    Kb: "ready",
    Lb: "readystatechange",
    TIMEOUT: "timeout",
    Gb: "incrementaldata",
    Jb: "progress",
    zb: "downloadprogress",
    $b: "uploadprogress"
};
function $f4a7ee607ae1ef78$var$Ub() {}
$f4a7ee607ae1ef78$var$Ub.prototype.h = null;
function $f4a7ee607ae1ef78$var$Vb(a) {
    return a.h || (a.h = a.i());
}
function $f4a7ee607ae1ef78$var$Wb() {}
var $f4a7ee607ae1ef78$var$Xb = {
    OPEN: "a",
    vb: "b",
    Ra: "c",
    Hb: "d"
};
function $f4a7ee607ae1ef78$var$Yb() {
    $f4a7ee607ae1ef78$var$w.call(this, "d");
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Yb, $f4a7ee607ae1ef78$var$w);
function $f4a7ee607ae1ef78$var$Zb() {
    $f4a7ee607ae1ef78$var$w.call(this, "c");
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Zb, $f4a7ee607ae1ef78$var$w);
var $f4a7ee607ae1ef78$var$$b;
function $f4a7ee607ae1ef78$var$ac() {}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$ac, $f4a7ee607ae1ef78$var$Ub);
$f4a7ee607ae1ef78$var$ac.prototype.g = function() {
    return new XMLHttpRequest;
};
$f4a7ee607ae1ef78$var$ac.prototype.i = function() {
    return {};
};
$f4a7ee607ae1ef78$var$$b = new $f4a7ee607ae1ef78$var$ac;
function $f4a7ee607ae1ef78$var$bc(a, b, c, d) {
    this.l = a;
    this.j = b;
    this.m = c;
    this.W = d || 1;
    this.U = new $f4a7ee607ae1ef78$var$Bb(this);
    this.P = $f4a7ee607ae1ef78$var$cc;
    a = $f4a7ee607ae1ef78$var$va ? 125 : void 0;
    this.V = new $f4a7ee607ae1ef78$var$wb(a);
    this.I = null;
    this.i = !1;
    this.s = this.A = this.v = this.L = this.G = this.Y = this.B = null;
    this.F = [];
    this.g = null;
    this.C = 0;
    this.o = this.u = null;
    this.ca = -1;
    this.J = !1;
    this.O = 0;
    this.M = null;
    this.ba = this.K = this.aa = this.S = !1;
    this.h = new $f4a7ee607ae1ef78$var$dc;
}
function $f4a7ee607ae1ef78$var$dc() {
    this.i = null;
    this.g = "";
    this.h = !1;
}
var $f4a7ee607ae1ef78$var$cc = 45E3, $f4a7ee607ae1ef78$var$ec = {}, $f4a7ee607ae1ef78$var$fc = {};
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$bc.prototype;
$f4a7ee607ae1ef78$var$k.setTimeout = function(a) {
    this.P = a;
};
function $f4a7ee607ae1ef78$var$gc(a, b, c) {
    a.L = 1;
    a.v = $f4a7ee607ae1ef78$var$hc($f4a7ee607ae1ef78$var$G(b));
    a.s = c;
    a.S = !0;
    $f4a7ee607ae1ef78$var$ic(a, null);
}
function $f4a7ee607ae1ef78$var$ic(a, b) {
    a.G = Date.now();
    $f4a7ee607ae1ef78$var$jc(a);
    a.A = $f4a7ee607ae1ef78$var$G(a.v);
    var c = a.A, d = a.W;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $f4a7ee607ae1ef78$var$kc(c.i, "t", d);
    a.C = 0;
    c = a.l.J;
    a.h = new $f4a7ee607ae1ef78$var$dc;
    a.g = $f4a7ee607ae1ef78$var$lc(a.l, c ? b : null, !a.s);
    0 < a.O && (a.M = new $f4a7ee607ae1ef78$var$Ab($f4a7ee607ae1ef78$var$q(a.Pa, a, a.g), a.O));
    $f4a7ee607ae1ef78$var$Db(a.U, a.g, "readystatechange", a.nb);
    b = a.I ? $f4a7ee607ae1ef78$var$Pa(a.I) : {};
    a.s ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ha(a.A, a.u, a.s, b)) : (a.u = "GET", a.g.ha(a.A, a.u, null, b));
    $f4a7ee607ae1ef78$var$Ob();
    $f4a7ee607ae1ef78$var$Hb(a.j, a.u, a.A, a.m, a.W, a.s);
}
$f4a7ee607ae1ef78$var$k.nb = function(a) {
    a = a.target;
    const b = this.M;
    b && 3 == $f4a7ee607ae1ef78$var$H(a) ? b.l() : this.Pa(a);
};
$f4a7ee607ae1ef78$var$k.Pa = function(a) {
    try {
        if (a == this.g) a: {
            const u = $f4a7ee607ae1ef78$var$H(this.g);
            var b = this.g.Ia();
            const L = this.g.da();
            if (!(3 > u) && (3 != u || $f4a7ee607ae1ef78$var$va || this.g && (this.h.h || this.g.ja() || $f4a7ee607ae1ef78$var$mc(this.g)))) {
                this.J || 4 != u || 7 == b || (8 == b || 0 >= L ? $f4a7ee607ae1ef78$var$Ob(3) : $f4a7ee607ae1ef78$var$Ob(2));
                $f4a7ee607ae1ef78$var$nc(this);
                var c = this.g.da();
                this.ca = c;
                b: if ($f4a7ee607ae1ef78$var$oc(this)) {
                    var d = $f4a7ee607ae1ef78$var$mc(this.g);
                    a = "";
                    var e = d.length, f = 4 == $f4a7ee607ae1ef78$var$H(this.g);
                    if (!this.h.i) {
                        if ("undefined" === typeof TextDecoder) {
                            $f4a7ee607ae1ef78$var$I(this);
                            $f4a7ee607ae1ef78$var$pc(this);
                            var h = "";
                            break b;
                        }
                        this.h.i = new $f4a7ee607ae1ef78$var$l.TextDecoder;
                    }
                    for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                        stream: f && b == e - 1
                    });
                    d.splice(0, e);
                    this.h.g += a;
                    this.C = 0;
                    h = this.h.g;
                } else h = this.g.ja();
                this.i = 200 == c;
                $f4a7ee607ae1ef78$var$Ib(this.j, this.u, this.A, this.m, this.W, u, c);
                if (this.i) {
                    if (this.aa && !this.K) {
                        b: {
                            if (this.g) {
                                var n, t = this.g;
                                if ((n = t.g ? t.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !$f4a7ee607ae1ef78$var$x(n)) {
                                    var m = n;
                                    break b;
                                }
                            }
                            m = null;
                        }
                        if (c = m) $f4a7ee607ae1ef78$var$D(this.j, this.m, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, $f4a7ee607ae1ef78$var$qc(this, c);
                        else {
                            this.i = !1;
                            this.o = 3;
                            $f4a7ee607ae1ef78$var$F(12);
                            $f4a7ee607ae1ef78$var$I(this);
                            $f4a7ee607ae1ef78$var$pc(this);
                            break a;
                        }
                    }
                    this.S ? ($f4a7ee607ae1ef78$var$rc(this, u, h), $f4a7ee607ae1ef78$var$va && this.i && 3 == u && ($f4a7ee607ae1ef78$var$Db(this.U, this.V, "tick", this.mb), this.V.start())) : ($f4a7ee607ae1ef78$var$D(this.j, this.m, h, null), $f4a7ee607ae1ef78$var$qc(this, h));
                    4 == u && $f4a7ee607ae1ef78$var$I(this);
                    this.i && !this.J && (4 == u ? $f4a7ee607ae1ef78$var$sc(this.l, this) : (this.i = !1, $f4a7ee607ae1ef78$var$jc(this)));
                } else $f4a7ee607ae1ef78$var$tc(this.g), 400 == c && 0 < h.indexOf("Unknown SID") ? (this.o = 3, $f4a7ee607ae1ef78$var$F(12)) : (this.o = 0, $f4a7ee607ae1ef78$var$F(13)), $f4a7ee607ae1ef78$var$I(this), $f4a7ee607ae1ef78$var$pc(this);
            }
        }
    } catch (u) {} finally{}
};
function $f4a7ee607ae1ef78$var$oc(a) {
    return a.g ? "GET" == a.u && 2 != a.L && a.l.Ha : !1;
}
function $f4a7ee607ae1ef78$var$rc(a, b, c) {
    let d = !0, e;
    for(; !a.J && a.C < c.length;)if (e = $f4a7ee607ae1ef78$var$uc(a, c), e == $f4a7ee607ae1ef78$var$fc) {
        4 == b && (a.o = 4, $f4a7ee607ae1ef78$var$F(14), d = !1);
        $f4a7ee607ae1ef78$var$D(a.j, a.m, null, "[Incomplete Response]");
        break;
    } else if (e == $f4a7ee607ae1ef78$var$ec) {
        a.o = 4;
        $f4a7ee607ae1ef78$var$F(15);
        $f4a7ee607ae1ef78$var$D(a.j, a.m, c, "[Invalid Chunk]");
        d = !1;
        break;
    } else $f4a7ee607ae1ef78$var$D(a.j, a.m, e, null), $f4a7ee607ae1ef78$var$qc(a, e);
    $f4a7ee607ae1ef78$var$oc(a) && e != $f4a7ee607ae1ef78$var$fc && e != $f4a7ee607ae1ef78$var$ec && (a.h.g = "", a.C = 0);
    4 != b || 0 != c.length || a.h.h || (a.o = 1, $f4a7ee607ae1ef78$var$F(16), d = !1);
    a.i = a.i && d;
    d ? 0 < c.length && !a.ba && (a.ba = !0, b = a.l, b.g == a && b.ca && !b.M && (b.l.info("Great, no buffering proxy detected. Bytes received: " + c.length), $f4a7ee607ae1ef78$var$vc(b), b.M = !0, $f4a7ee607ae1ef78$var$F(11))) : ($f4a7ee607ae1ef78$var$D(a.j, a.m, c, "[Invalid Chunked Response]"), $f4a7ee607ae1ef78$var$I(a), $f4a7ee607ae1ef78$var$pc(a));
}
$f4a7ee607ae1ef78$var$k.mb = function() {
    if (this.g) {
        var a = $f4a7ee607ae1ef78$var$H(this.g), b = this.g.ja();
        this.C < b.length && ($f4a7ee607ae1ef78$var$nc(this), $f4a7ee607ae1ef78$var$rc(this, a, b), this.i && 4 != a && $f4a7ee607ae1ef78$var$jc(this));
    }
};
function $f4a7ee607ae1ef78$var$uc(a, b) {
    var c = a.C, d = b.indexOf("\n", c);
    if (-1 == d) return $f4a7ee607ae1ef78$var$fc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $f4a7ee607ae1ef78$var$ec;
    d += 1;
    if (d + c > b.length) return $f4a7ee607ae1ef78$var$fc;
    b = b.slice(d, d + c);
    a.C = d + c;
    return b;
}
$f4a7ee607ae1ef78$var$k.cancel = function() {
    this.J = !0;
    $f4a7ee607ae1ef78$var$I(this);
};
function $f4a7ee607ae1ef78$var$jc(a) {
    a.Y = Date.now() + a.P;
    $f4a7ee607ae1ef78$var$wc(a, a.P);
}
function $f4a7ee607ae1ef78$var$wc(a, b) {
    if (null != a.B) throw Error("WatchDog timer not null");
    a.B = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(a.lb, a), b);
}
function $f4a7ee607ae1ef78$var$nc(a) {
    a.B && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.B), a.B = null);
}
$f4a7ee607ae1ef78$var$k.lb = function() {
    this.B = null;
    const a = Date.now();
    0 <= a - this.Y ? ($f4a7ee607ae1ef78$var$Kb(this.j, this.A), 2 != this.L && ($f4a7ee607ae1ef78$var$Ob(), $f4a7ee607ae1ef78$var$F(17)), $f4a7ee607ae1ef78$var$I(this), this.o = 2, $f4a7ee607ae1ef78$var$pc(this)) : $f4a7ee607ae1ef78$var$wc(this, this.Y - a);
};
function $f4a7ee607ae1ef78$var$pc(a) {
    0 == a.l.H || a.J || $f4a7ee607ae1ef78$var$sc(a.l, a);
}
function $f4a7ee607ae1ef78$var$I(a) {
    $f4a7ee607ae1ef78$var$nc(a);
    var b = a.M;
    b && "function" == typeof b.sa && b.sa();
    a.M = null;
    $f4a7ee607ae1ef78$var$xb(a.V);
    $f4a7ee607ae1ef78$var$Fb(a.U);
    a.g && (b = a.g, a.g = null, b.abort(), b.sa());
}
function $f4a7ee607ae1ef78$var$qc(a, b) {
    try {
        var c = a.l;
        if (0 != c.H && (c.g == a || $f4a7ee607ae1ef78$var$xc(c.i, a))) {
            if (!a.K && $f4a7ee607ae1ef78$var$xc(c.i, a) && 3 == c.H) {
                try {
                    var d = c.Ja.g.parse(b);
                } catch (m) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.u) {
                            if (c.g) {
                                if (c.g.G + 3E3 < a.G) $f4a7ee607ae1ef78$var$yc(c), $f4a7ee607ae1ef78$var$zc(c);
                                else break a;
                            }
                            $f4a7ee607ae1ef78$var$Ac(c);
                            $f4a7ee607ae1ef78$var$F(18);
                        }
                    } else c.Fa = e[1], 0 < c.Fa - c.V && 37500 > e[2] && c.G && 0 == c.A && !c.v && (c.v = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(c.ib, c), 6E3));
                    if (1 >= $f4a7ee607ae1ef78$var$Bc(c.i) && c.oa) {
                        try {
                            c.oa();
                        } catch (m) {}
                        c.oa = void 0;
                    }
                } else $f4a7ee607ae1ef78$var$J(c, 11);
            } else if ((a.K || c.g == a) && $f4a7ee607ae1ef78$var$yc(c), !$f4a7ee607ae1ef78$var$x(b)) for(e = c.Ja.g.parse(b), b = 0; b < e.length; b++){
                let m = e[b];
                c.V = m[0];
                m = m[1];
                if (2 == c.H) {
                    if ("c" == m[0]) {
                        c.K = m[1];
                        c.pa = m[2];
                        const u = m[3];
                        null != u && (c.ra = u, c.l.info("VER=" + c.ra));
                        const L = m[4];
                        null != L && (c.Ga = L, c.l.info("SVER=" + c.Ga));
                        const La = m[5];
                        null != La && "number" === typeof La && 0 < La && (d = 1.5 * La, c.L = d, c.l.info("backChannelRequestTimeoutMs_=" + d));
                        d = c;
                        const la = a.g;
                        if (la) {
                            const Ma = la.g ? la.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                            if (Ma) {
                                var f = d.i;
                                f.g || -1 == Ma.indexOf("spdy") && -1 == Ma.indexOf("quic") && -1 == Ma.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && ($f4a7ee607ae1ef78$var$Cc(f, f.h), f.h = null));
                            }
                            if (d.F) {
                                const Eb = la.g ? la.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                Eb && (d.Da = Eb, $f4a7ee607ae1ef78$var$K(d.I, d.F, Eb));
                            }
                        }
                        c.H = 3;
                        c.h && c.h.Ba();
                        c.ca && (c.S = Date.now() - a.G, c.l.info("Handshake RTT: " + c.S + "ms"));
                        d = c;
                        var h = a;
                        d.wa = $f4a7ee607ae1ef78$var$Dc(d, d.J ? d.pa : null, d.Y);
                        if (h.K) {
                            $f4a7ee607ae1ef78$var$Ec(d.i, h);
                            var n = h, t = d.L;
                            t && n.setTimeout(t);
                            n.B && ($f4a7ee607ae1ef78$var$nc(n), $f4a7ee607ae1ef78$var$jc(n));
                            d.g = h;
                        } else $f4a7ee607ae1ef78$var$Fc(d);
                        0 < c.j.length && $f4a7ee607ae1ef78$var$Gc(c);
                    } else "stop" != m[0] && "close" != m[0] || $f4a7ee607ae1ef78$var$J(c, 7);
                } else 3 == c.H && ("stop" == m[0] || "close" == m[0] ? "stop" == m[0] ? $f4a7ee607ae1ef78$var$J(c, 7) : $f4a7ee607ae1ef78$var$Hc(c) : "noop" != m[0] && c.h && c.h.Aa(m), c.A = 0);
            }
        }
        $f4a7ee607ae1ef78$var$Ob(4);
    } catch (m) {}
}
function $f4a7ee607ae1ef78$var$Ic(a) {
    if (a.Z && "function" == typeof a.Z) return a.Z();
    if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
    if ("string" === typeof a) return a.split("");
    if ($f4a7ee607ae1ef78$var$aa(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return b;
}
function $f4a7ee607ae1ef78$var$Jc(a) {
    if (a.ta && "function" == typeof a.ta) return a.ta();
    if (!a.Z || "function" != typeof a.Z) {
        if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
        if (!("undefined" !== typeof Set && a instanceof Set)) {
            if ($f4a7ee607ae1ef78$var$aa(a) || "string" === typeof a) {
                var b = [];
                a = a.length;
                for(var c = 0; c < a; c++)b.push(c);
                return b;
            }
            b = [];
            c = 0;
            for(const d in a)b[c++] = d;
            return b;
        }
    }
}
function $f4a7ee607ae1ef78$var$Kc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($f4a7ee607ae1ef78$var$aa(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
    else for(var c = $f4a7ee607ae1ef78$var$Jc(a), d = $f4a7ee607ae1ef78$var$Ic(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
}
var $f4a7ee607ae1ef78$var$Lc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
function $f4a7ee607ae1ef78$var$Mc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $f4a7ee607ae1ef78$var$M(a) {
    this.g = this.s = this.j = "";
    this.m = null;
    this.o = this.l = "";
    this.h = !1;
    if (a instanceof $f4a7ee607ae1ef78$var$M) {
        this.h = a.h;
        $f4a7ee607ae1ef78$var$Nc(this, a.j);
        this.s = a.s;
        this.g = a.g;
        $f4a7ee607ae1ef78$var$Oc(this, a.m);
        this.l = a.l;
        var b = a.i;
        var c = new $f4a7ee607ae1ef78$var$Pc;
        c.i = b.i;
        b.g && (c.g = new Map(b.g), c.h = b.h);
        $f4a7ee607ae1ef78$var$Qc(this, c);
        this.o = a.o;
    } else a && (b = String(a).match($f4a7ee607ae1ef78$var$Lc)) ? (this.h = !1, $f4a7ee607ae1ef78$var$Nc(this, b[1] || "", !0), this.s = $f4a7ee607ae1ef78$var$Rc(b[2] || ""), this.g = $f4a7ee607ae1ef78$var$Rc(b[3] || "", !0), $f4a7ee607ae1ef78$var$Oc(this, b[4]), this.l = $f4a7ee607ae1ef78$var$Rc(b[5] || "", !0), $f4a7ee607ae1ef78$var$Qc(this, b[6] || "", !0), this.o = $f4a7ee607ae1ef78$var$Rc(b[7] || "")) : (this.h = !1, this.i = new $f4a7ee607ae1ef78$var$Pc(null, this.h));
}
$f4a7ee607ae1ef78$var$M.prototype.toString = function() {
    var a = [], b = this.j;
    b && a.push($f4a7ee607ae1ef78$var$Sc(b, $f4a7ee607ae1ef78$var$Tc, !0), ":");
    var c = this.g;
    if (c || "file" == b) a.push("//"), (b = this.s) && a.push($f4a7ee607ae1ef78$var$Sc(b, $f4a7ee607ae1ef78$var$Tc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.m, null != c && a.push(":", String(c));
    if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push($f4a7ee607ae1ef78$var$Sc(c, "/" == c.charAt(0) ? $f4a7ee607ae1ef78$var$Uc : $f4a7ee607ae1ef78$var$Vc, !0));
    (c = this.i.toString()) && a.push("?", c);
    (c = this.o) && a.push("#", $f4a7ee607ae1ef78$var$Sc(c, $f4a7ee607ae1ef78$var$Wc));
    return a.join("");
};
function $f4a7ee607ae1ef78$var$G(a) {
    return new $f4a7ee607ae1ef78$var$M(a);
}
function $f4a7ee607ae1ef78$var$Nc(a, b, c) {
    a.j = c ? $f4a7ee607ae1ef78$var$Rc(b, !0) : b;
    a.j && (a.j = a.j.replace(/:$/, ""));
}
function $f4a7ee607ae1ef78$var$Oc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.m = b;
    } else a.m = null;
}
function $f4a7ee607ae1ef78$var$Qc(a, b, c) {
    b instanceof $f4a7ee607ae1ef78$var$Pc ? (a.i = b, $f4a7ee607ae1ef78$var$Xc(a.i, a.h)) : (c || (b = $f4a7ee607ae1ef78$var$Sc(b, $f4a7ee607ae1ef78$var$Yc)), a.i = new $f4a7ee607ae1ef78$var$Pc(b, a.h));
}
function $f4a7ee607ae1ef78$var$K(a, b, c) {
    a.i.set(b, c);
}
function $f4a7ee607ae1ef78$var$hc(a) {
    $f4a7ee607ae1ef78$var$K(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
    return a;
}
function $f4a7ee607ae1ef78$var$Rc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $f4a7ee607ae1ef78$var$Sc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $f4a7ee607ae1ef78$var$Zc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $f4a7ee607ae1ef78$var$Zc(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $f4a7ee607ae1ef78$var$Tc = /[#\/\?@]/g, $f4a7ee607ae1ef78$var$Vc = /[#\?:]/g, $f4a7ee607ae1ef78$var$Uc = /[#\?]/g, $f4a7ee607ae1ef78$var$Yc = /[#\?@]/g, $f4a7ee607ae1ef78$var$Wc = /#/g;
function $f4a7ee607ae1ef78$var$Pc(a, b) {
    this.h = this.g = null;
    this.i = a || null;
    this.j = !!b;
}
function $f4a7ee607ae1ef78$var$N(a) {
    a.g || (a.g = new Map, a.h = 0, a.i && $f4a7ee607ae1ef78$var$Mc(a.i, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$Pc.prototype;
$f4a7ee607ae1ef78$var$k.add = function(a, b) {
    $f4a7ee607ae1ef78$var$N(this);
    this.i = null;
    a = $f4a7ee607ae1ef78$var$O(this, a);
    var c = this.g.get(a);
    c || this.g.set(a, c = []);
    c.push(b);
    this.h += 1;
    return this;
};
function $f4a7ee607ae1ef78$var$$c(a, b) {
    $f4a7ee607ae1ef78$var$N(a);
    b = $f4a7ee607ae1ef78$var$O(a, b);
    a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
}
function $f4a7ee607ae1ef78$var$ad(a, b) {
    $f4a7ee607ae1ef78$var$N(a);
    b = $f4a7ee607ae1ef78$var$O(a, b);
    return a.g.has(b);
}
$f4a7ee607ae1ef78$var$k.forEach = function(a, b) {
    $f4a7ee607ae1ef78$var$N(this);
    this.g.forEach(function(c, d) {
        c.forEach(function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$f4a7ee607ae1ef78$var$k.ta = function() {
    $f4a7ee607ae1ef78$var$N(this);
    const a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
    for(let d = 0; d < b.length; d++){
        const e = a[d];
        for(let f = 0; f < e.length; f++)c.push(b[d]);
    }
    return c;
};
$f4a7ee607ae1ef78$var$k.Z = function(a) {
    $f4a7ee607ae1ef78$var$N(this);
    let b = [];
    if ("string" === typeof a) $f4a7ee607ae1ef78$var$ad(this, a) && (b = b.concat(this.g.get($f4a7ee607ae1ef78$var$O(this, a))));
    else {
        a = Array.from(this.g.values());
        for(let c = 0; c < a.length; c++)b = b.concat(a[c]);
    }
    return b;
};
$f4a7ee607ae1ef78$var$k.set = function(a, b) {
    $f4a7ee607ae1ef78$var$N(this);
    this.i = null;
    a = $f4a7ee607ae1ef78$var$O(this, a);
    $f4a7ee607ae1ef78$var$ad(this, a) && (this.h -= this.g.get(a).length);
    this.g.set(a, [
        b
    ]);
    this.h += 1;
    return this;
};
$f4a7ee607ae1ef78$var$k.get = function(a, b) {
    if (!a) return b;
    a = this.Z(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $f4a7ee607ae1ef78$var$kc(a, b, c) {
    $f4a7ee607ae1ef78$var$$c(a, b);
    0 < c.length && (a.i = null, a.g.set($f4a7ee607ae1ef78$var$O(a, b), $f4a7ee607ae1ef78$var$ma(c)), a.h += c.length);
}
$f4a7ee607ae1ef78$var$k.toString = function() {
    if (this.i) return this.i;
    if (!this.g) return "";
    const a = [], b = Array.from(this.g.keys());
    for(var c = 0; c < b.length; c++){
        var d = b[c];
        const f = encodeURIComponent(String(d)), h = this.Z(d);
        for(d = 0; d < h.length; d++){
            var e = f;
            "" !== h[d] && (e += "=" + encodeURIComponent(String(h[d])));
            a.push(e);
        }
    }
    return this.i = a.join("&");
};
function $f4a7ee607ae1ef78$var$O(a, b) {
    b = String(b);
    a.j && (b = b.toLowerCase());
    return b;
}
function $f4a7ee607ae1ef78$var$Xc(a, b) {
    b && !a.j && ($f4a7ee607ae1ef78$var$N(a), a.i = null, a.g.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($f4a7ee607ae1ef78$var$$c(this, d), $f4a7ee607ae1ef78$var$kc(this, e, c));
    }, a));
    a.j = b;
}
var $f4a7ee607ae1ef78$var$bd = class {
    constructor(a, b){
        this.g = a;
        this.map = b;
    }
};
function $f4a7ee607ae1ef78$var$cd(a) {
    this.l = a || $f4a7ee607ae1ef78$var$dd;
    $f4a7ee607ae1ef78$var$l.PerformanceNavigationTiming ? (a = $f4a7ee607ae1ef78$var$l.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($f4a7ee607ae1ef78$var$l.g && $f4a7ee607ae1ef78$var$l.g.Ka && $f4a7ee607ae1ef78$var$l.g.Ka() && $f4a7ee607ae1ef78$var$l.g.Ka().ec);
    this.j = a ? this.l : 1;
    this.g = null;
    1 < this.j && (this.g = new Set);
    this.h = null;
    this.i = [];
}
var $f4a7ee607ae1ef78$var$dd = 10;
function $f4a7ee607ae1ef78$var$ed(a) {
    return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
}
function $f4a7ee607ae1ef78$var$Bc(a) {
    return a.h ? 1 : a.g ? a.g.size : 0;
}
function $f4a7ee607ae1ef78$var$xc(a, b) {
    return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
}
function $f4a7ee607ae1ef78$var$Cc(a, b) {
    a.g ? a.g.add(b) : a.h = b;
}
function $f4a7ee607ae1ef78$var$Ec(a, b) {
    a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
}
$f4a7ee607ae1ef78$var$cd.prototype.cancel = function() {
    this.i = $f4a7ee607ae1ef78$var$fd(this);
    if (this.h) this.h.cancel(), this.h = null;
    else if (this.g && 0 !== this.g.size) {
        for (const a of this.g.values())a.cancel();
        this.g.clear();
    }
};
function $f4a7ee607ae1ef78$var$fd(a) {
    if (null != a.h) return a.i.concat(a.h.F);
    if (null != a.g && 0 !== a.g.size) {
        let b = a.i;
        for (const c of a.g.values())b = b.concat(c.F);
        return b;
    }
    return $f4a7ee607ae1ef78$var$ma(a.i);
}
var $f4a7ee607ae1ef78$var$gd = class {
    stringify(a) {
        return $f4a7ee607ae1ef78$var$l.JSON.stringify(a, void 0);
    }
    parse(a) {
        return $f4a7ee607ae1ef78$var$l.JSON.parse(a, void 0);
    }
};
function $f4a7ee607ae1ef78$var$hd() {
    this.g = new $f4a7ee607ae1ef78$var$gd;
}
function $f4a7ee607ae1ef78$var$id(a, b, c) {
    const d = c || "";
    try {
        $f4a7ee607ae1ef78$var$Kc(a, function(e, f) {
            let h = e;
            $f4a7ee607ae1ef78$var$p(e) && (h = $f4a7ee607ae1ef78$var$jb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $f4a7ee607ae1ef78$var$jd(a, b) {
    const c = new $f4a7ee607ae1ef78$var$Gb;
    if ($f4a7ee607ae1ef78$var$l.Image) {
        const d = new Image;
        d.onload = $f4a7ee607ae1ef78$var$ha($f4a7ee607ae1ef78$var$kd, c, d, "TestLoadImage: loaded", !0, b);
        d.onerror = $f4a7ee607ae1ef78$var$ha($f4a7ee607ae1ef78$var$kd, c, d, "TestLoadImage: error", !1, b);
        d.onabort = $f4a7ee607ae1ef78$var$ha($f4a7ee607ae1ef78$var$kd, c, d, "TestLoadImage: abort", !1, b);
        d.ontimeout = $f4a7ee607ae1ef78$var$ha($f4a7ee607ae1ef78$var$kd, c, d, "TestLoadImage: timeout", !1, b);
        $f4a7ee607ae1ef78$var$l.setTimeout(function() {
            if (d.ontimeout) d.ontimeout();
        }, 1E4);
        d.src = a;
    } else b(!1);
}
function $f4a7ee607ae1ef78$var$kd(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
function $f4a7ee607ae1ef78$var$ld(a) {
    this.l = a.fc || null;
    this.j = a.ob || !1;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$ld, $f4a7ee607ae1ef78$var$Ub);
$f4a7ee607ae1ef78$var$ld.prototype.g = function() {
    return new $f4a7ee607ae1ef78$var$md(this.l, this.j);
};
$f4a7ee607ae1ef78$var$ld.prototype.i = function(a) {
    return function() {
        return a;
    };
}({});
function $f4a7ee607ae1ef78$var$md(a, b) {
    $f4a7ee607ae1ef78$var$B.call(this);
    this.F = a;
    this.u = b;
    this.m = void 0;
    this.readyState = $f4a7ee607ae1ef78$var$nd;
    this.status = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.v = new Headers;
    this.h = null;
    this.C = "GET";
    this.B = "";
    this.g = !1;
    this.A = this.j = this.l = null;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$md, $f4a7ee607ae1ef78$var$B);
var $f4a7ee607ae1ef78$var$nd = 0;
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$md.prototype;
$f4a7ee607ae1ef78$var$k.open = function(a, b) {
    if (this.readyState != $f4a7ee607ae1ef78$var$nd) throw this.abort(), Error("Error reopening a connection");
    this.C = a;
    this.B = b;
    this.readyState = 1;
    $f4a7ee607ae1ef78$var$od(this);
};
$f4a7ee607ae1ef78$var$k.send = function(a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    const b = {
        headers: this.v,
        method: this.C,
        credentials: this.m,
        cache: void 0
    };
    a && (b.body = a);
    (this.F || $f4a7ee607ae1ef78$var$l).fetch(new Request(this.B, b)).then(this.$a.bind(this), this.ka.bind(this));
};
$f4a7ee607ae1ef78$var$k.abort = function() {
    this.response = this.responseText = "";
    this.v = new Headers;
    this.status = 0;
    this.j && this.j.cancel("Request was aborted.").catch(()=>{});
    1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, $f4a7ee607ae1ef78$var$pd(this));
    this.readyState = $f4a7ee607ae1ef78$var$nd;
};
$f4a7ee607ae1ef78$var$k.$a = function(a) {
    if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, $f4a7ee607ae1ef78$var$od(this)), this.g && (this.readyState = 3, $f4a7ee607ae1ef78$var$od(this), this.g))) {
        if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Ya.bind(this), this.ka.bind(this));
        else if ("undefined" !== typeof $f4a7ee607ae1ef78$var$l.ReadableStream && "body" in a) {
            this.j = a.body.getReader();
            if (this.u) {
                if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                this.response = [];
            } else this.response = this.responseText = "", this.A = new TextDecoder;
            $f4a7ee607ae1ef78$var$qd(this);
        } else a.text().then(this.Za.bind(this), this.ka.bind(this));
    }
};
function $f4a7ee607ae1ef78$var$qd(a) {
    a.j.read().then(a.Xa.bind(a)).catch(a.ka.bind(a));
}
$f4a7ee607ae1ef78$var$k.Xa = function(a) {
    if (this.g) {
        if (this.u && a.value) this.response.push(a.value);
        else if (!this.u) {
            var b = a.value ? a.value : new Uint8Array(0);
            if (b = this.A.decode(b, {
                stream: !a.done
            })) this.response = this.responseText += b;
        }
        a.done ? $f4a7ee607ae1ef78$var$pd(this) : $f4a7ee607ae1ef78$var$od(this);
        3 == this.readyState && $f4a7ee607ae1ef78$var$qd(this);
    }
};
$f4a7ee607ae1ef78$var$k.Za = function(a) {
    this.g && (this.response = this.responseText = a, $f4a7ee607ae1ef78$var$pd(this));
};
$f4a7ee607ae1ef78$var$k.Ya = function(a) {
    this.g && (this.response = a, $f4a7ee607ae1ef78$var$pd(this));
};
$f4a7ee607ae1ef78$var$k.ka = function() {
    this.g && $f4a7ee607ae1ef78$var$pd(this);
};
function $f4a7ee607ae1ef78$var$pd(a) {
    a.readyState = 4;
    a.l = null;
    a.j = null;
    a.A = null;
    $f4a7ee607ae1ef78$var$od(a);
}
$f4a7ee607ae1ef78$var$k.setRequestHeader = function(a, b) {
    this.v.append(a, b);
};
$f4a7ee607ae1ef78$var$k.getResponseHeader = function(a) {
    return this.h ? this.h.get(a.toLowerCase()) || "" : "";
};
$f4a7ee607ae1ef78$var$k.getAllResponseHeaders = function() {
    if (!this.h) return "";
    const a = [], b = this.h.entries();
    for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    return a.join("\r\n");
};
function $f4a7ee607ae1ef78$var$od(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
}
Object.defineProperty($f4a7ee607ae1ef78$var$md.prototype, "withCredentials", {
    get: function() {
        return "include" === this.m;
    },
    set: function(a) {
        this.m = a ? "include" : "same-origin";
    }
});
var $f4a7ee607ae1ef78$var$rd = $f4a7ee607ae1ef78$var$l.JSON.parse;
function $f4a7ee607ae1ef78$var$P(a) {
    $f4a7ee607ae1ef78$var$B.call(this);
    this.headers = new Map;
    this.u = a || null;
    this.h = !1;
    this.C = this.g = null;
    this.I = "";
    this.m = 0;
    this.j = "";
    this.l = this.G = this.v = this.F = !1;
    this.B = 0;
    this.A = null;
    this.K = $f4a7ee607ae1ef78$var$sd;
    this.L = this.M = !1;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$P, $f4a7ee607ae1ef78$var$B);
var $f4a7ee607ae1ef78$var$sd = "", $f4a7ee607ae1ef78$var$td = /^https?$/i, $f4a7ee607ae1ef78$var$ud = [
    "POST",
    "PUT"
];
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$P.prototype;
$f4a7ee607ae1ef78$var$k.Oa = function(a) {
    this.M = a;
};
$f4a7ee607ae1ef78$var$k.ha = function(a, b, c, d) {
    if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.I + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.I = a;
    this.j = "";
    this.m = 0;
    this.F = !1;
    this.h = !0;
    this.g = this.u ? this.u.g() : $f4a7ee607ae1ef78$var$$b.g();
    this.C = this.u ? $f4a7ee607ae1ef78$var$Vb(this.u) : $f4a7ee607ae1ef78$var$Vb($f4a7ee607ae1ef78$var$$b);
    this.g.onreadystatechange = $f4a7ee607ae1ef78$var$q(this.La, this);
    try {
        this.G = !0, this.g.open(b, String(a), !0), this.G = !1;
    } catch (f) {
        $f4a7ee607ae1ef78$var$vd(this, f);
        return;
    }
    a = c || "";
    c = new Map(this.headers);
    if (d) {
        if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
        else if ("function" === typeof d.keys && "function" === typeof d.get) for (const f of d.keys())c.set(f, d.get(f));
        else throw Error("Unknown input type for opt_headers: " + String(d));
    }
    d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
    e = $f4a7ee607ae1ef78$var$l.FormData && a instanceof $f4a7ee607ae1ef78$var$l.FormData;
    !(0 <= $f4a7ee607ae1ef78$var$ka($f4a7ee607ae1ef78$var$ud, b)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    for (const [f, h] of c)this.g.setRequestHeader(f, h);
    this.K && (this.g.responseType = this.K);
    "withCredentials" in this.g && this.g.withCredentials !== this.M && (this.g.withCredentials = this.M);
    try {
        $f4a7ee607ae1ef78$var$wd(this), 0 < this.B && ((this.L = $f4a7ee607ae1ef78$var$xd(this.g)) ? (this.g.timeout = this.B, this.g.ontimeout = $f4a7ee607ae1ef78$var$q(this.ua, this)) : this.A = $f4a7ee607ae1ef78$var$yb(this.ua, this.B, this)), this.v = !0, this.g.send(a), this.v = !1;
    } catch (f) {
        $f4a7ee607ae1ef78$var$vd(this, f);
    }
};
function $f4a7ee607ae1ef78$var$xd(a) {
    return $f4a7ee607ae1ef78$var$z && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
$f4a7ee607ae1ef78$var$k.ua = function() {
    "undefined" != typeof $f4a7ee607ae1ef78$var$goog && this.g && (this.j = "Timed out after " + this.B + "ms, aborting", this.m = 8, $f4a7ee607ae1ef78$var$C(this, "timeout"), this.abort(8));
};
function $f4a7ee607ae1ef78$var$vd(a, b) {
    a.h = !1;
    a.g && (a.l = !0, a.g.abort(), a.l = !1);
    a.j = b;
    a.m = 5;
    $f4a7ee607ae1ef78$var$yd(a);
    $f4a7ee607ae1ef78$var$zd(a);
}
function $f4a7ee607ae1ef78$var$yd(a) {
    a.F || (a.F = !0, $f4a7ee607ae1ef78$var$C(a, "complete"), $f4a7ee607ae1ef78$var$C(a, "error"));
}
$f4a7ee607ae1ef78$var$k.abort = function(a) {
    this.g && this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1, this.m = a || 7, $f4a7ee607ae1ef78$var$C(this, "complete"), $f4a7ee607ae1ef78$var$C(this, "abort"), $f4a7ee607ae1ef78$var$zd(this));
};
$f4a7ee607ae1ef78$var$k.N = function() {
    this.g && (this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1), $f4a7ee607ae1ef78$var$zd(this, !0));
    $f4a7ee607ae1ef78$var$P.$.N.call(this);
};
$f4a7ee607ae1ef78$var$k.La = function() {
    this.s || (this.G || this.v || this.l ? $f4a7ee607ae1ef78$var$Ad(this) : this.kb());
};
$f4a7ee607ae1ef78$var$k.kb = function() {
    $f4a7ee607ae1ef78$var$Ad(this);
};
function $f4a7ee607ae1ef78$var$Ad(a) {
    if (a.h && "undefined" != typeof $f4a7ee607ae1ef78$var$goog && (!a.C[1] || 4 != $f4a7ee607ae1ef78$var$H(a) || 2 != a.da())) {
        if (a.v && 4 == $f4a7ee607ae1ef78$var$H(a)) $f4a7ee607ae1ef78$var$yb(a.La, 0, a);
        else if ($f4a7ee607ae1ef78$var$C(a, "readystatechange"), 4 == $f4a7ee607ae1ef78$var$H(a)) {
            a.h = !1;
            try {
                const h = a.da();
                a: switch(h){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var b = !0;
                        break a;
                    default:
                        b = !1;
                }
                var c;
                if (!(c = b)) {
                    var d;
                    if (d = 0 === h) {
                        var e = String(a.I).match($f4a7ee607ae1ef78$var$Lc)[1] || null;
                        !e && $f4a7ee607ae1ef78$var$l.self && $f4a7ee607ae1ef78$var$l.self.location && (e = $f4a7ee607ae1ef78$var$l.self.location.protocol.slice(0, -1));
                        d = !$f4a7ee607ae1ef78$var$td.test(e ? e.toLowerCase() : "");
                    }
                    c = d;
                }
                if (c) $f4a7ee607ae1ef78$var$C(a, "complete"), $f4a7ee607ae1ef78$var$C(a, "success");
                else {
                    a.m = 6;
                    try {
                        var f = 2 < $f4a7ee607ae1ef78$var$H(a) ? a.g.statusText : "";
                    } catch (n) {
                        f = "";
                    }
                    a.j = f + " [" + a.da() + "]";
                    $f4a7ee607ae1ef78$var$yd(a);
                }
            } finally{
                $f4a7ee607ae1ef78$var$zd(a);
            }
        }
    }
}
function $f4a7ee607ae1ef78$var$zd(a, b) {
    if (a.g) {
        $f4a7ee607ae1ef78$var$wd(a);
        const c = a.g, d = a.C[0] ? ()=>{} : null;
        a.g = null;
        a.C = null;
        b || $f4a7ee607ae1ef78$var$C(a, "ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $f4a7ee607ae1ef78$var$wd(a) {
    a.g && a.L && (a.g.ontimeout = null);
    a.A && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.A), a.A = null);
}
$f4a7ee607ae1ef78$var$k.isActive = function() {
    return !!this.g;
};
function $f4a7ee607ae1ef78$var$H(a) {
    return a.g ? a.g.readyState : 0;
}
$f4a7ee607ae1ef78$var$k.da = function() {
    try {
        return 2 < $f4a7ee607ae1ef78$var$H(this) ? this.g.status : -1;
    } catch (a) {
        return -1;
    }
};
$f4a7ee607ae1ef78$var$k.ja = function() {
    try {
        return this.g ? this.g.responseText : "";
    } catch (a) {
        return "";
    }
};
$f4a7ee607ae1ef78$var$k.Wa = function(a) {
    if (this.g) {
        var b = this.g.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $f4a7ee607ae1ef78$var$rd(b);
    }
};
function $f4a7ee607ae1ef78$var$mc(a) {
    try {
        if (!a.g) return null;
        if ("response" in a.g) return a.g.response;
        switch(a.K){
            case $f4a7ee607ae1ef78$var$sd:
            case "text":
                return a.g.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
        }
        return null;
    } catch (b) {
        return null;
    }
}
function $f4a7ee607ae1ef78$var$tc(a) {
    const b = {};
    a = (a.g && 2 <= $f4a7ee607ae1ef78$var$H(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
    for(let d = 0; d < a.length; d++){
        if ($f4a7ee607ae1ef78$var$x(a[d])) continue;
        var c = $f4a7ee607ae1ef78$var$qb(a[d]);
        const e = c[0];
        c = c[1];
        if ("string" !== typeof c) continue;
        c = c.trim();
        const f = b[e] || [];
        b[e] = f;
        f.push(c);
    }
    $f4a7ee607ae1ef78$var$Oa(b, function(d) {
        return d.join(", ");
    });
}
$f4a7ee607ae1ef78$var$k.Ia = function() {
    return this.m;
};
$f4a7ee607ae1ef78$var$k.Sa = function() {
    return "string" === typeof this.j ? this.j : String(this.j);
};
function $f4a7ee607ae1ef78$var$Bd(a) {
    let b = "";
    $f4a7ee607ae1ef78$var$Na(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $f4a7ee607ae1ef78$var$Cd(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $f4a7ee607ae1ef78$var$Bd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $f4a7ee607ae1ef78$var$K(a, b, c));
}
function $f4a7ee607ae1ef78$var$Dd(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $f4a7ee607ae1ef78$var$Ed(a) {
    this.Ga = 0;
    this.j = [];
    this.l = new $f4a7ee607ae1ef78$var$Gb;
    this.pa = this.wa = this.I = this.Y = this.g = this.Da = this.F = this.na = this.o = this.U = this.s = null;
    this.fb = this.W = 0;
    this.cb = $f4a7ee607ae1ef78$var$Dd("failFast", !1, a);
    this.G = this.v = this.u = this.m = this.h = null;
    this.aa = !0;
    this.Fa = this.V = -1;
    this.ba = this.A = this.C = 0;
    this.ab = $f4a7ee607ae1ef78$var$Dd("baseRetryDelayMs", 5E3, a);
    this.hb = $f4a7ee607ae1ef78$var$Dd("retryDelaySeedMs", 1E4, a);
    this.eb = $f4a7ee607ae1ef78$var$Dd("forwardChannelMaxRetries", 2, a);
    this.xa = $f4a7ee607ae1ef78$var$Dd("forwardChannelRequestTimeoutMs", 2E4, a);
    this.va = a && a.xmlHttpFactory || void 0;
    this.Ha = a && a.dc || !1;
    this.L = void 0;
    this.J = a && a.supportsCrossDomainXhr || !1;
    this.K = "";
    this.i = new $f4a7ee607ae1ef78$var$cd(a && a.concurrentRequestLimit);
    this.Ja = new $f4a7ee607ae1ef78$var$hd;
    this.P = a && a.fastHandshake || !1;
    this.O = a && a.encodeInitMessageHeaders || !1;
    this.P && this.O && (this.O = !1);
    this.bb = a && a.bc || !1;
    a && a.Ea && this.l.Ea();
    a && a.forceLongPolling && (this.aa = !1);
    this.ca = !this.P && this.aa && a && a.detectBufferingProxy || !1;
    this.qa = void 0;
    a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.qa = a.longPollingTimeout);
    this.oa = void 0;
    this.S = 0;
    this.M = !1;
    this.ma = this.B = null;
}
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$Ed.prototype;
$f4a7ee607ae1ef78$var$k.ra = 8;
$f4a7ee607ae1ef78$var$k.H = 1;
function $f4a7ee607ae1ef78$var$Hc(a) {
    $f4a7ee607ae1ef78$var$Fd(a);
    if (3 == a.H) {
        var b = a.W++, c = $f4a7ee607ae1ef78$var$G(a.I);
        $f4a7ee607ae1ef78$var$K(c, "SID", a.K);
        $f4a7ee607ae1ef78$var$K(c, "RID", b);
        $f4a7ee607ae1ef78$var$K(c, "TYPE", "terminate");
        $f4a7ee607ae1ef78$var$Gd(a, c);
        b = new $f4a7ee607ae1ef78$var$bc(a, a.l, b);
        b.L = 2;
        b.v = $f4a7ee607ae1ef78$var$hc($f4a7ee607ae1ef78$var$G(c));
        c = !1;
        if ($f4a7ee607ae1ef78$var$l.navigator && $f4a7ee607ae1ef78$var$l.navigator.sendBeacon) try {
            c = $f4a7ee607ae1ef78$var$l.navigator.sendBeacon(b.v.toString(), "");
        } catch (d) {}
        !c && $f4a7ee607ae1ef78$var$l.Image && ((new Image).src = b.v, c = !0);
        c || (b.g = $f4a7ee607ae1ef78$var$lc(b.l, null), b.g.ha(b.v));
        b.G = Date.now();
        $f4a7ee607ae1ef78$var$jc(b);
    }
    $f4a7ee607ae1ef78$var$Hd(a);
}
function $f4a7ee607ae1ef78$var$zc(a) {
    a.g && ($f4a7ee607ae1ef78$var$vc(a), a.g.cancel(), a.g = null);
}
function $f4a7ee607ae1ef78$var$Fd(a) {
    $f4a7ee607ae1ef78$var$zc(a);
    a.u && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.u), a.u = null);
    $f4a7ee607ae1ef78$var$yc(a);
    a.i.cancel();
    a.m && ("number" === typeof a.m && $f4a7ee607ae1ef78$var$l.clearTimeout(a.m), a.m = null);
}
function $f4a7ee607ae1ef78$var$Gc(a) {
    if (!$f4a7ee607ae1ef78$var$ed(a.i) && !a.m) {
        a.m = !0;
        var b = a.Na;
        $f4a7ee607ae1ef78$var$sb || $f4a7ee607ae1ef78$var$vb();
        $f4a7ee607ae1ef78$var$tb || ($f4a7ee607ae1ef78$var$sb(), $f4a7ee607ae1ef78$var$tb = !0);
        $f4a7ee607ae1ef78$var$mb.add(b, a);
        a.C = 0;
    }
}
function $f4a7ee607ae1ef78$var$Id(a, b) {
    if ($f4a7ee607ae1ef78$var$Bc(a.i) >= a.i.j - (a.m ? 1 : 0)) return !1;
    if (a.m) return a.j = b.F.concat(a.j), !0;
    if (1 == a.H || 2 == a.H || a.C >= (a.cb ? 0 : a.eb)) return !1;
    a.m = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(a.Na, a, b), $f4a7ee607ae1ef78$var$Jd(a, a.C));
    a.C++;
    return !0;
}
$f4a7ee607ae1ef78$var$k.Na = function(a) {
    if (this.m) {
        if (this.m = null, 1 == this.H) {
            if (!a) {
                this.W = Math.floor(1E5 * Math.random());
                a = this.W++;
                const e = new $f4a7ee607ae1ef78$var$bc(this, this.l, a);
                let f = this.s;
                this.U && (f ? (f = $f4a7ee607ae1ef78$var$Pa(f), $f4a7ee607ae1ef78$var$Ra(f, this.U)) : f = this.U);
                null !== this.o || this.O || (e.I = f, f = null);
                if (this.P) a: {
                    var b = 0;
                    for(var c = 0; c < this.j.length; c++){
                        b: {
                            var d = this.j[c];
                            if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                d = d.length;
                                break b;
                            }
                            d = void 0;
                        }
                        if (void 0 === d) break;
                        b += d;
                        if (4096 < b) {
                            b = c;
                            break a;
                        }
                        if (4096 === b || c === this.j.length - 1) {
                            b = c + 1;
                            break a;
                        }
                    }
                    b = 1E3;
                }
                else b = 1E3;
                b = $f4a7ee607ae1ef78$var$Kd(this, e, b);
                c = $f4a7ee607ae1ef78$var$G(this.I);
                $f4a7ee607ae1ef78$var$K(c, "RID", a);
                $f4a7ee607ae1ef78$var$K(c, "CVER", 22);
                this.F && $f4a7ee607ae1ef78$var$K(c, "X-HTTP-Session-Id", this.F);
                $f4a7ee607ae1ef78$var$Gd(this, c);
                f && (this.O ? b = "headers=" + encodeURIComponent(String($f4a7ee607ae1ef78$var$Bd(f))) + "&" + b : this.o && $f4a7ee607ae1ef78$var$Cd(c, this.o, f));
                $f4a7ee607ae1ef78$var$Cc(this.i, e);
                this.bb && $f4a7ee607ae1ef78$var$K(c, "TYPE", "init");
                this.P ? ($f4a7ee607ae1ef78$var$K(c, "$req", b), $f4a7ee607ae1ef78$var$K(c, "SID", "null"), e.aa = !0, $f4a7ee607ae1ef78$var$gc(e, c, null)) : $f4a7ee607ae1ef78$var$gc(e, c, b);
                this.H = 2;
            }
        } else 3 == this.H && (a ? $f4a7ee607ae1ef78$var$Ld(this, a) : 0 == this.j.length || $f4a7ee607ae1ef78$var$ed(this.i) || $f4a7ee607ae1ef78$var$Ld(this));
    }
};
function $f4a7ee607ae1ef78$var$Ld(a, b) {
    var c;
    b ? c = b.m : c = a.W++;
    const d = $f4a7ee607ae1ef78$var$G(a.I);
    $f4a7ee607ae1ef78$var$K(d, "SID", a.K);
    $f4a7ee607ae1ef78$var$K(d, "RID", c);
    $f4a7ee607ae1ef78$var$K(d, "AID", a.V);
    $f4a7ee607ae1ef78$var$Gd(a, d);
    a.o && a.s && $f4a7ee607ae1ef78$var$Cd(d, a.o, a.s);
    c = new $f4a7ee607ae1ef78$var$bc(a, a.l, c, a.C + 1);
    null === a.o && (c.I = a.s);
    b && (a.j = b.F.concat(a.j));
    b = $f4a7ee607ae1ef78$var$Kd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.xa) + Math.round(.5 * a.xa * Math.random()));
    $f4a7ee607ae1ef78$var$Cc(a.i, c);
    $f4a7ee607ae1ef78$var$gc(c, d, b);
}
function $f4a7ee607ae1ef78$var$Gd(a, b) {
    a.na && $f4a7ee607ae1ef78$var$Na(a.na, function(c, d) {
        $f4a7ee607ae1ef78$var$K(b, d, c);
    });
    a.h && $f4a7ee607ae1ef78$var$Kc({}, function(c, d) {
        $f4a7ee607ae1ef78$var$K(b, d, c);
    });
}
function $f4a7ee607ae1ef78$var$Kd(a, b, c) {
    c = Math.min(a.j.length, c);
    var d = a.h ? $f4a7ee607ae1ef78$var$q(a.h.Va, a.h, a) : null;
    a: {
        var e = a.j;
        let f = -1;
        for(;;){
            const h = [
                "count=" + c
            ];
            -1 == f ? 0 < c ? (f = e[0].g, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
            let n = !0;
            for(let t = 0; t < c; t++){
                let m = e[t].g;
                const u = e[t].map;
                m -= f;
                if (0 > m) f = Math.max(0, e[t].g - 100), n = !1;
                else try {
                    $f4a7ee607ae1ef78$var$id(u, h, "req" + m + "_");
                } catch (L) {
                    d && d(u);
                }
            }
            if (n) {
                d = h.join("&");
                break a;
            }
        }
    }
    a = a.j.splice(0, c);
    b.F = a;
    return d;
}
function $f4a7ee607ae1ef78$var$Fc(a) {
    if (!a.g && !a.u) {
        a.ba = 1;
        var b = a.Ma;
        $f4a7ee607ae1ef78$var$sb || $f4a7ee607ae1ef78$var$vb();
        $f4a7ee607ae1ef78$var$tb || ($f4a7ee607ae1ef78$var$sb(), $f4a7ee607ae1ef78$var$tb = !0);
        $f4a7ee607ae1ef78$var$mb.add(b, a);
        a.A = 0;
    }
}
function $f4a7ee607ae1ef78$var$Ac(a) {
    if (a.g || a.u || 3 <= a.A) return !1;
    a.ba++;
    a.u = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(a.Ma, a), $f4a7ee607ae1ef78$var$Jd(a, a.A));
    a.A++;
    return !0;
}
$f4a7ee607ae1ef78$var$k.Ma = function() {
    this.u = null;
    $f4a7ee607ae1ef78$var$Md(this);
    if (this.ca && !(this.M || null == this.g || 0 >= this.S)) {
        var a = 2 * this.S;
        this.l.info("BP detection timer enabled: " + a);
        this.B = $f4a7ee607ae1ef78$var$Rb($f4a7ee607ae1ef78$var$q(this.jb, this), a);
    }
};
$f4a7ee607ae1ef78$var$k.jb = function() {
    this.B && (this.B = null, this.l.info("BP detection timeout reached."), this.l.info("Buffering proxy detected and switch to long-polling!"), this.G = !1, this.M = !0, $f4a7ee607ae1ef78$var$F(10), $f4a7ee607ae1ef78$var$zc(this), $f4a7ee607ae1ef78$var$Md(this));
};
function $f4a7ee607ae1ef78$var$vc(a) {
    null != a.B && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.B), a.B = null);
}
function $f4a7ee607ae1ef78$var$Md(a) {
    a.g = new $f4a7ee607ae1ef78$var$bc(a, a.l, "rpc", a.ba);
    null === a.o && (a.g.I = a.s);
    a.g.O = 0;
    var b = $f4a7ee607ae1ef78$var$G(a.wa);
    $f4a7ee607ae1ef78$var$K(b, "RID", "rpc");
    $f4a7ee607ae1ef78$var$K(b, "SID", a.K);
    $f4a7ee607ae1ef78$var$K(b, "AID", a.V);
    $f4a7ee607ae1ef78$var$K(b, "CI", a.G ? "0" : "1");
    !a.G && a.qa && $f4a7ee607ae1ef78$var$K(b, "TO", a.qa);
    $f4a7ee607ae1ef78$var$K(b, "TYPE", "xmlhttp");
    $f4a7ee607ae1ef78$var$Gd(a, b);
    a.o && a.s && $f4a7ee607ae1ef78$var$Cd(b, a.o, a.s);
    a.L && a.g.setTimeout(a.L);
    var c = a.g;
    a = a.pa;
    c.L = 1;
    c.v = $f4a7ee607ae1ef78$var$hc($f4a7ee607ae1ef78$var$G(b));
    c.s = null;
    c.S = !0;
    $f4a7ee607ae1ef78$var$ic(c, a);
}
$f4a7ee607ae1ef78$var$k.ib = function() {
    null != this.v && (this.v = null, $f4a7ee607ae1ef78$var$zc(this), $f4a7ee607ae1ef78$var$Ac(this), $f4a7ee607ae1ef78$var$F(19));
};
function $f4a7ee607ae1ef78$var$yc(a) {
    null != a.v && ($f4a7ee607ae1ef78$var$l.clearTimeout(a.v), a.v = null);
}
function $f4a7ee607ae1ef78$var$sc(a, b) {
    var c = null;
    if (a.g == b) {
        $f4a7ee607ae1ef78$var$yc(a);
        $f4a7ee607ae1ef78$var$vc(a);
        a.g = null;
        var d = 2;
    } else if ($f4a7ee607ae1ef78$var$xc(a.i, b)) c = b.F, $f4a7ee607ae1ef78$var$Ec(a.i, b), d = 1;
    else return;
    if (0 != a.H) {
        if (b.i) {
            if (1 == d) {
                c = b.s ? b.s.length : 0;
                b = Date.now() - b.G;
                var e = a.C;
                d = $f4a7ee607ae1ef78$var$Mb();
                $f4a7ee607ae1ef78$var$C(d, new $f4a7ee607ae1ef78$var$Qb(d, c));
                $f4a7ee607ae1ef78$var$Gc(a);
            } else $f4a7ee607ae1ef78$var$Fc(a);
        } else if (e = b.o, 3 == e || 0 == e && 0 < b.ca || !(1 == d && $f4a7ee607ae1ef78$var$Id(a, b) || 2 == d && $f4a7ee607ae1ef78$var$Ac(a))) switch(c && 0 < c.length && (b = a.i, b.i = b.i.concat(c)), e){
            case 1:
                $f4a7ee607ae1ef78$var$J(a, 5);
                break;
            case 4:
                $f4a7ee607ae1ef78$var$J(a, 10);
                break;
            case 3:
                $f4a7ee607ae1ef78$var$J(a, 6);
                break;
            default:
                $f4a7ee607ae1ef78$var$J(a, 2);
        }
    }
}
function $f4a7ee607ae1ef78$var$Jd(a, b) {
    let c = a.ab + Math.floor(Math.random() * a.hb);
    a.isActive() || (c *= 2);
    return c * b;
}
function $f4a7ee607ae1ef78$var$J(a, b) {
    a.l.info("Error code " + b);
    if (2 == b) {
        var c = null;
        a.h && (c = null);
        var d = $f4a7ee607ae1ef78$var$q(a.pb, a);
        c || (c = new $f4a7ee607ae1ef78$var$M("//www.google.com/images/cleardot.gif"), $f4a7ee607ae1ef78$var$l.location && "http" == $f4a7ee607ae1ef78$var$l.location.protocol || $f4a7ee607ae1ef78$var$Nc(c, "https"), $f4a7ee607ae1ef78$var$hc(c));
        $f4a7ee607ae1ef78$var$jd(c.toString(), d);
    } else $f4a7ee607ae1ef78$var$F(2);
    a.H = 0;
    a.h && a.h.za(b);
    $f4a7ee607ae1ef78$var$Hd(a);
    $f4a7ee607ae1ef78$var$Fd(a);
}
$f4a7ee607ae1ef78$var$k.pb = function(a) {
    a ? (this.l.info("Successfully pinged google.com"), $f4a7ee607ae1ef78$var$F(2)) : (this.l.info("Failed to ping google.com"), $f4a7ee607ae1ef78$var$F(1));
};
function $f4a7ee607ae1ef78$var$Hd(a) {
    a.H = 0;
    a.ma = [];
    if (a.h) {
        const b = $f4a7ee607ae1ef78$var$fd(a.i);
        if (0 != b.length || 0 != a.j.length) $f4a7ee607ae1ef78$var$na(a.ma, b), $f4a7ee607ae1ef78$var$na(a.ma, a.j), a.i.i.length = 0, $f4a7ee607ae1ef78$var$ma(a.j), a.j.length = 0;
        a.h.ya();
    }
}
function $f4a7ee607ae1ef78$var$Dc(a, b, c) {
    var d = c instanceof $f4a7ee607ae1ef78$var$M ? $f4a7ee607ae1ef78$var$G(c) : new $f4a7ee607ae1ef78$var$M(c);
    if ("" != d.g) b && (d.g = b + "." + d.g), $f4a7ee607ae1ef78$var$Oc(d, d.m);
    else {
        var e = $f4a7ee607ae1ef78$var$l.location;
        d = e.protocol;
        b = b ? b + "." + e.hostname : e.hostname;
        e = +e.port;
        var f = new $f4a7ee607ae1ef78$var$M(null);
        d && $f4a7ee607ae1ef78$var$Nc(f, d);
        b && (f.g = b);
        e && $f4a7ee607ae1ef78$var$Oc(f, e);
        c && (f.l = c);
        d = f;
    }
    c = a.F;
    b = a.Da;
    c && b && $f4a7ee607ae1ef78$var$K(d, c, b);
    $f4a7ee607ae1ef78$var$K(d, "VER", a.ra);
    $f4a7ee607ae1ef78$var$Gd(a, d);
    return d;
}
function $f4a7ee607ae1ef78$var$lc(a, b, c) {
    if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
    b = c && a.Ha && !a.va ? new $f4a7ee607ae1ef78$var$P(new $f4a7ee607ae1ef78$var$ld({
        ob: !0
    })) : new $f4a7ee607ae1ef78$var$P(a.va);
    b.Oa(a.J);
    return b;
}
$f4a7ee607ae1ef78$var$k.isActive = function() {
    return !!this.h && this.h.isActive(this);
};
function $f4a7ee607ae1ef78$var$Nd() {}
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$Nd.prototype;
$f4a7ee607ae1ef78$var$k.Ba = function() {};
$f4a7ee607ae1ef78$var$k.Aa = function() {};
$f4a7ee607ae1ef78$var$k.za = function() {};
$f4a7ee607ae1ef78$var$k.ya = function() {};
$f4a7ee607ae1ef78$var$k.isActive = function() {
    return !0;
};
$f4a7ee607ae1ef78$var$k.Va = function() {};
function $f4a7ee607ae1ef78$var$Od() {
    if ($f4a7ee607ae1ef78$var$z && !(10 <= Number($f4a7ee607ae1ef78$var$Fa))) throw Error("Environmental error: no available transport.");
}
$f4a7ee607ae1ef78$var$Od.prototype.g = function(a, b) {
    return new $f4a7ee607ae1ef78$var$Q(a, b);
};
function $f4a7ee607ae1ef78$var$Q(a, b) {
    $f4a7ee607ae1ef78$var$B.call(this);
    this.g = new $f4a7ee607ae1ef78$var$Ed(b);
    this.l = a;
    this.h = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.g.s = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.Ca && (a ? a["X-WebChannel-Client-Profile"] = b.Ca : a = {
        "X-WebChannel-Client-Profile": b.Ca
    });
    this.g.U = a;
    (a = b && b.cc) && !$f4a7ee607ae1ef78$var$x(a) && (this.g.o = a);
    this.A = b && b.supportsCrossDomainXhr || !1;
    this.v = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$f4a7ee607ae1ef78$var$x(b) && (this.g.F = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
    this.j = new $f4a7ee607ae1ef78$var$R(this);
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Q, $f4a7ee607ae1ef78$var$B);
$f4a7ee607ae1ef78$var$Q.prototype.m = function() {
    this.g.h = this.j;
    this.A && (this.g.J = !0);
    var a = this.g, b = this.l, c = this.h || void 0;
    $f4a7ee607ae1ef78$var$F(0);
    a.Y = b;
    a.na = c || {};
    a.G = a.aa;
    a.I = $f4a7ee607ae1ef78$var$Dc(a, null, a.Y);
    $f4a7ee607ae1ef78$var$Gc(a);
};
$f4a7ee607ae1ef78$var$Q.prototype.close = function() {
    $f4a7ee607ae1ef78$var$Hc(this.g);
};
$f4a7ee607ae1ef78$var$Q.prototype.u = function(a) {
    var b = this.g;
    if ("string" === typeof a) {
        var c = {};
        c.__data__ = a;
        a = c;
    } else this.v && (c = {}, c.__data__ = $f4a7ee607ae1ef78$var$jb(a), a = c);
    b.j.push(new $f4a7ee607ae1ef78$var$bd(b.fb++, a));
    3 == b.H && $f4a7ee607ae1ef78$var$Gc(b);
};
$f4a7ee607ae1ef78$var$Q.prototype.N = function() {
    this.g.h = null;
    delete this.j;
    $f4a7ee607ae1ef78$var$Hc(this.g);
    delete this.g;
    $f4a7ee607ae1ef78$var$Q.$.N.call(this);
};
function $f4a7ee607ae1ef78$var$Pd(a) {
    $f4a7ee607ae1ef78$var$Yb.call(this);
    a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
    var b = a.__sm__;
    if (b) {
        a: {
            for(const c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
        this.data = b;
    } else this.data = a;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Pd, $f4a7ee607ae1ef78$var$Yb);
function $f4a7ee607ae1ef78$var$Qd() {
    $f4a7ee607ae1ef78$var$Zb.call(this);
    this.status = 1;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$Qd, $f4a7ee607ae1ef78$var$Zb);
function $f4a7ee607ae1ef78$var$R(a) {
    this.g = a;
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$R, $f4a7ee607ae1ef78$var$Nd);
$f4a7ee607ae1ef78$var$R.prototype.Ba = function() {
    $f4a7ee607ae1ef78$var$C(this.g, "a");
};
$f4a7ee607ae1ef78$var$R.prototype.Aa = function(a) {
    $f4a7ee607ae1ef78$var$C(this.g, new $f4a7ee607ae1ef78$var$Pd(a));
};
$f4a7ee607ae1ef78$var$R.prototype.za = function(a) {
    $f4a7ee607ae1ef78$var$C(this.g, new $f4a7ee607ae1ef78$var$Qd());
};
$f4a7ee607ae1ef78$var$R.prototype.ya = function() {
    $f4a7ee607ae1ef78$var$C(this.g, "b");
};
function $f4a7ee607ae1ef78$var$Rd() {
    this.blockSize = -1;
}
function $f4a7ee607ae1ef78$var$S() {
    this.blockSize = -1;
    this.blockSize = 64;
    this.g = Array(4);
    this.m = Array(this.blockSize);
    this.i = this.h = 0;
    this.reset();
}
$f4a7ee607ae1ef78$var$r($f4a7ee607ae1ef78$var$S, $f4a7ee607ae1ef78$var$Rd);
$f4a7ee607ae1ef78$var$S.prototype.reset = function() {
    this.g[0] = 1732584193;
    this.g[1] = 4023233417;
    this.g[2] = 2562383102;
    this.g[3] = 271733878;
    this.i = this.h = 0;
};
function $f4a7ee607ae1ef78$var$Sd(a, b, c) {
    c || (c = 0);
    var d = Array(16);
    if ("string" === typeof b) for(var e = 0; 16 > e; ++e)d[e] = b.charCodeAt(c++) | b.charCodeAt(c++) << 8 | b.charCodeAt(c++) << 16 | b.charCodeAt(c++) << 24;
    else for(e = 0; 16 > e; ++e)d[e] = b[c++] | b[c++] << 8 | b[c++] << 16 | b[c++] << 24;
    b = a.g[0];
    c = a.g[1];
    e = a.g[2];
    var f = a.g[3];
    var h = b + (f ^ c & (e ^ f)) + d[0] + 3614090360 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[1] + 3905402710 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[2] + 606105819 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[3] + 3250441966 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[4] + 4118548399 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[5] + 1200080426 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[6] + 2821735955 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[7] + 4249261313 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[8] + 1770035416 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[9] + 2336552879 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[10] + 4294925233 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[11] + 2304563134 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[12] + 1804603682 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[13] + 4254626195 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[14] + 2792965006 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[15] + 1236535329 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (e ^ f & (c ^ e)) + d[1] + 4129170786 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[6] + 3225465664 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[11] + 643717713 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[0] + 3921069994 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[5] + 3593408605 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[10] + 38016083 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[15] + 3634488961 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[4] + 3889429448 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[9] + 568446438 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[14] + 3275163606 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[3] + 4107603335 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[8] + 1163531501 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[13] + 2850285829 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[2] + 4243563512 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[7] + 1735328473 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[12] + 2368359562 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (c ^ e ^ f) + d[5] + 4294588738 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[8] + 2272392833 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[11] + 1839030562 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[14] + 4259657740 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[1] + 2763975236 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[4] + 1272893353 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[7] + 4139469664 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[10] + 3200236656 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[13] + 681279174 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[0] + 3936430074 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[3] + 3572445317 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[6] + 76029189 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[9] + 3654602809 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[12] + 3873151461 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[15] + 530742520 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[2] + 3299628645 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (e ^ (c | ~f)) + d[0] + 4096336452 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[7] + 1126891415 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[14] + 2878612391 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[5] + 4237533241 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[12] + 1700485571 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[3] + 2399980690 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[10] + 4293915773 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[1] + 2240044497 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[8] + 1873313359 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[15] + 4264355552 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[6] + 2734768916 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[13] + 1309151649 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[4] + 4149444226 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[11] + 3174756917 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[2] + 718787259 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[9] + 3951481745 & 4294967295;
    a.g[0] = a.g[0] + b & 4294967295;
    a.g[1] = a.g[1] + (e + (h << 21 & 4294967295 | h >>> 11)) & 4294967295;
    a.g[2] = a.g[2] + e & 4294967295;
    a.g[3] = a.g[3] + f & 4294967295;
}
$f4a7ee607ae1ef78$var$S.prototype.j = function(a, b) {
    void 0 === b && (b = a.length);
    for(var c = b - this.blockSize, d = this.m, e = this.h, f = 0; f < b;){
        if (0 == e) for(; f <= c;)$f4a7ee607ae1ef78$var$Sd(this, a, f), f += this.blockSize;
        if ("string" === typeof a) {
            for(; f < b;)if (d[e++] = a.charCodeAt(f++), e == this.blockSize) {
                $f4a7ee607ae1ef78$var$Sd(this, d);
                e = 0;
                break;
            }
        } else for(; f < b;)if (d[e++] = a[f++], e == this.blockSize) {
            $f4a7ee607ae1ef78$var$Sd(this, d);
            e = 0;
            break;
        }
    }
    this.h = e;
    this.i += b;
};
$f4a7ee607ae1ef78$var$S.prototype.l = function() {
    var a = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
    a[0] = 128;
    for(var b = 1; b < a.length - 8; ++b)a[b] = 0;
    var c = 8 * this.i;
    for(b = a.length - 8; b < a.length; ++b)a[b] = c & 255, c /= 256;
    this.j(a);
    a = Array(16);
    for(b = c = 0; 4 > b; ++b)for(var d = 0; 32 > d; d += 8)a[c++] = this.g[b] >>> d & 255;
    return a;
};
function $f4a7ee607ae1ef78$var$T(a, b) {
    this.h = b;
    for(var c = [], d = !0, e = a.length - 1; 0 <= e; e--){
        var f = a[e] | 0;
        d && f == b || (c[e] = f, d = !1);
    }
    this.g = c;
}
var $f4a7ee607ae1ef78$var$sa = {};
function $f4a7ee607ae1ef78$var$Td(a) {
    return -128 <= a && 128 > a ? $f4a7ee607ae1ef78$var$ra(a, function(b) {
        return new $f4a7ee607ae1ef78$var$T([
            b | 0
        ], 0 > b ? -1 : 0);
    }) : new $f4a7ee607ae1ef78$var$T([
        a | 0
    ], 0 > a ? -1 : 0);
}
function $f4a7ee607ae1ef78$var$U(a) {
    if (isNaN(a) || !isFinite(a)) return $f4a7ee607ae1ef78$var$V;
    if (0 > a) return $f4a7ee607ae1ef78$var$W($f4a7ee607ae1ef78$var$U(-a));
    for(var b = [], c = 1, d = 0; a >= c; d++)b[d] = a / c | 0, c *= $f4a7ee607ae1ef78$var$Ud;
    return new $f4a7ee607ae1ef78$var$T(b, 0);
}
function $f4a7ee607ae1ef78$var$Vd(a, b) {
    if (0 == a.length) throw Error("number format error: empty string");
    b = b || 10;
    if (2 > b || 36 < b) throw Error("radix out of range: " + b);
    if ("-" == a.charAt(0)) return $f4a7ee607ae1ef78$var$W($f4a7ee607ae1ef78$var$Vd(a.substring(1), b));
    if (0 <= a.indexOf("-")) throw Error('number format error: interior "-" character');
    for(var c = $f4a7ee607ae1ef78$var$U(Math.pow(b, 8)), d = $f4a7ee607ae1ef78$var$V, e = 0; e < a.length; e += 8){
        var f = Math.min(8, a.length - e), h = parseInt(a.substring(e, e + f), b);
        8 > f ? (f = $f4a7ee607ae1ef78$var$U(Math.pow(b, f)), d = d.R(f).add($f4a7ee607ae1ef78$var$U(h))) : (d = d.R(c), d = d.add($f4a7ee607ae1ef78$var$U(h)));
    }
    return d;
}
var $f4a7ee607ae1ef78$var$Ud = 4294967296, $f4a7ee607ae1ef78$var$V = $f4a7ee607ae1ef78$var$Td(0), $f4a7ee607ae1ef78$var$Wd = $f4a7ee607ae1ef78$var$Td(1), $f4a7ee607ae1ef78$var$Xd = $f4a7ee607ae1ef78$var$Td(16777216);
$f4a7ee607ae1ef78$var$k = $f4a7ee607ae1ef78$var$T.prototype;
$f4a7ee607ae1ef78$var$k.ea = function() {
    if ($f4a7ee607ae1ef78$var$X(this)) return -$f4a7ee607ae1ef78$var$W(this).ea();
    for(var a = 0, b = 1, c = 0; c < this.g.length; c++){
        var d = this.D(c);
        a += (0 <= d ? d : $f4a7ee607ae1ef78$var$Ud + d) * b;
        b *= $f4a7ee607ae1ef78$var$Ud;
    }
    return a;
};
$f4a7ee607ae1ef78$var$k.toString = function(a) {
    a = a || 10;
    if (2 > a || 36 < a) throw Error("radix out of range: " + a);
    if ($f4a7ee607ae1ef78$var$Y(this)) return "0";
    if ($f4a7ee607ae1ef78$var$X(this)) return "-" + $f4a7ee607ae1ef78$var$W(this).toString(a);
    for(var b = $f4a7ee607ae1ef78$var$U(Math.pow(a, 6)), c = this, d = "";;){
        var e = $f4a7ee607ae1ef78$var$Yd(c, b).g;
        c = $f4a7ee607ae1ef78$var$Zd(c, e.R(b));
        var f = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(a);
        c = e;
        if ($f4a7ee607ae1ef78$var$Y(c)) return f + d;
        for(; 6 > f.length;)f = "0" + f;
        d = f + d;
    }
};
$f4a7ee607ae1ef78$var$k.D = function(a) {
    return 0 > a ? 0 : a < this.g.length ? this.g[a] : this.h;
};
function $f4a7ee607ae1ef78$var$Y(a) {
    if (0 != a.h) return !1;
    for(var b = 0; b < a.g.length; b++)if (0 != a.g[b]) return !1;
    return !0;
}
function $f4a7ee607ae1ef78$var$X(a) {
    return -1 == a.h;
}
$f4a7ee607ae1ef78$var$k.X = function(a) {
    a = $f4a7ee607ae1ef78$var$Zd(this, a);
    return $f4a7ee607ae1ef78$var$X(a) ? -1 : $f4a7ee607ae1ef78$var$Y(a) ? 0 : 1;
};
function $f4a7ee607ae1ef78$var$W(a) {
    for(var b = a.g.length, c = [], d = 0; d < b; d++)c[d] = ~a.g[d];
    return new $f4a7ee607ae1ef78$var$T(c, ~a.h).add($f4a7ee607ae1ef78$var$Wd);
}
$f4a7ee607ae1ef78$var$k.abs = function() {
    return $f4a7ee607ae1ef78$var$X(this) ? $f4a7ee607ae1ef78$var$W(this) : this;
};
$f4a7ee607ae1ef78$var$k.add = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0, e = 0; e <= b; e++){
        var f = d + (this.D(e) & 65535) + (a.D(e) & 65535), h = (f >>> 16) + (this.D(e) >>> 16) + (a.D(e) >>> 16);
        d = h >>> 16;
        f &= 65535;
        h &= 65535;
        c[e] = h << 16 | f;
    }
    return new $f4a7ee607ae1ef78$var$T(c, c[c.length - 1] & -2147483648 ? -1 : 0);
};
function $f4a7ee607ae1ef78$var$Zd(a, b) {
    return a.add($f4a7ee607ae1ef78$var$W(b));
}
$f4a7ee607ae1ef78$var$k.R = function(a) {
    if ($f4a7ee607ae1ef78$var$Y(this) || $f4a7ee607ae1ef78$var$Y(a)) return $f4a7ee607ae1ef78$var$V;
    if ($f4a7ee607ae1ef78$var$X(this)) return $f4a7ee607ae1ef78$var$X(a) ? $f4a7ee607ae1ef78$var$W(this).R($f4a7ee607ae1ef78$var$W(a)) : $f4a7ee607ae1ef78$var$W($f4a7ee607ae1ef78$var$W(this).R(a));
    if ($f4a7ee607ae1ef78$var$X(a)) return $f4a7ee607ae1ef78$var$W(this.R($f4a7ee607ae1ef78$var$W(a)));
    if (0 > this.X($f4a7ee607ae1ef78$var$Xd) && 0 > a.X($f4a7ee607ae1ef78$var$Xd)) return $f4a7ee607ae1ef78$var$U(this.ea() * a.ea());
    for(var b = this.g.length + a.g.length, c = [], d = 0; d < 2 * b; d++)c[d] = 0;
    for(d = 0; d < this.g.length; d++)for(var e = 0; e < a.g.length; e++){
        var f = this.D(d) >>> 16, h = this.D(d) & 65535, n = a.D(e) >>> 16, t = a.D(e) & 65535;
        c[2 * d + 2 * e] += h * t;
        $f4a7ee607ae1ef78$var$$d(c, 2 * d + 2 * e);
        c[2 * d + 2 * e + 1] += f * t;
        $f4a7ee607ae1ef78$var$$d(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 1] += h * n;
        $f4a7ee607ae1ef78$var$$d(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 2] += f * n;
        $f4a7ee607ae1ef78$var$$d(c, 2 * d + 2 * e + 2);
    }
    for(d = 0; d < b; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
    for(d = b; d < 2 * b; d++)c[d] = 0;
    return new $f4a7ee607ae1ef78$var$T(c, 0);
};
function $f4a7ee607ae1ef78$var$$d(a, b) {
    for(; (a[b] & 65535) != a[b];)a[b + 1] += a[b] >>> 16, a[b] &= 65535, b++;
}
function $f4a7ee607ae1ef78$var$ae(a, b) {
    this.g = a;
    this.h = b;
}
function $f4a7ee607ae1ef78$var$Yd(a, b) {
    if ($f4a7ee607ae1ef78$var$Y(b)) throw Error("division by zero");
    if ($f4a7ee607ae1ef78$var$Y(a)) return new $f4a7ee607ae1ef78$var$ae($f4a7ee607ae1ef78$var$V, $f4a7ee607ae1ef78$var$V);
    if ($f4a7ee607ae1ef78$var$X(a)) return b = $f4a7ee607ae1ef78$var$Yd($f4a7ee607ae1ef78$var$W(a), b), new $f4a7ee607ae1ef78$var$ae($f4a7ee607ae1ef78$var$W(b.g), $f4a7ee607ae1ef78$var$W(b.h));
    if ($f4a7ee607ae1ef78$var$X(b)) return b = $f4a7ee607ae1ef78$var$Yd(a, $f4a7ee607ae1ef78$var$W(b)), new $f4a7ee607ae1ef78$var$ae($f4a7ee607ae1ef78$var$W(b.g), b.h);
    if (30 < a.g.length) {
        if ($f4a7ee607ae1ef78$var$X(a) || $f4a7ee607ae1ef78$var$X(b)) throw Error("slowDivide_ only works with positive integers.");
        for(var c = $f4a7ee607ae1ef78$var$Wd, d = b; 0 >= d.X(a);)c = $f4a7ee607ae1ef78$var$be(c), d = $f4a7ee607ae1ef78$var$be(d);
        var e = $f4a7ee607ae1ef78$var$Z(c, 1), f = $f4a7ee607ae1ef78$var$Z(d, 1);
        d = $f4a7ee607ae1ef78$var$Z(d, 2);
        for(c = $f4a7ee607ae1ef78$var$Z(c, 2); !$f4a7ee607ae1ef78$var$Y(d);){
            var h = f.add(d);
            0 >= h.X(a) && (e = e.add(c), f = h);
            d = $f4a7ee607ae1ef78$var$Z(d, 1);
            c = $f4a7ee607ae1ef78$var$Z(c, 1);
        }
        b = $f4a7ee607ae1ef78$var$Zd(a, e.R(b));
        return new $f4a7ee607ae1ef78$var$ae(e, b);
    }
    for(e = $f4a7ee607ae1ef78$var$V; 0 <= a.X(b);){
        c = Math.max(1, Math.floor(a.ea() / b.ea()));
        d = Math.ceil(Math.log(c) / Math.LN2);
        d = 48 >= d ? 1 : Math.pow(2, d - 48);
        f = $f4a7ee607ae1ef78$var$U(c);
        for(h = f.R(b); $f4a7ee607ae1ef78$var$X(h) || 0 < h.X(a);)c -= d, f = $f4a7ee607ae1ef78$var$U(c), h = f.R(b);
        $f4a7ee607ae1ef78$var$Y(f) && (f = $f4a7ee607ae1ef78$var$Wd);
        e = e.add(f);
        a = $f4a7ee607ae1ef78$var$Zd(a, h);
    }
    return new $f4a7ee607ae1ef78$var$ae(e, a);
}
$f4a7ee607ae1ef78$var$k.gb = function(a) {
    return $f4a7ee607ae1ef78$var$Yd(this, a).h;
};
$f4a7ee607ae1ef78$var$k.and = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) & a.D(d);
    return new $f4a7ee607ae1ef78$var$T(c, this.h & a.h);
};
$f4a7ee607ae1ef78$var$k.or = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) | a.D(d);
    return new $f4a7ee607ae1ef78$var$T(c, this.h | a.h);
};
$f4a7ee607ae1ef78$var$k.xor = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) ^ a.D(d);
    return new $f4a7ee607ae1ef78$var$T(c, this.h ^ a.h);
};
function $f4a7ee607ae1ef78$var$be(a) {
    for(var b = a.g.length + 1, c = [], d = 0; d < b; d++)c[d] = a.D(d) << 1 | a.D(d - 1) >>> 31;
    return new $f4a7ee607ae1ef78$var$T(c, a.h);
}
function $f4a7ee607ae1ef78$var$Z(a, b) {
    var c = b >> 5;
    b %= 32;
    for(var d = a.g.length - c, e = [], f = 0; f < d; f++)e[f] = 0 < b ? a.D(f + c) >>> b | a.D(f + c + 1) << 32 - b : a.D(f + c);
    return new $f4a7ee607ae1ef78$var$T(e, a.h);
}
$f4a7ee607ae1ef78$var$Od.prototype.createWebChannel = $f4a7ee607ae1ef78$var$Od.prototype.g;
$f4a7ee607ae1ef78$var$Q.prototype.send = $f4a7ee607ae1ef78$var$Q.prototype.u;
$f4a7ee607ae1ef78$var$Q.prototype.open = $f4a7ee607ae1ef78$var$Q.prototype.m;
$f4a7ee607ae1ef78$var$Q.prototype.close = $f4a7ee607ae1ef78$var$Q.prototype.close;
$f4a7ee607ae1ef78$var$Sb.NO_ERROR = 0;
$f4a7ee607ae1ef78$var$Sb.TIMEOUT = 8;
$f4a7ee607ae1ef78$var$Sb.HTTP_ERROR = 6;
$f4a7ee607ae1ef78$var$Tb.COMPLETE = "complete";
$f4a7ee607ae1ef78$var$Wb.EventType = $f4a7ee607ae1ef78$var$Xb;
$f4a7ee607ae1ef78$var$Xb.OPEN = "a";
$f4a7ee607ae1ef78$var$Xb.CLOSE = "b";
$f4a7ee607ae1ef78$var$Xb.ERROR = "c";
$f4a7ee607ae1ef78$var$Xb.MESSAGE = "d";
$f4a7ee607ae1ef78$var$B.prototype.listen = $f4a7ee607ae1ef78$var$B.prototype.O;
$f4a7ee607ae1ef78$var$P.prototype.listenOnce = $f4a7ee607ae1ef78$var$P.prototype.P;
$f4a7ee607ae1ef78$var$P.prototype.getLastError = $f4a7ee607ae1ef78$var$P.prototype.Sa;
$f4a7ee607ae1ef78$var$P.prototype.getLastErrorCode = $f4a7ee607ae1ef78$var$P.prototype.Ia;
$f4a7ee607ae1ef78$var$P.prototype.getStatus = $f4a7ee607ae1ef78$var$P.prototype.da;
$f4a7ee607ae1ef78$var$P.prototype.getResponseJson = $f4a7ee607ae1ef78$var$P.prototype.Wa;
$f4a7ee607ae1ef78$var$P.prototype.getResponseText = $f4a7ee607ae1ef78$var$P.prototype.ja;
$f4a7ee607ae1ef78$var$P.prototype.send = $f4a7ee607ae1ef78$var$P.prototype.ha;
$f4a7ee607ae1ef78$var$P.prototype.setWithCredentials = $f4a7ee607ae1ef78$var$P.prototype.Oa;
$f4a7ee607ae1ef78$var$S.prototype.digest = $f4a7ee607ae1ef78$var$S.prototype.l;
$f4a7ee607ae1ef78$var$S.prototype.reset = $f4a7ee607ae1ef78$var$S.prototype.reset;
$f4a7ee607ae1ef78$var$S.prototype.update = $f4a7ee607ae1ef78$var$S.prototype.j;
$f4a7ee607ae1ef78$var$T.prototype.add = $f4a7ee607ae1ef78$var$T.prototype.add;
$f4a7ee607ae1ef78$var$T.prototype.multiply = $f4a7ee607ae1ef78$var$T.prototype.R;
$f4a7ee607ae1ef78$var$T.prototype.modulo = $f4a7ee607ae1ef78$var$T.prototype.gb;
$f4a7ee607ae1ef78$var$T.prototype.compare = $f4a7ee607ae1ef78$var$T.prototype.X;
$f4a7ee607ae1ef78$var$T.prototype.toNumber = $f4a7ee607ae1ef78$var$T.prototype.ea;
$f4a7ee607ae1ef78$var$T.prototype.toString = $f4a7ee607ae1ef78$var$T.prototype.toString;
$f4a7ee607ae1ef78$var$T.prototype.getBits = $f4a7ee607ae1ef78$var$T.prototype.D;
$f4a7ee607ae1ef78$var$T.fromNumber = $f4a7ee607ae1ef78$var$U;
$f4a7ee607ae1ef78$var$T.fromString = $f4a7ee607ae1ef78$var$Vd;
var $f4a7ee607ae1ef78$export$66869136fc133c3a = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.createWebChannelTransport = function() {
    return new $f4a7ee607ae1ef78$var$Od;
};
var $f4a7ee607ae1ef78$export$888d0d9ab79d08fc = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.getStatEventTarget = function() {
    return $f4a7ee607ae1ef78$var$Mb();
};
var $f4a7ee607ae1ef78$export$d4e71bc0b80dc0fb = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.ErrorCode = $f4a7ee607ae1ef78$var$Sb;
var $f4a7ee607ae1ef78$export$3d7865934588d77e = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.EventType = $f4a7ee607ae1ef78$var$Tb;
var $f4a7ee607ae1ef78$export$d61e24a684f9e51 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.Event = $f4a7ee607ae1ef78$var$E;
var $f4a7ee607ae1ef78$export$cbbc350c1dfc80cb = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.Stat = {
    xb: 0,
    Ab: 1,
    Bb: 2,
    Ub: 3,
    Zb: 4,
    Wb: 5,
    Xb: 6,
    Vb: 7,
    Tb: 8,
    Yb: 9,
    PROXY: 10,
    NOPROXY: 11,
    Rb: 12,
    Nb: 13,
    Ob: 14,
    Mb: 15,
    Pb: 16,
    Qb: 17,
    tb: 18,
    sb: 19,
    ub: 20
};
var $f4a7ee607ae1ef78$export$ddb1030448106742 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.FetchXmlHttpFactory = $f4a7ee607ae1ef78$var$ld;
var $f4a7ee607ae1ef78$export$aa726fb96ad3e039 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.WebChannel = $f4a7ee607ae1ef78$var$Wb;
var $f4a7ee607ae1ef78$export$26404658cda3ee02 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.XhrIo = $f4a7ee607ae1ef78$var$P;
var $f4a7ee607ae1ef78$export$9f5a3dfc7a9f5dd = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.Md5 = $f4a7ee607ae1ef78$var$S;
var $f4a7ee607ae1ef78$export$70ffa26850098d01 = $f4a7ee607ae1ef78$export$2e2bcd8739ae039.Integer = $f4a7ee607ae1ef78$var$T;


const $70fd6868680e912c$var$b = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $70fd6868680e912c$var$V {
    constructor(t){
        this.uid = t;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(t) {
        return t.uid === this.uid;
    }
}
/** A user with a null UID. */ $70fd6868680e912c$var$V.UNAUTHENTICATED = new $70fd6868680e912c$var$V(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$70fd6868680e912c$var$V.GOOGLE_CREDENTIALS = new $70fd6868680e912c$var$V("google-credentials-uid"), $70fd6868680e912c$var$V.FIRST_PARTY = new $70fd6868680e912c$var$V("first-party-uid"), $70fd6868680e912c$var$V.MOCK_USER = new $70fd6868680e912c$var$V("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $70fd6868680e912c$var$S = "9.23.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$D = new (0, $45b460d9de9b230f$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $70fd6868680e912c$var$C() {
    return $70fd6868680e912c$var$D.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $70fd6868680e912c$export$c622e99c0ce7b1c9(t) {
    $70fd6868680e912c$var$D.setLogLevel(t);
}
function $70fd6868680e912c$var$N(t, ...e) {
    if ($70fd6868680e912c$var$D.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) {
        const n = e.map($70fd6868680e912c$var$$);
        $70fd6868680e912c$var$D.debug(`Firestore (${$70fd6868680e912c$var$S}): ${t}`, ...n);
    }
}
function $70fd6868680e912c$var$k(t, ...e) {
    if ($70fd6868680e912c$var$D.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).ERROR) {
        const n = e.map($70fd6868680e912c$var$$);
        $70fd6868680e912c$var$D.error(`Firestore (${$70fd6868680e912c$var$S}): ${t}`, ...n);
    }
}
/**
 * @internal
 */ function $70fd6868680e912c$export$86cd73f49cc6e0bb(t, ...e) {
    if ($70fd6868680e912c$var$D.logLevel <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).WARN) {
        const n = e.map($70fd6868680e912c$var$$);
        $70fd6868680e912c$var$D.warn(`Firestore (${$70fd6868680e912c$var$S}): ${t}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $70fd6868680e912c$var$$(t) {
    if ("string" == typeof t) return t;
    try {
        return e = t, JSON.stringify(e);
    } catch (e) {
        // Converting to JSON failed, just log the object directly
        return t;
    }
    /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ var e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $70fd6868680e912c$var$O(t = "Unexpected state") {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const e = `FIRESTORE (${$70fd6868680e912c$var$S}) INTERNAL ASSERTION FAILED: ` + t;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $70fd6868680e912c$var$k(e), new Error(e);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $70fd6868680e912c$var$F(t, e) {
    t || $70fd6868680e912c$var$O();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $70fd6868680e912c$export$1d2b90eea9bba017(t, e) {
    t || $70fd6868680e912c$var$O();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $70fd6868680e912c$var$L(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$q = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $70fd6868680e912c$export$8fada0bf726bf278 extends (0, $c38e0f42709c826a$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ t, /**
     * A custom error description.
     */ e){
        super(t, e), this.code = t, this.message = e, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$K {
    constructor(){
        this.promise = new Promise((t, e)=>{
            this.resolve = t, this.reject = e;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$G {
    constructor(t, e){
        this.user = e, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${t}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$65ffa50b6039c992 {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(t, e) {
        // Fire with initial user.
        t.enqueueRetryable(()=>e($70fd6868680e912c$var$V.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $70fd6868680e912c$var$j {
    constructor(t){
        this.token = t, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(t, e) {
        this.changeListener = e, // Fire with initial user.
        t.enqueueRetryable(()=>e(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $70fd6868680e912c$var$z {
    constructor(t){
        this.t = t, /** Tracks the current User. */ this.currentUser = $70fd6868680e912c$var$V.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(t, e) {
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const s = (t)=>this.i !== n ? (n = this.i, e(t)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let i = new $70fd6868680e912c$var$K;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), i.resolve(), i = new $70fd6868680e912c$var$K, t.enqueueRetryable(()=>s(this.currentUser));
        };
        const r = ()=>{
            const e = i;
            t.enqueueRetryable(async ()=>{
                await e.promise, await s(this.currentUser);
            });
        }, o = (t)=>{
            $70fd6868680e912c$var$N("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = t, this.auth.addAuthTokenListener(this.o), r();
        };
        this.t.onInit((t)=>o(t)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const t = this.t.getImmediate({
                    optional: !0
                });
                t ? o(t) : // If auth is still not available, proceed with `null` user
                ($70fd6868680e912c$var$N("FirebaseAuthCredentialsProvider", "Auth not yet detected"), i.resolve(), i = new $70fd6868680e912c$var$K);
            }
        }, 0), r();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const t = this.i, e = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(e).then((e)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== t ? ($70fd6868680e912c$var$N("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : e ? ($70fd6868680e912c$var$F("string" == typeof e.accessToken), new $70fd6868680e912c$var$G(e.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.auth.removeAuthTokenListener(this.o);
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const t = this.auth && this.auth.getUid();
        return $70fd6868680e912c$var$F(null === t || "string" == typeof t), new $70fd6868680e912c$var$V(t);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $70fd6868680e912c$var$W {
    constructor(t, e, n){
        this.h = t, this.l = e, this.m = n, this.type = "FirstParty", this.user = $70fd6868680e912c$var$V.FIRST_PARTY, this.g = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ p() {
        return this.m ? this.m() : null;
    }
    get headers() {
        this.g.set("X-Goog-AuthUser", this.h);
        // Use array notation to prevent minification
        const t = this.p();
        return t && this.g.set("Authorization", t), this.l && this.g.set("X-Goog-Iam-Authorization-Token", this.l), this.g;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $70fd6868680e912c$var$H {
    constructor(t, e, n){
        this.h = t, this.l = e, this.m = n;
    }
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$W(this.h, this.l, this.m));
    }
    start(t, e) {
        // Fire with initial uid.
        t.enqueueRetryable(()=>e($70fd6868680e912c$var$V.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $70fd6868680e912c$var$J {
    constructor(t){
        this.value = t, this.type = "AppCheck", this.headers = new Map, t && t.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $70fd6868680e912c$var$Y {
    constructor(t){
        this.I = t, this.forceRefresh = !1, this.appCheck = null, this.T = null;
    }
    start(t, e) {
        const n = (t)=>{
            null != t.error && $70fd6868680e912c$var$N("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${t.error.message}`);
            const n = t.token !== this.T;
            return this.T = t.token, $70fd6868680e912c$var$N("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? e(t.token) : Promise.resolve();
        };
        this.o = (e)=>{
            t.enqueueRetryable(()=>n(e));
        };
        const s = (t)=>{
            $70fd6868680e912c$var$N("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = t, this.appCheck.addTokenListener(this.o);
        };
        this.I.onInit((t)=>s(t)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const t = this.I.getImmediate({
                    optional: !0
                });
                t ? s(t) : // If AppCheck is still not available, proceed without it.
                $70fd6868680e912c$var$N("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        const t = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(t).then((t)=>t ? ($70fd6868680e912c$var$F("string" == typeof t.token), this.T = t.token, new $70fd6868680e912c$var$J(t.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.appCheck.removeTokenListener(this.o);
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $70fd6868680e912c$export$b342cec01954510f {
    getToken() {
        return Promise.resolve(new $70fd6868680e912c$var$J(""));
    }
    invalidateToken() {}
    start(t, e) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $70fd6868680e912c$var$Z(t) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const e = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(t);
    if (e && "function" == typeof e.getRandomValues) e.getRandomValues(n);
    else // Falls back to Math.random
    for(let e = 0; e < t; e++)n[e] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$tt {
    static A() {
        // Alphanumeric characters
        const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length;
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const s = $70fd6868680e912c$var$Z(40);
            for(let i = 0; i < s.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && s[i] < e && (n += t.charAt(s[i] % t.length));
        }
        return n;
    }
}
function $70fd6868680e912c$var$et(t, e) {
    return t < e ? -1 : t > e ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $70fd6868680e912c$var$nt(t, e, n) {
    return t.length === e.length && t.every((t, s)=>n(t, e[s]));
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $70fd6868680e912c$var$st(t) {
    // Return the input string, with an additional NUL byte appended.
    return t + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $70fd6868680e912c$export$d9bcbd5e1ff81430 {
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ t, /**
     * The fractions of a second at nanosecond resolution.*
     */ e){
        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (e >= 1e9) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
        if (t < -62135596800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
        // This will break in the year 10,000.
        if (t >= 253402300800) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
    }
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(t) {
        return $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(t.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(t) {
        const e = Math.floor(t / 1e3), n = Math.floor(1e6 * (t - 1e3 * e));
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e, n);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / 1e6;
    }
    _compareTo(t) {
        return this.seconds === t.seconds ? $70fd6868680e912c$var$et(this.nanoseconds, t.nanoseconds) : $70fd6868680e912c$var$et(this.seconds, t.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(t) {
        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /** Returns a JSON-serializable representation of this `Timestamp`. */ toJSON() {
        return {
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexiographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexiographical ordering.
        const t = this.seconds - -62135596800;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $70fd6868680e912c$var$rt {
    constructor(t){
        this.timestamp = t;
    }
    static fromTimestamp(t) {
        return new $70fd6868680e912c$var$rt(t);
    }
    static min() {
        return new $70fd6868680e912c$var$rt(new $70fd6868680e912c$export$d9bcbd5e1ff81430(0, 0));
    }
    static max() {
        return new $70fd6868680e912c$var$rt(new $70fd6868680e912c$export$d9bcbd5e1ff81430(253402300799, 999999999));
    }
    compareTo(t) {
        return this.timestamp._compareTo(t.timestamp);
    }
    isEqual(t) {
        return this.timestamp.isEqual(t.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ class $70fd6868680e912c$var$ot {
    constructor(t, e, n){
        void 0 === e ? e = 0 : e > t.length && $70fd6868680e912c$var$O(), void 0 === n ? n = t.length - e : n > t.length - e && $70fd6868680e912c$var$O(), this.segments = t, this.offset = e, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(t) {
        return 0 === $70fd6868680e912c$var$ot.comparator(this, t);
    }
    child(t) {
        const e = this.segments.slice(this.offset, this.limit());
        return t instanceof $70fd6868680e912c$var$ot ? t.forEach((t)=>{
            e.push(t);
        }) : e.push(t), this.construct(e);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(t) {
        return t = void 0 === t ? 1 : t, this.construct(this.segments, this.offset + t, this.length - t);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(t) {
        return this.segments[this.offset + t];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(t) {
        if (t.length < this.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    isImmediateParentOf(t) {
        if (this.length + 1 !== t.length) return !1;
        for(let e = 0; e < this.length; e++)if (this.get(e) !== t.get(e)) return !1;
        return !0;
    }
    forEach(t) {
        for(let e = this.offset, n = this.limit(); e < n; e++)t(this.segments[e]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    static comparator(t, e) {
        const n = Math.min(t.length, e.length);
        for(let s = 0; s < n; s++){
            const n = t.get(s), i = e.get(s);
            if (n < i) return -1;
            if (n > i) return 1;
        }
        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $70fd6868680e912c$var$ut extends $70fd6868680e912c$var$ot {
    construct(t, e, n) {
        return new $70fd6868680e912c$var$ut(t, e, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...t) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const e = [];
        for (const n of t){
            if (n.indexOf("//") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and traling slashed.
            e.push(...n.split("/").filter((t)=>t.length > 0));
        }
        return new $70fd6868680e912c$var$ut(e);
    }
    static emptyPath() {
        return new $70fd6868680e912c$var$ut([]);
    }
}
const $70fd6868680e912c$var$ct = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $70fd6868680e912c$export$b7871852b967eaf1 extends $70fd6868680e912c$var$ot {
    construct(t, e, n) {
        return new $70fd6868680e912c$export$b7871852b967eaf1(t, e, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(t) {
        return $70fd6868680e912c$var$ct.test(t);
    }
    canonicalString() {
        return this.toArray().map((t)=>(t = t.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $70fd6868680e912c$export$b7871852b967eaf1.isValidIdentifier(t) || (t = "`" + t + "`"), t)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && "__name__" === this.get(0);
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([
            "__name__"
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(t) {
        const e = [];
        let n = "", s = 0;
        const i = ()=>{
            if (0 === n.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            e.push(n), n = "";
        };
        let r = !1;
        for(; s < t.length;){
            const e = t[s];
            if ("\\" === e) {
                if (s + 1 === t.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
                const e = t[s + 1];
                if ("\\" !== e && "." !== e && "`" !== e) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
                n += e, s += 2;
            } else "`" === e ? (r = !r, s++) : "." !== e || r ? (n += e, s++) : (i(), s++);
        }
        if (i(), r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
        return new $70fd6868680e912c$export$b7871852b967eaf1(e);
    }
    static emptyPath() {
        return new $70fd6868680e912c$export$b7871852b967eaf1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $70fd6868680e912c$export$afc2e57c475b7810 {
    constructor(t){
        this.path = t;
    }
    static fromPath(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.fromString(t));
    }
    static fromName(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.fromString(t).popFirst(5));
    }
    static empty() {
        return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(t) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(t) {
        return null !== t && 0 === $70fd6868680e912c$var$ut.comparator(this.path, t.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(t, e) {
        return $70fd6868680e912c$var$ut.comparator(t.path, e.path);
    }
    static isDocumentKey(t) {
        return t.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(t) {
        return new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ut(t.slice()));
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $70fd6868680e912c$var$lt {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ t, /** The collection ID this index applies to. */ e, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ s){
        this.indexId = t, this.collectionGroup = e, this.fields = n, this.indexState = s;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $70fd6868680e912c$var$ft(t) {
    return t.fields.find((t)=>2 /* IndexKind.CONTAINS */  === t.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $70fd6868680e912c$var$dt(t) {
    return t.fields.filter((t)=>2 /* IndexKind.CONTAINS */  !== t.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $70fd6868680e912c$var$wt(t, e) {
    let n = $70fd6868680e912c$var$et(t.collectionGroup, e.collectionGroup);
    if (0 !== n) return n;
    for(let s = 0; s < Math.min(t.fields.length, e.fields.length); ++s)if (n = $70fd6868680e912c$var$mt(t.fields[s], e.fields[s]), 0 !== n) return n;
    return $70fd6868680e912c$var$et(t.fields.length, e.fields.length);
}
/** Returns a debug representation of the field index */ $70fd6868680e912c$var$lt.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $70fd6868680e912c$var$_t {
    constructor(/** The field path of the component. */ t, /** The fields sorting order. */ e){
        this.fieldPath = t, this.kind = e;
    }
}
function $70fd6868680e912c$var$mt(t, e) {
    const n = $70fd6868680e912c$export$b7871852b967eaf1.comparator(t.fieldPath, e.fieldPath);
    return 0 !== n ? n : $70fd6868680e912c$var$et(t.kind, e.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $70fd6868680e912c$var$gt {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ t, /** The the latest indexed read time, document and batch id. */ e){
        this.sequenceNumber = t, this.offset = e;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $70fd6868680e912c$var$gt(0, $70fd6868680e912c$var$It.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $70fd6868680e912c$var$yt(t, e) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = t.toTimestamp().seconds, s = t.toTimestamp().nanoseconds + 1, i = $70fd6868680e912c$var$rt.fromTimestamp(1e9 === s ? new $70fd6868680e912c$export$d9bcbd5e1ff81430(n + 1, 0) : new $70fd6868680e912c$export$d9bcbd5e1ff81430(n, s));
    return new $70fd6868680e912c$var$It(i, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e);
}
/** Creates a new offset based on the provided document. */ function $70fd6868680e912c$var$pt(t) {
    return new $70fd6868680e912c$var$It(t.readTime, t.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $70fd6868680e912c$var$It {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ t, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ e, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = t, this.documentKey = e, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $70fd6868680e912c$var$It($70fd6868680e912c$var$rt.min(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), -1);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $70fd6868680e912c$var$It($70fd6868680e912c$var$rt.max(), $70fd6868680e912c$export$afc2e57c475b7810.empty(), -1);
    }
}
function $70fd6868680e912c$var$Tt(t, e) {
    let n = t.readTime.compareTo(e.readTime);
    return 0 !== n ? n : (n = $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.documentKey, e.documentKey), 0 !== n ? n : $70fd6868680e912c$var$et(t.largestBatchId, e.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Et = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $70fd6868680e912c$var$At {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(t) {
        this.onCommittedListeners.push(t);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((t)=>t());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $70fd6868680e912c$var$vt(t) {
    if (t.code !== $70fd6868680e912c$var$q.FAILED_PRECONDITION || t.message !== $70fd6868680e912c$var$Et) throw t;
    $70fd6868680e912c$var$N("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $70fd6868680e912c$var$Rt {
    constructor(t){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, t((t)=>{
            this.isDone = !0, this.result = t, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(t);
        }, (t)=>{
            this.isDone = !0, this.error = t, this.catchCallback && this.catchCallback(t);
        });
    }
    catch(t) {
        return this.next(void 0, t);
    }
    next(t, e) {
        return this.callbackAttached && $70fd6868680e912c$var$O(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(e, this.error) : this.wrapSuccess(t, this.result) : new $70fd6868680e912c$var$Rt((n, s)=>{
            this.nextCallback = (e)=>{
                this.wrapSuccess(t, e).next(n, s);
            }, this.catchCallback = (t)=>{
                this.wrapFailure(e, t).next(n, s);
            };
        });
    }
    toPromise() {
        return new Promise((t, e)=>{
            this.next(t, e);
        });
    }
    wrapUserFunction(t) {
        try {
            const e = t();
            return e instanceof $70fd6868680e912c$var$Rt ? e : $70fd6868680e912c$var$Rt.resolve(e);
        } catch (t) {
            return $70fd6868680e912c$var$Rt.reject(t);
        }
    }
    wrapSuccess(t, e) {
        return t ? this.wrapUserFunction(()=>t(e)) : $70fd6868680e912c$var$Rt.resolve(e);
    }
    wrapFailure(t, e) {
        return t ? this.wrapUserFunction(()=>t(e)) : $70fd6868680e912c$var$Rt.reject(e);
    }
    static resolve(t) {
        return new $70fd6868680e912c$var$Rt((e, n)=>{
            e(t);
        });
    }
    static reject(t) {
        return new $70fd6868680e912c$var$Rt((e, n)=>{
            n(t);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t) {
        return new $70fd6868680e912c$var$Rt((e, n)=>{
            let s = 0, i = 0, r = !1;
            t.forEach((t)=>{
                ++s, t.next(()=>{
                    ++i, r && i === s && e();
                }, (t)=>n(t));
            }), r = !0, i === s && e();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(t) {
        let e = $70fd6868680e912c$var$Rt.resolve(!1);
        for (const n of t)e = e.next((t)=>t ? $70fd6868680e912c$var$Rt.resolve(t) : n());
        return e;
    }
    static forEach(t, e) {
        const n = [];
        return t.forEach((t, s)=>{
            n.push(e.call(this, t, s));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(t, e) {
        return new $70fd6868680e912c$var$Rt((n, s)=>{
            const i = t.length, r = new Array(i);
            let o = 0;
            for(let u = 0; u < i; u++){
                const c = u;
                e(t[c]).next((t)=>{
                    r[c] = t, ++o, o === i && n(r);
                }, (t)=>s(t));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(t, e) {
        return new $70fd6868680e912c$var$Rt((n, s)=>{
            const i = ()=>{
                !0 === t() ? e().next(()=>{
                    i();
                }, s) : n();
            };
            i();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $70fd6868680e912c$var$Pt {
    constructor(t, e){
        this.action = t, this.transaction = e, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.v = new $70fd6868680e912c$var$K, this.transaction.oncomplete = ()=>{
            this.v.resolve();
        }, this.transaction.onabort = ()=>{
            e.error ? this.v.reject(new $70fd6868680e912c$var$St(t, e.error)) : this.v.resolve();
        }, this.transaction.onerror = (e)=>{
            const n = $70fd6868680e912c$var$kt(e.target.error);
            this.v.reject(new $70fd6868680e912c$var$St(t, n));
        };
    }
    static open(t, e, n, s) {
        try {
            return new $70fd6868680e912c$var$Pt(e, t.transaction(s, n));
        } catch (t) {
            throw new $70fd6868680e912c$var$St(e, t);
        }
    }
    get R() {
        return this.v.promise;
    }
    abort(t) {
        t && this.v.reject(t), this.aborted || ($70fd6868680e912c$var$N("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    P() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = this.transaction;
        this.aborted || "function" != typeof t.commit || t.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(t) {
        const e = this.transaction.objectStore(t);
        return new $70fd6868680e912c$var$Ct(e);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $70fd6868680e912c$var$bt {
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(t, e, n){
        this.name = t, this.version = e, this.V = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $70fd6868680e912c$var$bt.S((0, $c38e0f42709c826a$export$c36915b22ce77c19)()) && $70fd6868680e912c$var$k("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /** Deletes the specified database. */ static delete(t) {
        return $70fd6868680e912c$var$N("SimpleDb", "Removing database:", t), $70fd6868680e912c$var$xt(window.indexedDB.deleteDatabase(t)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static D() {
        if (!(0, $c38e0f42709c826a$export$3865db50535c2055)()) return !1;
        if ($70fd6868680e912c$var$bt.C()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const t = (0, $c38e0f42709c826a$export$c36915b22ce77c19)(), e = $70fd6868680e912c$var$bt.S(t), n = 0 < e && e < 10, s = $70fd6868680e912c$var$bt.N(t), i = 0 < s && s < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(t.indexOf("MSIE ") > 0 || t.indexOf("Trident/") > 0 || t.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static C() {
        var t;
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static M(t, e) {
        return t.store(e);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static S(t) {
        const e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    // visible for testing
    /** Parse User Agent to determine Android version. Returns -1 if not found. */ static N(t) {
        const e = t.match(/Android ([\d.]+)/i), n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async $(t) {
        return this.db || ($70fd6868680e912c$var$N("SimpleDb", "Opening database:", this.name), this.db = await new Promise((e, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const s = indexedDB.open(this.name, this.version);
            s.onsuccess = (t)=>{
                const n = t.target.result;
                e(n);
            }, s.onblocked = ()=>{
                n(new $70fd6868680e912c$var$St(t, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, s.onerror = (e)=>{
                const s = e.target.error;
                "VersionError" === s.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === s.name ? n(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + s)) : n(new $70fd6868680e912c$var$St(t, s));
            }, s.onupgradeneeded = (t)=>{
                $70fd6868680e912c$var$N("SimpleDb", 'Database "' + this.name + '" requires upgrade from version:', t.oldVersion);
                const e = t.target.result;
                this.V.O(e, s.transaction, t.oldVersion, this.version).next(()=>{
                    $70fd6868680e912c$var$N("SimpleDb", "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.F && (this.db.onversionchange = (t)=>this.F(t)), this.db;
    }
    B(t) {
        this.F = t, this.db && (this.db.onversionchange = (e)=>t(e));
    }
    async runTransaction(t, e, n, s) {
        const i = "readonly" === e;
        let r = 0;
        for(;;){
            ++r;
            try {
                this.db = await this.$(t);
                const e = $70fd6868680e912c$var$Pt.open(this.db, t, i ? "readonly" : "readwrite", n), r = s(e).next((t)=>(e.P(), t)).catch((t)=>// Abort the transaction if there was an error.
                    (e.abort(t), $70fd6868680e912c$var$Rt.reject(t))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return r.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await e.R, r;
            } catch (t) {
                const e = t, n = "FirebaseError" !== e.name && r < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($70fd6868680e912c$var$N("SimpleDb", "Transaction failed with error:", e.message, "Retrying:", n), this.close(), !n) return Promise.reject(e);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $70fd6868680e912c$var$Vt {
    constructor(t){
        this.L = t, this.q = !1, this.U = null;
    }
    get isDone() {
        return this.q;
    }
    get K() {
        return this.U;
    }
    set cursor(t) {
        this.L = t;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.q = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ G(t) {
        this.U = t;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $70fd6868680e912c$var$xt(this.L.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $70fd6868680e912c$var$St extends $70fd6868680e912c$export$8fada0bf726bf278 {
    constructor(t, e){
        super($70fd6868680e912c$var$q.UNAVAILABLE, `IndexedDB transaction '${t}' failed: ${e}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $70fd6868680e912c$var$Dt(t) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === t.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $70fd6868680e912c$var$Ct {
    constructor(t){
        this.store = t;
    }
    put(t, e) {
        let n;
        return void 0 !== e ? ($70fd6868680e912c$var$N("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : ($70fd6868680e912c$var$N("SimpleDb", "PUT", this.store.name, "<auto-key>", t), n = this.store.put(t)), $70fd6868680e912c$var$xt(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(t) {
        $70fd6868680e912c$var$N("SimpleDb", "ADD", this.store.name, t, t);
        return $70fd6868680e912c$var$xt(this.store.add(t));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(t) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $70fd6868680e912c$var$xt(this.store.get(t)).next((e)=>// Normalize nonexistence to null.
            (void 0 === e && (e = null), $70fd6868680e912c$var$N("SimpleDb", "GET", this.store.name, t, e), e));
    }
    delete(t) {
        $70fd6868680e912c$var$N("SimpleDb", "DELETE", this.store.name, t);
        return $70fd6868680e912c$var$xt(this.store.delete(t));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $70fd6868680e912c$var$N("SimpleDb", "COUNT", this.store.name);
        return $70fd6868680e912c$var$xt(this.store.count());
    }
    j(t, e) {
        const n = this.options(t, e);
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster. Unfortunately, getAll() does not support custom indices.
        if (n.index || "function" != typeof this.store.getAll) {
            const t = this.cursor(n), e = [];
            return this.W(t, (t, n)=>{
                e.push(n);
            }).next(()=>e);
        }
        {
            const t = this.store.getAll(n.range);
            return new $70fd6868680e912c$var$Rt((e, n)=>{
                t.onerror = (t)=>{
                    n(t.target.error);
                }, t.onsuccess = (t)=>{
                    e(t.target.result);
                };
            });
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ H(t, e) {
        const n = this.store.getAll(t, null === e ? void 0 : e);
        return new $70fd6868680e912c$var$Rt((t, e)=>{
            n.onerror = (t)=>{
                e(t.target.error);
            }, n.onsuccess = (e)=>{
                t(e.target.result);
            };
        });
    }
    J(t, e) {
        $70fd6868680e912c$var$N("SimpleDb", "DELETE ALL", this.store.name);
        const n = this.options(t, e);
        n.Y = !1;
        const s = this.cursor(n);
        return this.W(s, (t, e, n)=>n.delete());
    }
    X(t, e) {
        let n;
        e ? n = t : (n = {}, e = t);
        const s = this.cursor(n);
        return this.W(s, e);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ Z(t) {
        const e = this.cursor({});
        return new $70fd6868680e912c$var$Rt((n, s)=>{
            e.onerror = (t)=>{
                const e = $70fd6868680e912c$var$kt(t.target.error);
                s(e);
            }, e.onsuccess = (e)=>{
                const s = e.target.result;
                s ? t(s.primaryKey, s.value).next((t)=>{
                    t ? s.continue() : n();
                }) : n();
            };
        });
    }
    W(t, e) {
        const n = [];
        return new $70fd6868680e912c$var$Rt((s, i)=>{
            t.onerror = (t)=>{
                i(t.target.error);
            }, t.onsuccess = (t)=>{
                const i = t.target.result;
                if (!i) return void s();
                const r = new $70fd6868680e912c$var$Vt(i), o = e(i.primaryKey, i.value, r);
                if (o instanceof $70fd6868680e912c$var$Rt) {
                    const t = o.catch((t)=>(r.done(), $70fd6868680e912c$var$Rt.reject(t)));
                    n.push(t);
                }
                r.isDone ? s() : null === r.K ? i.continue() : i.continue(r.K);
            };
        }).next(()=>$70fd6868680e912c$var$Rt.waitFor(n));
    }
    options(t, e) {
        let n;
        return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
            index: n,
            range: e
        };
    }
    cursor(t) {
        let e = "next";
        if (t.reverse && (e = "prev"), t.index) {
            const n = this.store.index(t.index);
            return t.Y ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
        }
        return this.store.openCursor(t.range, e);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $70fd6868680e912c$var$xt(t) {
    return new $70fd6868680e912c$var$Rt((e, n)=>{
        t.onsuccess = (t)=>{
            const n = t.target.result;
            e(n);
        }, t.onerror = (t)=>{
            const e = $70fd6868680e912c$var$kt(t.target.error);
            n(e);
        };
    });
}
// Guard so we only report the error once.
let $70fd6868680e912c$var$Nt = !1;
function $70fd6868680e912c$var$kt(t) {
    const e = $70fd6868680e912c$var$bt.S((0, $c38e0f42709c826a$export$c36915b22ce77c19)());
    if (e >= 12.2 && e < 13) {
        const e = "An internal error was encountered in the Indexed Database server";
        if (t.message.indexOf(e) >= 0) {
            // Wrap error in a more descriptive one.
            const t = new $70fd6868680e912c$export$8fada0bf726bf278("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${e}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $70fd6868680e912c$var$Nt || ($70fd6868680e912c$var$Nt = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw t;
            }, 0)), t;
        }
    }
    return t;
}
/** This class is responsible for the scheduling of Index Backfiller. */ class $70fd6868680e912c$var$Mt {
    constructor(t, e){
        this.asyncQueue = t, this.tt = e, this.task = null;
    }
    start() {
        this.et(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    et(t) {
        $70fd6868680e912c$var$N("IndexBackiller", `Scheduled in ${t}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , t, async ()=>{
            this.task = null;
            try {
                $70fd6868680e912c$var$N("IndexBackiller", `Documents written: ${await this.tt.nt()}`);
            } catch (t) {
                $70fd6868680e912c$var$Dt(t) ? $70fd6868680e912c$var$N("IndexBackiller", "Ignoring IndexedDB error during index backfill: ", t) : await $70fd6868680e912c$var$vt(t);
            }
            await this.et(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $70fd6868680e912c$var$$t {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ t, e){
        this.localStore = t, this.persistence = e;
    }
    async nt(t = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (e)=>this.st(e, t));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ st(t, e) {
        const n = new Set;
        let s = e, i = !0;
        return $70fd6868680e912c$var$Rt.doWhile(()=>!0 === i && s > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(t).next((e)=>{
                if (null !== e && !n.has(e)) return $70fd6868680e912c$var$N("IndexBackiller", `Processing collection: ${e}`), this.it(t, e, s).next((t)=>{
                    s -= t, n.add(e);
                });
                i = !1;
            })).next(()=>e - s);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ it(t, e, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(t, e).next((s)=>this.localStore.localDocuments.getNextDocuments(t, e, s, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(t, i).next(()=>this.rt(s, n)).next((n)=>($70fd6868680e912c$var$N("IndexBackiller", `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(t, e, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ rt(t, e) {
        let n = t;
        return e.changes.forEach((t, e)=>{
            const s = $70fd6868680e912c$var$pt(e);
            $70fd6868680e912c$var$Tt(s, n) > 0 && (n = s);
        }), new $70fd6868680e912c$var$It(n.readTime, n.documentKey, Math.max(e.batchId, t.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $70fd6868680e912c$var$Ot {
    constructor(t, e){
        this.previousValue = t, e && (e.sequenceNumberHandler = (t)=>this.ot(t), this.ut = (t)=>e.writeSequenceNumber(t));
    }
    ot(t) {
        return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
    }
    next() {
        const t = ++this.previousValue;
        return this.ut && this.ut(t), t;
    }
}
$70fd6868680e912c$var$Ot.ct = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $70fd6868680e912c$var$Ft(t) {
    return null == t;
}
/** Returns whether the value represents -0. */ function $70fd6868680e912c$var$Bt(t) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === t && 1 / t == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $70fd6868680e912c$var$Lt(t) {
    return "number" == typeof t && Number.isInteger(t) && !$70fd6868680e912c$var$Bt(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $70fd6868680e912c$var$qt(t) {
    let e = "";
    for(let n = 0; n < t.length; n++)e.length > 0 && (e = $70fd6868680e912c$var$Kt(e)), e = $70fd6868680e912c$var$Ut(t.get(n), e);
    return $70fd6868680e912c$var$Kt(e);
}
/** Encodes a single segment of a resource path into the given result */ function $70fd6868680e912c$var$Ut(t, e) {
    let n = e;
    const s = t.length;
    for(let e = 0; e < s; e++){
        const s = t.charAt(e);
        switch(s){
            case "\0":
                n += "";
                break;
            case "":
                n += "";
                break;
            default:
                n += s;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $70fd6868680e912c$var$Kt(t) {
    return t + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $70fd6868680e912c$var$Gt(t) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const e = t.length;
    if ($70fd6868680e912c$var$F(e >= 2), 2 === e) return $70fd6868680e912c$var$F("" === t.charAt(0) && "" === t.charAt(1)), $70fd6868680e912c$var$ut.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = e - 2, n = [];
    let s = "";
    for(let i = 0; i < e;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const e = t.indexOf("", i);
        (e < 0 || e > __PRIVATE_lastReasonableEscapeIndex) && $70fd6868680e912c$var$O();
        switch(t.charAt(e + 1)){
            case "":
                const r = t.substring(i, e);
                let o;
                0 === s.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = r : (s += r, o = s, s = ""), n.push(o);
                break;
            case "":
                s += t.substring(i, e), s += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                s += t.substring(i, e + 1);
                break;
            default:
                $70fd6868680e912c$var$O();
        }
        i = e + 2;
    }
    return new $70fd6868680e912c$var$ut(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Qt = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $70fd6868680e912c$var$jt(t, e) {
    return [
        t,
        $70fd6868680e912c$var$qt(e)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $70fd6868680e912c$var$zt(t, e, n) {
    return [
        t,
        $70fd6868680e912c$var$qt(e),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $70fd6868680e912c$var$Wt = {}, $70fd6868680e912c$var$Ht = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $70fd6868680e912c$var$Jt = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $70fd6868680e912c$var$Yt = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $70fd6868680e912c$var$Xt = [
    "canonicalId",
    "targetId"
], $70fd6868680e912c$var$Zt = [
    "targetId",
    "path"
], $70fd6868680e912c$var$te = [
    "path",
    "targetId"
], $70fd6868680e912c$var$ee = [
    "collectionId",
    "parent"
], $70fd6868680e912c$var$ne = [
    "indexId",
    "uid"
], $70fd6868680e912c$var$se = [
    "uid",
    "sequenceNumber"
], $70fd6868680e912c$var$ie = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $70fd6868680e912c$var$re = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $70fd6868680e912c$var$oe = [
    "userId",
    "collectionPath",
    "documentId"
], $70fd6868680e912c$var$ue = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $70fd6868680e912c$var$ce = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $70fd6868680e912c$var$ae = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $70fd6868680e912c$var$he = [
    ...$70fd6868680e912c$var$ae,
    "documentOverlays"
], $70fd6868680e912c$var$le = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $70fd6868680e912c$var$fe = $70fd6868680e912c$var$le, $70fd6868680e912c$var$de = [
    ...$70fd6868680e912c$var$fe,
    "indexConfiguration",
    "indexState",
    "indexEntries"
];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$we extends $70fd6868680e912c$var$At {
    constructor(t, e){
        super(), this.ht = t, this.currentSequenceNumber = e;
    }
}
function $70fd6868680e912c$var$_e(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return $70fd6868680e912c$var$bt.M(n.ht, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$me(t) {
    let e = 0;
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && e++;
    return e;
}
function $70fd6868680e912c$var$ge(t, e) {
    for(const n in t)Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
}
function $70fd6868680e912c$var$ye(t) {
    for(const e in t)if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $70fd6868680e912c$var$pe {
    constructor(t, e){
        this.comparator = t, this.root = e || $70fd6868680e912c$var$Te.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(t, e) {
        return new $70fd6868680e912c$var$pe(this.comparator, this.root.insert(t, e, this.comparator).copy(null, null, $70fd6868680e912c$var$Te.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(t) {
        return new $70fd6868680e912c$var$pe(this.comparator, this.root.remove(t, this.comparator).copy(null, null, $70fd6868680e912c$var$Te.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(t) {
        let e = this.root;
        for(; !e.isEmpty();){
            const n = this.comparator(t, e.key);
            if (0 === n) return e.value;
            n < 0 ? e = e.left : n > 0 && (e = e.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(t) {
        // Number of nodes that were pruned when descending right
        let e = 0, n = this.root;
        for(; !n.isEmpty();){
            const s = this.comparator(t, n.key);
            if (0 === s) return e + n.left.size;
            s < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (e += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.root.inorderTraversal(t);
    }
    forEach(t) {
        this.inorderTraversal((e, n)=>(t(e, n), !1));
    }
    toString() {
        const t = [];
        return this.inorderTraversal((e, n)=>(t.push(`${e}:${n}`), !1)), `{${t.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.root.reverseTraversal(t);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $70fd6868680e912c$var$Ie(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(t) {
        return new $70fd6868680e912c$var$Ie(this.root, t, this.comparator, !1);
    }
    getReverseIterator() {
        return new $70fd6868680e912c$var$Ie(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(t) {
        return new $70fd6868680e912c$var$Ie(this.root, t, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $70fd6868680e912c$var$Ie {
    constructor(t, e, n, s){
        this.isReverse = s, this.nodeStack = [];
        let i = 1;
        for(; !t.isEmpty();)if (i = e ? n(t.key, e) : 1, // flip the comparison if we're going in reverse
        e && s && (i *= -1), i < 0) // This node is less than our start key. ignore it
        t = this.isReverse ? t.left : t.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(t);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(t), t = this.isReverse ? t.right : t.left;
        }
    }
    getNext() {
        let t = this.nodeStack.pop();
        const e = {
            key: t.key,
            value: t.value
        };
        if (this.isReverse) for(t = t.left; !t.isEmpty();)this.nodeStack.push(t), t = t.right;
        else for(t = t.right; !t.isEmpty();)this.nodeStack.push(t), t = t.left;
        return e;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const t = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: t.key,
            value: t.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $70fd6868680e912c$var$Te {
    constructor(t, e, n, s, i){
        this.key = t, this.value = e, this.color = null != n ? n : $70fd6868680e912c$var$Te.RED, this.left = null != s ? s : $70fd6868680e912c$var$Te.EMPTY, this.right = null != i ? i : $70fd6868680e912c$var$Te.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(t, e, n, s, i) {
        return new $70fd6868680e912c$var$Te(null != t ? t : this.key, null != e ? e : this.value, null != n ? n : this.color, null != s ? s : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(t) {
        return this.left.inorderTraversal(t) || t(this.key, this.value) || this.right.inorderTraversal(t);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(t) {
        return this.right.reverseTraversal(t) || t(this.key, this.value) || this.left.reverseTraversal(t);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(t, e, n) {
        let s = this;
        const i = n(t, s.key);
        return s = i < 0 ? s.copy(null, null, null, s.left.insert(t, e, n), null) : 0 === i ? s.copy(null, e, null, null, null) : s.copy(null, null, null, null, s.right.insert(t, e, n)), s.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $70fd6868680e912c$var$Te.EMPTY;
        let t = this;
        return t.left.isRed() || t.left.left.isRed() || (t = t.moveRedLeft()), t = t.copy(null, null, null, t.left.removeMin(), null), t.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(t, e) {
        let n, s = this;
        if (e(t, s.key) < 0) s.left.isEmpty() || s.left.isRed() || s.left.left.isRed() || (s = s.moveRedLeft()), s = s.copy(null, null, null, s.left.remove(t, e), null);
        else {
            if (s.left.isRed() && (s = s.rotateRight()), s.right.isEmpty() || s.right.isRed() || s.right.left.isRed() || (s = s.moveRedRight()), 0 === e(t, s.key)) {
                if (s.right.isEmpty()) return $70fd6868680e912c$var$Te.EMPTY;
                n = s.right.min(), s = s.copy(n.key, n.value, null, null, s.right.removeMin());
            }
            s = s.copy(null, null, null, null, s.right.remove(t, e));
        }
        return s.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let t = this;
        return t.right.isRed() && !t.left.isRed() && (t = t.rotateLeft()), t.left.isRed() && t.left.left.isRed() && (t = t.rotateRight()), t.left.isRed() && t.right.isRed() && (t = t.colorFlip()), t;
    }
    moveRedLeft() {
        let t = this.colorFlip();
        return t.right.left.isRed() && (t = t.copy(null, null, null, null, t.right.rotateRight()), t = t.rotateLeft(), t = t.colorFlip()), t;
    }
    moveRedRight() {
        let t = this.colorFlip();
        return t.left.left.isRed() && (t = t.rotateRight(), t = t.colorFlip()), t;
    }
    rotateLeft() {
        const t = this.copy(null, null, $70fd6868680e912c$var$Te.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, t, null);
    }
    rotateRight() {
        const t = this.copy(null, null, $70fd6868680e912c$var$Te.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, t);
    }
    colorFlip() {
        const t = this.left.copy(null, null, !this.left.color, null, null), e = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, t, e);
    }
    // For testing.
    checkMaxDepth() {
        const t = this.check();
        return Math.pow(2, t) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $70fd6868680e912c$var$O();
        if (this.right.isRed()) throw $70fd6868680e912c$var$O();
        const t = this.left.check();
        if (t !== this.right.check()) throw $70fd6868680e912c$var$O();
        return t + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$70fd6868680e912c$var$Te.EMPTY = null, $70fd6868680e912c$var$Te.RED = !0, $70fd6868680e912c$var$Te.BLACK = !1;
// end LLRBEmptyNode
$70fd6868680e912c$var$Te.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $70fd6868680e912c$var$O();
    }
    get value() {
        throw $70fd6868680e912c$var$O();
    }
    get color() {
        throw $70fd6868680e912c$var$O();
    }
    get left() {
        throw $70fd6868680e912c$var$O();
    }
    get right() {
        throw $70fd6868680e912c$var$O();
    }
    // Returns a copy of the current node.
    copy(t, e, n, s, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(t, e, n) {
        return new $70fd6868680e912c$var$Te(t, e);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(t, e) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(t) {
        return !1;
    }
    reverseTraversal(t) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $70fd6868680e912c$var$Ee {
    constructor(t){
        this.comparator = t, this.data = new $70fd6868680e912c$var$pe(this.comparator);
    }
    has(t) {
        return null !== this.data.get(t);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(t) {
        return this.data.indexOf(t);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(t) {
        this.data.inorderTraversal((e, n)=>(t(e), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(t, e) {
        const n = this.data.getIteratorFrom(t[0]);
        for(; n.hasNext();){
            const s = n.getNext();
            if (this.comparator(s.key, t[1]) >= 0) return;
            e(s.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(t, e) {
        let n;
        for(n = void 0 !== e ? this.data.getIteratorFrom(e) : this.data.getIterator(); n.hasNext();){
            if (!t(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(t) {
        const e = this.data.getIteratorFrom(t);
        return e.hasNext() ? e.getNext().key : null;
    }
    getIterator() {
        return new $70fd6868680e912c$var$Ae(this.data.getIterator());
    }
    getIteratorFrom(t) {
        return new $70fd6868680e912c$var$Ae(this.data.getIteratorFrom(t));
    }
    /** Inserts or updates an element */ add(t) {
        return this.copy(this.data.remove(t).insert(t, !0));
    }
    /** Deletes an element */ delete(t) {
        return this.has(t) ? this.copy(this.data.remove(t)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(t) {
        let e = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return e.size < t.size && (e = t, t = this), t.forEach((t)=>{
            e = e.add(t);
        }), e;
    }
    isEqual(t) {
        if (!(t instanceof $70fd6868680e912c$var$Ee)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.data.getIterator(), n = t.data.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, s = n.getNext().key;
            if (0 !== this.comparator(t, s)) return !1;
        }
        return !0;
    }
    toArray() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e);
        }), t;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>t.push(e)), "SortedSet(" + t.toString() + ")";
    }
    copy(t) {
        const e = new $70fd6868680e912c$var$Ee(this.comparator);
        return e.data = t, e;
    }
}
class $70fd6868680e912c$var$Ae {
    constructor(t){
        this.iter = t;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $70fd6868680e912c$var$ve(t) {
    return t.hasNext() ? t.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $70fd6868680e912c$var$Re {
    constructor(t){
        this.fields = t, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        t.sort($70fd6868680e912c$export$b7871852b967eaf1.comparator);
    }
    static empty() {
        return new $70fd6868680e912c$var$Re([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(t) {
        let e = new $70fd6868680e912c$var$Ee($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (const t of this.fields)e = e.add(t);
        for (const n of t)e = e.add(n);
        return new $70fd6868680e912c$var$Re(e.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(t) {
        for (const e of this.fields)if (e.isPrefixOf(t)) return !0;
        return !1;
    }
    isEqual(t) {
        return $70fd6868680e912c$var$nt(this.fields, t.fields, (t, e)=>t.isEqual(e));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $70fd6868680e912c$var$Pe extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $70fd6868680e912c$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $70fd6868680e912c$var$Ve {
    constructor(t){
        this.binaryString = t;
    }
    static fromBase64String(t) {
        const e = function(t) {
            try {
                return atob(t);
            } catch (t) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && t instanceof DOMException ? new $70fd6868680e912c$var$Pe("Invalid base64 string: " + t) : t;
            }
        }(t);
        return new $70fd6868680e912c$var$Ve(e);
    }
    static fromUint8Array(t) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const e = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function(t) {
            let e = "";
            for(let n = 0; n < t.length; ++n)e += String.fromCharCode(t[n]);
            return e;
        }(t);
        return new $70fd6868680e912c$var$Ve(e);
    }
    [Symbol.iterator]() {
        let t = 0;
        return {
            next: ()=>t < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(t++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        var t;
        return t = this.binaryString, btoa(t);
    }
    toUint8Array() {
        return function(t) {
            const e = new Uint8Array(t.length);
            for(let n = 0; n < t.length; n++)e[n] = t.charCodeAt(n);
            return e;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(t) {
        return $70fd6868680e912c$var$et(this.binaryString, t.binaryString);
    }
    isEqual(t) {
        return this.binaryString === t.binaryString;
    }
}
$70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING = new $70fd6868680e912c$var$Ve("");
const $70fd6868680e912c$var$Se = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $70fd6868680e912c$var$De(t) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($70fd6868680e912c$var$F(!!t), "string" == typeof t) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let e = 0;
        const n = $70fd6868680e912c$var$Se.exec(t);
        if ($70fd6868680e912c$var$F(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let t = n[1];
            t = (t + "000000000").substr(0, 9), e = Number(t);
        }
        // Parse the date to get the seconds.
        const s = new Date(t);
        return {
            seconds: Math.floor(s.getTime() / 1e3),
            nanos: e
        };
    }
    return {
        seconds: $70fd6868680e912c$var$Ce(t.seconds),
        nanos: $70fd6868680e912c$var$Ce(t.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $70fd6868680e912c$var$Ce(t) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $70fd6868680e912c$var$xe(t) {
    return "string" == typeof t ? $70fd6868680e912c$var$Ve.fromBase64String(t) : $70fd6868680e912c$var$Ve.fromUint8Array(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $70fd6868680e912c$var$Ne(t) {
    var e, n;
    return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $70fd6868680e912c$var$ke(t) {
    const e = t.mapValue.fields.__previous_value__;
    return $70fd6868680e912c$var$Ne(e) ? $70fd6868680e912c$var$ke(e) : e;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $70fd6868680e912c$var$Me(t) {
    const e = $70fd6868680e912c$var$De(t.mapValue.fields.__local_write_time__.timestampValue);
    return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$$e {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions Options that configure long-polling.
     * @param useFetchStreams Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(t, e, n, s, i, r, o, u, c){
        this.databaseId = t, this.appId = e, this.persistenceKey = n, this.host = s, this.ssl = i, this.forceLongPolling = r, this.autoDetectLongPolling = o, this.longPollingOptions = u, this.useFetchStreams = c;
    }
}
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $70fd6868680e912c$export$4c3ccc07620ae30a {
    constructor(t, e){
        this.projectId = t, this.database = e || "(default)";
    }
    static empty() {
        return new $70fd6868680e912c$export$4c3ccc07620ae30a("", "");
    }
    get isDefaultDatabase() {
        return "(default)" === this.database;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$export$4c3ccc07620ae30a && t.projectId === this.projectId && t.database === this.database;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Fe = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $70fd6868680e912c$var$Be = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $70fd6868680e912c$var$Le(t) {
    return "nullValue" in t ? 0 /* TypeOrder.NullValue */  : "booleanValue" in t ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in t || "doubleValue" in t ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in t ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in t ? 5 /* TypeOrder.StringValue */  : "bytesValue" in t ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in t ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in t ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in t ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in t ? $70fd6868680e912c$var$Ne(t) ? 4 /* TypeOrder.ServerTimestampValue */  : $70fd6868680e912c$var$en(t) ? 9007199254740991 /* TypeOrder.MaxValue */  : 10 /* TypeOrder.ObjectValue */  : $70fd6868680e912c$var$O();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $70fd6868680e912c$var$qe(t, e) {
    if (t === e) return !0;
    const n = $70fd6868680e912c$var$Le(t);
    if (n !== $70fd6868680e912c$var$Le(e)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return t.booleanValue === e.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$Me(t).isEqual($70fd6868680e912c$var$Me(e));
        case 3 /* TypeOrder.TimestampValue */ :
            return function(t, e) {
                if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return t.timestampValue === e.timestampValue;
                const n = $70fd6868680e912c$var$De(t.timestampValue), s = $70fd6868680e912c$var$De(e.timestampValue);
                return n.seconds === s.seconds && n.nanos === s.nanos;
            }(t, e);
        case 5 /* TypeOrder.StringValue */ :
            return t.stringValue === e.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function(t, e) {
                return $70fd6868680e912c$var$xe(t.bytesValue).isEqual($70fd6868680e912c$var$xe(e.bytesValue));
            }(t, e);
        case 7 /* TypeOrder.RefValue */ :
            return t.referenceValue === e.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function(t, e) {
                return $70fd6868680e912c$var$Ce(t.geoPointValue.latitude) === $70fd6868680e912c$var$Ce(e.geoPointValue.latitude) && $70fd6868680e912c$var$Ce(t.geoPointValue.longitude) === $70fd6868680e912c$var$Ce(e.geoPointValue.longitude);
            }(t, e);
        case 2 /* TypeOrder.NumberValue */ :
            return function(t, e) {
                if ("integerValue" in t && "integerValue" in e) return $70fd6868680e912c$var$Ce(t.integerValue) === $70fd6868680e912c$var$Ce(e.integerValue);
                if ("doubleValue" in t && "doubleValue" in e) {
                    const n = $70fd6868680e912c$var$Ce(t.doubleValue), s = $70fd6868680e912c$var$Ce(e.doubleValue);
                    return n === s ? $70fd6868680e912c$var$Bt(n) === $70fd6868680e912c$var$Bt(s) : isNaN(n) && isNaN(s);
                }
                return !1;
            }(t, e);
        case 9 /* TypeOrder.ArrayValue */ :
            return $70fd6868680e912c$var$nt(t.arrayValue.values || [], e.arrayValue.values || [], $70fd6868680e912c$var$qe);
        case 10 /* TypeOrder.ObjectValue */ :
            return function(t, e) {
                const n = t.mapValue.fields || {}, s = e.mapValue.fields || {};
                if ($70fd6868680e912c$var$me(n) !== $70fd6868680e912c$var$me(s)) return !1;
                for(const t in n)if (n.hasOwnProperty(t) && (void 0 === s[t] || !$70fd6868680e912c$var$qe(n[t], s[t]))) return !1;
                return !0;
            }(t, e);
        default:
            return $70fd6868680e912c$var$O();
    }
}
function $70fd6868680e912c$var$Ue(t, e) {
    return void 0 !== (t.values || []).find((t)=>$70fd6868680e912c$var$qe(t, e));
}
function $70fd6868680e912c$var$Ke(t, e) {
    if (t === e) return 0;
    const n = $70fd6868680e912c$var$Le(t), s = $70fd6868680e912c$var$Le(e);
    if (n !== s) return $70fd6868680e912c$var$et(n, s);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $70fd6868680e912c$var$et(t.booleanValue, e.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$Ce(t.integerValue || t.doubleValue), s = $70fd6868680e912c$var$Ce(e.integerValue || e.doubleValue);
                return n < s ? -1 : n > s ? 1 : n === s ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(s) ? 0 : -1 : 1;
            }(t, e);
        case 3 /* TypeOrder.TimestampValue */ :
            return $70fd6868680e912c$var$Ge(t.timestampValue, e.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $70fd6868680e912c$var$Ge($70fd6868680e912c$var$Me(t), $70fd6868680e912c$var$Me(e));
        case 5 /* TypeOrder.StringValue */ :
            return $70fd6868680e912c$var$et(t.stringValue, e.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$xe(t), s = $70fd6868680e912c$var$xe(e);
                return n.compareTo(s);
            }(t.bytesValue, e.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function(t, e) {
                const n = t.split("/"), s = e.split("/");
                for(let t = 0; t < n.length && t < s.length; t++){
                    const e = $70fd6868680e912c$var$et(n[t], s[t]);
                    if (0 !== e) return e;
                }
                return $70fd6868680e912c$var$et(n.length, s.length);
            }(t.referenceValue, e.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function(t, e) {
                const n = $70fd6868680e912c$var$et($70fd6868680e912c$var$Ce(t.latitude), $70fd6868680e912c$var$Ce(e.latitude));
                if (0 !== n) return n;
                return $70fd6868680e912c$var$et($70fd6868680e912c$var$Ce(t.longitude), $70fd6868680e912c$var$Ce(e.longitude));
            }(t.geoPointValue, e.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return function(t, e) {
                const n = t.values || [], s = e.values || [];
                for(let t = 0; t < n.length && t < s.length; ++t){
                    const e = $70fd6868680e912c$var$Ke(n[t], s[t]);
                    if (e) return e;
                }
                return $70fd6868680e912c$var$et(n.length, s.length);
            }(t.arrayValue, e.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function(t, e) {
                if (t === $70fd6868680e912c$var$Fe.mapValue && e === $70fd6868680e912c$var$Fe.mapValue) return 0;
                if (t === $70fd6868680e912c$var$Fe.mapValue) return 1;
                if (e === $70fd6868680e912c$var$Fe.mapValue) return -1;
                const n = t.fields || {}, s = Object.keys(n), i = e.fields || {}, r = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                s.sort(), r.sort();
                for(let t = 0; t < s.length && t < r.length; ++t){
                    const e = $70fd6868680e912c$var$et(s[t], r[t]);
                    if (0 !== e) return e;
                    const o = $70fd6868680e912c$var$Ke(n[s[t]], i[r[t]]);
                    if (0 !== o) return o;
                }
                return $70fd6868680e912c$var$et(s.length, r.length);
            }(t.mapValue, e.mapValue);
        default:
            throw $70fd6868680e912c$var$O();
    }
}
function $70fd6868680e912c$var$Ge(t, e) {
    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return $70fd6868680e912c$var$et(t, e);
    const n = $70fd6868680e912c$var$De(t), s = $70fd6868680e912c$var$De(e), i = $70fd6868680e912c$var$et(n.seconds, s.seconds);
    return 0 !== i ? i : $70fd6868680e912c$var$et(n.nanos, s.nanos);
}
function $70fd6868680e912c$var$Qe(t) {
    return $70fd6868680e912c$var$je(t);
}
function $70fd6868680e912c$var$je(t) {
    var e, n;
    return "nullValue" in t ? "null" : "booleanValue" in t ? "" + t.booleanValue : "integerValue" in t ? "" + t.integerValue : "doubleValue" in t ? "" + t.doubleValue : "timestampValue" in t ? function(t) {
        const e = $70fd6868680e912c$var$De(t);
        return `time(${e.seconds},${e.nanos})`;
    }(t.timestampValue) : "stringValue" in t ? t.stringValue : "bytesValue" in t ? $70fd6868680e912c$var$xe(t.bytesValue).toBase64() : "referenceValue" in t ? (n = t.referenceValue, $70fd6868680e912c$export$afc2e57c475b7810.fromName(n).toString()) : "geoPointValue" in t ? `geo(${(e = t.geoPointValue).latitude},${e.longitude})` : "arrayValue" in t ? function(t) {
        let e = "[", n = !0;
        for (const s of t.values || [])n ? n = !1 : e += ",", e += $70fd6868680e912c$var$je(s);
        return e + "]";
    }(t.arrayValue) : "mapValue" in t ? function(t) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const e = Object.keys(t.fields || {}).sort();
        let n = "{", s = !0;
        for (const i of e)s ? s = !1 : n += ",", n += `${i}:${$70fd6868680e912c$var$je(t.fields[i])}`;
        return n + "}";
    }(t.mapValue) : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$ze(t) {
    switch($70fd6868680e912c$var$Le(t)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const e = $70fd6868680e912c$var$ke(t);
            return e ? 16 + $70fd6868680e912c$var$ze(e) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * t.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $70fd6868680e912c$var$xe(t.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return t.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return (t.arrayValue.values || []).reduce((t, e)=>t + $70fd6868680e912c$var$ze(e), 0);
        case 10 /* TypeOrder.ObjectValue */ :
            return function(t) {
                let e = 0;
                return $70fd6868680e912c$var$ge(t.fields, (t, n)=>{
                    e += t.length + $70fd6868680e912c$var$ze(n);
                }), e;
            }(t.mapValue);
        default:
            throw $70fd6868680e912c$var$O();
    }
}
/** Returns a reference value for the provided database and key. */ function $70fd6868680e912c$var$We(t, e) {
    return {
        referenceValue: `projects/${t.projectId}/databases/${t.database}/documents/${e.path.canonicalString()}`
    };
}
/** Returns true if `value` is an IntegerValue . */ function $70fd6868680e912c$var$He(t) {
    return !!t && "integerValue" in t;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $70fd6868680e912c$var$Je(t) {
    return !!t && "arrayValue" in t;
}
/** Returns true if `value` is a NullValue. */ function $70fd6868680e912c$var$Ye(t) {
    return !!t && "nullValue" in t;
}
/** Returns true if `value` is NaN. */ function $70fd6868680e912c$var$Xe(t) {
    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $70fd6868680e912c$var$Ze(t) {
    return !!t && "mapValue" in t;
}
/** Creates a deep copy of `source`. */ function $70fd6868680e912c$var$tn(t) {
    if (t.geoPointValue) return {
        geoPointValue: Object.assign({}, t.geoPointValue)
    };
    if (t.timestampValue && "object" == typeof t.timestampValue) return {
        timestampValue: Object.assign({}, t.timestampValue)
    };
    if (t.mapValue) {
        const e = {
            mapValue: {
                fields: {}
            }
        };
        return $70fd6868680e912c$var$ge(t.mapValue.fields, (t, n)=>e.mapValue.fields[t] = $70fd6868680e912c$var$tn(n)), e;
    }
    if (t.arrayValue) {
        const e = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (t.arrayValue.values || []).length; ++n)e.arrayValue.values[n] = $70fd6868680e912c$var$tn(t.arrayValue.values[n]);
        return e;
    }
    return Object.assign({}, t);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $70fd6868680e912c$var$en(t) {
    return "__max__" === (((t.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */ function $70fd6868680e912c$var$nn(t) {
    return "nullValue" in t ? $70fd6868680e912c$var$Be : "booleanValue" in t ? {
        booleanValue: !1
    } : "integerValue" in t || "doubleValue" in t ? {
        doubleValue: NaN
    } : "timestampValue" in t ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in t ? {
        stringValue: ""
    } : "bytesValue" in t ? {
        bytesValue: ""
    } : "referenceValue" in t ? $70fd6868680e912c$var$We($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "geoPointValue" in t ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in t ? {
        arrayValue: {}
    } : "mapValue" in t ? {
        mapValue: {}
    } : $70fd6868680e912c$var$O();
}
/** Returns the largest value for the given value type (exclusive). */ function $70fd6868680e912c$var$sn(t) {
    return "nullValue" in t ? {
        booleanValue: !1
    } : "booleanValue" in t ? {
        doubleValue: NaN
    } : "integerValue" in t || "doubleValue" in t ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in t ? {
        stringValue: ""
    } : "stringValue" in t ? {
        bytesValue: ""
    } : "bytesValue" in t ? $70fd6868680e912c$var$We($70fd6868680e912c$export$4c3ccc07620ae30a.empty(), $70fd6868680e912c$export$afc2e57c475b7810.empty()) : "referenceValue" in t ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in t ? {
        arrayValue: {}
    } : "arrayValue" in t ? {
        mapValue: {}
    } : "mapValue" in t ? $70fd6868680e912c$var$Fe : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$rn(t, e) {
    const n = $70fd6868680e912c$var$Ke(t.value, e.value);
    return 0 !== n ? n : t.inclusive && !e.inclusive ? -1 : !t.inclusive && e.inclusive ? 1 : 0;
}
function $70fd6868680e912c$var$on(t, e) {
    const n = $70fd6868680e912c$var$Ke(t.value, e.value);
    return 0 !== n ? n : t.inclusive && !e.inclusive ? 1 : !t.inclusive && e.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $70fd6868680e912c$var$un {
    constructor(t){
        this.value = t;
    }
    static empty() {
        return new $70fd6868680e912c$var$un({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(t) {
        if (t.isEmpty()) return this.value;
        {
            let e = this.value;
            for(let n = 0; n < t.length - 1; ++n)if (e = (e.mapValue.fields || {})[t.get(n)], !$70fd6868680e912c$var$Ze(e)) return null;
            return e = (e.mapValue.fields || {})[t.lastSegment()], e || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(t, e) {
        this.getFieldsMap(t.popLast())[t.lastSegment()] = $70fd6868680e912c$var$tn(e);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(t) {
        let e = $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(), n = {}, s = [];
        t.forEach((t, i)=>{
            if (!e.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const t = this.getFieldsMap(e);
                this.applyChanges(t, n, s), n = {}, s = [], e = i.popLast();
            }
            t ? n[i.lastSegment()] = $70fd6868680e912c$var$tn(t) : s.push(i.lastSegment());
        });
        const i = this.getFieldsMap(e);
        this.applyChanges(i, n, s);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(t) {
        const e = this.field(t.popLast());
        $70fd6868680e912c$var$Ze(e) && e.mapValue.fields && delete e.mapValue.fields[t.lastSegment()];
    }
    isEqual(t) {
        return $70fd6868680e912c$var$qe(this.value, t.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(t) {
        let e = this.value;
        e.mapValue.fields || (e.mapValue = {
            fields: {}
        });
        for(let n = 0; n < t.length; ++n){
            let s = e.mapValue.fields[t.get(n)];
            $70fd6868680e912c$var$Ze(s) && s.mapValue.fields || (s = {
                mapValue: {
                    fields: {}
                }
            }, e.mapValue.fields[t.get(n)] = s), e = s;
        }
        return e.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(t, e, n) {
        $70fd6868680e912c$var$ge(e, (e, n)=>t[e] = n);
        for (const e of n)delete t[e];
    }
    clone() {
        return new $70fd6868680e912c$var$un($70fd6868680e912c$var$tn(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $70fd6868680e912c$var$cn(t) {
    const e = [];
    return $70fd6868680e912c$var$ge(t.fields, (t, n)=>{
        const s = new $70fd6868680e912c$export$b7871852b967eaf1([
            t
        ]);
        if ($70fd6868680e912c$var$Ze(n)) {
            const t = $70fd6868680e912c$var$cn(n.mapValue).fields;
            if (0 === t.length) // Preserve the empty map by adding it to the FieldMask.
            e.push(s);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of t)e.push(s.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        e.push(s);
    }), new $70fd6868680e912c$var$Re(e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $70fd6868680e912c$var$an {
    constructor(t, e, n, s, i, r, o){
        this.key = t, this.documentType = e, this.version = n, this.readTime = s, this.createTime = i, this.data = r, this.documentState = o;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(t) {
        return new $70fd6868680e912c$var$an(t, 0 /* DocumentType.INVALID */ , /* version */ $70fd6868680e912c$var$rt.min(), /* readTime */ $70fd6868680e912c$var$rt.min(), /* createTime */ $70fd6868680e912c$var$rt.min(), $70fd6868680e912c$var$un.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(t, e, n, s) {
        return new $70fd6868680e912c$var$an(t, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ e, /* readTime */ $70fd6868680e912c$var$rt.min(), /* createTime */ n, s, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(t, e) {
        return new $70fd6868680e912c$var$an(t, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ e, /* readTime */ $70fd6868680e912c$var$rt.min(), /* createTime */ $70fd6868680e912c$var$rt.min(), $70fd6868680e912c$var$un.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(t, e) {
        return new $70fd6868680e912c$var$an(t, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ e, /* readTime */ $70fd6868680e912c$var$rt.min(), /* createTime */ $70fd6868680e912c$var$rt.min(), $70fd6868680e912c$var$un.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(t, e) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($70fd6868680e912c$var$rt.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = t), this.version = t, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = e, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(t) {
        return this.version = t, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $70fd6868680e912c$var$un.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(t) {
        return this.version = t, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $70fd6868680e912c$var$un.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $70fd6868680e912c$var$rt.min(), this;
    }
    setReadTime(t) {
        return this.readTime = t, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$an && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.documentType === t.documentType && this.documentState === t.documentState && this.data.isEqual(t.data);
    }
    mutableCopy() {
        return new $70fd6868680e912c$var$an(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $70fd6868680e912c$var$hn {
    constructor(t, e){
        this.position = t, this.inclusive = e;
    }
}
function $70fd6868680e912c$var$ln(t, e, n) {
    let s = 0;
    for(let i = 0; i < t.position.length; i++){
        const r = e[i], o = t.position[i];
        if (r.field.isKeyField()) s = $70fd6868680e912c$export$afc2e57c475b7810.comparator($70fd6868680e912c$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else s = $70fd6868680e912c$var$Ke(o, n.data.field(r.field));
        if ("desc" /* Direction.DESCENDING */  === r.dir && (s *= -1), 0 !== s) break;
    }
    return s;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $70fd6868680e912c$var$fn(t, e) {
    if (null === t) return null === e;
    if (null === e) return !1;
    if (t.inclusive !== e.inclusive || t.position.length !== e.position.length) return !1;
    for(let n = 0; n < t.position.length; n++){
        if (!$70fd6868680e912c$var$qe(t.position[n], e.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $70fd6868680e912c$var$dn {
    constructor(t, e = "asc" /* Direction.ASCENDING */ ){
        this.field = t, this.dir = e;
    }
}
function $70fd6868680e912c$var$wn(t, e) {
    return t.dir === e.dir && t.field.isEqual(e.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$_n {
}
class $70fd6868680e912c$var$mn extends $70fd6868680e912c$var$_n {
    constructor(t, e, n){
        super(), this.field = t, this.op = e, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(t, e, n) {
        return t.isKeyField() ? "in" /* Operator.IN */  === e || "not-in" /* Operator.NOT_IN */  === e ? this.createKeyFieldInFilter(t, e, n) : new $70fd6868680e912c$var$Pn(t, e, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === e ? new $70fd6868680e912c$var$Dn(t, n) : "in" /* Operator.IN */  === e ? new $70fd6868680e912c$var$Cn(t, n) : "not-in" /* Operator.NOT_IN */  === e ? new $70fd6868680e912c$var$xn(t, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e ? new $70fd6868680e912c$var$Nn(t, n) : new $70fd6868680e912c$var$mn(t, e, n);
    }
    static createKeyFieldInFilter(t, e, n) {
        return "in" /* Operator.IN */  === e ? new $70fd6868680e912c$var$bn(t, n) : new $70fd6868680e912c$var$Vn(t, n);
    }
    matches(t) {
        const e = t.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== e && this.matchesComparison($70fd6868680e912c$var$Ke(e, this.value)) : null !== e && $70fd6868680e912c$var$Le(this.value) === $70fd6868680e912c$var$Le(e) && this.matchesComparison($70fd6868680e912c$var$Ke(e, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(t) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return t < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return t <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === t;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== t;
            case ">" /* Operator.GREATER_THAN */ :
                return t > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return t >= 0;
            default:
                return $70fd6868680e912c$var$O();
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
    getFirstInequalityField() {
        return this.isInequality() ? this.field : null;
    }
}
class $70fd6868680e912c$var$gn extends $70fd6868680e912c$var$_n {
    constructor(t, e){
        super(), this.filters = t, this.op = e, this.lt = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(t, e) {
        return new $70fd6868680e912c$var$gn(t, e);
    }
    matches(t) {
        return $70fd6868680e912c$var$yn(this) ? void 0 === this.filters.find((e)=>!e.matches(t)) : void 0 !== this.filters.find((e)=>e.matches(t));
    }
    getFlattenedFilters() {
        return null !== this.lt || (this.lt = this.filters.reduce((t, e)=>t.concat(e.getFlattenedFilters()), [])), this.lt;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
    getFirstInequalityField() {
        const t = this.ft((t)=>t.isInequality());
        return null !== t ? t.field : null;
    }
    // Performs a depth-first search to find and return the first FieldFilter in the composite filter
    // that satisfies the predicate. Returns `null` if none of the FieldFilters satisfy the
    // predicate.
    ft(t) {
        for (const e of this.getFlattenedFilters())if (t(e)) return e;
        return null;
    }
}
function $70fd6868680e912c$var$yn(t) {
    return "and" /* CompositeOperator.AND */  === t.op;
}
function $70fd6868680e912c$var$pn(t) {
    return "or" /* CompositeOperator.OR */  === t.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $70fd6868680e912c$var$In(t) {
    return $70fd6868680e912c$var$Tn(t) && $70fd6868680e912c$var$yn(t);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $70fd6868680e912c$var$Tn(t) {
    for (const e of t.filters)if (e instanceof $70fd6868680e912c$var$gn) return !1;
    return !0;
}
function $70fd6868680e912c$var$En(t) {
    if (t instanceof $70fd6868680e912c$var$mn) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return t.field.canonicalString() + t.op.toString() + $70fd6868680e912c$var$Qe(t.value);
    if ($70fd6868680e912c$var$In(t)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return t.filters.map((t)=>$70fd6868680e912c$var$En(t)).join(",");
    {
        // filter instanceof CompositeFilter
        const e = t.filters.map((t)=>$70fd6868680e912c$var$En(t)).join(",");
        return `${t.op}(${e})`;
    }
}
function $70fd6868680e912c$var$An(t, e) {
    return t instanceof $70fd6868680e912c$var$mn ? function(t, e) {
        return e instanceof $70fd6868680e912c$var$mn && t.op === e.op && t.field.isEqual(e.field) && $70fd6868680e912c$var$qe(t.value, e.value);
    }(t, e) : t instanceof $70fd6868680e912c$var$gn ? function(t, e) {
        if (e instanceof $70fd6868680e912c$var$gn && t.op === e.op && t.filters.length === e.filters.length) return t.filters.reduce((t, n, s)=>t && $70fd6868680e912c$var$An(n, e.filters[s]), !0);
        return !1;
    }(t, e) : void $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$vn(t, e) {
    const n = t.filters.concat(e);
    return $70fd6868680e912c$var$gn.create(n, t.op);
}
/** Returns a debug description for `filter`. */ function $70fd6868680e912c$var$Rn(t) {
    return t instanceof $70fd6868680e912c$var$mn ? function(t) {
        return `${t.field.canonicalString()} ${t.op} ${$70fd6868680e912c$var$Qe(t.value)}`;
    }(t) : t instanceof $70fd6868680e912c$var$gn ? function(t) {
        return t.op.toString() + " {" + t.getFilters().map($70fd6868680e912c$var$Rn).join(" ,") + "}";
    }(t) : "Filter";
}
class $70fd6868680e912c$var$Pn extends $70fd6868680e912c$var$mn {
    constructor(t, e, n){
        super(t, e, n), this.key = $70fd6868680e912c$export$afc2e57c475b7810.fromName(n.referenceValue);
    }
    matches(t) {
        const e = $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, this.key);
        return this.matchesComparison(e);
    }
}
/** Filter that matches on key fields within an array. */ class $70fd6868680e912c$var$bn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "in" /* Operator.IN */ , e), this.keys = $70fd6868680e912c$var$Sn("in" /* Operator.IN */ , e);
    }
    matches(t) {
        return this.keys.some((e)=>e.isEqual(t.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $70fd6868680e912c$var$Vn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "not-in" /* Operator.NOT_IN */ , e), this.keys = $70fd6868680e912c$var$Sn("not-in" /* Operator.NOT_IN */ , e);
    }
    matches(t) {
        return !this.keys.some((e)=>e.isEqual(t.key));
    }
}
function $70fd6868680e912c$var$Sn(t, e) {
    var n;
    return ((null === (n = e.arrayValue) || void 0 === n ? void 0 : n.values) || []).map((t)=>$70fd6868680e912c$export$afc2e57c475b7810.fromName(t.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $70fd6868680e912c$var$Dn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "array-contains" /* Operator.ARRAY_CONTAINS */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return $70fd6868680e912c$var$Je(e) && $70fd6868680e912c$var$Ue(e.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $70fd6868680e912c$var$Cn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "in" /* Operator.IN */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return null !== e && $70fd6868680e912c$var$Ue(this.value.arrayValue, e);
    }
}
/** A Filter that implements the not-in operator. */ class $70fd6868680e912c$var$xn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "not-in" /* Operator.NOT_IN */ , e);
    }
    matches(t) {
        if ($70fd6868680e912c$var$Ue(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const e = t.data.field(this.field);
        return null !== e && !$70fd6868680e912c$var$Ue(this.value.arrayValue, e);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $70fd6868680e912c$var$Nn extends $70fd6868680e912c$var$mn {
    constructor(t, e){
        super(t, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , e);
    }
    matches(t) {
        const e = t.data.field(this.field);
        return !(!$70fd6868680e912c$var$Je(e) || !e.arrayValue.values) && e.arrayValue.values.some((t)=>$70fd6868680e912c$var$Ue(this.value.arrayValue, t));
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $70fd6868680e912c$var$kn {
    constructor(t, e = null, n = [], s = [], i = null, r = null, o = null){
        this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = s, this.limit = i, this.startAt = r, this.endAt = o, this.dt = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $70fd6868680e912c$var$Mn(t, e = null, n = [], s = [], i = null, r = null, o = null) {
    return new $70fd6868680e912c$var$kn(t, e, n, s, i, r, o);
}
function $70fd6868680e912c$var$$n(t) {
    const e = $70fd6868680e912c$var$L(t);
    if (null === e.dt) {
        let t = e.path.canonicalString();
        null !== e.collectionGroup && (t += "|cg:" + e.collectionGroup), t += "|f:", t += e.filters.map((t)=>$70fd6868680e912c$var$En(t)).join(","), t += "|ob:", t += e.orderBy.map((t)=>(function(t) {
                // TODO(b/29183165): Make this collision robust.
                return t.field.canonicalString() + t.dir;
            })(t)).join(","), $70fd6868680e912c$var$Ft(e.limit) || (t += "|l:", t += e.limit), e.startAt && (t += "|lb:", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((t)=>$70fd6868680e912c$var$Qe(t)).join(",")), e.endAt && (t += "|ub:", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((t)=>$70fd6868680e912c$var$Qe(t)).join(",")), e.dt = t;
    }
    return e.dt;
}
function $70fd6868680e912c$var$On(t, e) {
    if (t.limit !== e.limit) return !1;
    if (t.orderBy.length !== e.orderBy.length) return !1;
    for(let n = 0; n < t.orderBy.length; n++)if (!$70fd6868680e912c$var$wn(t.orderBy[n], e.orderBy[n])) return !1;
    if (t.filters.length !== e.filters.length) return !1;
    for(let n = 0; n < t.filters.length; n++)if (!$70fd6868680e912c$var$An(t.filters[n], e.filters[n])) return !1;
    return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!$70fd6868680e912c$var$fn(t.startAt, e.startAt) && $70fd6868680e912c$var$fn(t.endAt, e.endAt);
}
function $70fd6868680e912c$var$Fn(t) {
    return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
}
/** Returns the field filters that target the given field path. */ function $70fd6868680e912c$var$Bn(t, e) {
    return t.filters.filter((t)=>t instanceof $70fd6868680e912c$var$mn && t.field.isEqual(e));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $70fd6868680e912c$var$Ln(t, e, n) {
    let s = $70fd6868680e912c$var$Be, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$Bn(t, e)){
        let t = $70fd6868680e912c$var$Be, e = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                t = $70fd6868680e912c$var$nn(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                t = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                t = n.value, e = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                t = $70fd6868680e912c$var$Be;
        }
        $70fd6868680e912c$var$rn({
            value: s,
            inclusive: i
        }, {
            value: t,
            inclusive: e
        }) < 0 && (s = t, i = e);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let r = 0; r < t.orderBy.length; ++r)if (t.orderBy[r].field.isEqual(e)) {
            const t = n.position[r];
            $70fd6868680e912c$var$rn({
                value: s,
                inclusive: i
            }, {
                value: t,
                inclusive: n.inclusive
            }) < 0 && (s = t, i = n.inclusive);
            break;
        }
    }
    return {
        value: s,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $70fd6868680e912c$var$qn(t, e, n) {
    let s = $70fd6868680e912c$var$Fe, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $70fd6868680e912c$var$Bn(t, e)){
        let t = $70fd6868680e912c$var$Fe, e = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                t = $70fd6868680e912c$var$sn(n.value), e = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                t = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                t = n.value, e = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                t = $70fd6868680e912c$var$Fe;
        }
        $70fd6868680e912c$var$on({
            value: s,
            inclusive: i
        }, {
            value: t,
            inclusive: e
        }) > 0 && (s = t, i = e);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let r = 0; r < t.orderBy.length; ++r)if (t.orderBy[r].field.isEqual(e)) {
            const t = n.position[r];
            $70fd6868680e912c$var$on({
                value: s,
                inclusive: i
            }, {
                value: t,
                inclusive: n.inclusive
            }) > 0 && (s = t, i = n.inclusive);
            break;
        }
    }
    return {
        value: s,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $70fd6868680e912c$var$Un {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(t, e = null, n = [], s = [], i = null, r = "F" /* LimitType.First */ , o = null, u = null){
        this.path = t, this.collectionGroup = e, this.explicitOrderBy = n, this.filters = s, this.limit = i, this.limitType = r, this.startAt = o, this.endAt = u, this.wt = null, // The corresponding `Target` of this `Query` instance.
        this._t = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $70fd6868680e912c$var$Kn(t, e, n, s, i, r, o, u) {
    return new $70fd6868680e912c$var$Un(t, e, n, s, i, r, o, u);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $70fd6868680e912c$var$Gn(t) {
    return new $70fd6868680e912c$var$Un(t);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $70fd6868680e912c$var$Qn(t) {
    return 0 === t.filters.length && null === t.limit && null == t.startAt && null == t.endAt && (0 === t.explicitOrderBy.length || 1 === t.explicitOrderBy.length && t.explicitOrderBy[0].field.isKeyField());
}
function $70fd6868680e912c$var$jn(t) {
    return t.explicitOrderBy.length > 0 ? t.explicitOrderBy[0].field : null;
}
function $70fd6868680e912c$var$zn(t) {
    for (const e of t.filters){
        const t = e.getFirstInequalityField();
        if (null !== t) return t;
    }
    return null;
}
/**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $70fd6868680e912c$var$Wn(t) {
    return null !== t.collectionGroup;
}
/**
 * Returns the implicit order by constraint that is used to execute the Query,
 * which can be different from the order by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`).
 */ function $70fd6868680e912c$var$Hn(t) {
    const e = $70fd6868680e912c$var$L(t);
    if (null === e.wt) {
        e.wt = [];
        const t = $70fd6868680e912c$var$zn(e), n = $70fd6868680e912c$var$jn(e);
        if (null !== t && null === n) // In order to implicitly add key ordering, we must also add the
        // inequality filter field for it to be a valid query.
        // Note that the default inequality field and key ordering is ascending.
        t.isKeyField() || e.wt.push(new $70fd6868680e912c$var$dn(t)), e.wt.push(new $70fd6868680e912c$var$dn($70fd6868680e912c$export$b7871852b967eaf1.keyField(), "asc" /* Direction.ASCENDING */ ));
        else {
            let t = !1;
            for (const n of e.explicitOrderBy)e.wt.push(n), n.field.isKeyField() && (t = !0);
            if (!t) {
                // The order of the implicit key ordering always matches the last
                // explicit order by
                const t = e.explicitOrderBy.length > 0 ? e.explicitOrderBy[e.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ ;
                e.wt.push(new $70fd6868680e912c$var$dn($70fd6868680e912c$export$b7871852b967eaf1.keyField(), t));
            }
        }
    }
    return e.wt;
}
/**
 * Converts this `Query` instance to it's corresponding `Target` representation.
 */ function $70fd6868680e912c$var$Jn(t) {
    const e = $70fd6868680e912c$var$L(t);
    if (!e._t) {
        if ("F" /* LimitType.First */  === e.limitType) e._t = $70fd6868680e912c$var$Mn(e.path, e.collectionGroup, $70fd6868680e912c$var$Hn(e), e.filters, e.limit, e.startAt, e.endAt);
        else {
            // Flip the orderBy directions since we want the last results
            const t = [];
            for (const n of $70fd6868680e912c$var$Hn(e)){
                const e = "desc" /* Direction.DESCENDING */  === n.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
                t.push(new $70fd6868680e912c$var$dn(n.field, e));
            }
            // We need to swap the cursors to match the now-flipped query ordering.
            const n = e.endAt ? new $70fd6868680e912c$var$hn(e.endAt.position, e.endAt.inclusive) : null, s = e.startAt ? new $70fd6868680e912c$var$hn(e.startAt.position, e.startAt.inclusive) : null;
            // Now return as a LimitType.First query.
            e._t = $70fd6868680e912c$var$Mn(e.path, e.collectionGroup, t, e.filters, e.limit, n, s);
        }
    }
    return e._t;
}
function $70fd6868680e912c$var$Yn(t, e) {
    e.getFirstInequalityField(), $70fd6868680e912c$var$zn(t);
    const n = t.filters.concat([
        e
    ]);
    return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, t.explicitOrderBy.slice(), n, t.limit, t.limitType, t.startAt, t.endAt);
}
function $70fd6868680e912c$var$Xn(t, e, n) {
    return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), e, n, t.startAt, t.endAt);
}
function $70fd6868680e912c$var$Zn(t, e) {
    return $70fd6868680e912c$var$On($70fd6868680e912c$var$Jn(t), $70fd6868680e912c$var$Jn(e)) && t.limitType === e.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $70fd6868680e912c$var$ts(t) {
    return `${$70fd6868680e912c$var$$n($70fd6868680e912c$var$Jn(t))}|lt:${t.limitType}`;
}
function $70fd6868680e912c$var$es(t) {
    return `Query(target=${function(t) {
        let e = t.path.canonicalString();
        return null !== t.collectionGroup && (e += " collectionGroup=" + t.collectionGroup), t.filters.length > 0 && (e += `, filters: [${t.filters.map((t)=>$70fd6868680e912c$var$Rn(t)).join(", ")}]`), $70fd6868680e912c$var$Ft(t.limit) || (e += ", limit: " + t.limit), t.orderBy.length > 0 && (e += `, orderBy: [${t.orderBy.map((t)=>(function(t) {
                return `${t.field.canonicalString()} (${t.dir})`;
            })(t)).join(", ")}]`), t.startAt && (e += ", startAt: ", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((t)=>$70fd6868680e912c$var$Qe(t)).join(",")), t.endAt && (e += ", endAt: ", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((t)=>$70fd6868680e912c$var$Qe(t)).join(",")), `Target(${e})`;
    }($70fd6868680e912c$var$Jn(t))}; limitType=${t.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $70fd6868680e912c$var$ns(t, e) {
    return e.isFoundDocument() && function(t, e) {
        const n = e.key.path;
        return null !== t.collectionGroup ? e.key.hasCollectionId(t.collectionGroup) && t.path.isPrefixOf(n) : $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) ? t.path.isEqual(n) : t.path.isImmediateParentOf(n);
    }(t, e) && function(t, e) {
        // We must use `queryOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $70fd6868680e912c$var$Hn(t))// order by key always matches
        if (!n.field.isKeyField() && null === e.data.field(n.field)) return !1;
        return !0;
    }(t, e) && function(t, e) {
        for (const n of t.filters)if (!n.matches(e)) return !1;
        return !0;
    }(t, e) && function(t, e) {
        if (t.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function(t, e, n) {
            const s = $70fd6868680e912c$var$ln(t, e, n);
            return t.inclusive ? s <= 0 : s < 0;
        }(t.startAt, $70fd6868680e912c$var$Hn(t), e)) return !1;
        if (t.endAt && !function(t, e, n) {
            const s = $70fd6868680e912c$var$ln(t, e, n);
            return t.inclusive ? s >= 0 : s > 0;
        }(t.endAt, $70fd6868680e912c$var$Hn(t), e)) return !1;
        return !0;
    }(t, e);
}
function $70fd6868680e912c$var$ss(t) {
    return t.collectionGroup || (t.path.length % 2 == 1 ? t.path.lastSegment() : t.path.get(t.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $70fd6868680e912c$var$is(t) {
    return (e, n)=>{
        let s = !1;
        for (const i of $70fd6868680e912c$var$Hn(t)){
            const t = $70fd6868680e912c$var$rs(i, e, n);
            if (0 !== t) return t;
            s = s || i.field.isKeyField();
        }
        return 0;
    };
}
function $70fd6868680e912c$var$rs(t, e, n) {
    const s = t.field.isKeyField() ? $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, n.key) : function(t, e, n) {
        const s = e.data.field(t), i = n.data.field(t);
        return null !== s && null !== i ? $70fd6868680e912c$var$Ke(s, i) : $70fd6868680e912c$var$O();
    }(t.field, e, n);
    switch(t.dir){
        case "asc" /* Direction.ASCENDING */ :
            return s;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * s;
        default:
            return $70fd6868680e912c$var$O();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $70fd6868680e912c$var$os {
    constructor(t, e){
        this.mapKeyFn = t, this.equalsFn = e, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(t) {
        const e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 !== n) {
            for (const [e, s] of n)if (this.equalsFn(e, t)) return s;
        }
    }
    has(t) {
        return void 0 !== this.get(t);
    }
    /** Put this key and value in the map. */ set(t, e) {
        const n = this.mapKeyFn(t), s = this.inner[n];
        if (void 0 === s) return this.inner[n] = [
            [
                t,
                e
            ]
        ], void this.innerSize++;
        for(let n = 0; n < s.length; n++)if (this.equalsFn(s[n][0], t)) // This is updating an existing entry and does not increase `innerSize`.
        return void (s[n] = [
            t,
            e
        ]);
        s.push([
            t,
            e
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(t) {
        const e = this.mapKeyFn(t), n = this.inner[e];
        if (void 0 === n) return !1;
        for(let s = 0; s < n.length; s++)if (this.equalsFn(n[s][0], t)) return 1 === n.length ? delete this.inner[e] : n.splice(s, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(t) {
        $70fd6868680e912c$var$ge(this.inner, (e, n)=>{
            for (const [e, s] of n)t(e, s);
        });
    }
    isEmpty() {
        return $70fd6868680e912c$var$ye(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$us = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$cs() {
    return $70fd6868680e912c$var$us;
}
const $70fd6868680e912c$var$as = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$hs(...t) {
    let e = $70fd6868680e912c$var$as;
    for (const n of t)e = e.insert(n.key, n);
    return e;
}
function $70fd6868680e912c$var$ls(t) {
    let e = $70fd6868680e912c$var$as;
    return t.forEach((t, n)=>e = e.insert(t, n.overlayedDocument)), e;
}
function $70fd6868680e912c$var$fs() {
    return $70fd6868680e912c$var$ws();
}
function $70fd6868680e912c$var$ds() {
    return $70fd6868680e912c$var$ws();
}
function $70fd6868680e912c$var$ws() {
    return new $70fd6868680e912c$var$os((t)=>t.toString(), (t, e)=>t.isEqual(e));
}
const $70fd6868680e912c$var$_s = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
const $70fd6868680e912c$var$ms = new $70fd6868680e912c$var$Ee($70fd6868680e912c$export$afc2e57c475b7810.comparator);
function $70fd6868680e912c$var$gs(...t) {
    let e = $70fd6868680e912c$var$ms;
    for (const n of t)e = e.add(n);
    return e;
}
const $70fd6868680e912c$var$ys = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
function $70fd6868680e912c$var$ps() {
    return $70fd6868680e912c$var$ys;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $70fd6868680e912c$var$Is(t, e) {
    if (t.useProto3Json) {
        if (isNaN(e)) return {
            doubleValue: "NaN"
        };
        if (e === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (e === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $70fd6868680e912c$var$Bt(e) ? "-0" : e
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $70fd6868680e912c$var$Ts(t) {
    return {
        integerValue: "" + t
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $70fd6868680e912c$var$Es(t, e) {
    return $70fd6868680e912c$var$Lt(e) ? $70fd6868680e912c$var$Ts(e) : $70fd6868680e912c$var$Is(t, e);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $70fd6868680e912c$var$As {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $70fd6868680e912c$var$vs(t, e, n) {
    return t instanceof $70fd6868680e912c$var$bs ? function(t, e) {
        const n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: t.seconds,
                        nanos: t.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return e && $70fd6868680e912c$var$Ne(e) && (e = $70fd6868680e912c$var$ke(e)), e && (n.fields.__previous_value__ = e), {
            mapValue: n
        };
    }(n, e) : t instanceof $70fd6868680e912c$var$Vs ? $70fd6868680e912c$var$Ss(t, e) : t instanceof $70fd6868680e912c$var$Ds ? $70fd6868680e912c$var$Cs(t, e) : function(t, e) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $70fd6868680e912c$var$Ps(t, e), s = $70fd6868680e912c$var$Ns(n) + $70fd6868680e912c$var$Ns(t.gt);
        return $70fd6868680e912c$var$He(n) && $70fd6868680e912c$var$He(t.gt) ? $70fd6868680e912c$var$Ts(s) : $70fd6868680e912c$var$Is(t.serializer, s);
    }(t, e);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $70fd6868680e912c$var$Rs(t, e, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return t instanceof $70fd6868680e912c$var$Vs ? $70fd6868680e912c$var$Ss(t, e) : t instanceof $70fd6868680e912c$var$Ds ? $70fd6868680e912c$var$Cs(t, e) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $70fd6868680e912c$var$Ps(t, e) {
    var n;
    return t instanceof $70fd6868680e912c$var$xs ? $70fd6868680e912c$var$He(n = e) || function(t) {
        return !!t && "doubleValue" in t;
    }(n) ? e : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $70fd6868680e912c$var$bs extends $70fd6868680e912c$var$As {
}
/** Transforms an array value via a union operation. */ class $70fd6868680e912c$var$Vs extends $70fd6868680e912c$var$As {
    constructor(t){
        super(), this.elements = t;
    }
}
function $70fd6868680e912c$var$Ss(t, e) {
    const n = $70fd6868680e912c$var$ks(e);
    for (const e of t.elements)n.some((t)=>$70fd6868680e912c$var$qe(t, e)) || n.push(e);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $70fd6868680e912c$var$Ds extends $70fd6868680e912c$var$As {
    constructor(t){
        super(), this.elements = t;
    }
}
function $70fd6868680e912c$var$Cs(t, e) {
    let n = $70fd6868680e912c$var$ks(e);
    for (const e of t.elements)n = n.filter((t)=>!$70fd6868680e912c$var$qe(t, e));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $70fd6868680e912c$var$xs extends $70fd6868680e912c$var$As {
    constructor(t, e){
        super(), this.serializer = t, this.gt = e;
    }
}
function $70fd6868680e912c$var$Ns(t) {
    return $70fd6868680e912c$var$Ce(t.integerValue || t.doubleValue);
}
function $70fd6868680e912c$var$ks(t) {
    return $70fd6868680e912c$var$Je(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $70fd6868680e912c$var$Ms {
    constructor(t, e){
        this.field = t, this.transform = e;
    }
}
function $70fd6868680e912c$var$$s(t, e) {
    return t.field.isEqual(e.field) && function(t, e) {
        return t instanceof $70fd6868680e912c$var$Vs && e instanceof $70fd6868680e912c$var$Vs || t instanceof $70fd6868680e912c$var$Ds && e instanceof $70fd6868680e912c$var$Ds ? $70fd6868680e912c$var$nt(t.elements, e.elements, $70fd6868680e912c$var$qe) : t instanceof $70fd6868680e912c$var$xs && e instanceof $70fd6868680e912c$var$xs ? $70fd6868680e912c$var$qe(t.gt, e.gt) : t instanceof $70fd6868680e912c$var$bs && e instanceof $70fd6868680e912c$var$bs;
    }(t.transform, e.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $70fd6868680e912c$var$Os {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ t, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ e){
        this.version = t, this.transformResults = e;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $70fd6868680e912c$var$Fs {
    constructor(t, e){
        this.updateTime = t, this.exists = e;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $70fd6868680e912c$var$Fs;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(t) {
        return new $70fd6868680e912c$var$Fs(void 0, t);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(t) {
        return new $70fd6868680e912c$var$Fs(t);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(t) {
        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $70fd6868680e912c$var$Bs(t, e) {
    return void 0 !== t.updateTime ? e.isFoundDocument() && e.version.isEqual(t.updateTime) : void 0 === t.exists || t.exists === e.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $70fd6868680e912c$var$Ls {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $70fd6868680e912c$var$qs(t, e) {
    if (!t.hasLocalMutations || e && 0 === e.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === e) return t.isNoDocument() ? new $70fd6868680e912c$var$Ys(t.key, $70fd6868680e912c$var$Fs.none()) : new $70fd6868680e912c$var$js(t.key, t.data, $70fd6868680e912c$var$Fs.none());
    {
        const n = t.data, s = $70fd6868680e912c$var$un.empty();
        let i = new $70fd6868680e912c$var$Ee($70fd6868680e912c$export$b7871852b967eaf1.comparator);
        for (let t of e.fields)if (!i.has(t)) {
            let e = n.field(t);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === e && t.length > 1 && (t = t.popLast(), e = n.field(t)), null === e ? s.delete(t) : s.set(t, e), i = i.add(t);
        }
        return new $70fd6868680e912c$var$zs(t.key, s, new $70fd6868680e912c$var$Re(i.toArray()), $70fd6868680e912c$var$Fs.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $70fd6868680e912c$var$Us(t, e, n) {
    t instanceof $70fd6868680e912c$var$js ? function(t, e, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const s = t.value.clone(), i = $70fd6868680e912c$var$Hs(t.fieldTransforms, e, n.transformResults);
        s.setAll(i), e.convertToFoundDocument(n.version, s).setHasCommittedMutations();
    }(t, e, n) : t instanceof $70fd6868680e912c$var$zs ? function(t, e, n) {
        if (!$70fd6868680e912c$var$Bs(t.precondition, e)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void e.convertToUnknownDocument(n.version);
        const s = $70fd6868680e912c$var$Hs(t.fieldTransforms, e, n.transformResults), i = e.data;
        i.setAll($70fd6868680e912c$var$Ws(t)), i.setAll(s), e.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(t, e, n) : function(t, e, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        e.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, e, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $70fd6868680e912c$var$Ks(t, e, n, s) {
    return t instanceof $70fd6868680e912c$var$js ? function(t, e, n, s) {
        if (!$70fd6868680e912c$var$Bs(t.precondition, e)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = t.value.clone(), r = $70fd6868680e912c$var$Js(t.fieldTransforms, s, e);
        return i.setAll(r), e.convertToFoundDocument(e.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(t, e, n, s) : t instanceof $70fd6868680e912c$var$zs ? function(t, e, n, s) {
        if (!$70fd6868680e912c$var$Bs(t.precondition, e)) return n;
        const i = $70fd6868680e912c$var$Js(t.fieldTransforms, s, e), r = e.data;
        if (r.setAll($70fd6868680e912c$var$Ws(t)), r.setAll(i), e.convertToFoundDocument(e.version, r).setHasLocalMutations(), null === n) return null;
        return n.unionWith(t.fieldMask.fields).unionWith(t.fieldTransforms.map((t)=>t.field));
    }(t, e, n, s) : function(t, e, n) {
        if ($70fd6868680e912c$var$Bs(t.precondition, e)) return e.convertToNoDocument(e.version).setHasLocalMutations(), null;
        return n;
    }(t, e, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $70fd6868680e912c$var$Gs(t, e) {
    let n = null;
    for (const s of t.fieldTransforms){
        const t = e.data.field(s.field), i = $70fd6868680e912c$var$Ps(s.transform, t || null);
        null != i && (null === n && (n = $70fd6868680e912c$var$un.empty()), n.set(s.field, i));
    }
    return n || null;
}
function $70fd6868680e912c$var$Qs(t, e) {
    return t.type === e.type && !!t.key.isEqual(e.key) && !!t.precondition.isEqual(e.precondition) && !!function(t, e) {
        return void 0 === t && void 0 === e || !(!t || !e) && $70fd6868680e912c$var$nt(t, e, (t, e)=>$70fd6868680e912c$var$$s(t, e));
    }(t.fieldTransforms, e.fieldTransforms) && (0 /* MutationType.Set */  === t.type ? t.value.isEqual(e.value) : 1 /* MutationType.Patch */  !== t.type || t.data.isEqual(e.data) && t.fieldMask.isEqual(e.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $70fd6868680e912c$var$js extends $70fd6868680e912c$var$Ls {
    constructor(t, e, n, s = []){
        super(), this.key = t, this.value = e, this.precondition = n, this.fieldTransforms = s, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$zs extends $70fd6868680e912c$var$Ls {
    constructor(t, e, n, s, i = []){
        super(), this.key = t, this.data = e, this.fieldMask = n, this.precondition = s, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $70fd6868680e912c$var$Ws(t) {
    const e = new Map;
    return t.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const s = t.data.field(n);
            e.set(n, s);
        }
    }), e;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$Hs(t, e, n) {
    const s = new Map;
    $70fd6868680e912c$var$F(t.length === n.length);
    for(let i = 0; i < n.length; i++){
        const r = t[i], o = r.transform, u = e.data.field(r.field);
        s.set(r.field, $70fd6868680e912c$var$Rs(o, u, n[i]));
    }
    return s;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $70fd6868680e912c$var$Js(t, e, n) {
    const s = new Map;
    for (const i of t){
        const t = i.transform, r = n.data.field(i.field);
        s.set(i.field, $70fd6868680e912c$var$vs(t, r, e));
    }
    return s;
}
/** A mutation that deletes the document at the given key. */ class $70fd6868680e912c$var$Ys extends $70fd6868680e912c$var$Ls {
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $70fd6868680e912c$var$Xs extends $70fd6868680e912c$var$Ls {
    constructor(t, e){
        super(), this.key = t, this.precondition = e, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $70fd6868680e912c$var$Zs {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(t, e, n, s){
        this.batchId = t, this.localWriteTime = e, this.baseMutations = n, this.mutations = s;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(t, e) {
        const n = e.mutationResults;
        for(let e = 0; e < this.mutations.length; e++){
            const s = this.mutations[e];
            if (s.key.isEqual(t.key)) $70fd6868680e912c$var$Us(s, t, n[e]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(t, e) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(t.key) && (e = $70fd6868680e912c$var$Ks(n, t, e, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(t.key) && (e = $70fd6868680e912c$var$Ks(n, t, e, this.localWriteTime));
        return e;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(t, e) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $70fd6868680e912c$var$ds();
        return this.mutations.forEach((s)=>{
            const i = t.get(s.key), r = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let o = this.applyToLocalView(r, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            o = e.has(s.key) ? null : o;
            const u = $70fd6868680e912c$var$qs(r, o);
            null !== u && n.set(s.key, u), r.isValidDocument() || r.convertToNoDocument($70fd6868680e912c$var$rt.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((t, e)=>t.add(e.key), $70fd6868680e912c$var$gs());
    }
    isEqual(t) {
        return this.batchId === t.batchId && $70fd6868680e912c$var$nt(this.mutations, t.mutations, (t, e)=>$70fd6868680e912c$var$Qs(t, e)) && $70fd6868680e912c$var$nt(this.baseMutations, t.baseMutations, (t, e)=>$70fd6868680e912c$var$Qs(t, e));
    }
}
/** The result of applying a mutation batch to the backend. */ class $70fd6868680e912c$var$ti {
    constructor(t, e, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ s){
        this.batch = t, this.commitVersion = e, this.mutationResults = n, this.docVersions = s;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(t, e, n) {
        $70fd6868680e912c$var$F(t.mutations.length === n.length);
        let s = $70fd6868680e912c$var$_s;
        const i = t.mutations;
        for(let t = 0; t < i.length; t++)s = s.insert(i[t].key, n[t].version);
        return new $70fd6868680e912c$var$ti(t, e, n, s);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $70fd6868680e912c$var$ei {
    constructor(t, e){
        this.largestBatchId = t, this.mutation = e;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(t) {
        return null !== t && this.mutation === t.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $70fd6868680e912c$var$ni {
    constructor(t, e, n){
        this.alias = t, this.yt = e, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$si {
    constructor(t, e){
        this.count = t, this.unchangedNames = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $70fd6868680e912c$var$ii, $70fd6868680e912c$var$ri;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $70fd6868680e912c$var$oi(t) {
    switch(t){
        default:
            return $70fd6868680e912c$var$O();
        case $70fd6868680e912c$var$q.CANCELLED:
        case $70fd6868680e912c$var$q.UNKNOWN:
        case $70fd6868680e912c$var$q.DEADLINE_EXCEEDED:
        case $70fd6868680e912c$var$q.RESOURCE_EXHAUSTED:
        case $70fd6868680e912c$var$q.INTERNAL:
        case $70fd6868680e912c$var$q.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $70fd6868680e912c$var$q.UNAUTHENTICATED:
            return !1;
        case $70fd6868680e912c$var$q.INVALID_ARGUMENT:
        case $70fd6868680e912c$var$q.NOT_FOUND:
        case $70fd6868680e912c$var$q.ALREADY_EXISTS:
        case $70fd6868680e912c$var$q.PERMISSION_DENIED:
        case $70fd6868680e912c$var$q.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $70fd6868680e912c$var$q.ABORTED:
        case $70fd6868680e912c$var$q.OUT_OF_RANGE:
        case $70fd6868680e912c$var$q.UNIMPLEMENTED:
        case $70fd6868680e912c$var$q.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $70fd6868680e912c$var$ui(t) {
    if (void 0 === t) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $70fd6868680e912c$var$k("GRPC error has no .code"), $70fd6868680e912c$var$q.UNKNOWN;
    switch(t){
        case $70fd6868680e912c$var$ii.OK:
            return $70fd6868680e912c$var$q.OK;
        case $70fd6868680e912c$var$ii.CANCELLED:
            return $70fd6868680e912c$var$q.CANCELLED;
        case $70fd6868680e912c$var$ii.UNKNOWN:
            return $70fd6868680e912c$var$q.UNKNOWN;
        case $70fd6868680e912c$var$ii.DEADLINE_EXCEEDED:
            return $70fd6868680e912c$var$q.DEADLINE_EXCEEDED;
        case $70fd6868680e912c$var$ii.RESOURCE_EXHAUSTED:
            return $70fd6868680e912c$var$q.RESOURCE_EXHAUSTED;
        case $70fd6868680e912c$var$ii.INTERNAL:
            return $70fd6868680e912c$var$q.INTERNAL;
        case $70fd6868680e912c$var$ii.UNAVAILABLE:
            return $70fd6868680e912c$var$q.UNAVAILABLE;
        case $70fd6868680e912c$var$ii.UNAUTHENTICATED:
            return $70fd6868680e912c$var$q.UNAUTHENTICATED;
        case $70fd6868680e912c$var$ii.INVALID_ARGUMENT:
            return $70fd6868680e912c$var$q.INVALID_ARGUMENT;
        case $70fd6868680e912c$var$ii.NOT_FOUND:
            return $70fd6868680e912c$var$q.NOT_FOUND;
        case $70fd6868680e912c$var$ii.ALREADY_EXISTS:
            return $70fd6868680e912c$var$q.ALREADY_EXISTS;
        case $70fd6868680e912c$var$ii.PERMISSION_DENIED:
            return $70fd6868680e912c$var$q.PERMISSION_DENIED;
        case $70fd6868680e912c$var$ii.FAILED_PRECONDITION:
            return $70fd6868680e912c$var$q.FAILED_PRECONDITION;
        case $70fd6868680e912c$var$ii.ABORTED:
            return $70fd6868680e912c$var$q.ABORTED;
        case $70fd6868680e912c$var$ii.OUT_OF_RANGE:
            return $70fd6868680e912c$var$q.OUT_OF_RANGE;
        case $70fd6868680e912c$var$ii.UNIMPLEMENTED:
            return $70fd6868680e912c$var$q.UNIMPLEMENTED;
        case $70fd6868680e912c$var$ii.DATA_LOSS:
            return $70fd6868680e912c$var$q.DATA_LOSS;
        default:
            return $70fd6868680e912c$var$O();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($70fd6868680e912c$var$ri = $70fd6868680e912c$var$ii || ($70fd6868680e912c$var$ii = {}))[$70fd6868680e912c$var$ri.OK = 0] = "OK", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.CANCELLED = 1] = "CANCELLED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.UNKNOWN = 2] = "UNKNOWN", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.NOT_FOUND = 5] = "NOT_FOUND", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.ABORTED = 10] = "ABORTED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.INTERNAL = 13] = "INTERNAL", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.UNAVAILABLE = 14] = "UNAVAILABLE", $70fd6868680e912c$var$ri[$70fd6868680e912c$var$ri.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Manages "testing hooks", hooks into the internals of the SDK to verify
 * internal state and events during integration tests. Do not use this class
 * except for testing purposes.
 *
 * There are two ways to retrieve the global singleton instance of this class:
 * 1. The `instance` property, which returns null if the global singleton
 *      instance has not been created. Use this property if the caller should
 *      "do nothing" if there are no testing hooks registered, such as when
 *      delivering an event to notify registered callbacks.
 * 2. The `getOrCreateInstance()` method, which creates the global singleton
 *      instance if it has not been created. Use this method if the instance is
 *      needed to, for example, register a callback.
 *
 * @internal
 */ class $70fd6868680e912c$export$3ab3ff3652492b82 {
    constructor(){
        this.onExistenceFilterMismatchCallbacks = new Map;
    }
    /**
     * Returns the singleton instance of this class, or null if it has not been
     * initialized.
     */ static get instance() {
        return $70fd6868680e912c$var$ai;
    }
    /**
     * Returns the singleton instance of this class, creating it if is has never
     * been created before.
     */ static getOrCreateInstance() {
        return null === $70fd6868680e912c$var$ai && ($70fd6868680e912c$var$ai = new $70fd6868680e912c$export$3ab3ff3652492b82), $70fd6868680e912c$var$ai;
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ onExistenceFilterMismatch(t) {
        const e = Symbol();
        return this.onExistenceFilterMismatchCallbacks.set(e, t), ()=>this.onExistenceFilterMismatchCallbacks.delete(e);
    }
    /**
     * Invokes all currently-registered `onExistenceFilterMismatch` callbacks.
     * @param info Information about the existence filter mismatch.
     */ notifyOnExistenceFilterMismatch(t) {
        this.onExistenceFilterMismatchCallbacks.forEach((e)=>e(t));
    }
}
/** The global singleton instance of `TestingHooks`. */ let $70fd6868680e912c$var$ai = null;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $70fd6868680e912c$var$hi() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$li = new (0, $f4a7ee607ae1ef78$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $70fd6868680e912c$var$fi(t) {
    const e = $70fd6868680e912c$var$hi().encode(t), n = new (0, $f4a7ee607ae1ef78$export$9f5a3dfc7a9f5dd);
    return n.update(e), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $70fd6868680e912c$var$di(t) {
    const e = new DataView(t.buffer), n = e.getUint32(0, /* littleEndian= */ !0), s = e.getUint32(4, /* littleEndian= */ !0), i = e.getUint32(8, /* littleEndian= */ !0), r = e.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $f4a7ee607ae1ef78$export$70ffa26850098d01)([
            n,
            s
        ], 0),
        new (0, $f4a7ee607ae1ef78$export$70ffa26850098d01)([
            i,
            r
        ], 0)
    ];
}
class $70fd6868680e912c$var$wi {
    constructor(t, e, n){
        if (this.bitmap = t, this.padding = e, this.hashCount = n, e < 0 || e >= 8) throw new $70fd6868680e912c$var$_i(`Invalid padding: ${e}`);
        if (n < 0) throw new $70fd6868680e912c$var$_i(`Invalid hash count: ${n}`);
        if (t.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $70fd6868680e912c$var$_i(`Invalid hash count: ${n}`);
        if (0 === t.length && 0 !== e) // Empty bloom filter should have 0 padding.
        throw new $70fd6868680e912c$var$_i(`Invalid padding when bitmap length is 0: ${e}`);
        this.It = 8 * t.length - e, // Set the bit count in Integer to avoid repetition in mightContain().
        this.Tt = (0, $f4a7ee607ae1ef78$export$70ffa26850098d01).fromNumber(this.It);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    Et(t, e, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let s = t.add(e.multiply((0, $f4a7ee607ae1ef78$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === s.compare($70fd6868680e912c$var$li) && (s = new (0, $f4a7ee607ae1ef78$export$70ffa26850098d01)([
            s.getBits(0),
            s.getBits(1)
        ], 0)), s.modulo(this.Tt).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    At(t) {
        return 0 != (this.bitmap[Math.floor(t / 8)] & 1 << t % 8);
    }
    vt(t) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.It) return !1;
        const e = $70fd6868680e912c$var$fi(t), [n, s] = $70fd6868680e912c$var$di(e);
        for(let t = 0; t < this.hashCount; t++){
            const e = this.Et(n, s, t);
            if (!this.At(e)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(t, e, n) {
        const s = t % 8 == 0 ? 0 : 8 - t % 8, i = new Uint8Array(Math.ceil(t / 8)), r = new $70fd6868680e912c$var$wi(i, s, e);
        return n.forEach((t)=>r.insert(t)), r;
    }
    insert(t) {
        if (0 === this.It) return;
        const e = $70fd6868680e912c$var$fi(t), [n, s] = $70fd6868680e912c$var$di(e);
        for(let t = 0; t < this.hashCount; t++){
            const e = this.Et(n, s, t);
            this.Rt(e);
        }
    }
    Rt(t) {
        const e = Math.floor(t / 8), n = t % 8;
        this.bitmap[e] |= 1 << n;
    }
}
class $70fd6868680e912c$var$_i extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $70fd6868680e912c$var$mi {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ t, /**
     * A map from target to changes to the target. See TargetChange.
     */ e, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ s, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i){
        this.snapshotVersion = t, this.targetChanges = e, this.targetMismatches = n, this.documentUpdates = s, this.resolvedLimboDocuments = i;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(t, e, n) {
        const s = new Map;
        return s.set(t, $70fd6868680e912c$var$gi.createSynthesizedTargetChangeForCurrentChange(t, e, n)), new $70fd6868680e912c$var$mi($70fd6868680e912c$var$rt.min(), s, new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), $70fd6868680e912c$var$cs(), $70fd6868680e912c$var$gs());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $70fd6868680e912c$var$gi {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ t, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ e, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ s, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = t, this.current = e, this.addedDocuments = n, this.modifiedDocuments = s, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(t, e, n) {
        return new $70fd6868680e912c$var$gi(n, e, $70fd6868680e912c$var$gs(), $70fd6868680e912c$var$gs(), $70fd6868680e912c$var$gs());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $70fd6868680e912c$var$yi {
    constructor(/** The new document applies to all of these targets. */ t, /** The new document is removed from all of these targets. */ e, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ s){
        this.Pt = t, this.removedTargetIds = e, this.key = n, this.bt = s;
    }
}
class $70fd6868680e912c$var$pi {
    constructor(t, e){
        this.targetId = t, this.Vt = e;
    }
}
class $70fd6868680e912c$var$Ii {
    constructor(/** What kind of change occurred to the watch target. */ t, /** The target IDs that were added/removed/set. */ e, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, s = null){
        this.state = t, this.targetIds = e, this.resumeToken = n, this.cause = s;
    }
}
/** Tracks the internal state of a Watch target. */ class $70fd6868680e912c$var$Ti {
    constructor(){
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.St = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Dt = $70fd6868680e912c$var$vi(), /** See public getters for explanations of these fields. */ this.Ct = $70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, this.xt = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Nt = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.xt;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Ct;
    }
    /** Whether this target has pending target adds or target removes. */ get kt() {
        return 0 !== this.St;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Mt() {
        return this.Nt;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ $t(t) {
        t.approximateByteSize() > 0 && (this.Nt = !0, this.Ct = t);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ Ot() {
        let t = $70fd6868680e912c$var$gs(), e = $70fd6868680e912c$var$gs(), n = $70fd6868680e912c$var$gs();
        return this.Dt.forEach((s, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    t = t.add(s);
                    break;
                case 2 /* ChangeType.Modified */ :
                    e = e.add(s);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(s);
                    break;
                default:
                    $70fd6868680e912c$var$O();
            }
        }), new $70fd6868680e912c$var$gi(this.Ct, this.xt, t, e, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ Ft() {
        this.Nt = !1, this.Dt = $70fd6868680e912c$var$vi();
    }
    Bt(t, e) {
        this.Nt = !0, this.Dt = this.Dt.insert(t, e);
    }
    Lt(t) {
        this.Nt = !0, this.Dt = this.Dt.remove(t);
    }
    qt() {
        this.St += 1;
    }
    Ut() {
        this.St -= 1;
    }
    Kt() {
        this.Nt = !0, this.xt = !0;
    }
}
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $70fd6868680e912c$var$Ei {
    constructor(t){
        this.Gt = t, /** The internal state of all tracked targets. */ this.Qt = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.jt = $70fd6868680e912c$var$cs(), /** A mapping of document keys to their set of target IDs. */ this.zt = $70fd6868680e912c$var$Ai(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Wt = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ Ht(t) {
        for (const e of t.Pt)t.bt && t.bt.isFoundDocument() ? this.Jt(e, t.bt) : this.Yt(e, t.key, t.bt);
        for (const e of t.removedTargetIds)this.Yt(e, t.key, t.bt);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ Xt(t) {
        this.forEachTarget(t, (e)=>{
            const n = this.Zt(e);
            switch(t.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.te(e) && n.$t(t.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ut(), n.kt || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.Ft(), n.$t(t.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Ut(), n.kt || this.removeTarget(e);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.te(e) && (n.Kt(), n.$t(t.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.te(e) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.ee(e), n.$t(t.resumeToken));
                    break;
                default:
                    $70fd6868680e912c$var$O();
            }
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(t, e) {
        t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.Qt.forEach((t, n)=>{
            this.te(n) && e(n);
        });
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ ne(t) {
        var e;
        const n = t.targetId, s = t.Vt.count, i = this.se(n);
        if (i) {
            const r = i.target;
            if ($70fd6868680e912c$var$Fn(r)) {
                if (0 === s) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const t = new $70fd6868680e912c$export$afc2e57c475b7810(r.path);
                    this.Yt(n, t, $70fd6868680e912c$var$an.newNoDocument(t, $70fd6868680e912c$var$rt.min()));
                } else $70fd6868680e912c$var$F(1 === s);
            } else {
                const i = this.ie(n);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (i !== s) {
                    // Apply bloom filter to identify and mark removed documents.
                    const s = this.re(t, i);
                    if (0 /* BloomFilterApplicationStatus.Success */  !== s) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.ee(n);
                        const t = 2 /* BloomFilterApplicationStatus.FalsePositive */  === s ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Wt = this.Wt.insert(n, t);
                    }
                    null === (e = $70fd6868680e912c$export$3ab3ff3652492b82.instance) || void 0 === e || e.notifyOnExistenceFilterMismatch(function(t, e, n) {
                        var s, i, r, o, u, c;
                        const a = {
                            localCacheCount: e,
                            existenceFilterCount: n.count
                        }, h = n.unchangedNames;
                        h && (a.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === t,
                            hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                            bitmapLength: null !== (o = null === (r = null === (i = null == h ? void 0 : h.bits) || void 0 === i ? void 0 : i.bitmap) || void 0 === r ? void 0 : r.length) && void 0 !== o ? o : 0,
                            padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0
                        });
                        return a;
                    }(s, i, t.Vt));
                }
            }
        }
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ re(t, e) {
        const { unchangedNames: n, count: s } = t.Vt;
        if (!n || !n.bits) return 1 /* BloomFilterApplicationStatus.Skipped */ ;
        const { bits: { bitmap: i = "", padding: r = 0 }, hashCount: o = 0 } = n;
        let u, c;
        try {
            u = $70fd6868680e912c$var$xe(i).toUint8Array();
        } catch (t) {
            if (t instanceof $70fd6868680e912c$var$Pe) return $70fd6868680e912c$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + t.message + "); ignoring the bloom filter and falling back to full re-query."), 1 /* BloomFilterApplicationStatus.Skipped */ ;
            throw t;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            c = new $70fd6868680e912c$var$wi(u, r, o);
        } catch (t) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb(t instanceof $70fd6868680e912c$var$_i ? "BloomFilter error: " : "Applying bloom filter failed: ", t), 1 /* BloomFilterApplicationStatus.Skipped */ ;
        }
        if (0 === c.It) return 1 /* BloomFilterApplicationStatus.Skipped */ ;
        return s !== e - this.oe(t.targetId, c) ? 2 /* BloomFilterApplicationStatus.FalsePositive */  : 0 /* BloomFilterApplicationStatus.Success */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ oe(t, e) {
        const n = this.Gt.getRemoteKeysForTarget(t);
        let s = 0;
        return n.forEach((n)=>{
            const i = this.Gt.ue(), r = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.vt(r) || (this.Yt(t, n, /*updatedDocument=*/ null), s++);
        }), s;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ ce(t) {
        const e = new Map;
        this.Qt.forEach((n, s)=>{
            const i = this.se(s);
            if (i) {
                if (n.current && $70fd6868680e912c$var$Fn(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document. This
                    // resolves the limbo state of the document, removing it from
                    // limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const e = new $70fd6868680e912c$export$afc2e57c475b7810(i.target.path);
                    null !== this.jt.get(e) || this.ae(s, e) || this.Yt(s, e, $70fd6868680e912c$var$an.newNoDocument(e, t));
                }
                n.Mt && (e.set(s, n.Ot()), n.Ft());
            }
        });
        let n = $70fd6868680e912c$var$gs();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.zt.forEach((t, e)=>{
            let s = !0;
            e.forEachWhile((t)=>{
                const e = this.se(t);
                return !e || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === e.purpose || (s = !1, !1);
            }), s && (n = n.add(t));
        }), this.jt.forEach((e, n)=>n.setReadTime(t));
        const s = new $70fd6868680e912c$var$mi(t, e, this.Wt, this.jt, n);
        return this.jt = $70fd6868680e912c$var$cs(), this.zt = $70fd6868680e912c$var$Ai(), this.Wt = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), s;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    Jt(t, e) {
        if (!this.te(t)) return;
        const n = this.ae(t, e.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        this.Zt(t).Bt(e.key, n), this.jt = this.jt.insert(e.key, e), this.zt = this.zt.insert(e.key, this.he(e.key).add(t));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    Yt(t, e, n) {
        if (!this.te(t)) return;
        const s = this.Zt(t);
        this.ae(t, e) ? s.Bt(e, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        s.Lt(e), this.zt = this.zt.insert(e, this.he(e).delete(t)), n && (this.jt = this.jt.insert(e, n));
    }
    removeTarget(t) {
        this.Qt.delete(t);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ ie(t) {
        const e = this.Zt(t).Ot();
        return this.Gt.getRemoteKeysForTarget(t).size + e.addedDocuments.size - e.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ qt(t) {
        this.Zt(t).qt();
    }
    Zt(t) {
        let e = this.Qt.get(t);
        return e || (e = new $70fd6868680e912c$var$Ti, this.Qt.set(t, e)), e;
    }
    he(t) {
        let e = this.zt.get(t);
        return e || (e = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et), this.zt = this.zt.insert(t, e)), e;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ te(t) {
        const e = null !== this.se(t);
        return e || $70fd6868680e912c$var$N("WatchChangeAggregator", "Detected inactive target", t), e;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ se(t) {
        const e = this.Qt.get(t);
        return e && e.kt ? null : this.Gt.le(t);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ ee(t) {
        this.Qt.set(t, new $70fd6868680e912c$var$Ti);
        this.Gt.getRemoteKeysForTarget(t).forEach((e)=>{
            this.Yt(t, e, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ ae(t, e) {
        return this.Gt.getRemoteKeysForTarget(t).has(e);
    }
}
function $70fd6868680e912c$var$Ai() {
    return new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
function $70fd6868680e912c$var$vi() {
    return new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
}
const $70fd6868680e912c$var$Ri = (()=>{
    const t = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return t;
})(), $70fd6868680e912c$var$Pi = (()=>{
    const t = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return t;
})(), $70fd6868680e912c$var$bi = (()=>{
    const t = {
        and: "AND",
        or: "OR"
    };
    return t;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $70fd6868680e912c$var$Vi {
    constructor(t, e){
        this.databaseId = t, this.useProto3Json = e;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $70fd6868680e912c$var$Si(t, e) {
    return t.useProto3Json || $70fd6868680e912c$var$Ft(e) ? e : {
        value: e
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $70fd6868680e912c$var$Di(t, e) {
    if (t.useProto3Json) return `${new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + e.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + e.seconds,
        nanos: e.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$Ci(t, e) {
    return t.useProto3Json ? e.toBase64() : e.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $70fd6868680e912c$var$xi(t, e) {
    return $70fd6868680e912c$var$Di(t, e.toTimestamp());
}
function $70fd6868680e912c$var$Ni(t) {
    return $70fd6868680e912c$var$F(!!t), $70fd6868680e912c$var$rt.fromTimestamp(function(t) {
        const e = $70fd6868680e912c$var$De(t);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }(t));
}
function $70fd6868680e912c$var$ki(t, e) {
    return (function(t) {
        return new $70fd6868680e912c$var$ut([
            "projects",
            t.projectId,
            "databases",
            t.database
        ]);
    })(t).child("documents").child(e).canonicalString();
}
function $70fd6868680e912c$var$Mi(t) {
    const e = $70fd6868680e912c$var$ut.fromString(t);
    return $70fd6868680e912c$var$F($70fd6868680e912c$var$ur(e)), e;
}
function $70fd6868680e912c$var$$i(t, e) {
    return $70fd6868680e912c$var$ki(t.databaseId, e.path);
}
function $70fd6868680e912c$var$Oi(t, e) {
    const n = $70fd6868680e912c$var$Mi(e);
    if (n.get(1) !== t.databaseId.projectId) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + t.databaseId.projectId);
    if (n.get(3) !== t.databaseId.database) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + t.databaseId.database);
    return new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$qi(n));
}
function $70fd6868680e912c$var$Fi(t, e) {
    return $70fd6868680e912c$var$ki(t.databaseId, e);
}
function $70fd6868680e912c$var$Bi(t) {
    const e = $70fd6868680e912c$var$Mi(t);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === e.length ? $70fd6868680e912c$var$ut.emptyPath() : $70fd6868680e912c$var$qi(e);
}
function $70fd6868680e912c$var$Li(t) {
    return new $70fd6868680e912c$var$ut([
        "projects",
        t.databaseId.projectId,
        "databases",
        t.databaseId.database
    ]).canonicalString();
}
function $70fd6868680e912c$var$qi(t) {
    return $70fd6868680e912c$var$F(t.length > 4 && "documents" === t.get(4)), t.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $70fd6868680e912c$var$Ui(t, e, n) {
    return {
        name: $70fd6868680e912c$var$$i(t, e),
        fields: n.value.mapValue.fields
    };
}
function $70fd6868680e912c$var$Ki(t, e, n) {
    const s = $70fd6868680e912c$var$Oi(t, e.name), i = $70fd6868680e912c$var$Ni(e.updateTime), r = e.createTime ? $70fd6868680e912c$var$Ni(e.createTime) : $70fd6868680e912c$var$rt.min(), o = new $70fd6868680e912c$var$un({
        mapValue: {
            fields: e.fields
        }
    }), u = $70fd6868680e912c$var$an.newFoundDocument(s, i, r, o);
    return n && u.setHasCommittedMutations(), n ? u.setHasCommittedMutations() : u;
}
function $70fd6868680e912c$var$Gi(t, e) {
    return "found" in e ? function(t, e) {
        $70fd6868680e912c$var$F(!!e.found), e.found.name, e.found.updateTime;
        const n = $70fd6868680e912c$var$Oi(t, e.found.name), s = $70fd6868680e912c$var$Ni(e.found.updateTime), i = e.found.createTime ? $70fd6868680e912c$var$Ni(e.found.createTime) : $70fd6868680e912c$var$rt.min(), r = new $70fd6868680e912c$var$un({
            mapValue: {
                fields: e.found.fields
            }
        });
        return $70fd6868680e912c$var$an.newFoundDocument(n, s, i, r);
    }(t, e) : "missing" in e ? function(t, e) {
        $70fd6868680e912c$var$F(!!e.missing), $70fd6868680e912c$var$F(!!e.readTime);
        const n = $70fd6868680e912c$var$Oi(t, e.missing), s = $70fd6868680e912c$var$Ni(e.readTime);
        return $70fd6868680e912c$var$an.newNoDocument(n, s);
    }(t, e) : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$Qi(t, e) {
    let n;
    if ("targetChange" in e) {
        e.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const s = function(t) {
            return "NO_CHANGE" === t ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === t ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === t ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === t ? 3 /* WatchTargetChangeState.Current */  : "RESET" === t ? 4 /* WatchTargetChangeState.Reset */  : $70fd6868680e912c$var$O();
        }(e.targetChange.targetChangeType || "NO_CHANGE"), i = e.targetChange.targetIds || [], r = function(t, e) {
            return t.useProto3Json ? ($70fd6868680e912c$var$F(void 0 === e || "string" == typeof e), $70fd6868680e912c$var$Ve.fromBase64String(e || "")) : ($70fd6868680e912c$var$F(void 0 === e || e instanceof Uint8Array), $70fd6868680e912c$var$Ve.fromUint8Array(e || new Uint8Array));
        }(t, e.targetChange.resumeToken), o = e.targetChange.cause, u = o && function(t) {
            const e = void 0 === t.code ? $70fd6868680e912c$var$q.UNKNOWN : $70fd6868680e912c$var$ui(t.code);
            return new $70fd6868680e912c$export$8fada0bf726bf278(e, t.message || "");
        }(o);
        n = new $70fd6868680e912c$var$Ii(s, i, r, u || null);
    } else if ("documentChange" in e) {
        e.documentChange;
        const s = e.documentChange;
        s.document, s.document.name, s.document.updateTime;
        const i = $70fd6868680e912c$var$Oi(t, s.document.name), r = $70fd6868680e912c$var$Ni(s.document.updateTime), o = s.document.createTime ? $70fd6868680e912c$var$Ni(s.document.createTime) : $70fd6868680e912c$var$rt.min(), u = new $70fd6868680e912c$var$un({
            mapValue: {
                fields: s.document.fields
            }
        }), c = $70fd6868680e912c$var$an.newFoundDocument(i, r, o, u), a = s.targetIds || [], h = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$yi(a, h, c.key, c);
    } else if ("documentDelete" in e) {
        e.documentDelete;
        const s = e.documentDelete;
        s.document;
        const i = $70fd6868680e912c$var$Oi(t, s.document), r = s.readTime ? $70fd6868680e912c$var$Ni(s.readTime) : $70fd6868680e912c$var$rt.min(), o = $70fd6868680e912c$var$an.newNoDocument(i, r), u = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$yi([], u, o.key, o);
    } else if ("documentRemove" in e) {
        e.documentRemove;
        const s = e.documentRemove;
        s.document;
        const i = $70fd6868680e912c$var$Oi(t, s.document), r = s.removedTargetIds || [];
        n = new $70fd6868680e912c$var$yi([], r, i, null);
    } else {
        if (!("filter" in e)) return $70fd6868680e912c$var$O();
        {
            e.filter;
            const t = e.filter;
            t.targetId;
            const { count: s = 0, unchangedNames: i } = t, r = new $70fd6868680e912c$var$si(s, i), o = t.targetId;
            n = new $70fd6868680e912c$var$pi(o, r);
        }
    }
    return n;
}
function $70fd6868680e912c$var$ji(t, e) {
    let n;
    if (e instanceof $70fd6868680e912c$var$js) n = {
        update: $70fd6868680e912c$var$Ui(t, e.key, e.value)
    };
    else if (e instanceof $70fd6868680e912c$var$Ys) n = {
        delete: $70fd6868680e912c$var$$i(t, e.key)
    };
    else if (e instanceof $70fd6868680e912c$var$zs) n = {
        update: $70fd6868680e912c$var$Ui(t, e.key, e.data),
        updateMask: $70fd6868680e912c$var$or(e.fieldMask)
    };
    else {
        if (!(e instanceof $70fd6868680e912c$var$Xs)) return $70fd6868680e912c$var$O();
        n = {
            verify: $70fd6868680e912c$var$$i(t, e.key)
        };
    }
    return e.fieldTransforms.length > 0 && (n.updateTransforms = e.fieldTransforms.map((t)=>(function(t, e) {
            const n = e.transform;
            if (n instanceof $70fd6868680e912c$var$bs) return {
                fieldPath: e.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $70fd6868680e912c$var$Vs) return {
                fieldPath: e.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$Ds) return {
                fieldPath: e.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $70fd6868680e912c$var$xs) return {
                fieldPath: e.field.canonicalString(),
                increment: n.gt
            };
            throw $70fd6868680e912c$var$O();
        })(0, t))), e.precondition.isNone || (n.currentDocument = function(t, e) {
        return void 0 !== e.updateTime ? {
            updateTime: $70fd6868680e912c$var$xi(t, e.updateTime)
        } : void 0 !== e.exists ? {
            exists: e.exists
        } : $70fd6868680e912c$var$O();
    }(t, e.precondition)), n;
}
function $70fd6868680e912c$var$zi(t, e) {
    const n = e.currentDocument ? function(t) {
        return void 0 !== t.updateTime ? $70fd6868680e912c$var$Fs.updateTime($70fd6868680e912c$var$Ni(t.updateTime)) : void 0 !== t.exists ? $70fd6868680e912c$var$Fs.exists(t.exists) : $70fd6868680e912c$var$Fs.none();
    }(e.currentDocument) : $70fd6868680e912c$var$Fs.none(), s = e.updateTransforms ? e.updateTransforms.map((e)=>(function(t, e) {
            let n = null;
            if ("setToServerValue" in e) $70fd6868680e912c$var$F("REQUEST_TIME" === e.setToServerValue), n = new $70fd6868680e912c$var$bs;
            else if ("appendMissingElements" in e) {
                const t = e.appendMissingElements.values || [];
                n = new $70fd6868680e912c$var$Vs(t);
            } else if ("removeAllFromArray" in e) {
                const t = e.removeAllFromArray.values || [];
                n = new $70fd6868680e912c$var$Ds(t);
            } else "increment" in e ? n = new $70fd6868680e912c$var$xs(t, e.increment) : $70fd6868680e912c$var$O();
            const s = $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
            return new $70fd6868680e912c$var$Ms(s, n);
        })(t, e)) : [];
    if (e.update) {
        e.update.name;
        const i = $70fd6868680e912c$var$Oi(t, e.update.name), r = new $70fd6868680e912c$var$un({
            mapValue: {
                fields: e.update.fields
            }
        });
        if (e.updateMask) {
            const t = function(t) {
                const e = t.fieldPaths || [];
                return new $70fd6868680e912c$var$Re(e.map((t)=>$70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t)));
            }(e.updateMask);
            return new $70fd6868680e912c$var$zs(i, r, t, n, s);
        }
        return new $70fd6868680e912c$var$js(i, r, n, s);
    }
    if (e.delete) {
        const s = $70fd6868680e912c$var$Oi(t, e.delete);
        return new $70fd6868680e912c$var$Ys(s, n);
    }
    if (e.verify) {
        const s = $70fd6868680e912c$var$Oi(t, e.verify);
        return new $70fd6868680e912c$var$Xs(s, n);
    }
    return $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$Wi(t, e) {
    return t && t.length > 0 ? ($70fd6868680e912c$var$F(void 0 !== e), t.map((t)=>(function(t, e) {
            // NOTE: Deletes don't have an updateTime.
            let n = t.updateTime ? $70fd6868680e912c$var$Ni(t.updateTime) : $70fd6868680e912c$var$Ni(e);
            return n.isEqual($70fd6868680e912c$var$rt.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $70fd6868680e912c$var$Ni(e)), new $70fd6868680e912c$var$Os(n, t.transformResults || []);
        })(t, e))) : [];
}
function $70fd6868680e912c$var$Hi(t, e) {
    return {
        documents: [
            $70fd6868680e912c$var$Fi(t, e.path)
        ]
    };
}
function $70fd6868680e912c$var$Ji(t, e) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, s = e.path;
    null !== e.collectionGroup ? (n.parent = $70fd6868680e912c$var$Fi(t, s), n.structuredQuery.from = [
        {
            collectionId: e.collectionGroup,
            allDescendants: !0
        }
    ]) : (n.parent = $70fd6868680e912c$var$Fi(t, s.popLast()), n.structuredQuery.from = [
        {
            collectionId: s.lastSegment()
        }
    ]);
    const i = function(t) {
        if (0 === t.length) return;
        return $70fd6868680e912c$var$rr($70fd6868680e912c$var$gn.create(t, "and" /* CompositeOperator.AND */ ));
    }(e.filters);
    i && (n.structuredQuery.where = i);
    const r = function(t) {
        if (0 === t.length) return;
        return t.map((t)=>// visible for testing
            (function(t) {
                return {
                    field: $70fd6868680e912c$var$sr(t.field),
                    direction: $70fd6868680e912c$var$tr(t.dir)
                };
            })(t));
    }(e.orderBy);
    r && (n.structuredQuery.orderBy = r);
    const o = $70fd6868680e912c$var$Si(t, e.limit);
    var u;
    return null !== o && (n.structuredQuery.limit = o), e.startAt && (n.structuredQuery.startAt = {
        before: (u = e.startAt).inclusive,
        values: u.position
    }), e.endAt && (n.structuredQuery.endAt = function(t) {
        return {
            before: !t.inclusive,
            values: t.position
        };
    }(e.endAt)), n;
}
function $70fd6868680e912c$var$Yi(t) {
    let e = $70fd6868680e912c$var$Bi(t.parent);
    const n = t.structuredQuery, s = n.from ? n.from.length : 0;
    let i = null;
    if (s > 0) {
        $70fd6868680e912c$var$F(1 === s);
        const t = n.from[0];
        t.allDescendants ? i = t.collectionId : e = e.child(t.collectionId);
    }
    let r = [];
    n.where && (r = function(t) {
        const e = $70fd6868680e912c$var$Zi(t);
        if (e instanceof $70fd6868680e912c$var$gn && $70fd6868680e912c$var$In(e)) return e.getFilters();
        return [
            e
        ];
    }(n.where));
    let o = [];
    n.orderBy && (o = n.orderBy.map((t)=>(function(t) {
            return new $70fd6868680e912c$var$dn($70fd6868680e912c$var$ir(t.field), // visible for testing
            function(t) {
                switch(t){
                    case "ASCENDING":
                        return "asc" /* Direction.ASCENDING */ ;
                    case "DESCENDING":
                        return "desc" /* Direction.DESCENDING */ ;
                    default:
                        return;
                }
            }(t.direction));
        })(t)));
    let u = null;
    n.limit && (u = function(t) {
        let e;
        return e = "object" == typeof t ? t.value : t, $70fd6868680e912c$var$Ft(e) ? null : e;
    }(n.limit));
    let c = null;
    n.startAt && (c = function(t) {
        const e = !!t.before, n = t.values || [];
        return new $70fd6868680e912c$var$hn(n, e);
    }(n.startAt));
    let a = null;
    return n.endAt && (a = function(t) {
        const e = !t.before, n = t.values || [];
        return new $70fd6868680e912c$var$hn(n, e);
    }(n.endAt)), $70fd6868680e912c$var$Kn(e, i, o, r, u, "F" /* LimitType.First */ , c, a);
}
function $70fd6868680e912c$var$Xi(t, e) {
    const n = function(t) {
        switch(t){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $70fd6868680e912c$var$O();
        }
    }(e.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $70fd6868680e912c$var$Zi(t) {
    return void 0 !== t.unaryFilter ? function(t) {
        switch(t.unaryFilter.op){
            case "IS_NAN":
                const e = $70fd6868680e912c$var$ir(t.unaryFilter.field);
                return $70fd6868680e912c$var$mn.create(e, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $70fd6868680e912c$var$ir(t.unaryFilter.field);
                return $70fd6868680e912c$var$mn.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const s = $70fd6868680e912c$var$ir(t.unaryFilter.field);
                return $70fd6868680e912c$var$mn.create(s, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $70fd6868680e912c$var$ir(t.unaryFilter.field);
                return $70fd6868680e912c$var$mn.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return $70fd6868680e912c$var$O();
        }
    }(t) : void 0 !== t.fieldFilter ? function(t) {
        return $70fd6868680e912c$var$mn.create($70fd6868680e912c$var$ir(t.fieldFilter.field), function(t) {
            switch(t){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return $70fd6868680e912c$var$O();
            }
        }(t.fieldFilter.op), t.fieldFilter.value);
    }(t) : void 0 !== t.compositeFilter ? function(t) {
        return $70fd6868680e912c$var$gn.create(t.compositeFilter.filters.map((t)=>$70fd6868680e912c$var$Zi(t)), function(t) {
            switch(t){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $70fd6868680e912c$var$O();
            }
        }(t.compositeFilter.op));
    }(t) : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$tr(t) {
    return $70fd6868680e912c$var$Ri[t];
}
function $70fd6868680e912c$var$er(t) {
    return $70fd6868680e912c$var$Pi[t];
}
function $70fd6868680e912c$var$nr(t) {
    return $70fd6868680e912c$var$bi[t];
}
function $70fd6868680e912c$var$sr(t) {
    return {
        fieldPath: t.canonicalString()
    };
}
function $70fd6868680e912c$var$ir(t) {
    return $70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
}
function $70fd6868680e912c$var$rr(t) {
    return t instanceof $70fd6868680e912c$var$mn ? function(t) {
        if ("==" /* Operator.EQUAL */  === t.op) {
            if ($70fd6868680e912c$var$Xe(t.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$sr(t.field),
                    op: "IS_NAN"
                }
            };
            if ($70fd6868680e912c$var$Ye(t.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$sr(t.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === t.op) {
            if ($70fd6868680e912c$var$Xe(t.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$sr(t.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($70fd6868680e912c$var$Ye(t.value)) return {
                unaryFilter: {
                    field: $70fd6868680e912c$var$sr(t.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $70fd6868680e912c$var$sr(t.field),
                op: $70fd6868680e912c$var$er(t.op),
                value: t.value
            }
        };
    }(t) : t instanceof $70fd6868680e912c$var$gn ? function(t) {
        const e = t.getFilters().map((t)=>$70fd6868680e912c$var$rr(t));
        if (1 === e.length) return e[0];
        return {
            compositeFilter: {
                op: $70fd6868680e912c$var$nr(t.op),
                filters: e
            }
        };
    }(t) : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$or(t) {
    const e = [];
    return t.fields.forEach((t)=>e.push(t.canonicalString())), {
        fieldPaths: e
    };
}
function $70fd6868680e912c$var$ur(t) {
    // Resource names have at least 4 components (project ID, database ID)
    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $70fd6868680e912c$var$cr {
    constructor(/** The target being listened to. */ t, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ e, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ s, /** The latest snapshot version seen for this target. */ i = $70fd6868680e912c$var$rt.min(), r = $70fd6868680e912c$var$rt.min(), o = $70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, u = null){
        this.target = t, this.targetId = e, this.purpose = n, this.sequenceNumber = s, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = r, this.resumeToken = o, this.expectedCount = u;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(t) {
        return new $70fd6868680e912c$var$cr(this.target, this.targetId, this.purpose, t, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(t, e) {
        return new $70fd6868680e912c$var$cr(this.target, this.targetId, this.purpose, this.sequenceNumber, e, this.lastLimboFreeSnapshotVersion, t, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(t) {
        return new $70fd6868680e912c$var$cr(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, t);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(t) {
        return new $70fd6868680e912c$var$cr(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, t, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $70fd6868680e912c$var$ar {
    constructor(t){
        this.fe = t;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $70fd6868680e912c$var$hr(t, e) {
    let n;
    if (e.document) n = $70fd6868680e912c$var$Ki(t.fe, e.document, !!e.hasCommittedMutations);
    else if (e.noDocument) {
        const t = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.noDocument.path), s = $70fd6868680e912c$var$wr(e.noDocument.readTime);
        n = $70fd6868680e912c$var$an.newNoDocument(t, s), e.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!e.unknownDocument) return $70fd6868680e912c$var$O();
        {
            const t = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path), s = $70fd6868680e912c$var$wr(e.unknownDocument.version);
            n = $70fd6868680e912c$var$an.newUnknownDocument(t, s);
        }
    }
    return e.readTime && n.setReadTime(function(t) {
        const e = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t[0], t[1]);
        return $70fd6868680e912c$var$rt.fromTimestamp(e);
    }(e.readTime)), n;
}
/** Encodes a document for storage locally. */ function $70fd6868680e912c$var$lr(t, e) {
    const n = e.key, s = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $70fd6868680e912c$var$fr(e.readTime),
        hasCommittedMutations: e.hasCommittedMutations
    };
    if (e.isFoundDocument()) s.document = function(t, e) {
        return {
            name: $70fd6868680e912c$var$$i(t, e.key),
            fields: e.data.value.mapValue.fields,
            updateTime: $70fd6868680e912c$var$Di(t, e.version.toTimestamp()),
            createTime: $70fd6868680e912c$var$Di(t, e.createTime.toTimestamp())
        };
    }(t.fe, e);
    else if (e.isNoDocument()) s.noDocument = {
        path: n.path.toArray(),
        readTime: $70fd6868680e912c$var$dr(e.version)
    };
    else {
        if (!e.isUnknownDocument()) return $70fd6868680e912c$var$O();
        s.unknownDocument = {
            path: n.path.toArray(),
            version: $70fd6868680e912c$var$dr(e.version)
        };
    }
    return s;
}
function $70fd6868680e912c$var$fr(t) {
    const e = t.toTimestamp();
    return [
        e.seconds,
        e.nanoseconds
    ];
}
function $70fd6868680e912c$var$dr(t) {
    const e = t.toTimestamp();
    return {
        seconds: e.seconds,
        nanoseconds: e.nanoseconds
    };
}
function $70fd6868680e912c$var$wr(t) {
    const e = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, t.nanoseconds);
    return $70fd6868680e912c$var$rt.fromTimestamp(e);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $70fd6868680e912c$var$_r(t, e) {
    const n = (e.baseMutations || []).map((e)=>$70fd6868680e912c$var$zi(t.fe, e));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let t = 0; t < e.mutations.length - 1; ++t){
        const n = e.mutations[t];
        if (t + 1 < e.mutations.length && void 0 !== e.mutations[t + 1].transform) {
            const s = e.mutations[t + 1];
            n.updateTransforms = s.transform.fieldTransforms, e.mutations.splice(t + 1, 1), ++t;
        }
    }
    const s = e.mutations.map((e)=>$70fd6868680e912c$var$zi(t.fe, e)), i = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromMillis(e.localWriteTimeMs);
    return new $70fd6868680e912c$var$Zs(e.batchId, i, n, s);
}
/** Decodes a DbTarget into TargetData */ function $70fd6868680e912c$var$mr(t) {
    const e = $70fd6868680e912c$var$wr(t.readTime), n = void 0 !== t.lastLimboFreeSnapshotVersion ? $70fd6868680e912c$var$wr(t.lastLimboFreeSnapshotVersion) : $70fd6868680e912c$var$rt.min();
    let s;
    var i;
    return void 0 !== t.query.documents ? ($70fd6868680e912c$var$F(1 === (i = t.query).documents.length), s = $70fd6868680e912c$var$Jn($70fd6868680e912c$var$Gn($70fd6868680e912c$var$Bi(i.documents[0])))) : s = function(t) {
        return $70fd6868680e912c$var$Jn($70fd6868680e912c$var$Yi(t));
    }(t.query), new $70fd6868680e912c$var$cr(s, t.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , t.lastListenSequenceNumber, e, n, $70fd6868680e912c$var$Ve.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $70fd6868680e912c$var$gr(t, e) {
    const n = $70fd6868680e912c$var$dr(e.snapshotVersion), s = $70fd6868680e912c$var$dr(e.lastLimboFreeSnapshotVersion);
    let i;
    i = $70fd6868680e912c$var$Fn(e.target) ? $70fd6868680e912c$var$Hi(t.fe, e.target) : $70fd6868680e912c$var$Ji(t.fe, e.target);
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const r = e.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: e.targetId,
        canonicalId: $70fd6868680e912c$var$$n(e.target),
        readTime: n,
        resumeToken: r,
        lastListenSequenceNumber: e.sequenceNumber,
        lastLimboFreeSnapshotVersion: s,
        query: i
    };
}
/**
 * A helper function for figuring out what kind of query has been stored.
 */ /**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $70fd6868680e912c$var$yr(t) {
    const e = $70fd6868680e912c$var$Yi({
        parent: t.parent,
        structuredQuery: t.structuredQuery
    });
    return "LAST" === t.limitType ? $70fd6868680e912c$var$Xn(e, e.limit, "L" /* LimitType.Last */ ) : e;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $70fd6868680e912c$var$pr(t, e) {
    return new $70fd6868680e912c$var$ei(e.largestBatchId, $70fd6868680e912c$var$zi(t.fe, e.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $70fd6868680e912c$var$Ir(t, e) {
    const n = e.path.lastSegment();
    return [
        t,
        $70fd6868680e912c$var$qt(e.path.popLast()),
        n
    ];
}
function $70fd6868680e912c$var$Tr(t, e, n, s) {
    return {
        indexId: t,
        uid: e.uid || "",
        sequenceNumber: n,
        readTime: $70fd6868680e912c$var$dr(s.readTime),
        documentKey: $70fd6868680e912c$var$qt(s.documentKey.path),
        largestBatchId: s.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Er {
    getBundleMetadata(t, e) {
        return $70fd6868680e912c$var$Ar(t).get(e).next((t)=>{
            if (t) return {
                id: (e = t).bundleId,
                createTime: $70fd6868680e912c$var$wr(e.createTime),
                version: e.version
            };
            /** Encodes a DbBundle to a BundleMetadata object. */ var e;
        /** Encodes a BundleMetadata to a DbBundle. */ });
    }
    saveBundleMetadata(t, e) {
        var n;
        return $70fd6868680e912c$var$Ar(t).put({
            bundleId: (n = e).id,
            createTime: $70fd6868680e912c$var$dr($70fd6868680e912c$var$Ni(n.createTime)),
            version: n.version
        });
    /** Encodes a DbNamedQuery to a NamedQuery. */ }
    getNamedQuery(t, e) {
        return $70fd6868680e912c$var$vr(t).get(e).next((t)=>{
            if (t) return {
                name: (e = t).name,
                query: $70fd6868680e912c$var$yr(e.bundledQuery),
                readTime: $70fd6868680e912c$var$wr(e.readTime)
            };
            var e;
        /** Encodes a NamedQuery from a bundle proto to a DbNamedQuery. */ });
    }
    saveNamedQuery(t, e) {
        return $70fd6868680e912c$var$vr(t).put(function(t) {
            return {
                name: t.name,
                readTime: $70fd6868680e912c$var$dr($70fd6868680e912c$var$Ni(t.readTime)),
                bundledQuery: t.bundledQuery
            };
        }(e));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $70fd6868680e912c$var$Ar(t) {
    return $70fd6868680e912c$var$_e(t, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $70fd6868680e912c$var$vr(t) {
    return $70fd6868680e912c$var$_e(t, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $70fd6868680e912c$var$Rr {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(t, e){
        this.serializer = t, this.userId = e;
    }
    static de(t, e) {
        const n = e.uid || "";
        return new $70fd6868680e912c$var$Rr(t, n);
    }
    getOverlay(t, e) {
        return $70fd6868680e912c$var$Pr(t).get($70fd6868680e912c$var$Ir(this.userId, e)).next((t)=>t ? $70fd6868680e912c$var$pr(this.serializer, t) : null);
    }
    getOverlays(t, e) {
        const n = $70fd6868680e912c$var$fs();
        return $70fd6868680e912c$var$Rt.forEach(e, (e)=>this.getOverlay(t, e).next((t)=>{
                null !== t && n.set(e, t);
            })).next(()=>n);
    }
    saveOverlays(t, e, n) {
        const s = [];
        return n.forEach((n, i)=>{
            const r = new $70fd6868680e912c$var$ei(e, i);
            s.push(this.we(t, r));
        }), $70fd6868680e912c$var$Rt.waitFor(s);
    }
    removeOverlaysForBatchId(t, e, n) {
        const s = new Set;
        // Get the set of unique collection paths.
        e.forEach((t)=>s.add($70fd6868680e912c$var$qt(t.getCollectionPath())));
        const i = [];
        return s.forEach((e)=>{
            const s = IDBKeyRange.bound([
                this.userId,
                e,
                n
            ], [
                this.userId,
                e,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($70fd6868680e912c$var$Pr(t).J("collectionPathOverlayIndex", s));
        }), $70fd6868680e912c$var$Rt.waitFor(i);
    }
    getOverlaysForCollection(t, e, n) {
        const s = $70fd6868680e912c$var$fs(), i = $70fd6868680e912c$var$qt(e), r = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$Pr(t).j("collectionPathOverlayIndex", r).next((t)=>{
            for (const e of t){
                const t = $70fd6868680e912c$var$pr(this.serializer, e);
                s.set(t.getKey(), t);
            }
            return s;
        });
    }
    getOverlaysForCollectionGroup(t, e, n, s) {
        const i = $70fd6868680e912c$var$fs();
        let r;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const o = IDBKeyRange.bound([
            this.userId,
            e,
            n
        ], [
            this.userId,
            e,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $70fd6868680e912c$var$Pr(t).X({
            index: "collectionGroupOverlayIndex",
            range: o
        }, (t, e, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const o = $70fd6868680e912c$var$pr(this.serializer, e);
            i.size() < s || o.largestBatchId === r ? (i.set(o.getKey(), o), r = o.largestBatchId) : n.done();
        }).next(()=>i);
    }
    we(t, e) {
        return $70fd6868680e912c$var$Pr(t).put(function(t, e, n) {
            const [s, i, r] = $70fd6868680e912c$var$Ir(e, n.mutation.key);
            return {
                userId: e,
                collectionPath: i,
                documentId: r,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $70fd6868680e912c$var$ji(t.fe, n.mutation)
            };
        }(this.serializer, this.userId, e));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $70fd6868680e912c$var$Pr(t) {
    return $70fd6868680e912c$var$_e(t, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $70fd6868680e912c$var$br {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ _e(t, e) {
        this.me(t, e), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        e.ge();
    }
    me(t, e) {
        if ("nullValue" in t) this.ye(e, 5);
        else if ("booleanValue" in t) this.ye(e, 10), e.pe(t.booleanValue ? 1 : 0);
        else if ("integerValue" in t) this.ye(e, 15), e.pe($70fd6868680e912c$var$Ce(t.integerValue));
        else if ("doubleValue" in t) {
            const n = $70fd6868680e912c$var$Ce(t.doubleValue);
            isNaN(n) ? this.ye(e, 13) : (this.ye(e, 15), $70fd6868680e912c$var$Bt(n) ? // -0.0, 0 and 0.0 are all considered the same
            e.pe(0) : e.pe(n));
        } else if ("timestampValue" in t) {
            const n = t.timestampValue;
            this.ye(e, 20), "string" == typeof n ? e.Ie(n) : (e.Ie(`${n.seconds || ""}`), e.pe(n.nanos || 0));
        } else if ("stringValue" in t) this.Te(t.stringValue, e), this.Ee(e);
        else if ("bytesValue" in t) this.ye(e, 30), e.Ae($70fd6868680e912c$var$xe(t.bytesValue)), this.Ee(e);
        else if ("referenceValue" in t) this.ve(t.referenceValue, e);
        else if ("geoPointValue" in t) {
            const n = t.geoPointValue;
            this.ye(e, 45), e.pe(n.latitude || 0), e.pe(n.longitude || 0);
        } else "mapValue" in t ? $70fd6868680e912c$var$en(t) ? this.ye(e, Number.MAX_SAFE_INTEGER) : (this.Re(t.mapValue, e), this.Ee(e)) : "arrayValue" in t ? (this.Pe(t.arrayValue, e), this.Ee(e)) : $70fd6868680e912c$var$O();
    }
    Te(t, e) {
        this.ye(e, 25), this.be(t, e);
    }
    be(t, e) {
        e.Ie(t);
    }
    Re(t, e) {
        const n = t.fields || {};
        this.ye(e, 55);
        for (const t of Object.keys(n))this.Te(t, e), this.me(n[t], e);
    }
    Pe(t, e) {
        const n = t.values || [];
        this.ye(e, 50);
        for (const t of n)this.me(t, e);
    }
    ve(t, e) {
        this.ye(e, 37);
        $70fd6868680e912c$export$afc2e57c475b7810.fromName(t).path.forEach((t)=>{
            this.ye(e, 60), this.be(t, e);
        });
    }
    ye(t, e) {
        t.pe(e);
    }
    Ee(t) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        t.pe(2);
    }
}
$70fd6868680e912c$var$br.Ve = new $70fd6868680e912c$var$br;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$Vr(t) {
    if (0 === t) return 8;
    let e = 0;
    return t >> 4 == 0 && // Test if the first four bits are zero.
    (e += 4, t <<= 4), t >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (e += 2, t <<= 2), t >> 7 == 0 && // Test if the remaining bit is zero.
    (e += 1), e;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $70fd6868680e912c$var$Sr(t) {
    // This is just the number of bytes for the unsigned representation of the number.
    const e = 64 - function(t) {
        let e = 0;
        for(let n = 0; n < 8; ++n){
            const s = $70fd6868680e912c$var$Vr(255 & t[n]);
            if (e += s, 8 !== s) break;
        }
        return e;
    }(t);
    return Math.ceil(e / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $70fd6868680e912c$var$Dr {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    Se(t) {
        const e = t[Symbol.iterator]();
        let n = e.next();
        for(; !n.done;)this.De(n.value), n = e.next();
        this.Ce();
    }
    xe(t) {
        const e = t[Symbol.iterator]();
        let n = e.next();
        for(; !n.done;)this.Ne(n.value), n = e.next();
        this.ke();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Me(t) {
        for (const e of t){
            const t = e.charCodeAt(0);
            if (t < 128) this.De(t);
            else if (t < 2048) this.De(960 | t >>> 6), this.De(128 | 63 & t);
            else if (e < "\ud800" || "\udbff" < e) this.De(480 | t >>> 12), this.De(128 | 63 & t >>> 6), this.De(128 | 63 & t);
            else {
                const t = e.codePointAt(0);
                this.De(240 | t >>> 18), this.De(128 | 63 & t >>> 12), this.De(128 | 63 & t >>> 6), this.De(128 | 63 & t);
            }
        }
        this.Ce();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ $e(t) {
        for (const e of t){
            const t = e.charCodeAt(0);
            if (t < 128) this.Ne(t);
            else if (t < 2048) this.Ne(960 | t >>> 6), this.Ne(128 | 63 & t);
            else if (e < "\ud800" || "\udbff" < e) this.Ne(480 | t >>> 12), this.Ne(128 | 63 & t >>> 6), this.Ne(128 | 63 & t);
            else {
                const t = e.codePointAt(0);
                this.Ne(240 | t >>> 18), this.Ne(128 | 63 & t >>> 12), this.Ne(128 | 63 & t >>> 6), this.Ne(128 | 63 & t);
            }
        }
        this.ke();
    }
    Oe(t) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const e = this.Fe(t), n = $70fd6868680e912c$var$Sr(e);
        this.Be(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let t = e.length - n; t < e.length; ++t)this.buffer[this.position++] = 255 & e[t];
    }
    Le(t) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const e = this.Fe(t), n = $70fd6868680e912c$var$Sr(e);
        this.Be(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let t = e.length - n; t < e.length; ++t)this.buffer[this.position++] = ~(255 & e[t]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ qe() {
        this.Ue(255), this.Ue(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ Ke() {
        this.Ge(255), this.Ge(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(t) {
        this.Be(t.length), this.buffer.set(t, this.position), this.position += t.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Qe() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ Fe(t) {
        const e = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function(t) {
            const e = new DataView(new ArrayBuffer(8));
            return e.setFloat64(0, t, /* littleEndian= */ !1), new Uint8Array(e.buffer);
        }(t), n = 0 != (128 & e[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        e[0] ^= n ? 255 : 128;
        for(let t = 1; t < e.length; ++t)e[t] ^= n ? 255 : 0;
        return e;
    }
    /** Writes a single byte ascending to the buffer. */ De(t) {
        const e = 255 & t;
        0 === e ? (this.Ue(0), this.Ue(255)) : 255 === e ? (this.Ue(255), this.Ue(0)) : this.Ue(e);
    }
    /** Writes a single byte descending to the buffer.  */ Ne(t) {
        const e = 255 & t;
        0 === e ? (this.Ge(0), this.Ge(255)) : 255 === e ? (this.Ge(255), this.Ge(0)) : this.Ge(t);
    }
    Ce() {
        this.Ue(0), this.Ue(1);
    }
    ke() {
        this.Ge(0), this.Ge(1);
    }
    Ue(t) {
        this.Be(1), this.buffer[this.position++] = t;
    }
    Ge(t) {
        this.Be(1), this.buffer[this.position++] = ~t;
    }
    Be(t) {
        const e = t + this.position;
        if (e <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < e && (n = e);
        // Create the new buffer.
        const s = new Uint8Array(n);
        s.set(this.buffer), this.buffer = s;
    }
}
class $70fd6868680e912c$var$Cr {
    constructor(t){
        this.je = t;
    }
    Ae(t) {
        this.je.Se(t);
    }
    Ie(t) {
        this.je.Me(t);
    }
    pe(t) {
        this.je.Oe(t);
    }
    ge() {
        this.je.qe();
    }
}
class $70fd6868680e912c$var$xr {
    constructor(t){
        this.je = t;
    }
    Ae(t) {
        this.je.xe(t);
    }
    Ie(t) {
        this.je.$e(t);
    }
    pe(t) {
        this.je.Le(t);
    }
    ge() {
        this.je.Ke();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $70fd6868680e912c$var$Nr {
    constructor(){
        this.je = new $70fd6868680e912c$var$Dr, this.ze = new $70fd6868680e912c$var$Cr(this.je), this.We = new $70fd6868680e912c$var$xr(this.je);
    }
    seed(t) {
        this.je.seed(t);
    }
    He(t) {
        return 0 /* IndexKind.ASCENDING */  === t ? this.ze : this.We;
    }
    Qe() {
        return this.je.Qe();
    }
    reset() {
        this.je.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $70fd6868680e912c$var$kr {
    constructor(t, e, n, s){
        this.indexId = t, this.documentKey = e, this.arrayValue = n, this.directionalValue = s;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Je() {
        const t = this.directionalValue.length, e = 0 === t || 255 === this.directionalValue[t - 1] ? t + 1 : t, n = new Uint8Array(e);
        return n.set(this.directionalValue, 0), e !== t ? n.set([
            0
        ], this.directionalValue.length) : ++n[n.length - 1], new $70fd6868680e912c$var$kr(this.indexId, this.documentKey, this.arrayValue, n);
    }
}
function $70fd6868680e912c$var$Mr(t, e) {
    let n = t.indexId - e.indexId;
    return 0 !== n ? n : (n = $70fd6868680e912c$var$$r(t.arrayValue, e.arrayValue), 0 !== n ? n : (n = $70fd6868680e912c$var$$r(t.directionalValue, e.directionalValue), 0 !== n ? n : $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.documentKey, e.documentKey)));
}
function $70fd6868680e912c$var$$r(t, e) {
    for(let n = 0; n < t.length && n < e.length; ++n){
        const s = t[n] - e[n];
        if (0 !== s) return s;
    }
    return t.length - e.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ class $70fd6868680e912c$var$Or {
    constructor(t){
        this.collectionId = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment(), this.Ye = t.orderBy, this.Xe = [];
        for (const e of t.filters){
            const t = e;
            t.isInequality() ? this.Ze = t : this.Xe.push(t);
        }
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ tn(t) {
        $70fd6868680e912c$var$F(t.collectionGroup === this.collectionId);
        // If there is an array element, find a matching filter.
        const e = $70fd6868680e912c$var$ft(t);
        if (void 0 !== e && !this.en(e)) return !1;
        const n = $70fd6868680e912c$var$dt(t);
        let s = new Set, i = 0, r = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.en(n[i]); ++i)s = s.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (void 0 !== this.Ze) {
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!s.has(this.Ze.field.canonicalString())) {
                const t = n[i];
                if (!this.nn(this.Ze, t) || !this.sn(this.Ye[r++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const t = n[i];
            if (r >= this.Ye.length || !this.sn(this.Ye[r++], t)) return !1;
        }
        return !0;
    }
    en(t) {
        for (const e of this.Xe)if (this.nn(e, t)) return !0;
        return !1;
    }
    nn(t, e) {
        if (void 0 === t || !t.field.isEqual(e.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === t.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t.op;
        return 2 /* IndexKind.CONTAINS */  === e.kind === n;
    }
    sn(t, e) {
        return !!t.field.isEqual(e.fieldPath) && (0 /* IndexKind.ASCENDING */  === e.kind && "asc" /* Direction.ASCENDING */  === t.dir || 1 /* IndexKind.DESCENDING */  === e.kind && "desc" /* Direction.DESCENDING */  === t.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $70fd6868680e912c$var$Fr(t) {
    var e, n;
    if ($70fd6868680e912c$var$F(t instanceof $70fd6868680e912c$var$mn || t instanceof $70fd6868680e912c$var$gn), t instanceof $70fd6868680e912c$var$mn) {
        if (t instanceof $70fd6868680e912c$var$Cn) {
            const s = (null === (n = null === (e = t.value.arrayValue) || void 0 === e ? void 0 : e.values) || void 0 === n ? void 0 : n.map((e)=>$70fd6868680e912c$var$mn.create(t.field, "==" /* Operator.EQUAL */ , e))) || [];
            return $70fd6868680e912c$var$gn.create(s, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return t;
    }
    // We have a composite filter.
    const s = t.filters.map((t)=>$70fd6868680e912c$var$Fr(t));
    return $70fd6868680e912c$var$gn.create(s, t.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $70fd6868680e912c$var$Br(t) {
    if (0 === t.getFilters().length) return [];
    const e = $70fd6868680e912c$var$Kr($70fd6868680e912c$var$Fr(t));
    return $70fd6868680e912c$var$F($70fd6868680e912c$var$Ur(e)), $70fd6868680e912c$var$Lr(e) || $70fd6868680e912c$var$qr(e) ? [
        e
    ] : e.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $70fd6868680e912c$var$Lr(t) {
    return t instanceof $70fd6868680e912c$var$mn;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $70fd6868680e912c$var$qr(t) {
    return t instanceof $70fd6868680e912c$var$gn && $70fd6868680e912c$var$In(t);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $70fd6868680e912c$var$Ur(t) {
    return $70fd6868680e912c$var$Lr(t) || $70fd6868680e912c$var$qr(t) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function(t) {
        if (t instanceof $70fd6868680e912c$var$gn && $70fd6868680e912c$var$pn(t)) {
            for (const e of t.getFilters())if (!$70fd6868680e912c$var$Lr(e) && !$70fd6868680e912c$var$qr(e)) return !1;
            return !0;
        }
        return !1;
    }(t);
}
function $70fd6868680e912c$var$Kr(t) {
    if ($70fd6868680e912c$var$F(t instanceof $70fd6868680e912c$var$mn || t instanceof $70fd6868680e912c$var$gn), t instanceof $70fd6868680e912c$var$mn) return t;
    if (1 === t.filters.length) return $70fd6868680e912c$var$Kr(t.filters[0]);
    // Compute DNF for each of the subfilters first
    const e = t.filters.map((t)=>$70fd6868680e912c$var$Kr(t));
    let n = $70fd6868680e912c$var$gn.create(e, t.op);
    return n = $70fd6868680e912c$var$jr(n), $70fd6868680e912c$var$Ur(n) ? n : ($70fd6868680e912c$var$F(n instanceof $70fd6868680e912c$var$gn), $70fd6868680e912c$var$F($70fd6868680e912c$var$yn(n)), $70fd6868680e912c$var$F(n.filters.length > 1), n.filters.reduce((t, e)=>$70fd6868680e912c$var$Gr(t, e)));
}
function $70fd6868680e912c$var$Gr(t, e) {
    let n;
    return $70fd6868680e912c$var$F(t instanceof $70fd6868680e912c$var$mn || t instanceof $70fd6868680e912c$var$gn), $70fd6868680e912c$var$F(e instanceof $70fd6868680e912c$var$mn || e instanceof $70fd6868680e912c$var$gn), // FieldFilter FieldFilter
    n = t instanceof $70fd6868680e912c$var$mn ? e instanceof $70fd6868680e912c$var$mn ? function(t, e) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $70fd6868680e912c$var$gn.create([
            t,
            e
        ], "and" /* CompositeOperator.AND */ );
    }(t, e) : $70fd6868680e912c$var$Qr(t, e) : e instanceof $70fd6868680e912c$var$mn ? $70fd6868680e912c$var$Qr(e, t) : function(t, e) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($70fd6868680e912c$var$F(t.filters.length > 0 && e.filters.length > 0), $70fd6868680e912c$var$yn(t) && $70fd6868680e912c$var$yn(e)) return $70fd6868680e912c$var$vn(t, e.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $70fd6868680e912c$var$pn(t) ? t : e, s = $70fd6868680e912c$var$pn(t) ? e : t, i = n.filters.map((t)=>$70fd6868680e912c$var$Gr(t, s));
        return $70fd6868680e912c$var$gn.create(i, "or" /* CompositeOperator.OR */ );
    }(t, e), $70fd6868680e912c$var$jr(n);
}
function $70fd6868680e912c$var$Qr(t, e) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($70fd6868680e912c$var$yn(e)) // Case 1
    return $70fd6868680e912c$var$vn(e, t.getFilters());
    {
        // Case 2
        const n = e.filters.map((e)=>$70fd6868680e912c$var$Gr(t, e));
        return $70fd6868680e912c$var$gn.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $70fd6868680e912c$var$jr(t) {
    if ($70fd6868680e912c$var$F(t instanceof $70fd6868680e912c$var$mn || t instanceof $70fd6868680e912c$var$gn), t instanceof $70fd6868680e912c$var$mn) return t;
    const e = t.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === e.length) return $70fd6868680e912c$var$jr(e[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($70fd6868680e912c$var$Tn(t)) return t;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = e.map((t)=>$70fd6868680e912c$var$jr(t)), s = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((e)=>{
        e instanceof $70fd6868680e912c$var$mn ? s.push(e) : e instanceof $70fd6868680e912c$var$gn && (e.op === t.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        s.push(...e.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        s.push(e));
    }), 1 === s.length ? s[0] : $70fd6868680e912c$var$gn.create(s, t.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $70fd6868680e912c$var$zr {
    constructor(){
        this.rn = new $70fd6868680e912c$var$Wr;
    }
    addToCollectionParentIndex(t, e) {
        return this.rn.add(e), $70fd6868680e912c$var$Rt.resolve();
    }
    getCollectionParents(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.rn.getEntries(e));
    }
    addFieldIndex(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve();
    }
    deleteFieldIndex(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve();
    }
    getDocumentsMatchingTarget(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve(null);
    }
    getIndexType(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve([]);
    }
    getNextCollectionGroupToUpdate(t) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve(null);
    }
    getMinOffset(t, e) {
        return $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$It.min());
    }
    getMinOffsetFromCollectionGroup(t, e) {
        return $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$It.min());
    }
    updateCollectionGroup(t, e, n) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve();
    }
    updateIndexEntries(t, e) {
        // Field indices are not supported with memory persistence.
        return $70fd6868680e912c$var$Rt.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $70fd6868680e912c$var$Wr {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(t) {
        const e = t.lastSegment(), n = t.popLast(), s = this.index[e] || new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$ut.comparator), i = !s.has(n);
        return this.index[e] = s.add(n), i;
    }
    has(t) {
        const e = t.lastSegment(), n = t.popLast(), s = this.index[e];
        return s && s.has(n);
    }
    getEntries(t) {
        return (this.index[t] || new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$ut.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Hr = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $70fd6868680e912c$var$Jr {
    constructor(t, e){
        this.user = t, this.databaseId = e, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.on = new $70fd6868680e912c$var$Wr, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.un = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$$n(t), (t, e)=>$70fd6868680e912c$var$On(t, e)), this.uid = t.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(t, e) {
        if (!this.on.has(e)) {
            const n = e.lastSegment(), s = e.popLast();
            t.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.on.add(e);
            });
            const i = {
                collectionId: n,
                parent: $70fd6868680e912c$var$qt(s)
            };
            return $70fd6868680e912c$var$Yr(t).put(i);
        }
        return $70fd6868680e912c$var$Rt.resolve();
    }
    getCollectionParents(t, e) {
        const n = [], s = IDBKeyRange.bound([
            e,
            ""
        ], [
            $70fd6868680e912c$var$st(e),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $70fd6868680e912c$var$Yr(t).j(s).next((t)=>{
            for (const s of t){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (s.collectionId !== e) break;
                n.push($70fd6868680e912c$var$Gt(s.parent));
            }
            return n;
        });
    }
    addFieldIndex(t, e) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $70fd6868680e912c$var$Zr(t), s = function(t) {
            return {
                indexId: t.indexId,
                collectionGroup: t.collectionGroup,
                fields: t.fields.map((t)=>[
                        t.fieldPath.canonicalString(),
                        t.kind
                    ])
            };
        }(e);
        delete s.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(s);
        if (e.indexState) {
            const n = $70fd6868680e912c$var$to(t);
            return i.next((t)=>{
                n.put($70fd6868680e912c$var$Tr(t, this.user, e.indexState.sequenceNumber, e.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(t, e) {
        const n = $70fd6868680e912c$var$Zr(t), s = $70fd6868680e912c$var$to(t), i = $70fd6868680e912c$var$Xr(t);
        return n.delete(e.indexId).next(()=>s.delete(IDBKeyRange.bound([
                e.indexId
            ], [
                e.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                e.indexId
            ], [
                e.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    getDocumentsMatchingTarget(t, e) {
        const n = $70fd6868680e912c$var$Xr(t);
        let s = !0;
        const i = new Map;
        return $70fd6868680e912c$var$Rt.forEach(this.cn(e), (e)=>this.an(t, e).next((t)=>{
                s && (s = !!t), i.set(e, t);
            })).next(()=>{
            if (s) {
                let t = $70fd6868680e912c$var$gs();
                const s = [];
                return $70fd6868680e912c$var$Rt.forEach(i, (i, r)=>{
                    var o;
                    $70fd6868680e912c$var$N("IndexedDbIndexManager", `Using index ${(o = i, `id=${o.indexId}|cg=${o.collectionGroup}|f=${o.fields.map((t)=>`${t.fieldPath}:${t.kind}`).join(",")}`)} to execute ${$70fd6868680e912c$var$$n(e)}`);
                    const u = function(t, e) {
                        const n = $70fd6868680e912c$var$ft(e);
                        if (void 0 === n) return null;
                        for (const e of $70fd6868680e912c$var$Bn(t, n.fieldPath))switch(e.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return e.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    e.value
                                ];
                        }
                        return null;
                    }(r, i), c = function(t, e) {
                        const n = new Map;
                        for (const s of $70fd6868680e912c$var$dt(e))for (const e of $70fd6868680e912c$var$Bn(t, s.fieldPath))switch(e.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(s.fieldPath.canonicalString(), e.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(s.fieldPath.canonicalString(), e.value), Array.from(n.values());
                        }
                        return null;
                    }(r, i), a = function(t, e) {
                        const n = [];
                        let s = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $70fd6868680e912c$var$dt(e)){
                            const e = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$Ln(t, i.fieldPath, t.startAt) : $70fd6868680e912c$var$qn(t, i.fieldPath, t.startAt);
                            n.push(e.value), s && (s = e.inclusive);
                        }
                        return new $70fd6868680e912c$var$hn(n, s);
                    }(r, i), h = function(t, e) {
                        const n = [];
                        let s = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $70fd6868680e912c$var$dt(e)){
                            const e = 0 /* IndexKind.ASCENDING */  === i.kind ? $70fd6868680e912c$var$qn(t, i.fieldPath, t.endAt) : $70fd6868680e912c$var$Ln(t, i.fieldPath, t.endAt);
                            n.push(e.value), s && (s = e.inclusive);
                        }
                        return new $70fd6868680e912c$var$hn(n, s);
                    }(r, i), l = this.hn(i, r, a), f = this.hn(i, r, h), d = this.ln(i, r, c), w = this.fn(i.indexId, u, l, a.inclusive, f, h.inclusive, d);
                    return $70fd6868680e912c$var$Rt.forEach(w, (i)=>n.H(i, e.limit).next((e)=>{
                            e.forEach((e)=>{
                                const n = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.documentKey);
                                t.has(n) || (t = t.add(n), s.push(n));
                            });
                        }));
                }).next(()=>s);
            }
            return $70fd6868680e912c$var$Rt.resolve(null);
        });
    }
    cn(t) {
        let e = this.un.get(t);
        if (e) return e;
        if (0 === t.filters.length) e = [
            t
        ];
        else e = $70fd6868680e912c$var$Br($70fd6868680e912c$var$gn.create(t.filters, "and" /* CompositeOperator.AND */ )).map((e)=>$70fd6868680e912c$var$Mn(t.path, t.collectionGroup, t.orderBy, e.getFilters(), t.limit, t.startAt, t.endAt));
        return this.un.set(t, e), e;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ fn(t, e, n, s, i, r, o) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const u = (null != e ? e.length : 1) * Math.max(n.length, i.length), c = u / (null != e ? e.length : 1), a = [];
        for(let h = 0; h < u; ++h){
            const u = e ? this.dn(e[h / c]) : $70fd6868680e912c$var$Hr, l = this.wn(t, u, n[h % c], s), f = this._n(t, u, i[h % c], r), d = o.map((e)=>this.wn(t, u, e, /* inclusive= */ !0));
            a.push(...this.createRange(l, f, d));
        }
        return a;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ wn(t, e, n, s) {
        const i = new $70fd6868680e912c$var$kr(t, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e, n);
        return s ? i : i.Je();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ _n(t, e, n, s) {
        const i = new $70fd6868680e912c$var$kr(t, $70fd6868680e912c$export$afc2e57c475b7810.empty(), e, n);
        return s ? i.Je() : i;
    }
    an(t, e) {
        const n = new $70fd6868680e912c$var$Or(e), s = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment();
        return this.getFieldIndexes(t, s).next((t)=>{
            // Return the index with the most number of segments.
            let e = null;
            for (const s of t)n.tn(s) && (!e || s.fields.length > e.fields.length) && (e = s);
            return e;
        });
    }
    getIndexType(t, e) {
        let n = 2 /* IndexType.FULL */ ;
        const s = this.cn(e);
        return $70fd6868680e912c$var$Rt.forEach(s, (e)=>this.an(t, e).next((t)=>{
                t ? 0 /* IndexType.NONE */  !== n && t.fields.length < function(t) {
                    let e = new $70fd6868680e912c$var$Ee($70fd6868680e912c$export$b7871852b967eaf1.comparator), n = !1;
                    for (const s of t.filters)for (const t of s.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    t.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === t.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t.op ? n = !0 : e = e.add(t.field));
                    for (const n of t.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (e = e.add(n.field));
                    return e.size + (n ? 1 : 0);
                }(e) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function(t) {
                return null !== t.limit;
            })(e) && s.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ mn(t, e) {
        const n = new $70fd6868680e912c$var$Nr;
        for (const s of $70fd6868680e912c$var$dt(t)){
            const t = e.data.field(s.fieldPath);
            if (null == t) return null;
            const i = n.He(s.kind);
            $70fd6868680e912c$var$br.Ve._e(t, i);
        }
        return n.Qe();
    }
    /** Encodes a single value to the ascending index format. */ dn(t) {
        const e = new $70fd6868680e912c$var$Nr;
        return $70fd6868680e912c$var$br.Ve._e(t, e.He(0 /* IndexKind.ASCENDING */ )), e.Qe();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ gn(t, e) {
        const n = new $70fd6868680e912c$var$Nr;
        return $70fd6868680e912c$var$br.Ve._e($70fd6868680e912c$var$We(this.databaseId, e), n.He(function(t) {
            const e = $70fd6868680e912c$var$dt(t);
            return 0 === e.length ? 0 /* IndexKind.ASCENDING */  : e[e.length - 1].kind;
        }(t))), n.Qe();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ ln(t, e, n) {
        if (null === n) return [];
        let s = [];
        s.push(new $70fd6868680e912c$var$Nr);
        let i = 0;
        for (const r of $70fd6868680e912c$var$dt(t)){
            const t = n[i++];
            for (const n of s)if (this.yn(e, r.fieldPath) && $70fd6868680e912c$var$Je(t)) s = this.pn(s, r, t);
            else {
                const e = n.He(r.kind);
                $70fd6868680e912c$var$br.Ve._e(t, e);
            }
        }
        return this.In(s);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ hn(t, e, n) {
        return this.ln(t, e, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ In(t) {
        const e = [];
        for(let n = 0; n < t.length; ++n)e[n] = t[n].Qe();
        return e;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ pn(t, e, n) {
        const s = [
            ...t
        ], i = [];
        for (const t of n.arrayValue.values || [])for (const n of s){
            const s = new $70fd6868680e912c$var$Nr;
            s.seed(n.Qe()), $70fd6868680e912c$var$br.Ve._e(t, s.He(e.kind)), i.push(s);
        }
        return i;
    }
    yn(t, e) {
        return !!t.filters.find((t)=>t instanceof $70fd6868680e912c$var$mn && t.field.isEqual(e) && ("in" /* Operator.IN */  === t.op || "not-in" /* Operator.NOT_IN */  === t.op));
    }
    getFieldIndexes(t, e) {
        const n = $70fd6868680e912c$var$Zr(t), s = $70fd6868680e912c$var$to(t);
        return (e ? n.j("collectionGroupIndex", IDBKeyRange.bound(e, e)) : n.j()).next((t)=>{
            const e = [];
            return $70fd6868680e912c$var$Rt.forEach(t, (t)=>s.get([
                    t.indexId,
                    this.uid
                ]).next((n)=>{
                    e.push(function(t, e) {
                        const n = e ? new $70fd6868680e912c$var$gt(e.sequenceNumber, new $70fd6868680e912c$var$It($70fd6868680e912c$var$wr(e.readTime), new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$Gt(e.documentKey)), e.largestBatchId)) : $70fd6868680e912c$var$gt.empty(), s = t.fields.map(([t, e])=>new $70fd6868680e912c$var$_t($70fd6868680e912c$export$b7871852b967eaf1.fromServerFormat(t), e));
                        return new $70fd6868680e912c$var$lt(t.indexId, t.collectionGroup, s, n);
                    }(t, n));
                })).next(()=>e);
        });
    }
    getNextCollectionGroupToUpdate(t) {
        return this.getFieldIndexes(t).next((t)=>0 === t.length ? null : (t.sort((t, e)=>{
                const n = t.indexState.sequenceNumber - e.indexState.sequenceNumber;
                return 0 !== n ? n : $70fd6868680e912c$var$et(t.collectionGroup, e.collectionGroup);
            }), t[0].collectionGroup));
    }
    updateCollectionGroup(t, e, n) {
        const s = $70fd6868680e912c$var$Zr(t), i = $70fd6868680e912c$var$to(t);
        return this.Tn(t).next((t)=>s.j("collectionGroupIndex", IDBKeyRange.bound(e, e)).next((e)=>$70fd6868680e912c$var$Rt.forEach(e, (e)=>i.put($70fd6868680e912c$var$Tr(e.indexId, this.user, t, n)))));
    }
    updateIndexEntries(t, e) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $70fd6868680e912c$var$Rt.forEach(e, (e, s)=>{
            const i = n.get(e.collectionGroup);
            return (i ? $70fd6868680e912c$var$Rt.resolve(i) : this.getFieldIndexes(t, e.collectionGroup)).next((i)=>(n.set(e.collectionGroup, i), $70fd6868680e912c$var$Rt.forEach(i, (n)=>this.En(t, e, n).next((e)=>{
                        const i = this.An(s, n);
                        return e.isEqual(i) ? $70fd6868680e912c$var$Rt.resolve() : this.vn(t, s, n, e, i);
                    }))));
        });
    }
    Rn(t, e, n, s) {
        return $70fd6868680e912c$var$Xr(t).put({
            indexId: s.indexId,
            uid: this.uid,
            arrayValue: s.arrayValue,
            directionalValue: s.directionalValue,
            orderedDocumentKey: this.gn(n, e.key),
            documentKey: e.key.path.toArray()
        });
    }
    Pn(t, e, n, s) {
        return $70fd6868680e912c$var$Xr(t).delete([
            s.indexId,
            this.uid,
            s.arrayValue,
            s.directionalValue,
            this.gn(n, e.key),
            e.key.path.toArray()
        ]);
    }
    En(t, e, n) {
        const s = $70fd6868680e912c$var$Xr(t);
        let i = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Mr);
        return s.X({
            index: "documentKeyIndex",
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                this.gn(n, e)
            ])
        }, (t, s)=>{
            i = i.add(new $70fd6868680e912c$var$kr(n.indexId, e, s.arrayValue, s.directionalValue));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ An(t, e) {
        let n = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Mr);
        const s = this.mn(e, t);
        if (null == s) return n;
        const i = $70fd6868680e912c$var$ft(e);
        if (null != i) {
            const r = t.data.field(i.fieldPath);
            if ($70fd6868680e912c$var$Je(r)) for (const i of r.arrayValue.values || [])n = n.add(new $70fd6868680e912c$var$kr(e.indexId, t.key, this.dn(i), s));
        } else n = n.add(new $70fd6868680e912c$var$kr(e.indexId, t.key, $70fd6868680e912c$var$Hr, s));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ vn(t, e, n, s, i) {
        $70fd6868680e912c$var$N("IndexedDbIndexManager", "Updating index entries for document '%s'", e.key);
        const r = [];
        return function(t, e, n, s, i) {
            const r = t.getIterator(), o = e.getIterator();
            let u = $70fd6868680e912c$var$ve(r), c = $70fd6868680e912c$var$ve(o);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; u || c;){
                let t = !1, e = !1;
                if (u && c) {
                    const s = n(u, c);
                    s < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    e = !0 : s > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (t = !0);
                } else null != u ? e = !0 : t = !0;
                t ? (s(c), c = $70fd6868680e912c$var$ve(o)) : e ? (i(u), u = $70fd6868680e912c$var$ve(r)) : (u = $70fd6868680e912c$var$ve(r), c = $70fd6868680e912c$var$ve(o));
            }
        }(s, i, $70fd6868680e912c$var$Mr, /* onAdd= */ (s)=>{
            r.push(this.Rn(t, e, n, s));
        }, /* onRemove= */ (s)=>{
            r.push(this.Pn(t, e, n, s));
        }), $70fd6868680e912c$var$Rt.waitFor(r);
    }
    Tn(t) {
        let e = 1;
        return $70fd6868680e912c$var$to(t).X({
            index: "sequenceNumberIndex",
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (t, n, s)=>{
            s.done(), e = n.sequenceNumber + 1;
        }).next(()=>e);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(t, e, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((t, e)=>$70fd6868680e912c$var$Mr(t, e)).filter((t, e, n)=>!e || 0 !== $70fd6868680e912c$var$Mr(t, n[e - 1]));
        const s = [];
        s.push(t);
        for (const i of n){
            const n = $70fd6868680e912c$var$Mr(i, t), r = $70fd6868680e912c$var$Mr(i, e);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            s[0] = t.Je();
            else if (n > 0 && r < 0) // `notInValue` is in the middle of the range
            s.push(i), s.push(i.Je());
            else if (r > 0) break;
        }
        s.push(e);
        const i = [];
        for(let t = 0; t < s.length; t += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.bn(s[t], s[t + 1])) return [];
            const e = [
                s[t].indexId,
                this.uid,
                s[t].arrayValue,
                s[t].directionalValue,
                $70fd6868680e912c$var$Hr,
                []
            ], n = [
                s[t + 1].indexId,
                this.uid,
                s[t + 1].arrayValue,
                s[t + 1].directionalValue,
                $70fd6868680e912c$var$Hr,
                []
            ];
            i.push(IDBKeyRange.bound(e, n));
        }
        return i;
    }
    bn(t, e) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $70fd6868680e912c$var$Mr(t, e) > 0;
    }
    getMinOffsetFromCollectionGroup(t, e) {
        return this.getFieldIndexes(t, e).next($70fd6868680e912c$var$eo);
    }
    getMinOffset(t, e) {
        return $70fd6868680e912c$var$Rt.mapArray(this.cn(e), (e)=>this.an(t, e).next((t)=>t || $70fd6868680e912c$var$O())).next($70fd6868680e912c$var$eo);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $70fd6868680e912c$var$Yr(t) {
    return $70fd6868680e912c$var$_e(t, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $70fd6868680e912c$var$Xr(t) {
    return $70fd6868680e912c$var$_e(t, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $70fd6868680e912c$var$Zr(t) {
    return $70fd6868680e912c$var$_e(t, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $70fd6868680e912c$var$to(t) {
    return $70fd6868680e912c$var$_e(t, "indexState");
}
function $70fd6868680e912c$var$eo(t) {
    $70fd6868680e912c$var$F(0 !== t.length);
    let e = t[0].indexState.offset, n = e.largestBatchId;
    for(let s = 1; s < t.length; s++){
        const i = t[s].indexState.offset;
        $70fd6868680e912c$var$Tt(i, e) < 0 && (e = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $70fd6868680e912c$var$It(e.readTime, e.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$no = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
class $70fd6868680e912c$var$so {
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    t, // The percentage of sequence numbers that we will attempt to collect
    e, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = t, this.percentileToCollect = e, this.maximumSequenceNumbersToCollect = n;
    }
    static withCacheSize(t) {
        return new $70fd6868680e912c$var$so(t, $70fd6868680e912c$var$so.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$so.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $70fd6868680e912c$var$io(t, e, n) {
    const s = t.store("mutations"), i = t.store("documentMutations"), r = [], o = IDBKeyRange.only(n.batchId);
    let u = 0;
    const c = s.X({
        range: o
    }, (t, e, n)=>(u++, n.delete()));
    r.push(c.next(()=>{
        $70fd6868680e912c$var$F(1 === u);
    }));
    const a = [];
    for (const t of n.mutations){
        const s = $70fd6868680e912c$var$zt(e, t.key.path, n.batchId);
        r.push(i.delete(s)), a.push(t.key);
    }
    return $70fd6868680e912c$var$Rt.waitFor(r).next(()=>a);
}
/**
 * Returns an approximate size for the given document.
 */ function $70fd6868680e912c$var$ro(t) {
    if (!t) return 0;
    let e;
    if (t.document) e = t.document;
    else if (t.unknownDocument) e = t.unknownDocument;
    else {
        if (!t.noDocument) throw $70fd6868680e912c$var$O();
        e = t.noDocument;
    }
    return JSON.stringify(e).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $70fd6868680e912c$var$so.DEFAULT_COLLECTION_PERCENTILE = 10, $70fd6868680e912c$var$so.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $70fd6868680e912c$var$so.DEFAULT = new $70fd6868680e912c$var$so(41943040, $70fd6868680e912c$var$so.DEFAULT_COLLECTION_PERCENTILE, $70fd6868680e912c$var$so.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $70fd6868680e912c$var$so.DISABLED = new $70fd6868680e912c$var$so(-1, 0, 0);
class $70fd6868680e912c$var$oo {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ t, e, n, s){
        this.userId = t, this.serializer = e, this.indexManager = n, this.referenceDelegate = s, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.Vn = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static de(t, e, n, s) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $70fd6868680e912c$var$F("" !== t.uid);
        const i = t.isAuthenticated() ? t.uid : "";
        return new $70fd6868680e912c$var$oo(i, e, n, s);
    }
    checkEmpty(t) {
        let e = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$co(t).X({
            index: "userMutationsIndex",
            range: n
        }, (t, n, s)=>{
            e = !1, s.done();
        }).next(()=>e);
    }
    addMutationBatch(t, e, n, s) {
        const i = $70fd6868680e912c$var$ao(t), r = $70fd6868680e912c$var$co(t);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return r.add({}).next((o)=>{
            $70fd6868680e912c$var$F("number" == typeof o);
            const u = new $70fd6868680e912c$var$Zs(o, e, n, s), c = function(t, e, n) {
                const s = n.baseMutations.map((e)=>$70fd6868680e912c$var$ji(t.fe, e)), i = n.mutations.map((e)=>$70fd6868680e912c$var$ji(t.fe, e));
                return {
                    userId: e,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: s,
                    mutations: i
                };
            }(this.serializer, this.userId, u), a = [];
            let h = new $70fd6868680e912c$var$Ee((t, e)=>$70fd6868680e912c$var$et(t.canonicalString(), e.canonicalString()));
            for (const t of s){
                const e = $70fd6868680e912c$var$zt(this.userId, t.key.path, o);
                h = h.add(t.key.path.popLast()), a.push(r.put(c)), a.push(i.put(e, $70fd6868680e912c$var$Wt));
            }
            return h.forEach((e)=>{
                a.push(this.indexManager.addToCollectionParentIndex(t, e));
            }), t.addOnCommittedListener(()=>{
                this.Vn[o] = u.keys();
            }), $70fd6868680e912c$var$Rt.waitFor(a).next(()=>u);
        });
    }
    lookupMutationBatch(t, e) {
        return $70fd6868680e912c$var$co(t).get(e).next((t)=>t ? ($70fd6868680e912c$var$F(t.userId === this.userId), $70fd6868680e912c$var$_r(this.serializer, t)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    Sn(t, e) {
        return this.Vn[e] ? $70fd6868680e912c$var$Rt.resolve(this.Vn[e]) : this.lookupMutationBatch(t, e).next((t)=>{
            if (t) {
                const n = t.keys();
                return this.Vn[e] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(t, e) {
        const n = e + 1, s = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $70fd6868680e912c$var$co(t).X({
            index: "userMutationsIndex",
            range: s
        }, (t, e, s)=>{
            e.userId === this.userId && ($70fd6868680e912c$var$F(e.batchId >= n), i = $70fd6868680e912c$var$_r(this.serializer, e)), s.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(t) {
        const e = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = -1;
        return $70fd6868680e912c$var$co(t).X({
            index: "userMutationsIndex",
            range: e,
            reverse: !0
        }, (t, e, s)=>{
            n = e.batchId, s.done();
        }).next(()=>n);
    }
    getAllMutationBatches(t) {
        const e = IDBKeyRange.bound([
            this.userId,
            -1
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $70fd6868680e912c$var$co(t).j("userMutationsIndex", e).next((t)=>t.map((t)=>$70fd6868680e912c$var$_r(this.serializer, t)));
    }
    getAllMutationBatchesAffectingDocumentKey(t, e) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $70fd6868680e912c$var$jt(this.userId, e.path), s = IDBKeyRange.lowerBound(n), i = [];
        return $70fd6868680e912c$var$ao(t).X({
            range: s
        }, (n, s, r)=>{
            const [o, u, c] = n, a = $70fd6868680e912c$var$Gt(u);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (o === this.userId && e.path.isEqual(a)) // Look up the mutation batch in the store.
            return $70fd6868680e912c$var$co(t).get(c).next((t)=>{
                if (!t) throw $70fd6868680e912c$var$O();
                $70fd6868680e912c$var$F(t.userId === this.userId), i.push($70fd6868680e912c$var$_r(this.serializer, t));
            });
            r.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(t, e) {
        let n = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
        const s = [];
        return e.forEach((e)=>{
            const i = $70fd6868680e912c$var$jt(this.userId, e.path), r = IDBKeyRange.lowerBound(i), o = $70fd6868680e912c$var$ao(t).X({
                range: r
            }, (t, s, i)=>{
                const [r, o, u] = t, c = $70fd6868680e912c$var$Gt(o);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                r === this.userId && e.path.isEqual(c) ? n = n.add(u) : i.done();
            });
            s.push(o);
        }), $70fd6868680e912c$var$Rt.waitFor(s).next(()=>this.Dn(t, n));
    }
    getAllMutationBatchesAffectingQuery(t, e) {
        const n = e.path, s = n.length + 1, i = $70fd6868680e912c$var$jt(this.userId, n), r = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let o = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
        return $70fd6868680e912c$var$ao(t).X({
            range: r
        }, (t, e, i)=>{
            const [r, u, c] = t, a = $70fd6868680e912c$var$Gt(u);
            r === this.userId && n.isPrefixOf(a) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            a.length === s && (o = o.add(c)) : i.done();
        }).next(()=>this.Dn(t, o));
    }
    Dn(t, e) {
        const n = [], s = [];
        // TODO(rockwood): Implement this using iterate.
        return e.forEach((e)=>{
            s.push($70fd6868680e912c$var$co(t).get(e).next((t)=>{
                if (null === t) throw $70fd6868680e912c$var$O();
                $70fd6868680e912c$var$F(t.userId === this.userId), n.push($70fd6868680e912c$var$_r(this.serializer, t));
            }));
        }), $70fd6868680e912c$var$Rt.waitFor(s).next(()=>n);
    }
    removeMutationBatch(t, e) {
        return $70fd6868680e912c$var$io(t.ht, this.userId, e).next((n)=>(t.addOnCommittedListener(()=>{
                this.Cn(e.batchId);
            }), $70fd6868680e912c$var$Rt.forEach(n, (e)=>this.referenceDelegate.markPotentiallyOrphaned(t, e))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    Cn(t) {
        delete this.Vn[t];
    }
    performConsistencyCheck(t) {
        return this.checkEmpty(t).next((e)=>{
            if (!e) return $70fd6868680e912c$var$Rt.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound([
                this.userId
            ]);
            const s = [];
            return $70fd6868680e912c$var$ao(t).X({
                range: n
            }, (t, e, n)=>{
                if (t[0] === this.userId) {
                    const e = $70fd6868680e912c$var$Gt(t[1]);
                    s.push(e);
                } else n.done();
            }).next(()=>{
                $70fd6868680e912c$var$F(0 === s.length);
            });
        });
    }
    containsKey(t, e) {
        return $70fd6868680e912c$var$uo(t, this.userId, e);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ xn(t) {
        return $70fd6868680e912c$var$ho(t).get(this.userId).next((t)=>t || {
                userId: this.userId,
                lastAcknowledgedBatchId: -1,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $70fd6868680e912c$var$uo(t, e, n) {
    const s = $70fd6868680e912c$var$jt(e, n.path), i = s[1], r = IDBKeyRange.lowerBound(s);
    let o = !1;
    return $70fd6868680e912c$var$ao(t).X({
        range: r,
        Y: !0
    }, (t, n, s)=>{
        const [r, u, /*batchID*/ c] = t;
        r === e && u === i && (o = !0), s.done();
    }).next(()=>o);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $70fd6868680e912c$var$co(t) {
    return $70fd6868680e912c$var$_e(t, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$ao(t) {
    return $70fd6868680e912c$var$_e(t, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $70fd6868680e912c$var$ho(t) {
    return $70fd6868680e912c$var$_e(t, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $70fd6868680e912c$var$lo {
    constructor(t){
        this.Nn = t;
    }
    next() {
        return this.Nn += 2, this.Nn;
    }
    static kn() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $70fd6868680e912c$var$lo(0);
    }
    static Mn() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $70fd6868680e912c$var$lo(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$fo {
    constructor(t, e){
        this.referenceDelegate = t, this.serializer = e;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(t) {
        return this.$n(t).next((e)=>{
            const n = new $70fd6868680e912c$var$lo(e.highestTargetId);
            return e.highestTargetId = n.next(), this.On(t, e).next(()=>e.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(t) {
        return this.$n(t).next((t)=>$70fd6868680e912c$var$rt.fromTimestamp(new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(t) {
        return this.$n(t).next((t)=>t.highestListenSequenceNumber);
    }
    setTargetsMetadata(t, e, n) {
        return this.$n(t).next((s)=>(s.highestListenSequenceNumber = e, n && (s.lastRemoteSnapshotVersion = n.toTimestamp()), e > s.highestListenSequenceNumber && (s.highestListenSequenceNumber = e), this.On(t, s)));
    }
    addTargetData(t, e) {
        return this.Fn(t, e).next(()=>this.$n(t).next((n)=>(n.targetCount += 1, this.Bn(e, n), this.On(t, n))));
    }
    updateTargetData(t, e) {
        return this.Fn(t, e);
    }
    removeTargetData(t, e) {
        return this.removeMatchingKeysForTargetId(t, e.targetId).next(()=>$70fd6868680e912c$var$wo(t).delete(e.targetId)).next(()=>this.$n(t)).next((e)=>($70fd6868680e912c$var$F(e.targetCount > 0), e.targetCount -= 1, this.On(t, e)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(t, e, n) {
        let s = 0;
        const i = [];
        return $70fd6868680e912c$var$wo(t).X((r, o)=>{
            const u = $70fd6868680e912c$var$mr(o);
            u.sequenceNumber <= e && null === n.get(u.targetId) && (s++, i.push(this.removeTargetData(t, u)));
        }).next(()=>$70fd6868680e912c$var$Rt.waitFor(i)).next(()=>s);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(t, e) {
        return $70fd6868680e912c$var$wo(t).X((t, n)=>{
            const s = $70fd6868680e912c$var$mr(n);
            e(s);
        });
    }
    $n(t) {
        return $70fd6868680e912c$var$_o(t).get("targetGlobalKey").next((t)=>($70fd6868680e912c$var$F(null !== t), t));
    }
    On(t, e) {
        return $70fd6868680e912c$var$_o(t).put("targetGlobalKey", e);
    }
    Fn(t, e) {
        return $70fd6868680e912c$var$wo(t).put($70fd6868680e912c$var$gr(this.serializer, e));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Bn(t, e) {
        let n = !1;
        return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, n = !0), n;
    }
    getTargetCount(t) {
        return this.$n(t).next((t)=>t.targetCount);
    }
    getTargetData(t, e) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $70fd6868680e912c$var$$n(e), s = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $70fd6868680e912c$var$wo(t).X({
            range: s,
            index: "queryTargetsIndex"
        }, (t, n, s)=>{
            const r = $70fd6868680e912c$var$mr(n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $70fd6868680e912c$var$On(e, r.target) && (i = r, s.done());
        }).next(()=>i);
    }
    addMatchingKeys(t, e, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const s = [], i = $70fd6868680e912c$var$mo(t);
        return e.forEach((e)=>{
            const r = $70fd6868680e912c$var$qt(e.path);
            s.push(i.put({
                targetId: n,
                path: r
            })), s.push(this.referenceDelegate.addReference(t, n, e));
        }), $70fd6868680e912c$var$Rt.waitFor(s);
    }
    removeMatchingKeys(t, e, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const s = $70fd6868680e912c$var$mo(t);
        return $70fd6868680e912c$var$Rt.forEach(e, (e)=>{
            const i = $70fd6868680e912c$var$qt(e.path);
            return $70fd6868680e912c$var$Rt.waitFor([
                s.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(t, n, e)
            ]);
        });
    }
    removeMatchingKeysForTargetId(t, e) {
        const n = $70fd6868680e912c$var$mo(t), s = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(s);
    }
    getMatchingKeysForTargetId(t, e) {
        const n = IDBKeyRange.bound([
            e
        ], [
            e + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), s = $70fd6868680e912c$var$mo(t);
        let i = $70fd6868680e912c$var$gs();
        return s.X({
            range: n,
            Y: !0
        }, (t, e, n)=>{
            const s = $70fd6868680e912c$var$Gt(t[1]), r = new $70fd6868680e912c$export$afc2e57c475b7810(s);
            i = i.add(r);
        }).next(()=>i);
    }
    containsKey(t, e) {
        const n = $70fd6868680e912c$var$qt(e.path), s = IDBKeyRange.bound([
            n
        ], [
            $70fd6868680e912c$var$st(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $70fd6868680e912c$var$mo(t).X({
            index: "documentTargetsIndex",
            Y: !0,
            range: s
        }, ([t, e], n, s)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== t && (i++, s.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    le(t, e) {
        return $70fd6868680e912c$var$wo(t).get(e).next((t)=>t ? $70fd6868680e912c$var$mr(t) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $70fd6868680e912c$var$wo(t) {
    return $70fd6868680e912c$var$_e(t, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $70fd6868680e912c$var$_o(t) {
    return $70fd6868680e912c$var$_e(t, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $70fd6868680e912c$var$mo(t) {
    return $70fd6868680e912c$var$_e(t, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$go([t, e], [n, s]) {
    const i = $70fd6868680e912c$var$et(t, n);
    return 0 === i ? $70fd6868680e912c$var$et(e, s) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $70fd6868680e912c$var$yo {
    constructor(t){
        this.Ln = t, this.buffer = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$go), this.qn = 0;
    }
    Un() {
        return ++this.qn;
    }
    Kn(t) {
        const e = [
            t,
            this.Un()
        ];
        if (this.buffer.size < this.Ln) this.buffer = this.buffer.add(e);
        else {
            const t = this.buffer.last();
            $70fd6868680e912c$var$go(e, t) < 0 && (this.buffer = this.buffer.delete(t).add(e));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $70fd6868680e912c$var$po {
    constructor(t, e, n){
        this.garbageCollector = t, this.asyncQueue = e, this.localStore = n, this.Gn = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.Qn(6e4);
    }
    stop() {
        this.Gn && (this.Gn.cancel(), this.Gn = null);
    }
    get started() {
        return null !== this.Gn;
    }
    Qn(t) {
        $70fd6868680e912c$var$N("LruGarbageCollector", `Garbage collection scheduled in ${t}ms`), this.Gn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , t, async ()=>{
            this.Gn = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (t) {
                $70fd6868680e912c$var$Dt(t) ? $70fd6868680e912c$var$N("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", t) : await $70fd6868680e912c$var$vt(t);
            }
            await this.Qn(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $70fd6868680e912c$var$Io {
    constructor(t, e){
        this.jn = t, this.params = e;
    }
    calculateTargetCount(t, e) {
        return this.jn.zn(t).next((t)=>Math.floor(e / 100 * t));
    }
    nthSequenceNumber(t, e) {
        if (0 === e) return $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$Ot.ct);
        const n = new $70fd6868680e912c$var$yo(e);
        return this.jn.forEachTarget(t, (t)=>n.Kn(t.sequenceNumber)).next(()=>this.jn.Wn(t, (t)=>n.Kn(t))).next(()=>n.maxValue);
    }
    removeTargets(t, e, n) {
        return this.jn.removeTargets(t, e, n);
    }
    removeOrphanedDocuments(t, e) {
        return this.jn.removeOrphanedDocuments(t, e);
    }
    collect(t, e) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$N("LruGarbageCollector", "Garbage collection skipped; disabled"), $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$no)) : this.getCacheSize(t).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($70fd6868680e912c$var$N("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $70fd6868680e912c$var$no) : this.Hn(t, e));
    }
    getCacheSize(t) {
        return this.jn.getCacheSize(t);
    }
    Hn(t, e) {
        let n, s, i, r, o, c, a;
        const h = Date.now();
        return this.calculateTargetCount(t, this.params.percentileToCollect).next((e)=>// Cap at the configured max
            (e > this.params.maximumSequenceNumbersToCollect ? ($70fd6868680e912c$var$N("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${e}`), s = this.params.maximumSequenceNumbersToCollect) : s = e, r = Date.now(), this.nthSequenceNumber(t, s))).next((s)=>(n = s, o = Date.now(), this.removeTargets(t, n, e))).next((e)=>(i = e, c = Date.now(), this.removeOrphanedDocuments(t, n))).next((t)=>{
            if (a = Date.now(), $70fd6868680e912c$var$C() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG) $70fd6868680e912c$var$N("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${r - h}ms\n\tDetermined least recently used ${s} in ` + (o - r) + "ms\n" + `\tRemoved ${i} targets in ` + (c - o) + "ms\n" + `\tRemoved ${t} documents in ` + (a - c) + "ms\n" + `Total Duration: ${a - h}ms`);
            return $70fd6868680e912c$var$Rt.resolve({
                didRun: !0,
                sequenceNumbersCollected: s,
                targetsRemoved: i,
                documentsRemoved: t
            });
        });
    }
}
function $70fd6868680e912c$var$To(t, e) {
    return new $70fd6868680e912c$var$Io(t, e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $70fd6868680e912c$var$Eo {
    constructor(t, e){
        this.db = t, this.garbageCollector = $70fd6868680e912c$var$To(this, e);
    }
    zn(t) {
        const e = this.Jn(t);
        return this.db.getTargetCache().getTargetCount(t).next((t)=>e.next((e)=>t + e));
    }
    Jn(t) {
        let e = 0;
        return this.Wn(t, (t)=>{
            e++;
        }).next(()=>e);
    }
    forEachTarget(t, e) {
        return this.db.getTargetCache().forEachTarget(t, e);
    }
    Wn(t, e) {
        return this.Yn(t, (t, n)=>e(n));
    }
    addReference(t, e, n) {
        return $70fd6868680e912c$var$Ao(t, n);
    }
    removeReference(t, e, n) {
        return $70fd6868680e912c$var$Ao(t, n);
    }
    removeTargets(t, e, n) {
        return this.db.getTargetCache().removeTargets(t, e, n);
    }
    markPotentiallyOrphaned(t, e) {
        return $70fd6868680e912c$var$Ao(t, e);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Xn(t, e) {
        return function(t, e) {
            let n = !1;
            return $70fd6868680e912c$var$ho(t).Z((s)=>$70fd6868680e912c$var$uo(t, s, e).next((t)=>(t && (n = !0), $70fd6868680e912c$var$Rt.resolve(!t)))).next(()=>n);
        }(t, e);
    }
    removeOrphanedDocuments(t, e) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), s = [];
        let i = 0;
        return this.Yn(t, (r, o)=>{
            if (o <= e) {
                const e = this.Xn(t, r).next((e)=>{
                    if (!e) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(t, r).next(()=>(n.removeEntry(r, $70fd6868680e912c$var$rt.min()), $70fd6868680e912c$var$mo(t).delete([
                            0,
                            $70fd6868680e912c$var$qt(r.path)
                        ])));
                });
                s.push(e);
            }
        }).next(()=>$70fd6868680e912c$var$Rt.waitFor(s)).next(()=>n.apply(t)).next(()=>i);
    }
    removeTarget(t, e) {
        const n = e.withSequenceNumber(t.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(t, n);
    }
    updateLimboDocument(t, e) {
        return $70fd6868680e912c$var$Ao(t, e);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Yn(t, e) {
        const n = $70fd6868680e912c$var$mo(t);
        let s, i = $70fd6868680e912c$var$Ot.ct;
        return n.X({
            index: "documentTargetsIndex"
        }, ([t, n], { path: r, sequenceNumber: o })=>{
            0 === t ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $70fd6868680e912c$var$Ot.ct && e(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$Gt(s)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = o, s = r) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $70fd6868680e912c$var$Ot.ct;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $70fd6868680e912c$var$Ot.ct && e(new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$Gt(s)), i);
        });
    }
    getCacheSize(t) {
        return this.db.getRemoteDocumentCache().getSize(t);
    }
}
function $70fd6868680e912c$var$Ao(t, e) {
    return $70fd6868680e912c$var$mo(t).put(/**
 * @returns A value suitable for writing a sentinel row in the target-document
 * store.
 */ function(t, e) {
        return {
            targetId: 0,
            path: $70fd6868680e912c$var$qt(t.path),
            sequenceNumber: e
        };
    }(e, t.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $70fd6868680e912c$var$vo {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $70fd6868680e912c$var$os((t)=>t.toString(), (t, e)=>t.isEqual(e)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(t) {
        this.assertNotApplied(), this.changes.set(t.key, t);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(t, e) {
        this.assertNotApplied(), this.changes.set(t, $70fd6868680e912c$var$an.newInvalidDocument(t).setReadTime(e));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(t, e) {
        this.assertNotApplied();
        const n = this.changes.get(e);
        return void 0 !== n ? $70fd6868680e912c$var$Rt.resolve(n) : this.getFromCache(t, e);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(t, e) {
        return this.getAllFromCache(t, e);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(t) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(t);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$Ro {
    constructor(t){
        this.serializer = t;
    }
    setIndexManager(t) {
        this.indexManager = t;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(t, e, n) {
        return $70fd6868680e912c$var$So(t).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(t, e, n) {
        return $70fd6868680e912c$var$So(t).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function(t, e) {
            const n = t.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $70fd6868680e912c$var$fr(e),
                /* document id */ n[n.length - 1]
            ];
        }(e, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(t, e) {
        return this.getMetadata(t).next((n)=>(n.byteSize += e, this.Zn(t, n)));
    }
    getEntry(t, e) {
        let n = $70fd6868680e912c$var$an.newInvalidDocument(e);
        return $70fd6868680e912c$var$So(t).X({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($70fd6868680e912c$var$Do(e))
        }, (t, s)=>{
            n = this.ts(e, s);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ es(t, e) {
        let n = {
            size: 0,
            document: $70fd6868680e912c$var$an.newInvalidDocument(e)
        };
        return $70fd6868680e912c$var$So(t).X({
            index: "documentKeyIndex",
            range: IDBKeyRange.only($70fd6868680e912c$var$Do(e))
        }, (t, s)=>{
            n = {
                document: this.ts(e, s),
                size: $70fd6868680e912c$var$ro(s)
            };
        }).next(()=>n);
    }
    getEntries(t, e) {
        let n = $70fd6868680e912c$var$cs();
        return this.ns(t, e, (t, e)=>{
            const s = this.ts(t, e);
            n = n.insert(t, s);
        }).next(()=>n);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ ss(t, e) {
        let n = $70fd6868680e912c$var$cs(), s = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        return this.ns(t, e, (t, e)=>{
            const i = this.ts(t, e);
            n = n.insert(t, i), s = s.insert(t, $70fd6868680e912c$var$ro(e));
        }).next(()=>({
                documents: n,
                rs: s
            }));
    }
    ns(t, e, n) {
        if (e.isEmpty()) return $70fd6868680e912c$var$Rt.resolve();
        let s = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$xo);
        e.forEach((t)=>s = s.add(t));
        const i = IDBKeyRange.bound($70fd6868680e912c$var$Do(s.first()), $70fd6868680e912c$var$Do(s.last())), r = s.getIterator();
        let o = r.getNext();
        return $70fd6868680e912c$var$So(t).X({
            index: "documentKeyIndex",
            range: i
        }, (t, e, s)=>{
            const i = $70fd6868680e912c$export$afc2e57c475b7810.fromSegments([
                ...e.prefixPath,
                e.collectionGroup,
                e.documentId
            ]);
            // Go through keys not found in cache.
            for(; o && $70fd6868680e912c$var$xo(o, i) < 0;)n(o, null), o = r.getNext();
            o && o.isEqual(i) && // Key found in cache.
            (n(o, e), o = r.hasNext() ? r.getNext() : null), // Skip to the next key (if there is one).
            o ? s.G($70fd6868680e912c$var$Do(o)) : s.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; o;)n(o, null), o = r.hasNext() ? r.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(t, e, n, s) {
        const i = e.path, r = [
            i.popLast().toArray(),
            i.lastSegment(),
            $70fd6868680e912c$var$fr(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], o = [
            i.popLast().toArray(),
            i.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $70fd6868680e912c$var$So(t).j(IDBKeyRange.bound(r, o, !0)).next((t)=>{
            let n = $70fd6868680e912c$var$cs();
            for (const i of t){
                const t = this.ts($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                t.isFoundDocument() && ($70fd6868680e912c$var$ns(e, t) || s.has(t.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(t.key, t));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(t, e, n, s) {
        let i = $70fd6868680e912c$var$cs();
        const r = $70fd6868680e912c$var$Co(e, n), o = $70fd6868680e912c$var$Co(e, $70fd6868680e912c$var$It.max());
        return $70fd6868680e912c$var$So(t).X({
            index: "collectionGroupIndex",
            range: IDBKeyRange.bound(r, o, !0)
        }, (t, e, n)=>{
            const r = this.ts($70fd6868680e912c$export$afc2e57c475b7810.fromSegments(e.prefixPath.concat(e.collectionGroup, e.documentId)), e);
            i = i.insert(r.key, r), i.size === s && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(t) {
        return new $70fd6868680e912c$var$bo(this, !!t && t.trackRemovals);
    }
    getSize(t) {
        return this.getMetadata(t).next((t)=>t.byteSize);
    }
    getMetadata(t) {
        return $70fd6868680e912c$var$Vo(t).get("remoteDocumentGlobalKey").next((t)=>($70fd6868680e912c$var$F(!!t), t));
    }
    Zn(t, e) {
        return $70fd6868680e912c$var$Vo(t).put("remoteDocumentGlobalKey", e);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ ts(t, e) {
        if (e) {
            const t = $70fd6868680e912c$var$hr(this.serializer, e);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(t.isNoDocument() && t.version.isEqual($70fd6868680e912c$var$rt.min()))) return t;
        }
        return $70fd6868680e912c$var$an.newInvalidDocument(t);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $70fd6868680e912c$var$Po(t) {
    return new $70fd6868680e912c$var$Ro(t);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $70fd6868680e912c$var$bo extends $70fd6868680e912c$var$vo {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(t, e){
        super(), this.os = t, this.trackRemovals = e, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.us = new $70fd6868680e912c$var$os((t)=>t.toString(), (t, e)=>t.isEqual(e));
    }
    applyChanges(t) {
        const e = [];
        let n = 0, s = new $70fd6868680e912c$var$Ee((t, e)=>$70fd6868680e912c$var$et(t.canonicalString(), e.canonicalString()));
        return this.changes.forEach((i, r)=>{
            const o = this.us.get(i);
            if (e.push(this.os.removeEntry(t, i, o.readTime)), r.isValidDocument()) {
                const u = $70fd6868680e912c$var$lr(this.os.serializer, r);
                s = s.add(i.path.popLast());
                const c = $70fd6868680e912c$var$ro(u);
                n += c - o.size, e.push(this.os.addEntry(t, i, u));
            } else if (n -= o.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $70fd6868680e912c$var$lr(this.os.serializer, r.convertToNoDocument($70fd6868680e912c$var$rt.min()));
                e.push(this.os.addEntry(t, i, n));
            }
        }), s.forEach((n)=>{
            e.push(this.os.indexManager.addToCollectionParentIndex(t, n));
        }), e.push(this.os.updateMetadata(t, n)), $70fd6868680e912c$var$Rt.waitFor(e);
    }
    getFromCache(t, e) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.os.es(t, e).next((t)=>(this.us.set(e, {
                size: t.size,
                readTime: t.document.readTime
            }), t.document));
    }
    getAllFromCache(t, e) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.os.ss(t, e).next(({ documents: t, rs: e })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (e.forEach((e, n)=>{
                this.us.set(e, {
                    size: n,
                    readTime: t.get(e).readTime
                });
            }), t));
    }
}
function $70fd6868680e912c$var$Vo(t) {
    return $70fd6868680e912c$var$_e(t, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $70fd6868680e912c$var$So(t) {
    return $70fd6868680e912c$var$_e(t, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $70fd6868680e912c$var$Do(t) {
    const e = t.path.toArray();
    return [
        /* prefix path */ e.slice(0, e.length - 2),
        /* collection id */ e[e.length - 2],
        /* document id */ e[e.length - 1]
    ];
}
function $70fd6868680e912c$var$Co(t, e) {
    const n = e.documentKey.path.toArray();
    return [
        /* collection id */ t,
        $70fd6868680e912c$var$fr(e.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $70fd6868680e912c$var$xo(t, e) {
    const n = t.path.toArray(), s = e.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let t = 0; t < n.length - 2 && t < s.length - 2; ++t)if (i = $70fd6868680e912c$var$et(n[t], s[t]), i) return i;
    return i = $70fd6868680e912c$var$et(n.length, s.length), i || (i = $70fd6868680e912c$var$et(n[n.length - 2], s[s.length - 2]), i || $70fd6868680e912c$var$et(n[n.length - 1], s[s.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $70fd6868680e912c$var$No {
    constructor(t, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ e){
        this.overlayedDocument = t, this.mutatedFields = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $70fd6868680e912c$var$ko {
    constructor(t, e, n, s){
        this.remoteDocumentCache = t, this.mutationQueue = e, this.documentOverlayCache = n, this.indexManager = s;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(t, e) {
        let n = null;
        return this.documentOverlayCache.getOverlay(t, e).next((s)=>(n = s, this.remoteDocumentCache.getEntry(t, e))).next((t)=>(null !== n && $70fd6868680e912c$var$Ks(n.mutation, t, $70fd6868680e912c$var$Re.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), t));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(t, e) {
        return this.remoteDocumentCache.getEntries(t, e).next((e)=>this.getLocalViewOfDocuments(t, e, $70fd6868680e912c$var$gs()).next(()=>e));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(t, e, n = $70fd6868680e912c$var$gs()) {
        const s = $70fd6868680e912c$var$fs();
        return this.populateOverlays(t, s, e).next(()=>this.computeViews(t, e, s, n).next((t)=>{
                let e = $70fd6868680e912c$var$hs();
                return t.forEach((t, n)=>{
                    e = e.insert(t, n.overlayedDocument);
                }), e;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(t, e) {
        const n = $70fd6868680e912c$var$fs();
        return this.populateOverlays(t, n, e).next(()=>this.computeViews(t, e, n, $70fd6868680e912c$var$gs()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(t, e, n) {
        const s = [];
        return n.forEach((t)=>{
            e.has(t) || s.push(t);
        }), this.documentOverlayCache.getOverlays(t, s).next((t)=>{
            t.forEach((t, n)=>{
                e.set(t, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ computeViews(t, e, n, s) {
        let i = $70fd6868680e912c$var$cs();
        const r = $70fd6868680e912c$var$ws(), o = $70fd6868680e912c$var$ws();
        return e.forEach((t, e)=>{
            const o = n.get(e.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            s.has(e.key) && (void 0 === o || o.mutation instanceof $70fd6868680e912c$var$zs) ? i = i.insert(e.key, e) : void 0 !== o ? (r.set(e.key, o.mutation.getFieldMask()), $70fd6868680e912c$var$Ks(o.mutation, e, o.mutation.getFieldMask(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            r.set(e.key, $70fd6868680e912c$var$Re.empty());
        }), this.recalculateAndSaveOverlays(t, i).next((t)=>(t.forEach((t, e)=>r.set(t, e)), e.forEach((t, e)=>{
                var n;
                return o.set(t, new $70fd6868680e912c$var$No(e, null !== (n = r.get(t)) && void 0 !== n ? n : null));
            }), o));
    }
    recalculateAndSaveOverlays(t, e) {
        const n = $70fd6868680e912c$var$ws();
        // A reverse lookup map from batch id to the documents within that batch.
        let s = new $70fd6868680e912c$var$pe((t, e)=>t - e), i = $70fd6868680e912c$var$gs();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(t, e).next((t)=>{
            for (const i of t)i.keys().forEach((t)=>{
                const r = e.get(t);
                if (null === r) return;
                let o = n.get(t) || $70fd6868680e912c$var$Re.empty();
                o = i.applyToLocalView(r, o), n.set(t, o);
                const u = (s.get(i.batchId) || $70fd6868680e912c$var$gs()).add(t);
                s = s.insert(i.batchId, u);
            });
        }).next(()=>{
            const r = [], o = s.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; o.hasNext();){
                const s = o.getNext(), u = s.key, c = s.value, a = $70fd6868680e912c$var$ds();
                c.forEach((t)=>{
                    if (!i.has(t)) {
                        const s = $70fd6868680e912c$var$qs(e.get(t), n.get(t));
                        null !== s && a.set(t, s), i = i.add(t);
                    }
                }), r.push(this.documentOverlayCache.saveOverlays(t, u, a));
            }
            return $70fd6868680e912c$var$Rt.waitFor(r);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(t, e) {
        return this.remoteDocumentCache.getEntries(t, e).next((e)=>this.recalculateAndSaveOverlays(t, e));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     */ getDocumentsMatchingQuery(t, e, n) {
        /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function(t) {
            return $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t.path) && null === t.collectionGroup && 0 === t.filters.length;
        }(e) ? this.getDocumentsMatchingDocumentQuery(t, e.path) : $70fd6868680e912c$var$Wn(e) ? this.getDocumentsMatchingCollectionGroupQuery(t, e, n) : this.getDocumentsMatchingCollectionQuery(t, e, n);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(t, e, n, s) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(t, e, n, s).next((i)=>{
            const r = s - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(t, e, n.largestBatchId, s - i.size) : $70fd6868680e912c$var$Rt.resolve($70fd6868680e912c$var$fs());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let o = -1, u = i;
            return r.next((e)=>$70fd6868680e912c$var$Rt.forEach(e, (e, n)=>(o < n.largestBatchId && (o = n.largestBatchId), i.get(e) ? $70fd6868680e912c$var$Rt.resolve() : this.remoteDocumentCache.getEntry(t, e).next((t)=>{
                        u = u.insert(e, t);
                    }))).next(()=>this.populateOverlays(t, e, i)).next(()=>this.computeViews(t, u, e, $70fd6868680e912c$var$gs())).next((t)=>({
                        batchId: o,
                        changes: $70fd6868680e912c$var$ls(t)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(t, e) {
        // Just do a simple document lookup.
        return this.getDocument(t, new $70fd6868680e912c$export$afc2e57c475b7810(e)).next((t)=>{
            let e = $70fd6868680e912c$var$hs();
            return t.isFoundDocument() && (e = e.insert(t.key, t)), e;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(t, e, n) {
        const s = e.collectionGroup;
        let i = $70fd6868680e912c$var$hs();
        return this.indexManager.getCollectionParents(t, s).next((r)=>$70fd6868680e912c$var$Rt.forEach(r, (r)=>{
                const o = function(t, e) {
                    return new $70fd6868680e912c$var$Un(e, /*collectionGroup=*/ null, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
                }(e, r.child(s));
                return this.getDocumentsMatchingCollectionQuery(t, o, n).next((t)=>{
                    t.forEach((t, e)=>{
                        i = i.insert(t, e);
                    });
                });
            }).next(()=>i));
    }
    getDocumentsMatchingCollectionQuery(t, e, n) {
        // Query the remote documents and overlay mutations.
        let s;
        return this.documentOverlayCache.getOverlaysForCollection(t, e.path, n.largestBatchId).next((i)=>(s = i, this.remoteDocumentCache.getDocumentsMatchingQuery(t, e, n, s))).next((t)=>{
            // As documents might match the query because of their overlay we need to
            // include documents for all overlays in the initial document set.
            s.forEach((e, n)=>{
                const s = n.getKey();
                null === t.get(s) && (t = t.insert(s, $70fd6868680e912c$var$an.newInvalidDocument(s)));
            });
            // Apply the overlays and match against the query.
            let n = $70fd6868680e912c$var$hs();
            return t.forEach((t, i)=>{
                const r = s.get(t);
                void 0 !== r && $70fd6868680e912c$var$Ks(r.mutation, i, $70fd6868680e912c$var$Re.empty(), $70fd6868680e912c$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                $70fd6868680e912c$var$ns(e, i) && (n = n.insert(t, i));
            }), n;
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Mo {
    constructor(t){
        this.serializer = t, this.cs = new Map, this.hs = new Map;
    }
    getBundleMetadata(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.cs.get(e));
    }
    saveBundleMetadata(t, e) {
        /** Decodes a BundleMetadata proto into a BundleMetadata object. */ var n;
        return this.cs.set(e.id, {
            id: (n = e).id,
            version: n.version,
            createTime: $70fd6868680e912c$var$Ni(n.createTime)
        }), $70fd6868680e912c$var$Rt.resolve();
    }
    getNamedQuery(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.hs.get(e));
    }
    saveNamedQuery(t, e) {
        return this.hs.set(e.name, function(t) {
            return {
                name: t.name,
                query: $70fd6868680e912c$var$yr(t.bundledQuery),
                readTime: $70fd6868680e912c$var$Ni(t.readTime)
            };
        }(e)), $70fd6868680e912c$var$Rt.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $70fd6868680e912c$var$$o {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator), this.ls = new Map;
    }
    getOverlay(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.overlays.get(e));
    }
    getOverlays(t, e) {
        const n = $70fd6868680e912c$var$fs();
        return $70fd6868680e912c$var$Rt.forEach(e, (e)=>this.getOverlay(t, e).next((t)=>{
                null !== t && n.set(e, t);
            })).next(()=>n);
    }
    saveOverlays(t, e, n) {
        return n.forEach((n, s)=>{
            this.we(t, e, s);
        }), $70fd6868680e912c$var$Rt.resolve();
    }
    removeOverlaysForBatchId(t, e, n) {
        const s = this.ls.get(n);
        return void 0 !== s && (s.forEach((t)=>this.overlays = this.overlays.remove(t)), this.ls.delete(n)), $70fd6868680e912c$var$Rt.resolve();
    }
    getOverlaysForCollection(t, e, n) {
        const s = $70fd6868680e912c$var$fs(), i = e.length + 1, r = new $70fd6868680e912c$export$afc2e57c475b7810(e.child("")), o = this.overlays.getIteratorFrom(r);
        for(; o.hasNext();){
            const t = o.getNext().value, r = t.getKey();
            if (!e.isPrefixOf(r.path)) break;
            // Documents from sub-collections
            r.path.length === i && t.largestBatchId > n && s.set(t.getKey(), t);
        }
        return $70fd6868680e912c$var$Rt.resolve(s);
    }
    getOverlaysForCollectionGroup(t, e, n, s) {
        let i = new $70fd6868680e912c$var$pe((t, e)=>t - e);
        const r = this.overlays.getIterator();
        for(; r.hasNext();){
            const t = r.getNext().value;
            if (t.getKey().getCollectionGroup() === e && t.largestBatchId > n) {
                let e = i.get(t.largestBatchId);
                null === e && (e = $70fd6868680e912c$var$fs(), i = i.insert(t.largestBatchId, e)), e.set(t.getKey(), t);
            }
        }
        const o = $70fd6868680e912c$var$fs(), u = i.getIterator();
        for(; u.hasNext();){
            if (u.getNext().value.forEach((t, e)=>o.set(t, e)), o.size() >= s) break;
        }
        return $70fd6868680e912c$var$Rt.resolve(o);
    }
    we(t, e, n) {
        // Remove the association of the overlay to its batch id.
        const s = this.overlays.get(n.key);
        if (null !== s) {
            const t = this.ls.get(s.largestBatchId).delete(n.key);
            this.ls.set(s.largestBatchId, t);
        }
        this.overlays = this.overlays.insert(n.key, new $70fd6868680e912c$var$ei(e, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.ls.get(e);
        void 0 === i && (i = $70fd6868680e912c$var$gs(), this.ls.set(e, i)), this.ls.set(e, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $70fd6868680e912c$var$Oo {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.fs = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Fo.ds), // A set of outstanding references to a document sorted by target id.
        this.ws = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Fo._s);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.fs.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(t, e) {
        const n = new $70fd6868680e912c$var$Fo(t, e);
        this.fs = this.fs.add(n), this.ws = this.ws.add(n);
    }
    /** Add references to the given document keys for the given ID. */ gs(t, e) {
        t.forEach((t)=>this.addReference(t, e));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(t, e) {
        this.ys(new $70fd6868680e912c$var$Fo(t, e));
    }
    ps(t, e) {
        t.forEach((t)=>this.removeReference(t, e));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ Is(t) {
        const e = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ut([])), n = new $70fd6868680e912c$var$Fo(e, t), s = new $70fd6868680e912c$var$Fo(e, t + 1), i = [];
        return this.ws.forEachInRange([
            n,
            s
        ], (t)=>{
            this.ys(t), i.push(t.key);
        }), i;
    }
    Ts() {
        this.fs.forEach((t)=>this.ys(t));
    }
    ys(t) {
        this.fs = this.fs.delete(t), this.ws = this.ws.delete(t);
    }
    Es(t) {
        const e = new $70fd6868680e912c$export$afc2e57c475b7810(new $70fd6868680e912c$var$ut([])), n = new $70fd6868680e912c$var$Fo(e, t), s = new $70fd6868680e912c$var$Fo(e, t + 1);
        let i = $70fd6868680e912c$var$gs();
        return this.ws.forEachInRange([
            n,
            s
        ], (t)=>{
            i = i.add(t.key);
        }), i;
    }
    containsKey(t) {
        const e = new $70fd6868680e912c$var$Fo(t, 0), n = this.fs.firstAfterOrEqual(e);
        return null !== n && t.isEqual(n.key);
    }
}
class $70fd6868680e912c$var$Fo {
    constructor(t, e){
        this.key = t, this.As = e;
    }
    /** Compare by key then by ID */ static ds(t, e) {
        return $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key) || $70fd6868680e912c$var$et(t.As, e.As);
    }
    /** Compare by ID then by key */ static _s(t, e) {
        return $70fd6868680e912c$var$et(t.As, e.As) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Bo {
    constructor(t, e){
        this.indexManager = t, this.referenceDelegate = e, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.vs = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Rs = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$Fo.ds);
    }
    checkEmpty(t) {
        return $70fd6868680e912c$var$Rt.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(t, e, n, s) {
        const i = this.vs;
        this.vs++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const r = new $70fd6868680e912c$var$Zs(i, e, n, s);
        this.mutationQueue.push(r);
        // Track references by document key and index collection parents.
        for (const e of s)this.Rs = this.Rs.add(new $70fd6868680e912c$var$Fo(e.key, i)), this.indexManager.addToCollectionParentIndex(t, e.key.path.popLast());
        return $70fd6868680e912c$var$Rt.resolve(r);
    }
    lookupMutationBatch(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.Ps(e));
    }
    getNextMutationBatchAfterBatchId(t, e) {
        const n = e + 1, s = this.bs(n), i = s < 0 ? 0 : s;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $70fd6868680e912c$var$Rt.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $70fd6868680e912c$var$Rt.resolve(0 === this.mutationQueue.length ? -1 : this.vs - 1);
    }
    getAllMutationBatches(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(t, e) {
        const n = new $70fd6868680e912c$var$Fo(e, 0), s = new $70fd6868680e912c$var$Fo(e, Number.POSITIVE_INFINITY), i = [];
        return this.Rs.forEachInRange([
            n,
            s
        ], (t)=>{
            const e = this.Ps(t.As);
            i.push(e);
        }), $70fd6868680e912c$var$Rt.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(t, e) {
        let n = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
        return e.forEach((t)=>{
            const e = new $70fd6868680e912c$var$Fo(t, 0), s = new $70fd6868680e912c$var$Fo(t, Number.POSITIVE_INFINITY);
            this.Rs.forEachInRange([
                e,
                s
            ], (t)=>{
                n = n.add(t.As);
            });
        }), $70fd6868680e912c$var$Rt.resolve(this.Vs(n));
    }
    getAllMutationBatchesAffectingQuery(t, e) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = e.path, s = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
        const r = new $70fd6868680e912c$var$Fo(new $70fd6868680e912c$export$afc2e57c475b7810(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let o = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$et);
        return this.Rs.forEachWhile((t)=>{
            const e = t.key.path;
            return !!n.isPrefixOf(e) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (e.length === s && (o = o.add(t.As)), !0);
        }, r), $70fd6868680e912c$var$Rt.resolve(this.Vs(o));
    }
    Vs(t) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const e = [];
        return t.forEach((t)=>{
            const n = this.Ps(t);
            null !== n && e.push(n);
        }), e;
    }
    removeMutationBatch(t, e) {
        $70fd6868680e912c$var$F(0 === this.Ss(e.batchId, "removed")), this.mutationQueue.shift();
        let n = this.Rs;
        return $70fd6868680e912c$var$Rt.forEach(e.mutations, (s)=>{
            const i = new $70fd6868680e912c$var$Fo(s.key, e.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(t, s.key);
        }).next(()=>{
            this.Rs = n;
        });
    }
    Cn(t) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(t, e) {
        const n = new $70fd6868680e912c$var$Fo(e, 0), s = this.Rs.firstAfterOrEqual(n);
        return $70fd6868680e912c$var$Rt.resolve(e.isEqual(s && s.key));
    }
    performConsistencyCheck(t) {
        return this.mutationQueue.length, $70fd6868680e912c$var$Rt.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ Ss(t, e) {
        return this.bs(t);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ bs(t) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return t - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ Ps(t) {
        const e = this.bs(t);
        if (e < 0 || e >= this.mutationQueue.length) return null;
        return this.mutationQueue[e];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $70fd6868680e912c$var$Lo {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(t){
        this.Ds = t, /** Underlying cache of documents and their read times. */ this.docs = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(t) {
        this.indexManager = t;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(t, e) {
        const n = e.key, s = this.docs.get(n), i = s ? s.size : 0, r = this.Ds(e);
        return this.docs = this.docs.insert(n, {
            document: e.mutableCopy(),
            size: r
        }), this.size += r - i, this.indexManager.addToCollectionParentIndex(t, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(t) {
        const e = this.docs.get(t);
        e && (this.docs = this.docs.remove(t), this.size -= e.size);
    }
    getEntry(t, e) {
        const n = this.docs.get(e);
        return $70fd6868680e912c$var$Rt.resolve(n ? n.document.mutableCopy() : $70fd6868680e912c$var$an.newInvalidDocument(e));
    }
    getEntries(t, e) {
        let n = $70fd6868680e912c$var$cs();
        return e.forEach((t)=>{
            const e = this.docs.get(t);
            n = n.insert(t, e ? e.document.mutableCopy() : $70fd6868680e912c$var$an.newInvalidDocument(t));
        }), $70fd6868680e912c$var$Rt.resolve(n);
    }
    getDocumentsMatchingQuery(t, e, n, s) {
        let i = $70fd6868680e912c$var$cs();
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        const r = e.path, o = new $70fd6868680e912c$export$afc2e57c475b7810(r.child("")), u = this.docs.getIteratorFrom(o);
        for(; u.hasNext();){
            const { key: t, value: { document: o } } = u.getNext();
            if (!r.isPrefixOf(t.path)) break;
            t.path.length > r.length + 1 || $70fd6868680e912c$var$Tt($70fd6868680e912c$var$pt(o), n) <= 0 || (s.has(o.key) || $70fd6868680e912c$var$ns(e, o)) && (i = i.insert(o.key, o.mutableCopy()));
        }
        return $70fd6868680e912c$var$Rt.resolve(i);
    }
    getAllFromCollectionGroup(t, e, n, s) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $70fd6868680e912c$var$O();
    }
    Cs(t, e) {
        return $70fd6868680e912c$var$Rt.forEach(this.docs, (t)=>e(t));
    }
    newChangeBuffer(t) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $70fd6868680e912c$var$qo(this);
    }
    getSize(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $70fd6868680e912c$var$qo extends $70fd6868680e912c$var$vo {
    constructor(t){
        super(), this.os = t;
    }
    applyChanges(t) {
        const e = [];
        return this.changes.forEach((n, s)=>{
            s.isValidDocument() ? e.push(this.os.addEntry(t, s)) : this.os.removeEntry(n);
        }), $70fd6868680e912c$var$Rt.waitFor(e);
    }
    getFromCache(t, e) {
        return this.os.getEntry(t, e);
    }
    getAllFromCache(t, e) {
        return this.os.getEntries(t, e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Uo {
    constructor(t){
        this.persistence = t, /**
         * Maps a target to the data about that target
         */ this.xs = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$$n(t), $70fd6868680e912c$var$On), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $70fd6868680e912c$var$rt.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Ns = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.ks = new $70fd6868680e912c$var$Oo, this.targetCount = 0, this.Ms = $70fd6868680e912c$var$lo.kn();
    }
    forEachTarget(t, e) {
        return this.xs.forEach((t, n)=>e(n)), $70fd6868680e912c$var$Rt.resolve();
    }
    getLastRemoteSnapshotVersion(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.Ns);
    }
    allocateTargetId(t) {
        return this.highestTargetId = this.Ms.next(), $70fd6868680e912c$var$Rt.resolve(this.highestTargetId);
    }
    setTargetsMetadata(t, e, n) {
        return n && (this.lastRemoteSnapshotVersion = n), e > this.Ns && (this.Ns = e), $70fd6868680e912c$var$Rt.resolve();
    }
    Fn(t) {
        this.xs.set(t.target, t);
        const e = t.targetId;
        e > this.highestTargetId && (this.Ms = new $70fd6868680e912c$var$lo(e), this.highestTargetId = e), t.sequenceNumber > this.Ns && (this.Ns = t.sequenceNumber);
    }
    addTargetData(t, e) {
        return this.Fn(e), this.targetCount += 1, $70fd6868680e912c$var$Rt.resolve();
    }
    updateTargetData(t, e) {
        return this.Fn(e), $70fd6868680e912c$var$Rt.resolve();
    }
    removeTargetData(t, e) {
        return this.xs.delete(e.target), this.ks.Is(e.targetId), this.targetCount -= 1, $70fd6868680e912c$var$Rt.resolve();
    }
    removeTargets(t, e, n) {
        let s = 0;
        const i = [];
        return this.xs.forEach((r, o)=>{
            o.sequenceNumber <= e && null === n.get(o.targetId) && (this.xs.delete(r), i.push(this.removeMatchingKeysForTargetId(t, o.targetId)), s++);
        }), $70fd6868680e912c$var$Rt.waitFor(i).next(()=>s);
    }
    getTargetCount(t) {
        return $70fd6868680e912c$var$Rt.resolve(this.targetCount);
    }
    getTargetData(t, e) {
        const n = this.xs.get(e) || null;
        return $70fd6868680e912c$var$Rt.resolve(n);
    }
    addMatchingKeys(t, e, n) {
        return this.ks.gs(e, n), $70fd6868680e912c$var$Rt.resolve();
    }
    removeMatchingKeys(t, e, n) {
        this.ks.ps(e, n);
        const s = this.persistence.referenceDelegate, i = [];
        return s && e.forEach((e)=>{
            i.push(s.markPotentiallyOrphaned(t, e));
        }), $70fd6868680e912c$var$Rt.waitFor(i);
    }
    removeMatchingKeysForTargetId(t, e) {
        return this.ks.Is(e), $70fd6868680e912c$var$Rt.resolve();
    }
    getMatchingKeysForTargetId(t, e) {
        const n = this.ks.Es(e);
        return $70fd6868680e912c$var$Rt.resolve(n);
    }
    containsKey(t, e) {
        return $70fd6868680e912c$var$Rt.resolve(this.ks.containsKey(e));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $70fd6868680e912c$var$Ko {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(t, e){
        this.$s = {}, this.overlays = {}, this.Os = new $70fd6868680e912c$var$Ot(0), this.Fs = !1, this.Fs = !0, this.referenceDelegate = t(this), this.Bs = new $70fd6868680e912c$var$Uo(this);
        this.indexManager = new $70fd6868680e912c$var$zr, this.remoteDocumentCache = function(t) {
            return new $70fd6868680e912c$var$Lo(t);
        }((t)=>this.referenceDelegate.Ls(t)), this.serializer = new $70fd6868680e912c$var$ar(e), this.qs = new $70fd6868680e912c$var$Mo(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.Fs = !1, Promise.resolve();
    }
    get started() {
        return this.Fs;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(t) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(t) {
        let e = this.overlays[t.toKey()];
        return e || (e = new $70fd6868680e912c$var$$o, this.overlays[t.toKey()] = e), e;
    }
    getMutationQueue(t, e) {
        let n = this.$s[t.toKey()];
        return n || (n = new $70fd6868680e912c$var$Bo(e, this.referenceDelegate), this.$s[t.toKey()] = n), n;
    }
    getTargetCache() {
        return this.Bs;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.qs;
    }
    runTransaction(t, e, n) {
        $70fd6868680e912c$var$N("MemoryPersistence", "Starting transaction:", t);
        const s = new $70fd6868680e912c$var$Go(this.Os.next());
        return this.referenceDelegate.Us(), n(s).next((t)=>this.referenceDelegate.Ks(s).next(()=>t)).toPromise().then((t)=>(s.raiseOnCommittedEvent(), t));
    }
    Gs(t, e) {
        return $70fd6868680e912c$var$Rt.or(Object.values(this.$s).map((n)=>()=>n.containsKey(t, e)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $70fd6868680e912c$var$Go extends $70fd6868680e912c$var$At {
    constructor(t){
        super(), this.currentSequenceNumber = t;
    }
}
class $70fd6868680e912c$var$Qo {
    constructor(t){
        this.persistence = t, /** Tracks all documents that are active in Query views. */ this.Qs = new $70fd6868680e912c$var$Oo, /** The list of documents that are potentially GCed after each transaction. */ this.js = null;
    }
    static zs(t) {
        return new $70fd6868680e912c$var$Qo(t);
    }
    get Ws() {
        if (this.js) return this.js;
        throw $70fd6868680e912c$var$O();
    }
    addReference(t, e, n) {
        return this.Qs.addReference(n, e), this.Ws.delete(n.toString()), $70fd6868680e912c$var$Rt.resolve();
    }
    removeReference(t, e, n) {
        return this.Qs.removeReference(n, e), this.Ws.add(n.toString()), $70fd6868680e912c$var$Rt.resolve();
    }
    markPotentiallyOrphaned(t, e) {
        return this.Ws.add(e.toString()), $70fd6868680e912c$var$Rt.resolve();
    }
    removeTarget(t, e) {
        this.Qs.Is(e.targetId).forEach((t)=>this.Ws.add(t.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(t, e.targetId).next((t)=>{
            t.forEach((t)=>this.Ws.add(t.toString()));
        }).next(()=>n.removeTargetData(t, e));
    }
    Us() {
        this.js = new Set;
    }
    Ks(t) {
        // Remove newly orphaned documents.
        const e = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $70fd6868680e912c$var$Rt.forEach(this.Ws, (n)=>{
            const s = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(n);
            return this.Hs(t, s).next((t)=>{
                t || e.removeEntry(s, $70fd6868680e912c$var$rt.min());
            });
        }).next(()=>(this.js = null, e.apply(t)));
    }
    updateLimboDocument(t, e) {
        return this.Hs(t, e).next((t)=>{
            t ? this.Ws.delete(e.toString()) : this.Ws.add(e.toString());
        });
    }
    Ls(t) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    Hs(t, e) {
        return $70fd6868680e912c$var$Rt.or([
            ()=>$70fd6868680e912c$var$Rt.resolve(this.Qs.containsKey(e)),
            ()=>this.persistence.getTargetCache().containsKey(t, e),
            ()=>this.persistence.Gs(t, e)
        ]);
    }
}
class $70fd6868680e912c$var$jo {
    constructor(t, e){
        this.persistence = t, this.Js = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$qt(t.path), (t, e)=>t.isEqual(e)), this.garbageCollector = $70fd6868680e912c$var$To(this, e);
    }
    static zs(t, e) {
        return new $70fd6868680e912c$var$jo(t, e);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    Us() {}
    Ks(t) {
        return $70fd6868680e912c$var$Rt.resolve();
    }
    forEachTarget(t, e) {
        return this.persistence.getTargetCache().forEachTarget(t, e);
    }
    zn(t) {
        const e = this.Jn(t);
        return this.persistence.getTargetCache().getTargetCount(t).next((t)=>e.next((e)=>t + e));
    }
    Jn(t) {
        let e = 0;
        return this.Wn(t, (t)=>{
            e++;
        }).next(()=>e);
    }
    Wn(t, e) {
        return $70fd6868680e912c$var$Rt.forEach(this.Js, (n, s)=>this.Xn(t, n, s).next((t)=>t ? $70fd6868680e912c$var$Rt.resolve() : e(s)));
    }
    removeTargets(t, e, n) {
        return this.persistence.getTargetCache().removeTargets(t, e, n);
    }
    removeOrphanedDocuments(t, e) {
        let n = 0;
        const s = this.persistence.getRemoteDocumentCache(), i = s.newChangeBuffer();
        return s.Cs(t, (s)=>this.Xn(t, s, e).next((t)=>{
                t || (n++, i.removeEntry(s, $70fd6868680e912c$var$rt.min()));
            })).next(()=>i.apply(t)).next(()=>n);
    }
    markPotentiallyOrphaned(t, e) {
        return this.Js.set(e, t.currentSequenceNumber), $70fd6868680e912c$var$Rt.resolve();
    }
    removeTarget(t, e) {
        const n = e.withSequenceNumber(t.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(t, n);
    }
    addReference(t, e, n) {
        return this.Js.set(n, t.currentSequenceNumber), $70fd6868680e912c$var$Rt.resolve();
    }
    removeReference(t, e, n) {
        return this.Js.set(n, t.currentSequenceNumber), $70fd6868680e912c$var$Rt.resolve();
    }
    updateLimboDocument(t, e) {
        return this.Js.set(e, t.currentSequenceNumber), $70fd6868680e912c$var$Rt.resolve();
    }
    Ls(t) {
        let e = t.key.toString().length;
        return t.isFoundDocument() && (e += $70fd6868680e912c$var$ze(t.data.value)), e;
    }
    Xn(t, e, n) {
        return $70fd6868680e912c$var$Rt.or([
            ()=>this.persistence.Gs(t, e),
            ()=>this.persistence.getTargetCache().containsKey(t, e),
            ()=>{
                const t = this.Js.get(e);
                return $70fd6868680e912c$var$Rt.resolve(void 0 !== t && t > n);
            }
        ]);
    }
    getCacheSize(t) {
        return this.persistence.getRemoteDocumentCache().getSize(t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $70fd6868680e912c$var$zo {
    constructor(t){
        this.serializer = t;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ O(t, e, n, s) {
        const i = new $70fd6868680e912c$var$Pt("createOrUpgrade", e);
        n < 1 && s >= 1 && (function(t) {
            t.createObjectStore("owner");
        }(t), function(t) {
            t.createObjectStore("mutationQueues", {
                keyPath: "userId"
            });
            t.createObjectStore("mutations", {
                keyPath: "batchId",
                autoIncrement: !0
            }).createIndex("userMutationsIndex", $70fd6868680e912c$var$Qt, {
                unique: !0
            }), t.createObjectStore("documentMutations");
        }(t), $70fd6868680e912c$var$Wo(t), function(t) {
            t.createObjectStore("remoteDocuments");
        }(t));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let r = $70fd6868680e912c$var$Rt.resolve();
        return n < 3 && s >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function(t) {
            t.deleteObjectStore("targetDocuments"), t.deleteObjectStore("targets"), t.deleteObjectStore("targetGlobal");
        }(t), $70fd6868680e912c$var$Wo(t)), r = r.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function(t) {
                const e = t.store("targetGlobal"), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $70fd6868680e912c$var$rt.min().toTimestamp(),
                    targetCount: 0
                };
                return e.put("targetGlobalKey", n);
            })(i))), n < 4 && s >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (r = r.next(()=>(function(t, e) {
                return e.store("mutations").j().next((n)=>{
                    t.deleteObjectStore("mutations");
                    t.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $70fd6868680e912c$var$Qt, {
                        unique: !0
                    });
                    const s = e.store("mutations"), i = n.map((t)=>s.put(t));
                    return $70fd6868680e912c$var$Rt.waitFor(i);
                });
            })(t, i))), r = r.next(()=>{
            !function(t) {
                t.createObjectStore("clientMetadata", {
                    keyPath: "clientId"
                });
            }(t);
        })), n < 5 && s >= 5 && (r = r.next(()=>this.Ys(i))), n < 6 && s >= 6 && (r = r.next(()=>((function(t) {
                t.createObjectStore("remoteDocumentGlobal");
            })(t), this.Xs(i)))), n < 7 && s >= 7 && (r = r.next(()=>this.Zs(i))), n < 8 && s >= 8 && (r = r.next(()=>this.ti(t, i))), n < 9 && s >= 9 && (r = r.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function(t) {
                t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
            }(t);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && s >= 10 && (r = r.next(()=>this.ei(i))), n < 11 && s >= 11 && (r = r.next(()=>{
            !function(t) {
                t.createObjectStore("bundles", {
                    keyPath: "bundleId"
                });
            }(t), function(t) {
                t.createObjectStore("namedQueries", {
                    keyPath: "name"
                });
            }(t);
        })), n < 12 && s >= 12 && (r = r.next(()=>{
            !function(t) {
                const e = t.createObjectStore("documentOverlays", {
                    keyPath: $70fd6868680e912c$var$oe
                });
                e.createIndex("collectionPathOverlayIndex", $70fd6868680e912c$var$ue, {
                    unique: !1
                }), e.createIndex("collectionGroupOverlayIndex", $70fd6868680e912c$var$ce, {
                    unique: !1
                });
            }(t);
        })), n < 13 && s >= 13 && (r = r.next(()=>(function(t) {
                const e = t.createObjectStore("remoteDocumentsV14", {
                    keyPath: $70fd6868680e912c$var$Ht
                });
                e.createIndex("documentKeyIndex", $70fd6868680e912c$var$Jt), e.createIndex("collectionGroupIndex", $70fd6868680e912c$var$Yt);
            })(t)).next(()=>this.ni(t, i)).next(()=>t.deleteObjectStore("remoteDocuments"))), n < 14 && s >= 14 && (r = r.next(()=>this.si(t, i))), n < 15 && s >= 15 && (r = r.next(()=>(function(t) {
                t.createObjectStore("indexConfiguration", {
                    keyPath: "indexId",
                    autoIncrement: !0
                }).createIndex("collectionGroupIndex", "collectionGroup", {
                    unique: !1
                });
                t.createObjectStore("indexState", {
                    keyPath: $70fd6868680e912c$var$ne
                }).createIndex("sequenceNumberIndex", $70fd6868680e912c$var$se, {
                    unique: !1
                });
                t.createObjectStore("indexEntries", {
                    keyPath: $70fd6868680e912c$var$ie
                }).createIndex("documentKeyIndex", $70fd6868680e912c$var$re, {
                    unique: !1
                });
            })(t))), r;
    }
    Xs(t) {
        let e = 0;
        return t.store("remoteDocuments").X((t, n)=>{
            e += $70fd6868680e912c$var$ro(n);
        }).next(()=>{
            const n = {
                byteSize: e
            };
            return t.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
        });
    }
    Ys(t) {
        const e = t.store("mutationQueues"), n = t.store("mutations");
        return e.j().next((e)=>$70fd6868680e912c$var$Rt.forEach(e, (e)=>{
                const s = IDBKeyRange.bound([
                    e.userId,
                    -1
                ], [
                    e.userId,
                    e.lastAcknowledgedBatchId
                ]);
                return n.j("userMutationsIndex", s).next((n)=>$70fd6868680e912c$var$Rt.forEach(n, (n)=>{
                        $70fd6868680e912c$var$F(n.userId === e.userId);
                        const s = $70fd6868680e912c$var$_r(this.serializer, n);
                        return $70fd6868680e912c$var$io(t, e.userId, s).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ Zs(t) {
        const e = t.store("targetDocuments"), n = t.store("remoteDocuments");
        return t.store("targetGlobal").get("targetGlobalKey").next((t)=>{
            const s = [];
            return n.X((n, i)=>{
                const r = new $70fd6868680e912c$var$ut(n), o = function(t) {
                    return [
                        0,
                        $70fd6868680e912c$var$qt(t)
                    ];
                }(r);
                s.push(e.get(o).next((n)=>n ? $70fd6868680e912c$var$Rt.resolve() : ((n)=>e.put({
                            targetId: 0,
                            path: $70fd6868680e912c$var$qt(n),
                            sequenceNumber: t.highestListenSequenceNumber
                        }))(r)));
            }).next(()=>$70fd6868680e912c$var$Rt.waitFor(s));
        });
    }
    ti(t, e) {
        // Create the index.
        t.createObjectStore("collectionParents", {
            keyPath: $70fd6868680e912c$var$ee
        });
        const n = e.store("collectionParents"), s = new $70fd6868680e912c$var$Wr, i = (t)=>{
            if (s.add(t)) {
                const e = t.lastSegment(), s = t.popLast();
                return n.put({
                    collectionId: e,
                    parent: $70fd6868680e912c$var$qt(s)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return e.store("remoteDocuments").X({
            Y: !0
        }, (t, e)=>{
            const n = new $70fd6868680e912c$var$ut(t);
            return i(n.popLast());
        }).next(()=>e.store("documentMutations").X({
                Y: !0
            }, ([t, e, n], s)=>{
                const r = $70fd6868680e912c$var$Gt(e);
                return i(r.popLast());
            }));
    }
    ei(t) {
        const e = t.store("targets");
        return e.X((t, n)=>{
            const s = $70fd6868680e912c$var$mr(n), i = $70fd6868680e912c$var$gr(this.serializer, s);
            return e.put(i);
        });
    }
    ni(t, e) {
        const n = e.store("remoteDocuments"), s = [];
        return n.X((t, n)=>{
            const i = e.store("remoteDocumentsV14"), r = (o = n, o.document ? new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.fromString(o.document.name).popFirst(5)) : o.noDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(o.noDocument.path) : o.unknownDocument ? $70fd6868680e912c$export$afc2e57c475b7810.fromSegments(o.unknownDocument.path) : $70fd6868680e912c$var$O()).path.toArray();
            var o;
            /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const u = {
                prefixPath: r.slice(0, r.length - 2),
                collectionGroup: r[r.length - 2],
                documentId: r[r.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            s.push(i.put(u));
        }).next(()=>$70fd6868680e912c$var$Rt.waitFor(s));
    }
    si(t, e) {
        const n = e.store("mutations"), s = $70fd6868680e912c$var$Po(this.serializer), i = new $70fd6868680e912c$var$Ko($70fd6868680e912c$var$Qo.zs, this.serializer.fe);
        return n.j().next((t)=>{
            const n = new Map;
            return t.forEach((t)=>{
                var e;
                let s = null !== (e = n.get(t.userId)) && void 0 !== e ? e : $70fd6868680e912c$var$gs();
                $70fd6868680e912c$var$_r(this.serializer, t).keys().forEach((t)=>s = s.add(t)), n.set(t.userId, s);
            }), $70fd6868680e912c$var$Rt.forEach(n, (t, n)=>{
                const r = new $70fd6868680e912c$var$V(n), o = $70fd6868680e912c$var$Rr.de(this.serializer, r), u = i.getIndexManager(r), c = $70fd6868680e912c$var$oo.de(r, this.serializer, u, i.referenceDelegate);
                return new $70fd6868680e912c$var$ko(s, c, o, u).recalculateAndSaveOverlaysForDocumentKeys(new $70fd6868680e912c$var$we(e, $70fd6868680e912c$var$Ot.ct), t).next();
            });
        });
    }
}
function $70fd6868680e912c$var$Wo(t) {
    t.createObjectStore("targetDocuments", {
        keyPath: $70fd6868680e912c$var$Zt
    }).createIndex("documentTargetsIndex", $70fd6868680e912c$var$te, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    t.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $70fd6868680e912c$var$Xt, {
        unique: !0
    }), t.createObjectStore("targetGlobal");
}
const $70fd6868680e912c$var$Ho = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $70fd6868680e912c$var$Jo {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ t, e, n, s, i, r, o, u, c, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ a, h = 15){
        if (this.allowTabSynchronization = t, this.persistenceKey = e, this.clientId = n, this.ii = i, this.window = r, this.document = o, this.ri = c, this.oi = a, this.ui = h, this.Os = null, this.Fs = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.ci = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.ai = null, /** The client metadata refresh task. */ this.hi = null, /** The last time we garbage collected the client metadata object store. */ this.li = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.fi = (t)=>Promise.resolve(), !$70fd6868680e912c$var$Jo.D()) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $70fd6868680e912c$var$Eo(this, s), this.di = e + "main", this.serializer = new $70fd6868680e912c$var$ar(u), this.wi = new $70fd6868680e912c$var$bt(this.di, this.ui, new $70fd6868680e912c$var$zo(this.serializer)), this.Bs = new $70fd6868680e912c$var$fo(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $70fd6868680e912c$var$Po(this.serializer), this.qs = new $70fd6868680e912c$var$Er, this.window && this.window.localStorage ? this._i = this.window.localStorage : (this._i = null, !1 === a && $70fd6868680e912c$var$k("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.mi().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, $70fd6868680e912c$var$Ho);
            return this.gi(), this.yi(), this.pi(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (t)=>this.Bs.getHighestSequenceNumber(t));
        }).then((t)=>{
            this.Os = new $70fd6868680e912c$var$Ot(t, this.ri);
        }).then(()=>{
            this.Fs = !0;
        }).catch((t)=>(this.wi && this.wi.close(), Promise.reject(t)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ Ii(t) {
        return this.fi = async (e)=>{
            if (this.started) return t(e);
        }, t(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(t) {
        this.wi.B(async (e)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === e.newVersion && await t();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(t) {
        this.networkEnabled !== t && (this.networkEnabled = t, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.ii.enqueueAndForget(async ()=>{
            this.started && await this.mi();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ mi() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (t)=>$70fd6868680e912c$var$Xo(t).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.Ti(t).next((t)=>{
                    t || (this.isPrimary = !1, this.ii.enqueueRetryable(()=>this.fi(!1)));
                });
            }).next(()=>this.Ei(t)).next((e)=>this.isPrimary && !e ? this.Ai(t).next(()=>!1) : !!e && this.vi(t).next(()=>!0))).catch((t)=>{
            if ($70fd6868680e912c$var$Dt(t)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $70fd6868680e912c$var$N("IndexedDbPersistence", "Failed to extend owner lease: ", t), this.isPrimary;
            if (!this.allowTabSynchronization) throw t;
            return $70fd6868680e912c$var$N("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", t), /* isPrimary= */ !1;
        }).then((t)=>{
            this.isPrimary !== t && this.ii.enqueueRetryable(()=>this.fi(t)), this.isPrimary = t;
        });
    }
    Ti(t) {
        return $70fd6868680e912c$var$Yo(t).get("owner").next((t)=>$70fd6868680e912c$var$Rt.resolve(this.Ri(t)));
    }
    Pi(t) {
        return $70fd6868680e912c$var$Xo(t).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async bi() {
        if (this.isPrimary && !this.Vi(this.li, 18e5)) {
            this.li = Date.now();
            const t = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (t)=>{
                const e = $70fd6868680e912c$var$_e(t, "clientMetadata");
                return e.j().next((t)=>{
                    const n = this.Si(t, 18e5), s = t.filter((t)=>-1 === n.indexOf(t));
                    // Delete metadata for clients that are no longer considered active.
                    return $70fd6868680e912c$var$Rt.forEach(s, (t)=>e.delete(t.clientId)).next(()=>s);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this._i) for (const e of t)this._i.removeItem(this.Di(e.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ pi() {
        this.hi = this.ii.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.mi().then(()=>this.bi()).then(()=>this.pi()));
    }
    /** Checks whether `client` is the local client. */ Ri(t) {
        return !!t && t.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ Ei(t) {
        if (this.oi) return $70fd6868680e912c$var$Rt.resolve(!0);
        return $70fd6868680e912c$var$Yo(t).get("owner").next((e)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== e && this.Vi(e.leaseTimestampMs, 5e3) && !this.Ci(e.ownerId)) {
                if (this.Ri(e) && this.networkEnabled) return !0;
                if (!this.Ri(e)) {
                    if (!e.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, $70fd6868680e912c$var$Ho);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $70fd6868680e912c$var$Xo(t).j().next((t)=>void 0 === this.Si(t, 5e3).find((t)=>{
                    if (this.clientId !== t.clientId) {
                        const e = !this.networkEnabled && t.networkEnabled, n = !this.inForeground && t.inForeground, s = this.networkEnabled === t.networkEnabled;
                        if (e || n && s) return !0;
                    }
                    return !1;
                }));
        }).next((t)=>(this.isPrimary !== t && $70fd6868680e912c$var$N("IndexedDbPersistence", `Client ${t ? "is" : "is not"} eligible for a primary lease.`), t));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.Fs = !1, this.xi(), this.hi && (this.hi.cancel(), this.hi = null), this.Ni(), this.ki(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.wi.runTransaction("shutdown", "readwrite", [
            "owner",
            "clientMetadata"
        ], (t)=>{
            const e = new $70fd6868680e912c$var$we(t, $70fd6868680e912c$var$Ot.ct);
            return this.Ai(e).next(()=>this.Pi(e));
        }), this.wi.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.Mi();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ Si(t, e) {
        return t.filter((t)=>this.Vi(t.updateTimeMs, e) && !this.Ci(t.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ $i() {
        return this.runTransaction("getActiveClients", "readonly", (t)=>$70fd6868680e912c$var$Xo(t).j().next((t)=>this.Si(t, 18e5).map((t)=>t.clientId)));
    }
    get started() {
        return this.Fs;
    }
    getMutationQueue(t, e) {
        return $70fd6868680e912c$var$oo.de(t, this.serializer, e, this.referenceDelegate);
    }
    getTargetCache() {
        return this.Bs;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(t) {
        return new $70fd6868680e912c$var$Jr(t, this.serializer.fe.databaseId);
    }
    getDocumentOverlayCache(t) {
        return $70fd6868680e912c$var$Rr.de(this.serializer, t);
    }
    getBundleCache() {
        return this.qs;
    }
    runTransaction(t, e, n) {
        $70fd6868680e912c$var$N("IndexedDbPersistence", "Starting transaction:", t);
        const s = "readonly" === e ? "readonly" : "readwrite", i = 15 === (r = this.ui) ? $70fd6868680e912c$var$de : 14 === r ? $70fd6868680e912c$var$fe : 13 === r ? $70fd6868680e912c$var$le : 12 === r ? $70fd6868680e912c$var$he : 11 === r ? $70fd6868680e912c$var$ae : void $70fd6868680e912c$var$O();
        /** Returns the object stores for the provided schema. */ var r;
        let o;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.wi.runTransaction(t, s, i, (s)=>(o = new $70fd6868680e912c$var$we(s, this.Os ? this.Os.next() : $70fd6868680e912c$var$Ot.ct), "readwrite-primary" === e ? this.Ti(o).next((t)=>!!t || this.Ei(o)).next((e)=>{
                if (!e) throw $70fd6868680e912c$var$k(`Failed to obtain primary lease for action '${t}'.`), this.isPrimary = !1, this.ii.enqueueRetryable(()=>this.fi(!1)), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, $70fd6868680e912c$var$Et);
                return n(o);
            }).next((t)=>this.vi(o).next(()=>t)) : this.Oi(o).next(()=>n(o)))).then((t)=>(o.raiseOnCommittedEvent(), t));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    Oi(t) {
        return $70fd6868680e912c$var$Yo(t).get("owner").next((t)=>{
            if (null !== t && this.Vi(t.leaseTimestampMs, 5e3) && !this.Ci(t.ownerId) && !this.Ri(t) && !(this.oi || this.allowTabSynchronization && t.allowTabSynchronization)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, $70fd6868680e912c$var$Ho);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ vi(t) {
        const e = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $70fd6868680e912c$var$Yo(t).put("owner", e);
    }
    static D() {
        return $70fd6868680e912c$var$bt.D();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ Ai(t) {
        const e = $70fd6868680e912c$var$Yo(t);
        return e.get("owner").next((t)=>this.Ri(t) ? ($70fd6868680e912c$var$N("IndexedDbPersistence", "Releasing primary lease."), e.delete("owner")) : $70fd6868680e912c$var$Rt.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ Vi(t, e) {
        const n = Date.now();
        return !(t < n - e) && (!(t > n) || ($70fd6868680e912c$var$k(`Detected an update time that is in the future: ${t} > ${n}`), !1));
    }
    gi() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.ai = ()=>{
            this.ii.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.mi()));
        }, this.document.addEventListener("visibilitychange", this.ai), this.inForeground = "visible" === this.document.visibilityState);
    }
    Ni() {
        this.ai && (this.document.removeEventListener("visibilitychange", this.ai), this.ai = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ yi() {
        var t;
        "function" == typeof (null === (t = this.window) || void 0 === t ? void 0 : t.addEventListener) && (this.ci = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.xi();
            const t = /(?:Version|Mobile)\/1[456]/;
            (0, $c38e0f42709c826a$export$95df08bae54cb4df)() && (navigator.appVersion.match(t) || navigator.userAgent.match(t)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.ii.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.ii.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.ci));
    }
    ki() {
        this.ci && (this.window.removeEventListener("pagehide", this.ci), this.ci = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ Ci(t) {
        var e;
        try {
            const n = null !== (null === (e = this._i) || void 0 === e ? void 0 : e.getItem(this.Di(t)));
            return $70fd6868680e912c$var$N("IndexedDbPersistence", `Client '${t}' ${n ? "is" : "is not"} zombied in LocalStorage`), n;
        } catch (t) {
            // Gracefully handle if LocalStorage isn't working.
            return $70fd6868680e912c$var$k("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ xi() {
        if (this._i) try {
            this._i.setItem(this.Di(this.clientId), String(Date.now()));
        } catch (t) {
            // Gracefully handle if LocalStorage isn't available / working.
            $70fd6868680e912c$var$k("Failed to set zombie client id.", t);
        }
    }
    /** Removes the zombied client entry if it exists. */ Mi() {
        if (this._i) try {
            this._i.removeItem(this.Di(this.clientId));
        } catch (t) {
        // Ignore
        }
    }
    Di(t) {
        return `firestore_zombie_${this.persistenceKey}_${t}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $70fd6868680e912c$var$Yo(t) {
    return $70fd6868680e912c$var$_e(t, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $70fd6868680e912c$var$Xo(t) {
    return $70fd6868680e912c$var$_e(t, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $70fd6868680e912c$var$Zo(t, e) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = t.projectId;
    return t.isDefaultDatabase || (n += "." + t.database), "firestore/" + e + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $70fd6868680e912c$var$tu {
    constructor(t, e, n, s){
        this.targetId = t, this.fromCache = e, this.Fi = n, this.Bi = s;
    }
    static Li(t, e) {
        let n = $70fd6868680e912c$var$gs(), s = $70fd6868680e912c$var$gs();
        for (const t of e.docChanges)switch(t.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(t.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                s = s.add(t.doc.key);
        }
        return new $70fd6868680e912c$var$tu(t, e.fromCache, n, s);
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $70fd6868680e912c$var$eu {
    constructor(){
        this.qi = !1;
    }
    /** Sets the document view to query against. */ initialize(t, e) {
        this.Ui = t, this.indexManager = e, this.qi = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(t, e, n, s) {
        return this.Ki(t, e).next((i)=>i || this.Gi(t, e, s, n)).next((n)=>n || this.Qi(t, e));
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ Ki(t, e) {
        if ($70fd6868680e912c$var$Qn(e)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $70fd6868680e912c$var$Rt.resolve(null);
        let n = $70fd6868680e912c$var$Jn(e);
        return this.indexManager.getIndexType(t, n).next((s)=>0 /* IndexType.NONE */  === s ? null : (null !== e.limit && 1 /* IndexType.PARTIAL */  === s && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (e = $70fd6868680e912c$var$Xn(e, null, "F" /* LimitType.First */ ), n = $70fd6868680e912c$var$Jn(e)), this.indexManager.getDocumentsMatchingTarget(t, n).next((s)=>{
                const i = $70fd6868680e912c$var$gs(...s);
                return this.Ui.getDocuments(t, i).next((s)=>this.indexManager.getMinOffset(t, n).next((n)=>{
                        const r = this.ji(e, s);
                        return this.zi(e, r, i, n.readTime) ? this.Ki(t, $70fd6868680e912c$var$Xn(e, null, "F" /* LimitType.First */ )) : this.Wi(t, r, e, n);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ Gi(t, e, n, s) {
        return $70fd6868680e912c$var$Qn(e) || s.isEqual($70fd6868680e912c$var$rt.min()) ? this.Qi(t, e) : this.Ui.getDocuments(t, n).next((i)=>{
            const r = this.ji(e, i);
            return this.zi(e, r, n, s) ? this.Qi(t, e) : ($70fd6868680e912c$var$C() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$N("QueryEngine", "Re-using previous result from %s to execute query: %s", s.toString(), $70fd6868680e912c$var$es(e)), this.Wi(t, r, e, $70fd6868680e912c$var$yt(s, -1)));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ ji(t, e) {
        // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        let n = new $70fd6868680e912c$var$Ee($70fd6868680e912c$var$is(t));
        return e.forEach((e, s)=>{
            $70fd6868680e912c$var$ns(t, s) && (n = n.add(s));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ zi(t, e, n, s) {
        if (null === t.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== e.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === t.limitType ? e.last() : e.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(s) > 0);
    }
    Qi(t, e) {
        return $70fd6868680e912c$var$C() <= (0, $45b460d9de9b230f$export$243e62d78d3b544d).DEBUG && $70fd6868680e912c$var$N("QueryEngine", "Using full collection scan to execute query:", $70fd6868680e912c$var$es(e)), this.Ui.getDocumentsMatchingQuery(t, e, $70fd6868680e912c$var$It.min());
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ Wi(t, e, n, s) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Ui.getDocumentsMatchingQuery(t, n, s).next((t)=>// Merge with existing results
            (e.forEach((e)=>{
                t = t.insert(e.key, e);
            }), t));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$nu {
    constructor(/** Manages our in-memory or durable persistence. */ t, e, n, s){
        this.persistence = t, this.Hi = e, this.serializer = s, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.Ji = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Yi = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$$n(t), $70fd6868680e912c$var$On), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Xi = new Map, this.Zi = t.getRemoteDocumentCache(), this.Bs = t.getTargetCache(), this.qs = t.getBundleCache(), this.tr(n);
    }
    tr(t) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(t), this.indexManager = this.persistence.getIndexManager(t), this.mutationQueue = this.persistence.getMutationQueue(t, this.indexManager), this.localDocuments = new $70fd6868680e912c$var$ko(this.Zi, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Zi.setIndexManager(this.indexManager), this.Hi.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(t) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (e)=>t.collect(e, this.Ji));
    }
}
function $70fd6868680e912c$var$su(/** Manages our in-memory or durable persistence. */ t, e, n, s) {
    return new $70fd6868680e912c$var$nu(t, e, n, s);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $70fd6868680e912c$var$iu(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return await n.persistence.runTransaction("Handle user change", "readonly", (t)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let s;
        return n.mutationQueue.getAllMutationBatches(t).next((i)=>(s = i, n.tr(e), n.mutationQueue.getAllMutationBatches(t))).next((e)=>{
            const i = [], r = [];
            // Union the old/new changed keys.
            let o = $70fd6868680e912c$var$gs();
            for (const t of s){
                i.push(t.batchId);
                for (const e of t.mutations)o = o.add(e.key);
            }
            for (const t of e){
                r.push(t.batchId);
                for (const e of t.mutations)o = o.add(e.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(t, o).next((t)=>({
                    er: t,
                    removedBatchIds: i,
                    addedBatchIds: r
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $70fd6868680e912c$var$ru(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (t)=>{
        const s = e.batch.keys(), i = n.Zi.newChangeBuffer({
            trackRemovals: !0
        });
        return (function(t, e, n, s) {
            const i = n.batch, r = i.keys();
            let o = $70fd6868680e912c$var$Rt.resolve();
            return r.forEach((t)=>{
                o = o.next(()=>s.getEntry(e, t)).next((e)=>{
                    const r = n.docVersions.get(t);
                    $70fd6868680e912c$var$F(null !== r), e.version.compareTo(r) < 0 && (i.applyToRemoteDocument(e, n), e.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (e.setReadTime(n.commitVersion), s.addEntry(e)));
                });
            }), o.next(()=>t.mutationQueue.removeMutationBatch(e, i));
        })(n, t, e, i).next(()=>i.apply(t)).next(()=>n.mutationQueue.performConsistencyCheck(t)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(t, s, e.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, function(t) {
                let e = $70fd6868680e912c$var$gs();
                for(let n = 0; n < t.mutationResults.length; ++n)t.mutationResults[n].transformResults.length > 0 && (e = e.add(t.batch.mutations[n].key));
                return e;
            }(e))).next(()=>n.localDocuments.getDocuments(t, s));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $70fd6868680e912c$var$ou(t) {
    const e = $70fd6868680e912c$var$L(t);
    return e.persistence.runTransaction("Get last remote snapshot version", "readonly", (t)=>e.Bs.getLastRemoteSnapshotVersion(t));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $70fd6868680e912c$var$uu(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = e.snapshotVersion;
    let i = n.Ji;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (t)=>{
        const r = n.Zi.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.Ji;
        const o = [];
        e.targetChanges.forEach((r, u)=>{
            const c = i.get(u);
            if (!c) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Bs.removeMatchingKeys(t, r.removedDocuments, u).next(()=>n.Bs.addMatchingKeys(t, r.addedDocuments, u)));
            let a = c.withSequenceNumber(t.currentSequenceNumber);
            null !== e.targetMismatches.get(u) ? a = a.withResumeToken($70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, $70fd6868680e912c$var$rt.min()).withLastLimboFreeSnapshotVersion($70fd6868680e912c$var$rt.min()) : r.resumeToken.approximateByteSize() > 0 && (a = a.withResumeToken(r.resumeToken, s)), i = i.insert(u, a), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function(t, e, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === t.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (e.snapshotVersion.toMicroseconds() - t.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(c, a, r) && o.push(n.Bs.updateTargetData(t, a));
        });
        let u = $70fd6868680e912c$var$cs(), c = $70fd6868680e912c$var$gs();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (e.documentUpdates.forEach((s)=>{
            e.resolvedLimboDocuments.has(s) && o.push(n.persistence.referenceDelegate.updateLimboDocument(t, s));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($70fd6868680e912c$var$cu(t, r, e.documentUpdates).next((t)=>{
            u = t.nr, c = t.sr;
        })), !s.isEqual($70fd6868680e912c$var$rt.min())) {
            const e = n.Bs.getLastRemoteSnapshotVersion(t).next((e)=>n.Bs.setTargetsMetadata(t, t.currentSequenceNumber, s));
            o.push(e);
        }
        return $70fd6868680e912c$var$Rt.waitFor(o).next(()=>r.apply(t)).next(()=>n.localDocuments.getLocalViewOfDocuments(t, u, c)).next(()=>u);
    }).then((t)=>(n.Ji = i, t));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $70fd6868680e912c$var$cu(t, e, n) {
    let s = $70fd6868680e912c$var$gs(), i = $70fd6868680e912c$var$gs();
    return n.forEach((t)=>s = s.add(t)), e.getEntries(t, s).next((t)=>{
        let s = $70fd6868680e912c$var$cs();
        return n.forEach((n, r)=>{
            const o = t.get(n);
            // Check if see if there is a existence state change for this document.
            r.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            r.isNoDocument() && r.version.isEqual($70fd6868680e912c$var$rt.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (e.removeEntry(n, r.readTime), s = s.insert(n, r)) : !o.isValidDocument() || r.version.compareTo(o.version) > 0 || 0 === r.version.compareTo(o.version) && o.hasPendingWrites ? (e.addEntry(r), s = s.insert(n, r)) : $70fd6868680e912c$var$N("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", r.version);
        }), {
            nr: s,
            sr: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $70fd6868680e912c$var$au(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (t)=>(void 0 === e && (e = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(t, e)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $70fd6868680e912c$var$hu(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return n.persistence.runTransaction("Allocate target", "readwrite", (t)=>{
        let s;
        return n.Bs.getTargetData(t, e).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (s = i, $70fd6868680e912c$var$Rt.resolve(s)) : n.Bs.allocateTargetId(t).next((i)=>(s = new $70fd6868680e912c$var$cr(e, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , t.currentSequenceNumber), n.Bs.addTargetData(t, s).next(()=>s))));
    }).then((t)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const s = n.Ji.get(t.targetId);
        return (null === s || t.snapshotVersion.compareTo(s.snapshotVersion) > 0) && (n.Ji = n.Ji.insert(t.targetId, t), n.Yi.set(e, t.targetId)), t;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $70fd6868680e912c$var$lu(t, e, n) {
    const s = $70fd6868680e912c$var$L(t), i = s.Ji.get(e), r = n ? "readwrite" : "readwrite-primary";
    try {
        n || await s.persistence.runTransaction("Release target", r, (t)=>s.persistence.referenceDelegate.removeTarget(t, i));
    } catch (t) {
        if (!$70fd6868680e912c$var$Dt(t)) throw t;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $70fd6868680e912c$var$N("LocalStore", `Failed to update sequence numbers for target ${e}: ${t}`);
    }
    s.Ji = s.Ji.remove(e), s.Yi.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $70fd6868680e912c$var$fu(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    let i = $70fd6868680e912c$var$rt.min(), r = $70fd6868680e912c$var$gs();
    return s.persistence.runTransaction("Execute query", "readonly", (t)=>(function(t, e, n) {
            const s = $70fd6868680e912c$var$L(t), i = s.Yi.get(n);
            return void 0 !== i ? $70fd6868680e912c$var$Rt.resolve(s.Ji.get(i)) : s.Bs.getTargetData(e, n);
        })(s, t, $70fd6868680e912c$var$Jn(e)).next((e)=>{
            if (e) return i = e.lastLimboFreeSnapshotVersion, s.Bs.getMatchingKeysForTargetId(t, e.targetId).next((t)=>{
                r = t;
            });
        }).next(()=>s.Hi.getDocumentsMatchingQuery(t, e, n ? i : $70fd6868680e912c$var$rt.min(), n ? r : $70fd6868680e912c$var$gs())).next((t)=>($70fd6868680e912c$var$_u(s, $70fd6868680e912c$var$ss(e), t), {
                documents: t,
                ir: r
            })));
}
// PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$du(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$L(n.Bs), i = n.Ji.get(e);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (t)=>s.le(t, e).next((t)=>t ? t.target : null));
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$wu(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = n.Xi.get(e) || $70fd6868680e912c$var$rt.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (t)=>n.Zi.getAllFromCollectionGroup(t, e, $70fd6868680e912c$var$yt(s, -1), /* limit= */ Number.MAX_SAFE_INTEGER)).then((t)=>($70fd6868680e912c$var$_u(n, e, t), t));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$_u(t, e, n) {
    let s = t.Xi.get(e) || $70fd6868680e912c$var$rt.min();
    n.forEach((t, e)=>{
        e.readTime.compareTo(s) > 0 && (s = e.readTime);
    }), t.Xi.set(e, s);
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $70fd6868680e912c$var$mu(t, e, n, s) {
    const i = $70fd6868680e912c$var$L(t);
    let r = $70fd6868680e912c$var$gs(), o = $70fd6868680e912c$var$cs();
    for (const t of n){
        const n = e.rr(t.metadata.name);
        t.document && (r = r.add(n));
        const s = e.ur(t);
        s.setReadTime(e.cr(t.metadata.readTime)), o = o.insert(n, s);
    }
    const u = i.Zi.newChangeBuffer({
        trackRemovals: !0
    }), c = await $70fd6868680e912c$var$hu(i, function(t) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $70fd6868680e912c$var$Jn($70fd6868680e912c$var$Gn($70fd6868680e912c$var$ut.fromString(`__bundle__/docs/${t}`)));
    }(s));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (t)=>$70fd6868680e912c$var$cu(t, u, o).next((e)=>(u.apply(t), e)).next((e)=>i.Bs.removeMatchingKeysForTargetId(t, c.targetId).next(()=>i.Bs.addMatchingKeys(t, r, c.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(t, e.nr, e.sr)).next(()=>e.nr)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $70fd6868680e912c$var$gu(t, e, n = $70fd6868680e912c$var$gs()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const s = await $70fd6868680e912c$var$hu(t, $70fd6868680e912c$var$Jn($70fd6868680e912c$var$yr(e.bundledQuery))), i = $70fd6868680e912c$var$L(t);
    return i.persistence.runTransaction("Save named query", "readwrite", (t)=>{
        const r = $70fd6868680e912c$var$Ni(e.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (s.snapshotVersion.compareTo(r) >= 0) return i.qs.saveNamedQuery(t, e);
        // Update existing target data because the query from the bundle is newer.
        const o = s.withResumeToken($70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, r);
        return i.Ji = i.Ji.insert(o.targetId, o), i.Bs.updateTargetData(t, o).next(()=>i.Bs.removeMatchingKeysForTargetId(t, s.targetId)).next(()=>i.Bs.addMatchingKeys(t, n, s.targetId)).next(()=>i.qs.saveNamedQuery(t, e));
    });
}
/** Assembles the key for a client state in WebStorage */ function $70fd6868680e912c$var$yu(t, e) {
    return `firestore_clients_${t}_${e}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $70fd6868680e912c$var$pu(t, e, n) {
    let s = `firestore_mutations_${t}_${n}`;
    return e.isAuthenticated() && (s += `_${e.uid}`), s;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $70fd6868680e912c$var$Iu(t, e) {
    return `firestore_targets_${t}_${e}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$Tu {
    constructor(t, e, n, s){
        this.user = t, this.batchId = e, this.state = n, this.error = s;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ar(t, e, n) {
        const s = JSON.parse(n);
        let i, r = "object" == typeof s && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(s.state) && (void 0 === s.error || "object" == typeof s.error);
        return r && s.error && (r = "string" == typeof s.error.message && "string" == typeof s.error.code, r && (i = new $70fd6868680e912c$export$8fada0bf726bf278(s.error.code, s.error.message))), r ? new $70fd6868680e912c$var$Tu(t, e, s.state, i) : ($70fd6868680e912c$var$k("SharedClientState", `Failed to parse mutation state for ID '${e}': ${n}`), null);
    }
    hr() {
        const t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $70fd6868680e912c$var$Eu {
    constructor(t, e, n){
        this.targetId = t, this.state = e, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ar(t, e) {
        const n = JSON.parse(e);
        let s, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (s = new $70fd6868680e912c$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new $70fd6868680e912c$var$Eu(t, n.state, s) : ($70fd6868680e912c$var$k("SharedClientState", `Failed to parse target state for ID '${t}': ${e}`), null);
    }
    hr() {
        const t = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (t.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(t);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $70fd6868680e912c$var$Au {
    constructor(t, e){
        this.clientId = t, this.activeTargetIds = e;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ar(t, e) {
        const n = JSON.parse(e);
        let s = "object" == typeof n && n.activeTargetIds instanceof Array, i = $70fd6868680e912c$var$ps();
        for(let t = 0; s && t < n.activeTargetIds.length; ++t)s = $70fd6868680e912c$var$Lt(n.activeTargetIds[t]), i = i.add(n.activeTargetIds[t]);
        return s ? new $70fd6868680e912c$var$Au(t, i) : ($70fd6868680e912c$var$k("SharedClientState", `Failed to parse client data for instance '${t}': ${e}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $70fd6868680e912c$var$vu {
    constructor(t, e){
        this.clientId = t, this.onlineState = e;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ar(t) {
        const e = JSON.parse(t);
        return "object" == typeof e && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(e.onlineState) && "string" == typeof e.clientId ? new $70fd6868680e912c$var$vu(e.clientId, e.onlineState) : ($70fd6868680e912c$var$k("SharedClientState", `Failed to parse online state: ${t}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $70fd6868680e912c$var$Ru {
    constructor(){
        this.activeTargetIds = $70fd6868680e912c$var$ps();
    }
    lr(t) {
        this.activeTargetIds = this.activeTargetIds.add(t);
    }
    dr(t) {
        this.activeTargetIds = this.activeTargetIds.delete(t);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ hr() {
        const t = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(t);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $70fd6868680e912c$var$Pu {
    constructor(t, e, n, s, i){
        this.window = t, this.ii = e, this.persistenceKey = n, this.wr = s, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this._r = this.mr.bind(this), this.gr = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.yr = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const r = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.pr = $70fd6868680e912c$var$yu(this.persistenceKey, this.wr), this.Ir = /** Assembles the key for the current sequence number. */ function(t) {
            return `firestore_sequence_number_${t}`;
        }(this.persistenceKey), this.gr = this.gr.insert(this.wr, new $70fd6868680e912c$var$Ru), this.Tr = new RegExp(`^firestore_clients_${r}_([^_]*)$`), this.Er = new RegExp(`^firestore_mutations_${r}_(\\d+)(?:_(.*))?$`), this.Ar = new RegExp(`^firestore_targets_${r}_(\\d+)$`), this.vr = /** Assembles the key for the online state of the primary tab. */ function(t) {
            return `firestore_online_state_${t}`;
        }(this.persistenceKey), this.Rr = function(t) {
            return `firestore_bundle_loaded_v2_${t}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this._r);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static D(t) {
        return !(!t || !t.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const t = await this.syncEngine.$i();
        for (const e of t){
            if (e === this.wr) continue;
            const t = this.getItem($70fd6868680e912c$var$yu(this.persistenceKey, e));
            if (t) {
                const n = $70fd6868680e912c$var$Au.ar(e, t);
                n && (this.gr = this.gr.insert(n.clientId, n));
            }
        }
        this.Pr();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const e = this.storage.getItem(this.vr);
        if (e) {
            const t = this.br(e);
            t && this.Vr(t);
        }
        for (const t of this.yr)this.mr(t);
        this.yr = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(t) {
        this.setItem(this.Ir, JSON.stringify(t));
    }
    getAllActiveQueryTargets() {
        return this.Sr(this.gr);
    }
    isActiveQueryTarget(t) {
        let e = !1;
        return this.gr.forEach((n, s)=>{
            s.activeTargetIds.has(t) && (e = !0);
        }), e;
    }
    addPendingMutation(t) {
        this.Dr(t, "pending");
    }
    updateMutationState(t, e, n) {
        this.Dr(t, e, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.Cr(t);
    }
    addLocalQueryTarget(t) {
        let e = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(t)) {
            const n = this.storage.getItem($70fd6868680e912c$var$Iu(this.persistenceKey, t));
            if (n) {
                const s = $70fd6868680e912c$var$Eu.ar(t, n);
                s && (e = s.state);
            }
        }
        return this.Nr.lr(t), this.Pr(), e;
    }
    removeLocalQueryTarget(t) {
        this.Nr.dr(t), this.Pr();
    }
    isLocalQueryTarget(t) {
        return this.Nr.activeTargetIds.has(t);
    }
    clearQueryState(t) {
        this.removeItem($70fd6868680e912c$var$Iu(this.persistenceKey, t));
    }
    updateQueryState(t, e, n) {
        this.kr(t, e, n);
    }
    handleUserChange(t, e, n) {
        e.forEach((t)=>{
            this.Cr(t);
        }), this.currentUser = t, n.forEach((t)=>{
            this.addPendingMutation(t);
        });
    }
    setOnlineState(t) {
        this.Mr(t);
    }
    notifyBundleLoaded(t) {
        this.$r(t);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this._r), this.removeItem(this.pr), this.started = !1);
    }
    getItem(t) {
        const e = this.storage.getItem(t);
        return $70fd6868680e912c$var$N("SharedClientState", "READ", t, e), e;
    }
    setItem(t, e) {
        $70fd6868680e912c$var$N("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
    }
    removeItem(t) {
        $70fd6868680e912c$var$N("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
    }
    mr(t) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const e = t;
        if (e.storageArea === this.storage) {
            if ($70fd6868680e912c$var$N("SharedClientState", "EVENT", e.key, e.newValue), e.key === this.pr) return void $70fd6868680e912c$var$k("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.ii.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== e.key) {
                        if (this.Tr.test(e.key)) {
                            if (null == e.newValue) {
                                const t = this.Or(e.key);
                                return this.Fr(t, null);
                            }
                            {
                                const t = this.Br(e.key, e.newValue);
                                if (t) return this.Fr(t.clientId, t);
                            }
                        } else if (this.Er.test(e.key)) {
                            if (null !== e.newValue) {
                                const t = this.Lr(e.key, e.newValue);
                                if (t) return this.qr(t);
                            }
                        } else if (this.Ar.test(e.key)) {
                            if (null !== e.newValue) {
                                const t = this.Ur(e.key, e.newValue);
                                if (t) return this.Kr(t);
                            }
                        } else if (e.key === this.vr) {
                            if (null !== e.newValue) {
                                const t = this.br(e.newValue);
                                if (t) return this.Vr(t);
                            }
                        } else if (e.key === this.Ir) {
                            const t = function(t) {
                                let e = $70fd6868680e912c$var$Ot.ct;
                                if (null != t) try {
                                    const n = JSON.parse(t);
                                    $70fd6868680e912c$var$F("number" == typeof n), e = n;
                                } catch (t) {
                                    $70fd6868680e912c$var$k("SharedClientState", "Failed to read sequence number from WebStorage", t);
                                }
                                return e;
                            }(e.newValue);
                            t !== $70fd6868680e912c$var$Ot.ct && this.sequenceNumberHandler(t);
                        } else if (e.key === this.Rr) {
                            const t = this.Gr(e.newValue);
                            await Promise.all(t.map((t)=>this.syncEngine.Qr(t)));
                        }
                    }
                } else this.yr.push(e);
            });
        }
    }
    get Nr() {
        return this.gr.get(this.wr);
    }
    Pr() {
        this.setItem(this.pr, this.Nr.hr());
    }
    Dr(t, e, n) {
        const s = new $70fd6868680e912c$var$Tu(this.currentUser, t, e, n), i = $70fd6868680e912c$var$pu(this.persistenceKey, this.currentUser, t);
        this.setItem(i, s.hr());
    }
    Cr(t) {
        const e = $70fd6868680e912c$var$pu(this.persistenceKey, this.currentUser, t);
        this.removeItem(e);
    }
    Mr(t) {
        const e = {
            clientId: this.wr,
            onlineState: t
        };
        this.storage.setItem(this.vr, JSON.stringify(e));
    }
    kr(t, e, n) {
        const s = $70fd6868680e912c$var$Iu(this.persistenceKey, t), i = new $70fd6868680e912c$var$Eu(t, e, n);
        this.setItem(s, i.hr());
    }
    $r(t) {
        const e = JSON.stringify(Array.from(t));
        this.setItem(this.Rr, e);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ Or(t) {
        const e = this.Tr.exec(t);
        return e ? e[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ Br(t, e) {
        const n = this.Or(t);
        return $70fd6868680e912c$var$Au.ar(n, e);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Lr(t, e) {
        const n = this.Er.exec(t), s = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $70fd6868680e912c$var$Tu.ar(new $70fd6868680e912c$var$V(i), s, e);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ur(t, e) {
        const n = this.Ar.exec(t), s = Number(n[1]);
        return $70fd6868680e912c$var$Eu.ar(s, e);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ br(t) {
        return $70fd6868680e912c$var$vu.ar(t);
    }
    Gr(t) {
        return JSON.parse(t);
    }
    async qr(t) {
        if (t.user.uid === this.currentUser.uid) return this.syncEngine.jr(t.batchId, t.state, t.error);
        $70fd6868680e912c$var$N("SharedClientState", `Ignoring mutation for non-active user ${t.user.uid}`);
    }
    Kr(t) {
        return this.syncEngine.zr(t.targetId, t.state, t.error);
    }
    Fr(t, e) {
        const n = e ? this.gr.insert(t, e) : this.gr.remove(t), s = this.Sr(this.gr), i = this.Sr(n), r = [], o = [];
        return i.forEach((t)=>{
            s.has(t) || r.push(t);
        }), s.forEach((t)=>{
            i.has(t) || o.push(t);
        }), this.syncEngine.Wr(r, o).then(()=>{
            this.gr = n;
        });
    }
    Vr(t) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.gr.get(t.clientId) && this.onlineStateHandler(t.onlineState);
    }
    Sr(t) {
        let e = $70fd6868680e912c$var$ps();
        return t.forEach((t, n)=>{
            e = e.unionWith(n.activeTargetIds);
        }), e;
    }
}
class $70fd6868680e912c$var$bu {
    constructor(){
        this.Hr = new $70fd6868680e912c$var$Ru, this.Jr = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(t) {
    // No op.
    }
    updateMutationState(t, e, n) {
    // No op.
    }
    addLocalQueryTarget(t) {
        return this.Hr.lr(t), this.Jr[t] || "not-current";
    }
    updateQueryState(t, e, n) {
        this.Jr[t] = e;
    }
    removeLocalQueryTarget(t) {
        this.Hr.dr(t);
    }
    isLocalQueryTarget(t) {
        return this.Hr.activeTargetIds.has(t);
    }
    clearQueryState(t) {
        delete this.Jr[t];
    }
    getAllActiveQueryTargets() {
        return this.Hr.activeTargetIds;
    }
    isActiveQueryTarget(t) {
        return this.Hr.activeTargetIds.has(t);
    }
    start() {
        return this.Hr = new $70fd6868680e912c$var$Ru, Promise.resolve();
    }
    handleUserChange(t, e, n) {
    // No op.
    }
    setOnlineState(t) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(t) {}
    notifyBundleLoaded(t) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Vu {
    Yr(t) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ class $70fd6868680e912c$var$Su {
    constructor(){
        this.Xr = ()=>this.Zr(), this.eo = ()=>this.no(), this.so = [], this.io();
    }
    Yr(t) {
        this.so.push(t);
    }
    shutdown() {
        window.removeEventListener("online", this.Xr), window.removeEventListener("offline", this.eo);
    }
    io() {
        window.addEventListener("online", this.Xr), window.addEventListener("offline", this.eo);
    }
    Zr() {
        $70fd6868680e912c$var$N("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
        for (const t of this.so)t(0 /* NetworkStatus.AVAILABLE */ );
    }
    no() {
        $70fd6868680e912c$var$N("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
        for (const t of this.so)t(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static D() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $70fd6868680e912c$var$Du = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $70fd6868680e912c$var$Cu() {
    return null === $70fd6868680e912c$var$Du ? $70fd6868680e912c$var$Du = 268435456 + Math.round(2147483648 * Math.random()) : $70fd6868680e912c$var$Du++, "0x" + $70fd6868680e912c$var$Du.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$xu = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $70fd6868680e912c$var$Nu {
    constructor(t){
        this.ro = t.ro, this.oo = t.oo;
    }
    uo(t) {
        this.co = t;
    }
    ao(t) {
        this.ho = t;
    }
    onMessage(t) {
        this.lo = t;
    }
    close() {
        this.oo();
    }
    send(t) {
        this.ro(t);
    }
    fo() {
        this.co();
    }
    wo(t) {
        this.ho(t);
    }
    _o(t) {
        this.lo(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$ku = "WebChannelConnection";
class $70fd6868680e912c$var$Mu extends /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class {
    constructor(t){
        this.databaseInfo = t, this.databaseId = t.databaseId;
        const e = t.ssl ? "https" : "http";
        this.mo = e + "://" + t.host, this.yo = "projects/" + this.databaseId.projectId + "/databases/" + this.databaseId.database + "/documents";
    }
    get po() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    Io(t, e, n, s, i) {
        const r = $70fd6868680e912c$var$Cu(), o = this.To(t, e);
        $70fd6868680e912c$var$N("RestConnection", `Sending RPC '${t}' ${r}:`, o, n);
        const u = {};
        return this.Eo(u, s, i), this.Ao(t, o, u, n).then((e)=>($70fd6868680e912c$var$N("RestConnection", `Received RPC '${t}' ${r}: `, e), e), (e)=>{
            throw $70fd6868680e912c$export$86cd73f49cc6e0bb("RestConnection", `RPC '${t}' ${r} failed with error: `, e, "url: ", o, "request:", n), e;
        });
    }
    vo(t, e, n, s, i, r) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Io(t, e, n, s, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ Eo(t, e, n) {
        t["X-Goog-Api-Client"] = "gl-js/ fire/" + $70fd6868680e912c$var$S, // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        t["Content-Type"] = "text/plain", this.databaseInfo.appId && (t["X-Firebase-GMPID"] = this.databaseInfo.appId), e && e.headers.forEach((e, n)=>t[n] = e), n && n.headers.forEach((e, n)=>t[n] = e);
    }
    To(t, e) {
        const n = $70fd6868680e912c$var$xu[t];
        return `${this.mo}/v1/${e}:${n}`;
    }
} {
    constructor(t){
        super(t), this.forceLongPolling = t.forceLongPolling, this.autoDetectLongPolling = t.autoDetectLongPolling, this.useFetchStreams = t.useFetchStreams, this.longPollingOptions = t.longPollingOptions;
    }
    Ao(t, e, n, s) {
        const i = $70fd6868680e912c$var$Cu();
        return new Promise((r, o)=>{
            const u = new (0, $f4a7ee607ae1ef78$export$26404658cda3ee02);
            u.setWithCredentials(!0), u.listenOnce((0, $f4a7ee607ae1ef78$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(u.getLastErrorCode()){
                        case (0, $f4a7ee607ae1ef78$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const e = u.getResponseJson();
                            $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `XHR for RPC '${t}' ${i} received:`, JSON.stringify(e)), r(e);
                            break;
                        case (0, $f4a7ee607ae1ef78$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' ${i} timed out`), o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $f4a7ee607ae1ef78$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = u.getStatus();
                            if ($70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' ${i} failed with status:`, n, "response text:", u.getResponseText()), n > 0) {
                                let t = u.getResponseJson();
                                Array.isArray(t) && (t = t[0]);
                                const e = null == t ? void 0 : t.error;
                                if (e && e.status && e.message) {
                                    const t = function(t) {
                                        const e = t.toLowerCase().replace(/_/g, "-");
                                        return Object.values($70fd6868680e912c$var$q).indexOf(e) >= 0 ? e : $70fd6868680e912c$var$q.UNKNOWN;
                                    }(e.status);
                                    o(new $70fd6868680e912c$export$8fada0bf726bf278(t, e.message));
                                } else o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNKNOWN, "Server responded with status " + u.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            o(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $70fd6868680e912c$var$O();
                    }
                } finally{
                    $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' ${i} completed.`);
                }
            });
            const c = JSON.stringify(s);
            $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' ${i} sending request:`, s), u.send(e, "POST", c, n, 15);
        });
    }
    Ro(t, e, n) {
        const s = $70fd6868680e912c$var$Cu(), i = [
            this.mo,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            t,
            "/channel"
        ], r = (0, $f4a7ee607ae1ef78$export$66869136fc133c3a)(), o = (0, $f4a7ee607ae1ef78$export$888d0d9ab79d08fc)(), u = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, c = this.longPollingOptions.timeoutSeconds;
        void 0 !== c && (u.longPollingTimeout = Math.round(1e3 * c)), this.useFetchStreams && (u.xmlHttpFactory = new (0, $f4a7ee607ae1ef78$export$ddb1030448106742)({})), this.Eo(u.initMessageHeaders, e, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        u.encodeInitMessageHeaders = !0;
        const a = i.join("");
        $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `Creating RPC '${t}' stream ${s}: ${a}`, u);
        const h = r.createWebChannel(a, u);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let l = !1, f = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const d = new $70fd6868680e912c$var$Nu({
            ro: (e)=>{
                f ? $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `Not sending because RPC '${t}' stream ${s} is closed:`, e) : (l || ($70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `Opening RPC '${t}' stream ${s} transport.`), h.open(), l = !0), $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} sending:`, e), h.send(e));
            },
            oo: ()=>h.close()
        }), w = (t, e, n)=>{
            // TODO(dimond): closure typing seems broken because WebChannel does
            // not implement goog.events.Listenable
            t.listen(e, (t)=>{
                try {
                    n(t);
                } catch (t) {
                    setTimeout(()=>{
                        throw t;
                    }, 0);
                }
            });
        };
        // Closure events are guarded and exceptions are swallowed, so catch any
        // exception and rethrow using a setTimeout so they become visible again.
        // Note that eventually this function could go away if we are confident
        // enough the code is exception free.
        return w(h, (0, $f4a7ee607ae1ef78$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            f || $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} transport opened.`);
        }), w(h, (0, $f4a7ee607ae1ef78$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            f || (f = !0, $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} transport closed`), d.wo());
        }), w(h, (0, $f4a7ee607ae1ef78$export$aa726fb96ad3e039).EventType.ERROR, (e)=>{
            f || (f = !0, $70fd6868680e912c$export$86cd73f49cc6e0bb($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} transport errored:`, e), d.wo(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, "The operation could not be completed")));
        }), w(h, (0, $f4a7ee607ae1ef78$export$aa726fb96ad3e039).EventType.MESSAGE, (e)=>{
            var n;
            if (!f) {
                const i = e.data[0];
                $70fd6868680e912c$var$F(!!i);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const r = i, o = r.error || (null === (n = r[0]) || void 0 === n ? void 0 : n.error);
                if (o) {
                    $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} received error:`, o);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const e = o.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function(t) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const e = $70fd6868680e912c$var$ii[t];
                        if (void 0 !== e) return $70fd6868680e912c$var$ui(e);
                    }(e), i = o.message;
                    void 0 === n && (n = $70fd6868680e912c$var$q.INTERNAL, i = "Unknown error status: " + e + " with message " + o.message), // Mark closed so no further events are propagated
                    f = !0, d.wo(new $70fd6868680e912c$export$8fada0bf726bf278(n, i)), h.close();
                } else $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} received:`, i), d._o(i);
            }
        }), w(o, (0, $f4a7ee607ae1ef78$export$d61e24a684f9e51).STAT_EVENT, (e)=>{
            e.stat === (0, $f4a7ee607ae1ef78$export$cbbc350c1dfc80cb).PROXY ? $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} detected buffering proxy`) : e.stat === (0, $f4a7ee607ae1ef78$export$cbbc350c1dfc80cb).NOPROXY && $70fd6868680e912c$var$N($70fd6868680e912c$var$ku, `RPC '${t}' stream ${s} detected no buffering proxy`);
        }), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            d.fo();
        }, 0), d;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $70fd6868680e912c$var$$u() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $70fd6868680e912c$var$Ou() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$Fu(t) {
    return new $70fd6868680e912c$var$Vi(t, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $70fd6868680e912c$var$Bu {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ t, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ e, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, s = 1.5, i = 6e4){
        this.ii = t, this.timerId = e, this.Po = n, this.bo = s, this.Vo = i, this.So = 0, this.Do = null, /** The last backoff attempt, as epoch milliseconds. */ this.Co = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.So = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ xo() {
        this.So = this.Vo;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ No(t) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const e = Math.floor(this.So + this.ko()), n = Math.max(0, Date.now() - this.Co), s = Math.max(0, e - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        s > 0 && $70fd6868680e912c$var$N("ExponentialBackoff", `Backing off for ${s} ms (base delay: ${this.So} ms, delay with jitter: ${e} ms, last attempt: ${n} ms ago)`), this.Do = this.ii.enqueueAfterDelay(this.timerId, s, ()=>(this.Co = Date.now(), t())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.So *= this.bo, this.So < this.Po && (this.So = this.Po), this.So > this.Vo && (this.So = this.Vo);
    }
    Mo() {
        null !== this.Do && (this.Do.skipDelay(), this.Do = null);
    }
    cancel() {
        null !== this.Do && (this.Do.cancel(), this.Do = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ ko() {
        return (Math.random() - .5) * this.So;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $70fd6868680e912c$var$Lu {
    constructor(t, e, n, s, i, r, o, u){
        this.ii = t, this.$o = n, this.Oo = s, this.connection = i, this.authCredentialsProvider = r, this.appCheckCredentialsProvider = o, this.listener = u, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Fo = 0, this.Bo = null, this.Lo = null, this.stream = null, this.qo = new $70fd6868680e912c$var$Bu(t, e);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ Uo() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Ko();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Ko() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.Go();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.Uo() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ Qo() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.qo.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ jo() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Ko() && null === this.Bo && (this.Bo = this.ii.enqueueAfterDelay(this.$o, 6e4, ()=>this.zo()));
    }
    /** Sends a message to the underlying stream. */ Wo(t) {
        this.Ho(), this.stream.send(t);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async zo() {
        if (this.Ko()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ Ho() {
        this.Bo && (this.Bo.cancel(), this.Bo = null);
    }
    /** Cancels the health check delayed operation. */ Jo() {
        this.Lo && (this.Lo.cancel(), this.Lo = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(t, e) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.Ho(), this.Jo(), this.qo.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.Fo++, 4 /* PersistentStreamState.Error */  !== t ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.qo.reset() : e && e.code === $70fd6868680e912c$var$q.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($70fd6868680e912c$var$k(e.toString()), $70fd6868680e912c$var$k("Using maximum backoff delay to prevent overloading the backend."), this.qo.xo()) : e && e.code === $70fd6868680e912c$var$q.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.Yo(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = t, // Notify the listener that the stream closed.
        await this.listener.ao(e);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ Yo() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const t = this.Xo(this.Fo), e = this.Fo;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([t, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.Fo === e && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.Zo(t, n);
        }, (e)=>{
            t(()=>{
                const t = new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNKNOWN, "Fetching auth token failed: " + e.message);
                return this.tu(t);
            });
        });
    }
    Zo(t, e) {
        const n = this.Xo(this.Fo);
        this.stream = this.eu(t, e), this.stream.uo(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.Lo = this.ii.enqueueAfterDelay(this.Oo, 1e4, ()=>(this.Ko() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.uo()));
        }), this.stream.ao((t)=>{
            n(()=>this.tu(t));
        }), this.stream.onMessage((t)=>{
            n(()=>this.onMessage(t));
        });
    }
    Go() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.qo.No(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    tu(t) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $70fd6868680e912c$var$N("PersistentStream", `close with error: ${t}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , t);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ Xo(t) {
        return (e)=>{
            this.ii.enqueueAndForget(()=>this.Fo === t ? e() : ($70fd6868680e912c$var$N("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $70fd6868680e912c$var$qu extends $70fd6868680e912c$var$Lu {
    constructor(t, e, n, s, i, r){
        super(t, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , e, n, s, r), this.serializer = i;
    }
    eu(t, e) {
        return this.connection.Ro("Listen", t, e);
    }
    onMessage(t) {
        // A successful response means the stream is healthy
        this.qo.reset();
        const e = $70fd6868680e912c$var$Qi(this.serializer, t), n = function(t) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in t)) return $70fd6868680e912c$var$rt.min();
            const e = t.targetChange;
            return e.targetIds && e.targetIds.length ? $70fd6868680e912c$var$rt.min() : e.readTime ? $70fd6868680e912c$var$Ni(e.readTime) : $70fd6868680e912c$var$rt.min();
        }(t);
        return this.listener.nu(e, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ su(t) {
        const e = {};
        e.database = $70fd6868680e912c$var$Li(this.serializer), e.addTarget = function(t, e) {
            let n;
            const s = e.target;
            if (n = $70fd6868680e912c$var$Fn(s) ? {
                documents: $70fd6868680e912c$var$Hi(t, s)
            } : {
                query: $70fd6868680e912c$var$Ji(t, s)
            }, n.targetId = e.targetId, e.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $70fd6868680e912c$var$Ci(t, e.resumeToken);
                const s = $70fd6868680e912c$var$Si(t, e.expectedCount);
                null !== s && (n.expectedCount = s);
            } else if (e.snapshotVersion.compareTo($70fd6868680e912c$var$rt.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $70fd6868680e912c$var$Di(t, e.snapshotVersion.toTimestamp());
                const s = $70fd6868680e912c$var$Si(t, e.expectedCount);
                null !== s && (n.expectedCount = s);
            }
            return n;
        }(this.serializer, t);
        const n = $70fd6868680e912c$var$Xi(this.serializer, t);
        n && (e.labels = n), this.Wo(e);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ iu(t) {
        const e = {};
        e.database = $70fd6868680e912c$var$Li(this.serializer), e.removeTarget = t, this.Wo(e);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $70fd6868680e912c$var$Uu extends $70fd6868680e912c$var$Lu {
    constructor(t, e, n, s, i, r){
        super(t, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , e, n, s, r), this.serializer = i, this.ru = !1;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get ou() {
        return this.ru;
    }
    // Override of PersistentStream.start
    start() {
        this.ru = !1, this.lastStreamToken = void 0, super.start();
    }
    Yo() {
        this.ru && this.uu([]);
    }
    eu(t, e) {
        return this.connection.Ro("Write", t, e);
    }
    onMessage(t) {
        if (// Always capture the last stream token.
        $70fd6868680e912c$var$F(!!t.streamToken), this.lastStreamToken = t.streamToken, this.ru) {
            // A successful first write response means the stream is healthy,
            // Note, that we could consider a successful handshake healthy, however,
            // the write itself might be causing an error we want to back off from.
            this.qo.reset();
            const e = $70fd6868680e912c$var$Wi(t.writeResults, t.commitTime), n = $70fd6868680e912c$var$Ni(t.commitTime);
            return this.listener.cu(n, e);
        }
        // The first response is always the handshake response
        return $70fd6868680e912c$var$F(!t.writeResults || 0 === t.writeResults.length), this.ru = !0, this.listener.au();
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ hu() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const t = {};
        t.database = $70fd6868680e912c$var$Li(this.serializer), this.Wo(t);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ uu(t) {
        const e = {
            streamToken: this.lastStreamToken,
            writes: t.map((t)=>$70fd6868680e912c$var$ji(this.serializer, t))
        };
        this.Wo(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $70fd6868680e912c$var$Ku extends class {
} {
    constructor(t, e, n, s){
        super(), this.authCredentials = t, this.appCheckCredentials = e, this.connection = n, this.serializer = s, this.lu = !1;
    }
    fu() {
        if (this.lu) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Io(t, e, n) {
        return this.fu(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, i])=>this.connection.Io(t, e, n, s, i)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $70fd6868680e912c$var$q.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNKNOWN, t.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ vo(t, e, n, s) {
        return this.fu(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, r])=>this.connection.vo(t, e, n, i, r, s)).catch((t)=>{
            throw "FirebaseError" === t.name ? (t.code === $70fd6868680e912c$var$q.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), t) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNKNOWN, t.toString());
        });
    }
    terminate() {
        this.lu = !0;
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
async function $70fd6868680e912c$var$Gu(t, e, n) {
    var s;
    const i = $70fd6868680e912c$var$L(t), { request: r, du: o } = function(t, e, n) {
        const s = $70fd6868680e912c$var$Ji(t, e), i = {}, r = [];
        let o = 0;
        return n.forEach((t)=>{
            // Map all client-side aliases to a unique short-form
            // alias. This avoids issues with client-side aliases that
            // exceed the 1500-byte string size limit.
            const e = "aggregate_" + o++;
            i[e] = t.alias, "count" === t.yt ? r.push({
                alias: e,
                count: {}
            }) : "avg" === t.yt ? r.push({
                alias: e,
                avg: {
                    field: $70fd6868680e912c$var$sr(t.fieldPath)
                }
            }) : "sum" === t.yt && r.push({
                alias: e,
                sum: {
                    field: $70fd6868680e912c$var$sr(t.fieldPath)
                }
            });
        }), {
            request: {
                structuredAggregationQuery: {
                    aggregations: r,
                    structuredQuery: s.structuredQuery
                },
                parent: s.parent
            },
            du: i
        };
    }(i.serializer, $70fd6868680e912c$var$Jn(e), n), u = r.parent;
    i.connection.po || delete r.parent;
    const c = (await i.vo("RunAggregationQuery", u, r, /*expectedResponseCount=*/ 1)).filter((t)=>!!t.result);
    // Omit RunAggregationQueryResponse that only contain readTimes.
    $70fd6868680e912c$var$F(1 === c.length);
    // Remap the short-form aliases that were sent to the server
    // to the client-side aliases. Users will access the results
    // using the client-side alias.
    const a = null === (s = c[0].result) || void 0 === s ? void 0 : s.aggregateFields;
    return Object.keys(a).reduce((t, e)=>(t[o[e]] = a[e], t), {});
}
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $70fd6868680e912c$var$Qu {
    constructor(t, e){
        this.asyncQueue = t, this.onlineStateHandler = e, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.wu = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this._u = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.mu = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ gu() {
        0 === this.wu && (this.yu("Unknown" /* OnlineState.Unknown */ ), this._u = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this._u = null, this.pu("Backend didn't respond within 10 seconds."), this.yu("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ Iu(t) {
        "Online" /* OnlineState.Online */  === this.state ? this.yu("Unknown" /* OnlineState.Unknown */ ) : (this.wu++, this.wu >= 1 && (this.Tu(), this.pu(`Connection failed 1 times. Most recent error: ${t.toString()}`), this.yu("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(t) {
        this.Tu(), this.wu = 0, "Online" /* OnlineState.Online */  === t && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.mu = !1), this.yu(t);
    }
    yu(t) {
        t !== this.state && (this.state = t, this.onlineStateHandler(t));
    }
    pu(t) {
        const e = `Could not reach Cloud Firestore backend. ${t}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.mu ? ($70fd6868680e912c$var$k(e), this.mu = !1) : $70fd6868680e912c$var$N("OnlineStateTracker", e);
    }
    Tu() {
        null !== this._u && (this._u.cancel(), this._u = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$ju {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ t, /** The client-side proxy for interacting with the backend. */ e, n, s, i){
        this.localStore = t, this.datastore = e, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Eu = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Au = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.vu = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.Ru = [], this.Pu = i, this.Pu.Yr((t)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $70fd6868680e912c$var$ec(this) && ($70fd6868680e912c$var$N("RemoteStore", "Restarting streams for network reachability change."), await async function(t) {
                    const e = $70fd6868680e912c$var$L(t);
                    e.vu.add(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$Wu(e), e.bu.set("Unknown" /* OnlineState.Unknown */ ), e.vu.delete(4 /* OfflineCause.ConnectivityChange */ ), await $70fd6868680e912c$var$zu(e);
                }(this));
            });
        }), this.bu = new $70fd6868680e912c$var$Qu(n, s);
    }
}
async function $70fd6868680e912c$var$zu(t) {
    if ($70fd6868680e912c$var$ec(t)) for (const e of t.Ru)await e(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $70fd6868680e912c$var$Wu(t) {
    for (const e of t.Ru)await e(/* enabled= */ !1);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $70fd6868680e912c$var$Hu(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    n.Au.has(e.targetId) || // Mark this as something the client is currently listening for.
    (n.Au.set(e.targetId, e), $70fd6868680e912c$var$tc(n) ? // The listen will be sent in onWatchStreamOpen
    $70fd6868680e912c$var$Zu(n) : $70fd6868680e912c$var$pc(n).Ko() && $70fd6868680e912c$var$Yu(n, e));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $70fd6868680e912c$var$Ju(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$pc(n);
    n.Au.delete(e), s.Ko() && $70fd6868680e912c$var$Xu(n, e), 0 === n.Au.size && (s.Ko() ? s.jo() : $70fd6868680e912c$var$ec(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.bu.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $70fd6868680e912c$var$Yu(t, e) {
    if (t.Vu.qt(e.targetId), e.resumeToken.approximateByteSize() > 0 || e.snapshotVersion.compareTo($70fd6868680e912c$var$rt.min()) > 0) {
        const n = t.remoteSyncer.getRemoteKeysForTarget(e.targetId).size;
        e = e.withExpectedCount(n);
    }
    $70fd6868680e912c$var$pc(t).su(e);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $70fd6868680e912c$var$Xu(t, e) {
    t.Vu.qt(e), $70fd6868680e912c$var$pc(t).iu(e);
}
function $70fd6868680e912c$var$Zu(t) {
    t.Vu = new $70fd6868680e912c$var$Ei({
        getRemoteKeysForTarget: (e)=>t.remoteSyncer.getRemoteKeysForTarget(e),
        le: (e)=>t.Au.get(e) || null,
        ue: ()=>t.datastore.serializer.databaseId
    }), $70fd6868680e912c$var$pc(t).start(), t.bu.gu();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $70fd6868680e912c$var$tc(t) {
    return $70fd6868680e912c$var$ec(t) && !$70fd6868680e912c$var$pc(t).Uo() && t.Au.size > 0;
}
function $70fd6868680e912c$var$ec(t) {
    return 0 === $70fd6868680e912c$var$L(t).vu.size;
}
function $70fd6868680e912c$var$nc(t) {
    t.Vu = void 0;
}
async function $70fd6868680e912c$var$sc(t) {
    t.Au.forEach((e, n)=>{
        $70fd6868680e912c$var$Yu(t, e);
    });
}
async function $70fd6868680e912c$var$ic(t, e) {
    $70fd6868680e912c$var$nc(t), // If we still need the watch stream, retry the connection.
    $70fd6868680e912c$var$tc(t) ? (t.bu.Iu(e), $70fd6868680e912c$var$Zu(t)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    t.bu.set("Unknown" /* OnlineState.Unknown */ );
}
async function $70fd6868680e912c$var$rc(t, e, n) {
    if (// Mark the client as online since we got a message from the server
    t.bu.set("Online" /* OnlineState.Online */ ), e instanceof $70fd6868680e912c$var$Ii && 2 /* WatchTargetChangeState.Removed */  === e.state && e.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        await /** Handles an error on a target */ async function(t, e) {
            const n = e.cause;
            for (const s of e.targetIds)// A watched target might have been removed already.
            t.Au.has(s) && (await t.remoteSyncer.rejectListen(s, n), t.Au.delete(s), t.Vu.removeTarget(s));
        }(t, e);
    } catch (n) {
        $70fd6868680e912c$var$N("RemoteStore", "Failed to remove targets %s: %s ", e.targetIds.join(","), n), await $70fd6868680e912c$var$oc(t, n);
    }
    else if (e instanceof $70fd6868680e912c$var$yi ? t.Vu.Ht(e) : e instanceof $70fd6868680e912c$var$pi ? t.Vu.ne(e) : t.Vu.Xt(e), !n.isEqual($70fd6868680e912c$var$rt.min())) try {
        const e = await $70fd6868680e912c$var$ou(t.localStore);
        n.compareTo(e) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        await /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function(t, e) {
            const n = t.Vu.ce(e);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            return n.targetChanges.forEach((n, s)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = t.Au.get(s);
                    // A watched target might have been removed already.
                    i && t.Au.set(s, i.withResumeToken(n.resumeToken, e));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            n.targetMismatches.forEach((e, n)=>{
                const s = t.Au.get(e);
                if (!s) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                t.Au.set(e, s.withResumeToken($70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING, s.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $70fd6868680e912c$var$Xu(t, e);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $70fd6868680e912c$var$cr(s.target, e, n, s.sequenceNumber);
                $70fd6868680e912c$var$Yu(t, i);
            }), t.remoteSyncer.applyRemoteEvent(n);
        }(t, n);
    } catch (e) {
        $70fd6868680e912c$var$N("RemoteStore", "Failed to raise snapshot:", e), await $70fd6868680e912c$var$oc(t, e);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $70fd6868680e912c$var$oc(t, e, n) {
    if (!$70fd6868680e912c$var$Dt(e)) throw e;
    t.vu.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $70fd6868680e912c$var$Wu(t), t.bu.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$70fd6868680e912c$var$ou(t.localStore)), // Probe IndexedDB periodically and re-enable network
    t.asyncQueue.enqueueRetryable(async ()=>{
        $70fd6868680e912c$var$N("RemoteStore", "Retrying IndexedDB access"), await n(), t.vu.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $70fd6868680e912c$var$zu(t);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $70fd6868680e912c$var$uc(t, e) {
    return e().catch((n)=>$70fd6868680e912c$var$oc(t, n, e));
}
async function $70fd6868680e912c$var$cc(t) {
    const e = $70fd6868680e912c$var$L(t), n = $70fd6868680e912c$var$Ic(e);
    let s = e.Eu.length > 0 ? e.Eu[e.Eu.length - 1].batchId : -1;
    for(; $70fd6868680e912c$var$ac(e);)try {
        const t = await $70fd6868680e912c$var$au(e.localStore, s);
        if (null === t) {
            0 === e.Eu.length && n.jo();
            break;
        }
        s = t.batchId, $70fd6868680e912c$var$hc(e, t);
    } catch (t) {
        await $70fd6868680e912c$var$oc(e, t);
    }
    $70fd6868680e912c$var$lc(e) && $70fd6868680e912c$var$fc(e);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $70fd6868680e912c$var$ac(t) {
    return $70fd6868680e912c$var$ec(t) && t.Eu.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $70fd6868680e912c$var$hc(t, e) {
    t.Eu.push(e);
    const n = $70fd6868680e912c$var$Ic(t);
    n.Ko() && n.ou && n.uu(e.mutations);
}
function $70fd6868680e912c$var$lc(t) {
    return $70fd6868680e912c$var$ec(t) && !$70fd6868680e912c$var$Ic(t).Uo() && t.Eu.length > 0;
}
function $70fd6868680e912c$var$fc(t) {
    $70fd6868680e912c$var$Ic(t).start();
}
async function $70fd6868680e912c$var$dc(t) {
    $70fd6868680e912c$var$Ic(t).hu();
}
async function $70fd6868680e912c$var$wc(t) {
    const e = $70fd6868680e912c$var$Ic(t);
    // Send the write pipeline now that the stream is established.
    for (const n of t.Eu)e.uu(n.mutations);
}
async function $70fd6868680e912c$var$_c(t, e, n) {
    const s = t.Eu.shift(), i = $70fd6868680e912c$var$ti.from(s, e, n);
    await $70fd6868680e912c$var$uc(t, ()=>t.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $70fd6868680e912c$var$cc(t);
}
async function $70fd6868680e912c$var$mc(t, e) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    e && $70fd6868680e912c$var$Ic(t).ou && // This error affects the actual write.
    await async function(t, e) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (n = e.code, $70fd6868680e912c$var$oi(n) && n !== $70fd6868680e912c$var$q.ABORTED) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = t.Eu.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $70fd6868680e912c$var$Ic(t).Qo(), await $70fd6868680e912c$var$uc(t, ()=>t.remoteSyncer.rejectFailedWrite(n.batchId, e)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $70fd6868680e912c$var$cc(t);
        }
        var n;
    }(t, e), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $70fd6868680e912c$var$lc(t) && $70fd6868680e912c$var$fc(t);
}
async function $70fd6868680e912c$var$gc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    n.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$N("RemoteStore", "RemoteStore received new credentials");
    const s = $70fd6868680e912c$var$ec(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.vu.add(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$Wu(n), s && // Don't set the network status to Unknown if we are offline.
    n.bu.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(e), n.vu.delete(3 /* OfflineCause.CredentialChange */ ), await $70fd6868680e912c$var$zu(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $70fd6868680e912c$var$yc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    e ? (n.vu.delete(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$zu(n)) : e || (n.vu.add(2 /* OfflineCause.IsSecondary */ ), await $70fd6868680e912c$var$Wu(n), n.bu.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$pc(t) {
    return t.Su || // Create stream (but note that it is not started yet).
    (t.Su = function(t, e, n) {
        const s = $70fd6868680e912c$var$L(t);
        return s.fu(), new $70fd6868680e912c$var$qu(e, s.connection, s.authCredentials, s.appCheckCredentials, s.serializer, n);
    }(t.datastore, t.asyncQueue, {
        uo: $70fd6868680e912c$var$sc.bind(null, t),
        ao: $70fd6868680e912c$var$ic.bind(null, t),
        nu: $70fd6868680e912c$var$rc.bind(null, t)
    }), t.Ru.push(async (e)=>{
        e ? (t.Su.Qo(), $70fd6868680e912c$var$tc(t) ? $70fd6868680e912c$var$Zu(t) : t.bu.set("Unknown" /* OnlineState.Unknown */ )) : (await t.Su.stop(), $70fd6868680e912c$var$nc(t));
    })), t.Su;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $70fd6868680e912c$var$Ic(t) {
    return t.Du || // Create stream (but note that it is not started yet).
    (t.Du = function(t, e, n) {
        const s = $70fd6868680e912c$var$L(t);
        return s.fu(), new $70fd6868680e912c$var$Uu(e, s.connection, s.authCredentials, s.appCheckCredentials, s.serializer, n);
    }(t.datastore, t.asyncQueue, {
        uo: $70fd6868680e912c$var$dc.bind(null, t),
        ao: $70fd6868680e912c$var$mc.bind(null, t),
        au: $70fd6868680e912c$var$wc.bind(null, t),
        cu: $70fd6868680e912c$var$_c.bind(null, t)
    }), t.Ru.push(async (e)=>{
        e ? (t.Du.Qo(), // This will start the write stream if necessary.
        await $70fd6868680e912c$var$cc(t)) : (await t.Du.stop(), t.Eu.length > 0 && ($70fd6868680e912c$var$N("RemoteStore", `Stopping write stream with ${t.Eu.length} pending writes`), t.Eu = []));
    })), t.Du;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $70fd6868680e912c$var$Tc {
    constructor(t, e, n, s, i){
        this.asyncQueue = t, this.timerId = e, this.targetTimeMs = n, this.op = s, this.removalCallback = i, this.deferred = new $70fd6868680e912c$var$K, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((t)=>{});
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(t, e, n, s, i) {
        const r = Date.now() + n, o = new $70fd6868680e912c$var$Tc(t, e, r, s, i);
        return o.start(n), o;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(t) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), t);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(t) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((t)=>this.deferred.resolve(t))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $70fd6868680e912c$var$Ec(t, e) {
    if ($70fd6868680e912c$var$k("AsyncQueue", `${e}: ${t}`), $70fd6868680e912c$var$Dt(t)) return new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, `${e}: ${t}`);
    throw t;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $70fd6868680e912c$var$Ac {
    /** The default ordering is by key if the comparator is omitted */ constructor(t){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = t ? (e, n)=>t(e, n) || $70fd6868680e912c$export$afc2e57c475b7810.comparator(e.key, n.key) : (t, e)=>$70fd6868680e912c$export$afc2e57c475b7810.comparator(t.key, e.key), this.keyedMap = $70fd6868680e912c$var$hs(), this.sortedSet = new $70fd6868680e912c$var$pe(this.comparator);
    }
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(t) {
        return new $70fd6868680e912c$var$Ac(t.comparator);
    }
    has(t) {
        return null != this.keyedMap.get(t);
    }
    get(t) {
        return this.keyedMap.get(t);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(t) {
        const e = this.keyedMap.get(t);
        return e ? this.sortedSet.indexOf(e) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(t) {
        this.sortedSet.inorderTraversal((e, n)=>(t(e), !1));
    }
    /** Inserts or updates a document with the same key */ add(t) {
        // First remove the element if we have it.
        const e = this.delete(t.key);
        return e.copy(e.keyedMap.insert(t.key, t), e.sortedSet.insert(t, null));
    }
    /** Deletes a document with a given key */ delete(t) {
        const e = this.get(t);
        return e ? this.copy(this.keyedMap.remove(t), this.sortedSet.remove(e)) : this;
    }
    isEqual(t) {
        if (!(t instanceof $70fd6868680e912c$var$Ac)) return !1;
        if (this.size !== t.size) return !1;
        const e = this.sortedSet.getIterator(), n = t.sortedSet.getIterator();
        for(; e.hasNext();){
            const t = e.getNext().key, s = n.getNext().key;
            if (!t.isEqual(s)) return !1;
        }
        return !0;
    }
    toString() {
        const t = [];
        return this.forEach((e)=>{
            t.push(e.toString());
        }), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
    }
    copy(t, e) {
        const n = new $70fd6868680e912c$var$Ac;
        return n.comparator = this.comparator, n.keyedMap = t, n.sortedSet = e, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $70fd6868680e912c$var$vc {
    constructor(){
        this.Cu = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
    }
    track(t) {
        const e = t.doc.key, n = this.Cu.get(e);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== t.type && 3 /* ChangeType.Metadata */  === n.type ? this.Cu = this.Cu.insert(e, t) : 3 /* ChangeType.Metadata */  === t.type && 1 /* ChangeType.Removed */  !== n.type ? this.Cu = this.Cu.insert(e, {
            type: n.type,
            doc: t.doc
        }) : 2 /* ChangeType.Modified */  === t.type && 2 /* ChangeType.Modified */  === n.type ? this.Cu = this.Cu.insert(e, {
            type: 2 /* ChangeType.Modified */ ,
            doc: t.doc
        }) : 2 /* ChangeType.Modified */  === t.type && 0 /* ChangeType.Added */  === n.type ? this.Cu = this.Cu.insert(e, {
            type: 0 /* ChangeType.Added */ ,
            doc: t.doc
        }) : 1 /* ChangeType.Removed */  === t.type && 0 /* ChangeType.Added */  === n.type ? this.Cu = this.Cu.remove(e) : 1 /* ChangeType.Removed */  === t.type && 2 /* ChangeType.Modified */  === n.type ? this.Cu = this.Cu.insert(e, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === t.type && 1 /* ChangeType.Removed */  === n.type ? this.Cu = this.Cu.insert(e, {
            type: 2 /* ChangeType.Modified */ ,
            doc: t.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $70fd6868680e912c$var$O() : this.Cu = this.Cu.insert(e, t);
    }
    xu() {
        const t = [];
        return this.Cu.inorderTraversal((e, n)=>{
            t.push(n);
        }), t;
    }
}
class $70fd6868680e912c$var$Rc {
    constructor(t, e, n, s, i, r, o, u, c){
        this.query = t, this.docs = e, this.oldDocs = n, this.docChanges = s, this.mutatedKeys = i, this.fromCache = r, this.syncStateChanged = o, this.excludesMetadataChanges = u, this.hasCachedResults = c;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(t, e, n, s, i) {
        const r = [];
        return e.forEach((t)=>{
            r.push({
                type: 0 /* ChangeType.Added */ ,
                doc: t
            });
        }), new $70fd6868680e912c$var$Rc(t, e, $70fd6868680e912c$var$Ac.emptySet(e), r, n, s, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(t) {
        if (!(this.fromCache === t.fromCache && this.hasCachedResults === t.hasCachedResults && this.syncStateChanged === t.syncStateChanged && this.mutatedKeys.isEqual(t.mutatedKeys) && $70fd6868680e912c$var$Zn(this.query, t.query) && this.docs.isEqual(t.docs) && this.oldDocs.isEqual(t.oldDocs))) return !1;
        const e = this.docChanges, n = t.docChanges;
        if (e.length !== n.length) return !1;
        for(let t = 0; t < e.length; t++)if (e[t].type !== n[t].type || !e[t].doc.isEqual(n[t].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $70fd6868680e912c$var$Pc {
    constructor(){
        this.Nu = void 0, this.listeners = [];
    }
}
class $70fd6868680e912c$var$bc {
    constructor(){
        this.queries = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$ts(t), $70fd6868680e912c$var$Zn), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.ku = new Set;
    }
}
async function $70fd6868680e912c$var$Vc(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = e.query;
    let i = !1, r = n.queries.get(s);
    if (r || (i = !0, r = new $70fd6868680e912c$var$Pc), i) try {
        r.Nu = await n.onListen(s);
    } catch (t) {
        const n = $70fd6868680e912c$var$Ec(t, `Initialization of query '${$70fd6868680e912c$var$es(e.query)}' failed`);
        return void e.onError(n);
    }
    if (n.queries.set(s, r), r.listeners.push(e), // Run global snapshot listeners if a consistent snapshot has been emitted.
    e.Mu(n.onlineState), r.Nu) e.$u(r.Nu) && $70fd6868680e912c$var$xc(n);
}
async function $70fd6868680e912c$var$Sc(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = e.query;
    let i = !1;
    const r = n.queries.get(s);
    if (r) {
        const t = r.listeners.indexOf(e);
        t >= 0 && (r.listeners.splice(t, 1), i = 0 === r.listeners.length);
    }
    if (i) return n.queries.delete(s), n.onUnlisten(s);
}
function $70fd6868680e912c$var$Dc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    let s = !1;
    for (const t of e){
        const e = t.query, i = n.queries.get(e);
        if (i) {
            for (const e of i.listeners)e.$u(t) && (s = !0);
            i.Nu = t;
        }
    }
    s && $70fd6868680e912c$var$xc(n);
}
function $70fd6868680e912c$var$Cc(t, e, n) {
    const s = $70fd6868680e912c$var$L(t), i = s.queries.get(e);
    if (i) for (const t of i.listeners)t.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    s.queries.delete(e);
}
// Call all global snapshot listeners that have been set.
function $70fd6868680e912c$var$xc(t) {
    t.ku.forEach((t)=>{
        t.next();
    });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $70fd6868680e912c$var$Nc {
    constructor(t, e, n){
        this.query = t, this.Ou = e, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Fu = !1, this.Bu = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ $u(t) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const e = [];
            for (const n of t.docChanges)3 /* ChangeType.Metadata */  !== n.type && e.push(n);
            t = new $70fd6868680e912c$var$Rc(t.query, t.docs, t.oldDocs, e, t.mutatedKeys, t.fromCache, t.syncStateChanged, /* excludesMetadataChanges= */ !0, t.hasCachedResults);
        }
        let e = !1;
        return this.Fu ? this.Lu(t) && (this.Ou.next(t), e = !0) : this.qu(t, this.onlineState) && (this.Uu(t), e = !0), this.Bu = t, e;
    }
    onError(t) {
        this.Ou.error(t);
    }
    /** Returns whether a snapshot was raised. */ Mu(t) {
        this.onlineState = t;
        let e = !1;
        return this.Bu && !this.Fu && this.qu(this.Bu, t) && (this.Uu(this.Bu), e = !0), e;
    }
    qu(t, e) {
        // Always raise the first event when we're synced
        if (!t.fromCache) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== e;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.Ku || !n) && (!t.docs.isEmpty() || t.hasCachedResults || "Offline" /* OnlineState.Offline */  === e);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    Lu(t) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (t.docChanges.length > 0) return !0;
        const e = this.Bu && this.Bu.hasPendingWrites !== t.hasPendingWrites;
        return !(!t.syncStateChanged && !e) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    Uu(t) {
        t = $70fd6868680e912c$var$Rc.fromInitialDocuments(t.query, t.docs, t.mutatedKeys, t.fromCache, t.hasCachedResults), this.Fu = !0, this.Ou.next(t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $70fd6868680e912c$var$kc {
    constructor(t, // How many bytes this element takes to store in the bundle.
    e){
        this.Gu = t, this.byteLength = e;
    }
    Qu() {
        return "metadata" in this.Gu;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $70fd6868680e912c$var$Mc {
    constructor(t){
        this.serializer = t;
    }
    rr(t) {
        return $70fd6868680e912c$var$Oi(this.serializer, t);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ ur(t) {
        return t.metadata.exists ? $70fd6868680e912c$var$Ki(this.serializer, t.document, !1) : $70fd6868680e912c$var$an.newNoDocument(this.rr(t.metadata.name), this.cr(t.metadata.readTime));
    }
    cr(t) {
        return $70fd6868680e912c$var$Ni(t);
    }
}
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ class $70fd6868680e912c$var$$c {
    constructor(t, e, n){
        this.ju = t, this.localStore = e, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $70fd6868680e912c$var$Oc(t);
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ zu(t) {
        this.progress.bytesLoaded += t.byteLength;
        let e = this.progress.documentsLoaded;
        if (t.Gu.namedQuery) this.queries.push(t.Gu.namedQuery);
        else if (t.Gu.documentMetadata) {
            this.documents.push({
                metadata: t.Gu.documentMetadata
            }), t.Gu.documentMetadata.exists || ++e;
            const n = $70fd6868680e912c$var$ut.fromString(t.Gu.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else t.Gu.document && (this.documents[this.documents.length - 1].document = t.Gu.document, ++e);
        return e !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = e, Object.assign({}, this.progress)) : null;
    }
    Wu(t) {
        const e = new Map, n = new $70fd6868680e912c$var$Mc(this.serializer);
        for (const s of t)if (s.metadata.queries) {
            const t = n.rr(s.metadata.name);
            for (const n of s.metadata.queries){
                const s = (e.get(n) || $70fd6868680e912c$var$gs()).add(t);
                e.set(n, s);
            }
        }
        return e;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async complete() {
        const t = await $70fd6868680e912c$var$mu(this.localStore, new $70fd6868680e912c$var$Mc(this.serializer), this.documents, this.ju.id), e = this.Wu(this.documents);
        for (const t of this.queries)await $70fd6868680e912c$var$gu(this.localStore, t, e.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Hu: this.collectionGroups,
            Ju: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $70fd6868680e912c$var$Oc(t) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: t.totalDocuments,
        totalBytes: t.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Fc {
    constructor(t){
        this.key = t;
    }
}
class $70fd6868680e912c$var$Bc {
    constructor(t){
        this.key = t;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $70fd6868680e912c$var$Lc {
    constructor(t, /** Documents included in the remote target */ e){
        this.query = t, this.Yu = e, this.Xu = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Zu = $70fd6868680e912c$var$gs(), /** Document Keys that have local changes */ this.mutatedKeys = $70fd6868680e912c$var$gs(), this.tc = $70fd6868680e912c$var$is(t), this.ec = new $70fd6868680e912c$var$Ac(this.tc);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get nc() {
        return this.Yu;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ sc(t, e) {
        const n = e ? e.ic : new $70fd6868680e912c$var$vc, s = e ? e.ec : this.ec;
        let i = e ? e.mutatedKeys : this.mutatedKeys, r = s, o = !1;
        // Track the last doc in a (full) limit. This is necessary, because some
        // update (a delete, or an update moving a doc past the old limit) might
        // mean there is some other document in the local cache that either should
        // come (1) between the old last limit doc and the new last document, in the
        // case of updates, or (2) after the new last document, in the case of
        // deletes. So we keep this doc at the old limit to compare the updates to.
        // Note that this should never get used in a refill (when previousChanges is
        // set), because there will only be adds -- no deletes or updates.
        const u = "F" /* LimitType.First */  === this.query.limitType && s.size === this.query.limit ? s.last() : null, c = "L" /* LimitType.Last */  === this.query.limitType && s.size === this.query.limit ? s.first() : null;
        // Drop documents out to meet limit/limitToLast requirement.
        if (t.inorderTraversal((t, e)=>{
            const a = s.get(t), h = $70fd6868680e912c$var$ns(this.query, e) ? e : null, l = !!a && this.mutatedKeys.has(a.key), f = !!h && (h.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(h.key) && h.hasCommittedMutations);
            let d = !1;
            // Calculate change
            if (a && h) a.data.isEqual(h.data) ? l !== f && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: h
            }), d = !0) : this.rc(a, h) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: h
            }), d = !0, (u && this.tc(h, u) > 0 || c && this.tc(h, c) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (o = !0));
            else !a && h ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: h
            }), d = !0) : a && !h && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: a
            }), d = !0, (u || c) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (o = !0));
            d && (h ? (r = r.add(h), i = f ? i.add(t) : i.delete(t)) : (r = r.delete(t), i = i.delete(t)));
        }), null !== this.query.limit) for(; r.size > this.query.limit;){
            const t = "F" /* LimitType.First */  === this.query.limitType ? r.last() : r.first();
            r = r.delete(t.key), i = i.delete(t.key), n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: t
            });
        }
        return {
            ec: r,
            ic: n,
            zi: o,
            mutatedKeys: i
        };
    }
    rc(t, e) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return t.hasLocalMutations && e.hasCommittedMutations && !e.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param updateLimboDocuments - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(t, e, n) {
        const s = this.ec;
        this.ec = t.ec, this.mutatedKeys = t.mutatedKeys;
        // Sort changes based on type and query comparator
        const i = t.ic.xu();
        i.sort((t, e)=>(function(t, e) {
                const n = (t)=>{
                    switch(t){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $70fd6868680e912c$var$O();
                    }
                };
                return n(t) - n(e);
            })(t.type, e.type) || this.tc(t.doc, e.doc)), this.oc(n);
        const r = e ? this.uc() : [], o = 0 === this.Zu.size && this.current ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , u = o !== this.Xu;
        if (this.Xu = o, 0 !== i.length || u) return {
            snapshot: new $70fd6868680e912c$var$Rc(this.query, t.ec, s, i, t.mutatedKeys, 0 /* SyncState.Local */  === o, u, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            cc: r
        };
        // no changes
        return {
            cc: r
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Mu(t) {
        return this.current && "Offline" /* OnlineState.Offline */  === t ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            ec: this.ec,
            ic: new $70fd6868680e912c$var$vc,
            mutatedKeys: this.mutatedKeys,
            zi: !1
        }, /* updateLimboDocuments= */ !1)) : {
            cc: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ ac(t) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Yu.has(t) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.ec.has(t) && !this.ec.get(t).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ oc(t) {
        t && (t.addedDocuments.forEach((t)=>this.Yu = this.Yu.add(t)), t.modifiedDocuments.forEach((t)=>{}), t.removedDocuments.forEach((t)=>this.Yu = this.Yu.delete(t)), this.current = t.current);
    }
    uc() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const t = this.Zu;
        this.Zu = $70fd6868680e912c$var$gs(), this.ec.forEach((t)=>{
            this.ac(t.key) && (this.Zu = this.Zu.add(t.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const e = [];
        return t.forEach((t)=>{
            this.Zu.has(t) || e.push(new $70fd6868680e912c$var$Bc(t));
        }), this.Zu.forEach((n)=>{
            t.has(n) || e.push(new $70fd6868680e912c$var$Fc(n));
        }), e;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    hc(t) {
        this.Yu = t.ir, this.Zu = $70fd6868680e912c$var$gs();
        const e = this.sc(t.documents);
        return this.applyChanges(e, /*updateLimboDocuments=*/ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    lc() {
        return $70fd6868680e912c$var$Rc.fromInitialDocuments(this.query, this.ec, this.mutatedKeys, 0 /* SyncState.Local */  === this.Xu, this.hasCachedResults);
    }
}
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $70fd6868680e912c$var$qc {
    constructor(/**
     * The query itself.
     */ t, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ e, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = t, this.targetId = e, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $70fd6868680e912c$var$Uc {
    constructor(t){
        this.key = t, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.fc = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $70fd6868680e912c$var$Kc {
    constructor(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    s, i, r){
        this.localStore = t, this.remoteStore = e, this.eventManager = n, this.sharedClientState = s, this.currentUser = i, this.maxConcurrentLimboResolutions = r, this.dc = {}, this.wc = new $70fd6868680e912c$var$os((t)=>$70fd6868680e912c$var$ts(t), $70fd6868680e912c$var$Zn), this._c = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.mc = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.gc = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.yc = new Map, this.Ic = new $70fd6868680e912c$var$Oo, /** Stores user completion handlers, indexed by User and BatchId. */ this.Tc = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Ec = new Map, this.Ac = $70fd6868680e912c$var$lo.Mn(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.vc = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.vc;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $70fd6868680e912c$var$Gc(t, e) {
    const n = $70fd6868680e912c$var$pa(t);
    let s, i;
    const r = n.wc.get(e);
    if (r) // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    s = r.targetId, n.sharedClientState.addLocalQueryTarget(s), i = r.view.lc();
    else {
        const t = await $70fd6868680e912c$var$hu(n.localStore, $70fd6868680e912c$var$Jn(e)), r = n.sharedClientState.addLocalQueryTarget(t.targetId);
        s = t.targetId, i = await $70fd6868680e912c$var$Qc(n, e, s, "current" === r, t.resumeToken), n.isPrimaryClient && $70fd6868680e912c$var$Hu(n.remoteStore, t);
    }
    return i;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $70fd6868680e912c$var$Qc(t, e, n, s, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    t.Rc = (e, n, s)=>(async function(t, e, n, s) {
            let i = e.view.sc(n);
            i.zi && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $70fd6868680e912c$var$fu(t.localStore, e.query, /* usePreviousResults= */ !1).then(({ documents: t })=>e.view.sc(t, i)));
            const r = s && s.targetChanges.get(e.targetId), o = e.view.applyChanges(i, /* updateLimboDocuments= */ t.isPrimaryClient, r);
            return $70fd6868680e912c$var$ia(t, e.targetId, o.cc), o.snapshot;
        })(t, e, n, s);
    const r = await $70fd6868680e912c$var$fu(t.localStore, e, /* usePreviousResults= */ !0), o = new $70fd6868680e912c$var$Lc(e, r.ir), u = o.sc(r.documents), c = $70fd6868680e912c$var$gi.createSynthesizedTargetChangeForCurrentChange(n, s && "Offline" /* OnlineState.Offline */  !== t.onlineState, i), a = o.applyChanges(u, /* updateLimboDocuments= */ t.isPrimaryClient, c);
    $70fd6868680e912c$var$ia(t, n, a.cc);
    const h = new $70fd6868680e912c$var$qc(e, n, o);
    return t.wc.set(e, h), t._c.has(n) ? t._c.get(n).push(e) : t._c.set(n, [
        e
    ]), a.snapshot;
}
/** Stops listening to the query. */ async function $70fd6868680e912c$var$jc(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = n.wc.get(e), i = n._c.get(s.targetId);
    if (i.length > 1) return n._c.set(s.targetId, i.filter((t)=>!$70fd6868680e912c$var$Zn(t, e))), void n.wc.delete(e);
    // No other queries are mapped to the target, clean up the query and the target.
    if (n.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        n.sharedClientState.removeLocalQueryTarget(s.targetId);
        n.sharedClientState.isActiveQueryTarget(s.targetId) || await $70fd6868680e912c$var$lu(n.localStore, s.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            n.sharedClientState.clearQueryState(s.targetId), $70fd6868680e912c$var$Ju(n.remoteStore, s.targetId), $70fd6868680e912c$var$na(n, s.targetId);
        }).catch($70fd6868680e912c$var$vt);
    } else $70fd6868680e912c$var$na(n, s.targetId), await $70fd6868680e912c$var$lu(n.localStore, s.targetId, /*keepPersistedTargetData=*/ !0);
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $70fd6868680e912c$var$zc(t, e, n) {
    const s = $70fd6868680e912c$var$Ia(t);
    try {
        const t = await function(t, e) {
            const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$export$d9bcbd5e1ff81430.now(), i = e.reduce((t, e)=>t.add(e.key), $70fd6868680e912c$var$gs());
            let r, o;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (t)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let u = $70fd6868680e912c$var$cs(), c = $70fd6868680e912c$var$gs();
                return n.Zi.getEntries(t, i).next((t)=>{
                    u = t, u.forEach((t, e)=>{
                        e.isValidDocument() || (c = c.add(t));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(t, u)).next((i)=>{
                    r = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const o = [];
                    for (const t of e){
                        const e = $70fd6868680e912c$var$Gs(t, r.get(t.key).overlayedDocument);
                        null != e && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        o.push(new $70fd6868680e912c$var$zs(t.key, e, $70fd6868680e912c$var$cn(e.value.mapValue), $70fd6868680e912c$var$Fs.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(t, s, o, e);
                }).next((e)=>{
                    o = e;
                    const s = e.applyToLocalDocumentSet(r, c);
                    return n.documentOverlayCache.saveOverlays(t, e.batchId, s);
                });
            }).then(()=>({
                    batchId: o.batchId,
                    changes: $70fd6868680e912c$var$ls(r)
                }));
        }(s.localStore, e);
        s.sharedClientState.addPendingMutation(t.batchId), function(t, e, n) {
            let s = t.Tc[t.currentUser.toKey()];
            s || (s = new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et));
            s = s.insert(e, n), t.Tc[t.currentUser.toKey()] = s;
        }(s, t.batchId, n), await $70fd6868680e912c$var$ua(s, t.changes), await $70fd6868680e912c$var$cc(s.remoteStore);
    } catch (t) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const e = $70fd6868680e912c$var$Ec(t, "Failed to persist write");
        n.reject(e);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $70fd6868680e912c$var$Wc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    try {
        const t = await $70fd6868680e912c$var$uu(n.localStore, e);
        // Update `receivedDocument` as appropriate for any limbo targets.
        e.targetChanges.forEach((t, e)=>{
            const s = n.yc.get(e);
            s && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($70fd6868680e912c$var$F(t.addedDocuments.size + t.modifiedDocuments.size + t.removedDocuments.size <= 1), t.addedDocuments.size > 0 ? s.fc = !0 : t.modifiedDocuments.size > 0 ? $70fd6868680e912c$var$F(s.fc) : t.removedDocuments.size > 0 && ($70fd6868680e912c$var$F(s.fc), s.fc = !1));
        }), await $70fd6868680e912c$var$ua(n, t, e);
    } catch (t) {
        await $70fd6868680e912c$var$vt(t);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $70fd6868680e912c$var$Hc(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (s.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !s.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const t = [];
        s.wc.forEach((n, s)=>{
            const i = s.view.Mu(e);
            i.snapshot && t.push(i.snapshot);
        }), function(t, e) {
            const n = $70fd6868680e912c$var$L(t);
            n.onlineState = e;
            let s = !1;
            n.queries.forEach((t, n)=>{
                for (const t of n.listeners)// Run global snapshot listeners if a consistent snapshot has been emitted.
                t.Mu(e) && (s = !0);
            }), s && $70fd6868680e912c$var$xc(n);
        }(s.eventManager, e), t.length && s.dc.nu(t), s.onlineState = e, s.isPrimaryClient && s.sharedClientState.setOnlineState(e);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $70fd6868680e912c$var$Jc(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    // PORTING NOTE: Multi-tab only.
    s.sharedClientState.updateQueryState(e, "rejected", n);
    const i = s.yc.get(e), r = i && i.key;
    if (r) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let t = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        t = t.insert(r, $70fd6868680e912c$var$an.newNoDocument(r, $70fd6868680e912c$var$rt.min()));
        const n = $70fd6868680e912c$var$gs().add(r), i = new $70fd6868680e912c$var$mi($70fd6868680e912c$var$rt.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $70fd6868680e912c$var$pe($70fd6868680e912c$var$et), t, n);
        await $70fd6868680e912c$var$Wc(s, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        s.gc = s.gc.remove(r), s.yc.delete(e), $70fd6868680e912c$var$oa(s);
    } else await $70fd6868680e912c$var$lu(s.localStore, e, /* keepPersistedTargetData */ !1).then(()=>$70fd6868680e912c$var$na(s, e, n)).catch($70fd6868680e912c$var$vt);
}
async function $70fd6868680e912c$var$Yc(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = e.batch.batchId;
    try {
        const t = await $70fd6868680e912c$var$ru(n.localStore, e);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $70fd6868680e912c$var$ea(n, s, /*error=*/ null), $70fd6868680e912c$var$ta(n, s), n.sharedClientState.updateMutationState(s, "acknowledged"), await $70fd6868680e912c$var$ua(n, t);
    } catch (t) {
        await $70fd6868680e912c$var$vt(t);
    }
}
async function $70fd6868680e912c$var$Xc(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    try {
        const t = await function(t, e) {
            const n = $70fd6868680e912c$var$L(t);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (t)=>{
                let s;
                return n.mutationQueue.lookupMutationBatch(t, e).next((e)=>($70fd6868680e912c$var$F(null !== e), s = e.keys(), n.mutationQueue.removeMutationBatch(t, e))).next(()=>n.mutationQueue.performConsistencyCheck(t)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(t, s, e)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(t, s)).next(()=>n.localDocuments.getDocuments(t, s));
            });
        }(s.localStore, e);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $70fd6868680e912c$var$ea(s, e, n), $70fd6868680e912c$var$ta(s, e), s.sharedClientState.updateMutationState(e, "rejected", n), await $70fd6868680e912c$var$ua(s, t);
    } catch (n) {
        await $70fd6868680e912c$var$vt(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $70fd6868680e912c$var$Zc(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    $70fd6868680e912c$var$ec(n.remoteStore) || $70fd6868680e912c$var$N("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const t = await function(t) {
            const e = $70fd6868680e912c$var$L(t);
            return e.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (t)=>e.mutationQueue.getHighestUnacknowledgedBatchId(t));
        }(n.localStore);
        if (-1 === t) // Trigger the callback right away if there is no pending writes at the moment.
        return void e.resolve();
        const s = n.Ec.get(t) || [];
        s.push(e), n.Ec.set(t, s);
    } catch (t) {
        const n = $70fd6868680e912c$var$Ec(t, "Initialization of waitForPendingWrites() operation failed");
        e.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $70fd6868680e912c$var$ta(t, e) {
    (t.Ec.get(e) || []).forEach((t)=>{
        t.resolve();
    }), t.Ec.delete(e);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $70fd6868680e912c$var$ea(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    let i = s.Tc[s.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const t = i.get(e);
        t && (n ? t.reject(n) : t.resolve(), i = i.remove(e)), s.Tc[s.currentUser.toKey()] = i;
    }
}
function $70fd6868680e912c$var$na(t, e, n = null) {
    t.sharedClientState.removeLocalQueryTarget(e);
    for (const s of t._c.get(e))t.wc.delete(s), n && t.dc.Pc(s, n);
    if (t._c.delete(e), t.isPrimaryClient) t.Ic.Is(e).forEach((e)=>{
        t.Ic.containsKey(e) || // We removed the last reference for this key
        $70fd6868680e912c$var$sa(t, e);
    });
}
function $70fd6868680e912c$var$sa(t, e) {
    t.mc.delete(e.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = t.gc.get(e);
    null !== n && ($70fd6868680e912c$var$Ju(t.remoteStore, n), t.gc = t.gc.remove(e), t.yc.delete(n), $70fd6868680e912c$var$oa(t));
}
function $70fd6868680e912c$var$ia(t, e, n) {
    for (const s of n)if (s instanceof $70fd6868680e912c$var$Fc) t.Ic.addReference(s.key, e), $70fd6868680e912c$var$ra(t, s);
    else if (s instanceof $70fd6868680e912c$var$Bc) {
        $70fd6868680e912c$var$N("SyncEngine", "Document no longer in limbo: " + s.key), t.Ic.removeReference(s.key, e);
        t.Ic.containsKey(s.key) || // We removed the last reference for this key
        $70fd6868680e912c$var$sa(t, s.key);
    } else $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$var$ra(t, e) {
    const n = e.key, s = n.path.canonicalString();
    t.gc.get(n) || t.mc.has(s) || ($70fd6868680e912c$var$N("SyncEngine", "New document in limbo: " + n), t.mc.add(s), $70fd6868680e912c$var$oa(t));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $70fd6868680e912c$var$oa(t) {
    for(; t.mc.size > 0 && t.gc.size < t.maxConcurrentLimboResolutions;){
        const e = t.mc.values().next().value;
        t.mc.delete(e);
        const n = new $70fd6868680e912c$export$afc2e57c475b7810($70fd6868680e912c$var$ut.fromString(e)), s = t.Ac.next();
        t.yc.set(s, new $70fd6868680e912c$var$Uc(n)), t.gc = t.gc.insert(n, s), $70fd6868680e912c$var$Hu(t.remoteStore, new $70fd6868680e912c$var$cr($70fd6868680e912c$var$Jn($70fd6868680e912c$var$Gn(n.path)), s, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $70fd6868680e912c$var$Ot.ct));
    }
}
async function $70fd6868680e912c$var$ua(t, e, n) {
    const s = $70fd6868680e912c$var$L(t), i = [], r = [], o = [];
    s.wc.isEmpty() || (s.wc.forEach((t, u)=>{
        o.push(s.Rc(u, e, n).then((t)=>{
            // Update views if there are actual changes.
            if (// If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            (t || n) && s.isPrimaryClient && s.sharedClientState.updateQueryState(u.targetId, (null == t ? void 0 : t.fromCache) ? "not-current" : "current"), t) {
                i.push(t);
                const e = $70fd6868680e912c$var$tu.Li(u.targetId, t);
                r.push(e);
            }
        }));
    }), await Promise.all(o), s.dc.nu(i), await async function(t, e) {
        const n = $70fd6868680e912c$var$L(t);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (t)=>$70fd6868680e912c$var$Rt.forEach(e, (e)=>$70fd6868680e912c$var$Rt.forEach(e.Fi, (s)=>n.persistence.referenceDelegate.addReference(t, e.targetId, s)).next(()=>$70fd6868680e912c$var$Rt.forEach(e.Bi, (s)=>n.persistence.referenceDelegate.removeReference(t, e.targetId, s)))));
        } catch (t) {
            if (!$70fd6868680e912c$var$Dt(t)) throw t;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $70fd6868680e912c$var$N("LocalStore", "Failed to update sequence numbers: " + t);
        }
        for (const t of e){
            const e = t.targetId;
            if (!t.fromCache) {
                const t = n.Ji.get(e), s = t.snapshotVersion, i = t.withLastLimboFreeSnapshotVersion(s);
                // Advance the last limbo free snapshot version
                n.Ji = n.Ji.insert(e, i);
            }
        }
    }(s.localStore, r));
}
async function $70fd6868680e912c$var$ca(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    if (!n.currentUser.isEqual(e)) {
        $70fd6868680e912c$var$N("SyncEngine", "User change. New user:", e.toKey());
        const t = await $70fd6868680e912c$var$iu(n.localStore, e);
        n.currentUser = e, // Fails tasks waiting for pending writes requested by previous user.
        function(t, e) {
            t.Ec.forEach((t)=>{
                t.forEach((t)=>{
                    t.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.CANCELLED, e));
                });
            }), t.Ec.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(e, t.removedBatchIds, t.addedBatchIds), await $70fd6868680e912c$var$ua(n, t.er);
    }
}
function $70fd6868680e912c$var$aa(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = n.yc.get(e);
    if (s && s.fc) return $70fd6868680e912c$var$gs().add(s.key);
    {
        let t = $70fd6868680e912c$var$gs();
        const s = n._c.get(e);
        if (!s) return t;
        for (const e of s){
            const s = n.wc.get(e);
            t = t.unionWith(s.view.nc);
        }
        return t;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $70fd6868680e912c$var$ha(t, e) {
    const n = $70fd6868680e912c$var$L(t), s = await $70fd6868680e912c$var$fu(n.localStore, e.query, /* usePreviousResults= */ !0), i = e.view.hc(s);
    return n.isPrimaryClient && $70fd6868680e912c$var$ia(n, e.targetId, i.cc), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$la(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    return $70fd6868680e912c$var$wu(n.localStore, e).then((t)=>$70fd6868680e912c$var$ua(n, t));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$fa(t, e, n, s) {
    const i = $70fd6868680e912c$var$L(t), r = await function(t, e) {
        const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$L(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (t)=>s.Sn(t, e).next((e)=>e ? n.localDocuments.getDocuments(t, e) : $70fd6868680e912c$var$Rt.resolve(null)));
    }(i.localStore, e);
    null !== r ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $70fd6868680e912c$var$cc(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($70fd6868680e912c$var$ea(i, e, s || null), $70fd6868680e912c$var$ta(i, e), function(t, e) {
        $70fd6868680e912c$var$L($70fd6868680e912c$var$L(t).mutationQueue).Cn(e);
    }(i.localStore, e)) : $70fd6868680e912c$var$O(), await $70fd6868680e912c$var$ua(i, r)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $70fd6868680e912c$var$N("SyncEngine", "Cannot apply mutation batch with id: " + e);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$da(t, e) {
    const n = $70fd6868680e912c$var$L(t);
    if ($70fd6868680e912c$var$pa(n), $70fd6868680e912c$var$Ia(n), !0 === e && !0 !== n.vc) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const t = n.sharedClientState.getAllActiveQueryTargets(), e = await $70fd6868680e912c$var$wa(n, t.toArray());
        n.vc = !0, await $70fd6868680e912c$var$yc(n.remoteStore, !0);
        for (const t of e)$70fd6868680e912c$var$Hu(n.remoteStore, t);
    } else if (!1 === e && !1 !== n.vc) {
        const t = [];
        let e = Promise.resolve();
        n._c.forEach((s, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? t.push(i) : e = e.then(()=>($70fd6868680e912c$var$na(n, i), $70fd6868680e912c$var$lu(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $70fd6868680e912c$var$Ju(n.remoteStore, i);
        }), await e, await $70fd6868680e912c$var$wa(n, t), // PORTING NOTE: Multi-Tab only.
        function(t) {
            const e = $70fd6868680e912c$var$L(t);
            e.yc.forEach((t, n)=>{
                $70fd6868680e912c$var$Ju(e.remoteStore, n);
            }), e.Ic.Ts(), e.yc = new Map, e.gc = new $70fd6868680e912c$var$pe($70fd6868680e912c$export$afc2e57c475b7810.comparator);
        }(n), n.vc = !1, await $70fd6868680e912c$var$yc(n.remoteStore, !1);
    }
}
async function $70fd6868680e912c$var$wa(t, e, n) {
    const s = $70fd6868680e912c$var$L(t), i = [], r = [];
    for (const t of e){
        let e;
        const n = s._c.get(t);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            e = await $70fd6868680e912c$var$hu(s.localStore, $70fd6868680e912c$var$Jn(n[0]));
            for (const t of n){
                const e = s.wc.get(t), n = await $70fd6868680e912c$var$ha(s, e);
                n.snapshot && r.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $70fd6868680e912c$var$du(s.localStore, t);
            e = await $70fd6868680e912c$var$hu(s.localStore, n), await $70fd6868680e912c$var$Qc(s, $70fd6868680e912c$var$_a(n), t, /*current=*/ !1, e.resumeToken);
        }
        i.push(e);
    }
    return s.dc.nu(r), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$_a(t) {
    return $70fd6868680e912c$var$Kn(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F" /* LimitType.First */ , t.startAt, t.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $70fd6868680e912c$var$ma(t) {
    const e = $70fd6868680e912c$var$L(t);
    return $70fd6868680e912c$var$L($70fd6868680e912c$var$L(e.localStore).persistence).$i();
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $70fd6868680e912c$var$ga(t, e, n, s) {
    const i = $70fd6868680e912c$var$L(t);
    if (i.vc) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $70fd6868680e912c$var$N("SyncEngine", "Ignoring unexpected query state notification.");
    const r = i._c.get(e);
    if (r && r.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                const t = await $70fd6868680e912c$var$wu(i.localStore, $70fd6868680e912c$var$ss(r[0])), s = $70fd6868680e912c$var$mi.createSynthesizedRemoteEventForCurrentChange(e, "current" === n, $70fd6868680e912c$var$Ve.EMPTY_BYTE_STRING);
                await $70fd6868680e912c$var$ua(i, t, s);
                break;
            }
        case "rejected":
            await $70fd6868680e912c$var$lu(i.localStore, e, /* keepPersistedTargetData */ !0), $70fd6868680e912c$var$na(i, e, s);
            break;
        default:
            $70fd6868680e912c$var$O();
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $70fd6868680e912c$var$ya(t, e, n) {
    const s = $70fd6868680e912c$var$pa(t);
    if (s.vc) {
        for (const t of e){
            if (s._c.has(t)) {
                // A target might have been added in a previous attempt
                $70fd6868680e912c$var$N("SyncEngine", "Adding an already active target " + t);
                continue;
            }
            const e = await $70fd6868680e912c$var$du(s.localStore, t), n = await $70fd6868680e912c$var$hu(s.localStore, e);
            await $70fd6868680e912c$var$Qc(s, $70fd6868680e912c$var$_a(e), n.targetId, /*current=*/ !1, n.resumeToken), $70fd6868680e912c$var$Hu(s.remoteStore, n);
        }
        for (const t of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        s._c.has(t) && // Release queries that are still active.
        await $70fd6868680e912c$var$lu(s.localStore, t, /* keepPersistedTargetData */ !1).then(()=>{
            $70fd6868680e912c$var$Ju(s.remoteStore, t), $70fd6868680e912c$var$na(s, t);
        }).catch($70fd6868680e912c$var$vt);
    }
}
function $70fd6868680e912c$var$pa(t) {
    const e = $70fd6868680e912c$var$L(t);
    return e.remoteStore.remoteSyncer.applyRemoteEvent = $70fd6868680e912c$var$Wc.bind(null, e), e.remoteStore.remoteSyncer.getRemoteKeysForTarget = $70fd6868680e912c$var$aa.bind(null, e), e.remoteStore.remoteSyncer.rejectListen = $70fd6868680e912c$var$Jc.bind(null, e), e.dc.nu = $70fd6868680e912c$var$Dc.bind(null, e.eventManager), e.dc.Pc = $70fd6868680e912c$var$Cc.bind(null, e.eventManager), e;
}
function $70fd6868680e912c$var$Ia(t) {
    const e = $70fd6868680e912c$var$L(t);
    return e.remoteStore.remoteSyncer.applySuccessfulWrite = $70fd6868680e912c$var$Yc.bind(null, e), e.remoteStore.remoteSyncer.rejectFailedWrite = $70fd6868680e912c$var$Xc.bind(null, e), e;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $70fd6868680e912c$var$Ta(t, e, n) {
    const s = $70fd6868680e912c$var$L(t);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function(t, e, n) {
        try {
            const s = await e.getMetadata();
            if (await function(t, e) {
                const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$Ni(e.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (t)=>n.qs.getBundleMetadata(t, e.id)).then((t)=>!!t && t.createTime.compareTo(s) >= 0);
            }(t.localStore, s)) return await e.close(), n._completeWith(function(t) {
                return {
                    taskState: "Success",
                    documentsLoaded: t.totalDocuments,
                    bytesLoaded: t.totalBytes,
                    totalDocuments: t.totalDocuments,
                    totalBytes: t.totalBytes
                };
            }(s)), Promise.resolve(new Set);
            n._updateProgress($70fd6868680e912c$var$Oc(s));
            const i = new $70fd6868680e912c$var$$c(s, t.localStore, e.serializer);
            let r = await e.bc();
            for(; r;){
                const t = await i.zu(r);
                t && n._updateProgress(t), r = await e.bc();
            }
            const o = await i.complete();
            return await $70fd6868680e912c$var$ua(t, o.Ju, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function(t, e) {
                const n = $70fd6868680e912c$var$L(t);
                return n.persistence.runTransaction("Save bundle", "readwrite", (t)=>n.qs.saveBundleMetadata(t, e));
            }(t.localStore, s), n._completeWith(o.progress), Promise.resolve(o.Hu);
        } catch (t) {
            return $70fd6868680e912c$export$86cd73f49cc6e0bb("SyncEngine", `Loading bundle failed with ${t}`), n._failWith(t), Promise.resolve(new Set);
        }
    })(s, e, n).then((t)=>{
        s.sharedClientState.notifyBundleLoaded(t);
    });
}
class $70fd6868680e912c$var$Ea {
    constructor(){
        this.synchronizeTabs = !1;
    }
    async initialize(t) {
        this.serializer = $70fd6868680e912c$var$Fu(t.databaseInfo.databaseId), this.sharedClientState = this.createSharedClientState(t), this.persistence = this.createPersistence(t), await this.persistence.start(), this.localStore = this.createLocalStore(t), this.gcScheduler = this.createGarbageCollectionScheduler(t, this.localStore), this.indexBackfillerScheduler = this.createIndexBackfillerScheduler(t, this.localStore);
    }
    createGarbageCollectionScheduler(t, e) {
        return null;
    }
    createIndexBackfillerScheduler(t, e) {
        return null;
    }
    createLocalStore(t) {
        return $70fd6868680e912c$var$su(this.persistence, new $70fd6868680e912c$var$eu, t.initialUser, this.serializer);
    }
    createPersistence(t) {
        return new $70fd6868680e912c$var$Ko($70fd6868680e912c$var$Qo.zs, this.serializer);
    }
    createSharedClientState(t) {
        return new $70fd6868680e912c$var$bu;
    }
    async terminate() {
        this.gcScheduler && this.gcScheduler.stop(), await this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
class $70fd6868680e912c$var$Aa extends $70fd6868680e912c$var$Ea {
    constructor(t){
        super(), this.cacheSizeBytes = t;
    }
    createGarbageCollectionScheduler(t, e) {
        $70fd6868680e912c$var$F(this.persistence.referenceDelegate instanceof $70fd6868680e912c$var$jo);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$po(n, t.asyncQueue, e);
    }
    createPersistence(t) {
        const e = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$so.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$so.DEFAULT;
        return new $70fd6868680e912c$var$Ko((t)=>$70fd6868680e912c$var$jo.zs(t, e), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $70fd6868680e912c$var$va extends $70fd6868680e912c$var$Ea {
    constructor(t, e, n){
        super(), this.Vc = t, this.cacheSizeBytes = e, this.forceOwnership = n, this.synchronizeTabs = !1;
    }
    async initialize(t) {
        await super.initialize(t), await this.Vc.initialize(this, t), // Enqueue writes from a previous session
        await $70fd6868680e912c$var$Ia(this.Vc.syncEngine), await $70fd6868680e912c$var$cc(this.Vc.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Ii(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    createLocalStore(t) {
        return $70fd6868680e912c$var$su(this.persistence, new $70fd6868680e912c$var$eu, t.initialUser, this.serializer);
    }
    createGarbageCollectionScheduler(t, e) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $70fd6868680e912c$var$po(n, t.asyncQueue, e);
    }
    createIndexBackfillerScheduler(t, e) {
        const n = new $70fd6868680e912c$var$$t(e, this.persistence);
        return new $70fd6868680e912c$var$Mt(t.asyncQueue, n);
    }
    createPersistence(t) {
        const e = $70fd6868680e912c$var$Zo(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $70fd6868680e912c$var$so.withCacheSize(this.cacheSizeBytes) : $70fd6868680e912c$var$so.DEFAULT;
        return new $70fd6868680e912c$var$Jo(this.synchronizeTabs, e, t.clientId, n, t.asyncQueue, $70fd6868680e912c$var$$u(), $70fd6868680e912c$var$Ou(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    createSharedClientState(t) {
        return new $70fd6868680e912c$var$bu;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $70fd6868680e912c$var$Ra extends $70fd6868680e912c$var$va {
    constructor(t, e){
        super(t, e, /* forceOwnership= */ !1), this.Vc = t, this.cacheSizeBytes = e, this.synchronizeTabs = !0;
    }
    async initialize(t) {
        await super.initialize(t);
        const e = this.Vc.syncEngine;
        this.sharedClientState instanceof $70fd6868680e912c$var$Pu && (this.sharedClientState.syncEngine = {
            jr: $70fd6868680e912c$var$fa.bind(null, e),
            zr: $70fd6868680e912c$var$ga.bind(null, e),
            Wr: $70fd6868680e912c$var$ya.bind(null, e),
            $i: $70fd6868680e912c$var$ma.bind(null, e),
            Qr: $70fd6868680e912c$var$la.bind(null, e)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence.Ii(async (t)=>{
            await $70fd6868680e912c$var$da(this.Vc.syncEngine, t), this.gcScheduler && (t && !this.gcScheduler.started ? this.gcScheduler.start() : t || this.gcScheduler.stop()), this.indexBackfillerScheduler && (t && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : t || this.indexBackfillerScheduler.stop());
        });
    }
    createSharedClientState(t) {
        const e = $70fd6868680e912c$var$$u();
        if (!$70fd6868680e912c$var$Pu.D(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $70fd6868680e912c$var$Zo(t.databaseInfo.databaseId, t.databaseInfo.persistenceKey);
        return new $70fd6868680e912c$var$Pu(e, t.asyncQueue, n, t.clientId, t.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $70fd6868680e912c$var$Pa {
    async initialize(t, e) {
        this.localStore || (this.localStore = t.localStore, this.sharedClientState = t.sharedClientState, this.datastore = this.createDatastore(e), this.remoteStore = this.createRemoteStore(e), this.eventManager = this.createEventManager(e), this.syncEngine = this.createSyncEngine(e, /* startAsPrimary=*/ !t.synchronizeTabs), this.sharedClientState.onlineStateHandler = (t)=>$70fd6868680e912c$var$Hc(this.syncEngine, t, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $70fd6868680e912c$var$ca.bind(null, this.syncEngine), await $70fd6868680e912c$var$yc(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(t) {
        return new $70fd6868680e912c$var$bc;
    }
    createDatastore(t) {
        const e = $70fd6868680e912c$var$Fu(t.databaseInfo.databaseId), n = (s = t.databaseInfo, new $70fd6868680e912c$var$Mu(s));
        var s;
        /** Return the Platform-specific connectivity monitor. */ return function(t, e, n, s) {
            return new $70fd6868680e912c$var$Ku(t, e, n, s);
        }(t.authCredentials, t.appCheckCredentials, n, e);
    }
    createRemoteStore(t) {
        var e, n, s, i, r;
        return e = this.localStore, n = this.datastore, s = t.asyncQueue, i = (t)=>$70fd6868680e912c$var$Hc(this.syncEngine, t, 0 /* OnlineStateSource.RemoteStore */ ), r = $70fd6868680e912c$var$Su.D() ? new $70fd6868680e912c$var$Su : new $70fd6868680e912c$var$Vu, new $70fd6868680e912c$var$ju(e, n, s, i, r);
    /** Re-enables the network. Idempotent. */ }
    createSyncEngine(t, e) {
        return function(t, e, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        s, i, r, o) {
            const u = new $70fd6868680e912c$var$Kc(t, e, n, s, i, r);
            return o && (u.vc = !0), u;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, t.initialUser, t.maxConcurrentLimboResolutions, e);
    }
    terminate() {
        return async function(t) {
            const e = $70fd6868680e912c$var$L(t);
            $70fd6868680e912c$var$N("RemoteStore", "RemoteStore shutting down."), e.vu.add(5 /* OfflineCause.Shutdown */ ), await $70fd6868680e912c$var$Wu(e), e.Pu.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            e.bu.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $70fd6868680e912c$var$ba(t, e = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < t.byteLength) {
                const s = {
                    value: t.slice(n, n + e),
                    done: !1
                };
                return n += e, s;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $70fd6868680e912c$var$Va {
    constructor(t){
        this.observer = t, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(t) {
        this.observer.next && this.Sc(this.observer.next, t);
    }
    error(t) {
        this.observer.error ? this.Sc(this.observer.error, t) : $70fd6868680e912c$var$k("Uncaught Error in snapshot listener:", t.toString());
    }
    Dc() {
        this.muted = !0;
    }
    Sc(t, e) {
        this.muted || setTimeout(()=>{
            this.muted || t(e);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $70fd6868680e912c$var$Sa {
    constructor(/** The reader to read from underlying binary bundle data source. */ t, e){
        this.Cc = t, this.serializer = e, /** Cached bundle metadata. */ this.metadata = new $70fd6868680e912c$var$K, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.xc = new TextDecoder("utf-8"), // Read the metadata (which is the first element).
        this.Nc().then((t)=>{
            t && t.Qu() ? this.metadata.resolve(t.Gu.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(null == t ? void 0 : t.Gu)}`));
        }, (t)=>this.metadata.reject(t));
    }
    close() {
        return this.Cc.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async bc() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.Nc();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async Nc() {
        const t = await this.kc();
        if (null === t) return null;
        const e = this.xc.decode(t), n = Number(e);
        isNaN(n) && this.Mc(`length string (${e}) is not valid number`);
        const s = await this.$c(n);
        return new $70fd6868680e912c$var$kc(JSON.parse(s), t.length + n);
    }
    /** First index of '{' from the underlying buffer. */ Oc() {
        return this.buffer.findIndex((t)=>t === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async kc() {
        for(; this.Oc() < 0;){
            if (await this.Fc()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const t = this.Oc();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        t < 0 && this.Mc("Reached the end of bundle when a length string is expected.");
        const e = this.buffer.slice(0, t);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(t), e;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async $c(t) {
        for(; this.buffer.length < t;)await this.Fc() && this.Mc("Reached the end of bundle when more is expected.");
        const e = this.xc.decode(this.buffer.slice(0, t));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(t), e;
    }
    Mc(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.Cc.cancel(), new Error(`Invalid bundle format: ${t}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Fc() {
        const t = await this.Cc.read();
        if (!t.done) {
            const e = new Uint8Array(this.buffer.length + t.value.length);
            e.set(this.buffer), e.set(t.value, this.buffer.length), this.buffer = e;
        }
        return t.done;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $70fd6868680e912c$var$Da {
    constructor(t){
        this.datastore = t, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastWriteError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(t) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
        const e = await async function(t, e) {
            const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$Li(n.serializer) + "/documents", i = {
                documents: e.map((t)=>$70fd6868680e912c$var$$i(n.serializer, t))
            }, r = await n.vo("BatchGetDocuments", s, i, e.length), o = new Map;
            r.forEach((t)=>{
                const e = $70fd6868680e912c$var$Gi(n.serializer, t);
                o.set(e.key.toString(), e);
            });
            const u = [];
            return e.forEach((t)=>{
                const e = o.get(t.toString());
                $70fd6868680e912c$var$F(!!e), u.push(e);
            }), u;
        }(this.datastore, t);
        return e.forEach((t)=>this.recordVersion(t)), e;
    }
    set(t, e) {
        this.write(e.toMutation(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    update(t, e) {
        try {
            this.write(e.toMutation(t, this.preconditionForUpdate(t)));
        } catch (t) {
            this.lastWriteError = t;
        }
        this.writtenDocs.add(t.toString());
    }
    delete(t) {
        this.write(new $70fd6868680e912c$var$Ys(t, this.precondition(t))), this.writtenDocs.add(t.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastWriteError) throw this.lastWriteError;
        const t = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((e)=>{
            t.delete(e.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        t.forEach((t, e)=>{
            const n = $70fd6868680e912c$export$afc2e57c475b7810.fromPath(e);
            this.mutations.push(new $70fd6868680e912c$var$Xs(n, this.precondition(n)));
        }), await async function(t, e) {
            const n = $70fd6868680e912c$var$L(t), s = $70fd6868680e912c$var$Li(n.serializer) + "/documents", i = {
                writes: e.map((t)=>$70fd6868680e912c$var$ji(n.serializer, t))
            };
            await n.Io("Commit", s, i);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(t) {
        let e;
        if (t.isFoundDocument()) e = t.version;
        else {
            if (!t.isNoDocument()) throw $70fd6868680e912c$var$O();
            // Represent a deleted doc using SnapshotVersion.min().
            e = $70fd6868680e912c$var$rt.min();
        }
        const n = this.readVersions.get(t.key.toString());
        if (n) {
            if (!e.isEqual(n)) // This transaction will fail no matter what.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(t.key.toString(), e);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(t) {
        const e = this.readVersions.get(t.toString());
        return !this.writtenDocs.has(t.toString()) && e ? e.isEqual($70fd6868680e912c$var$rt.min()) ? $70fd6868680e912c$var$Fs.exists(!1) : $70fd6868680e912c$var$Fs.updateTime(e) : $70fd6868680e912c$var$Fs.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(t) {
        const e = this.readVersions.get(t.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(t.toString()) && e) {
            if (e.isEqual($70fd6868680e912c$var$rt.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $70fd6868680e912c$var$Fs.updateTime(e);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $70fd6868680e912c$var$Fs.exists(!0);
    }
    write(t) {
        this.ensureCommitNotCalled(), this.mutations.push(t);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $70fd6868680e912c$var$Ca {
    constructor(t, e, n, s, i){
        this.asyncQueue = t, this.datastore = e, this.options = n, this.updateFunction = s, this.deferred = i, this.Bc = n.maxAttempts, this.qo = new $70fd6868680e912c$var$Bu(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ run() {
        this.Bc -= 1, this.Lc();
    }
    Lc() {
        this.qo.No(async ()=>{
            const t = new $70fd6868680e912c$var$Da(this.datastore), e = this.qc(t);
            e && e.then((e)=>{
                this.asyncQueue.enqueueAndForget(()=>t.commit().then(()=>{
                        this.deferred.resolve(e);
                    }).catch((t)=>{
                        this.Uc(t);
                    }));
            }).catch((t)=>{
                this.Uc(t);
            });
        });
    }
    qc(t) {
        try {
            const e = this.updateFunction(t);
            return !$70fd6868680e912c$var$Ft(e) && e.catch && e.then ? e : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (t) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(t), null;
        }
    }
    Uc(t) {
        this.Bc > 0 && this.Kc(t) ? (this.Bc -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Lc(), Promise.resolve()))) : this.deferred.reject(t);
    }
    Kc(t) {
        if ("FirebaseError" === t.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const e = t.code;
            return "aborted" === e || "failed-precondition" === e || "already-exists" === e || !$70fd6868680e912c$var$oi(e);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $70fd6868680e912c$var$xa {
    constructor(t, e, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, s){
        this.authCredentials = t, this.appCheckCredentials = e, this.asyncQueue = n, this.databaseInfo = s, this.user = $70fd6868680e912c$var$V.UNAUTHENTICATED, this.clientId = $70fd6868680e912c$var$tt.A(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this.authCredentials.start(n, async (t)=>{
            $70fd6868680e912c$var$N("FirestoreClient", "Received user=", t.uid), await this.authCredentialListener(t), this.user = t;
        }), this.appCheckCredentials.start(n, (t)=>($70fd6868680e912c$var$N("FirestoreClient", "Received new app check token=", t), this.appCheckCredentialListener(t, this.user)));
    }
    async getConfiguration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this.databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(t) {
        this.authCredentialListener = t;
    }
    setAppCheckTokenChangeListener(t) {
        this.appCheckCredentialListener = t;
    }
    /**
     * Checks that the client has not been terminated. Ensures that other methods on //
     * this class cannot be called after the client is terminated. //
     */ verifyNotTerminated() {
        if (this.asyncQueue.isShuttingDown) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const t = new $70fd6868680e912c$var$K;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), t.resolve();
            } catch (e) {
                const n = $70fd6868680e912c$var$Ec(e, "Failed to shutdown persistence");
                t.reject(n);
            }
        }), t.promise;
    }
}
async function $70fd6868680e912c$var$Na(t, e) {
    t.asyncQueue.verifyOperationInProgress(), $70fd6868680e912c$var$N("FirestoreClient", "Initializing OfflineComponentProvider");
    const n = await t.getConfiguration();
    await e.initialize(n);
    let s = n.initialUser;
    t.setCredentialChangeListener(async (t)=>{
        s.isEqual(t) || (await $70fd6868680e912c$var$iu(e.localStore, t), s = t);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    e.persistence.setDatabaseDeletedListener(()=>t.terminate()), t._offlineComponents = e;
}
async function $70fd6868680e912c$var$ka(t, e) {
    t.asyncQueue.verifyOperationInProgress();
    const n = await $70fd6868680e912c$var$$a(t);
    $70fd6868680e912c$var$N("FirestoreClient", "Initializing OnlineComponentProvider");
    const s = await t.getConfiguration();
    await e.initialize(n, s), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    t.setCredentialChangeListener((t)=>$70fd6868680e912c$var$gc(e.remoteStore, t)), t.setAppCheckTokenChangeListener((t, n)=>$70fd6868680e912c$var$gc(e.remoteStore, n)), t._onlineComponents = e;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function $70fd6868680e912c$var$Ma(t) {
    return "FirebaseError" === t.name ? t.code === $70fd6868680e912c$var$q.FAILED_PRECONDITION || t.code === $70fd6868680e912c$var$q.UNIMPLEMENTED : !("undefined" != typeof DOMException && t instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
    // or an aborted error depending on whether the error happened during
    // schema migration.
    22 === t.code || 20 === t.code || // Firefox Private Browsing mode disables IndexedDb and returns
    // INVALID_STATE for any usage.
    11 === t.code;
}
async function $70fd6868680e912c$var$$a(t) {
    if (!t._offlineComponents) {
        if (t._uninitializedComponentsProvider) {
            $70fd6868680e912c$var$N("FirestoreClient", "Using user provided OfflineComponentProvider");
            try {
                await $70fd6868680e912c$var$Na(t, t._uninitializedComponentsProvider._offline);
            } catch (e) {
                const n = e;
                if (!$70fd6868680e912c$var$Ma(n)) throw n;
                $70fd6868680e912c$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n), await $70fd6868680e912c$var$Na(t, new $70fd6868680e912c$var$Ea);
            }
        } else $70fd6868680e912c$var$N("FirestoreClient", "Using default OfflineComponentProvider"), await $70fd6868680e912c$var$Na(t, new $70fd6868680e912c$var$Ea);
    }
    return t._offlineComponents;
}
async function $70fd6868680e912c$var$Oa(t) {
    return t._onlineComponents || (t._uninitializedComponentsProvider ? ($70fd6868680e912c$var$N("FirestoreClient", "Using user provided OnlineComponentProvider"), await $70fd6868680e912c$var$ka(t, t._uninitializedComponentsProvider._online)) : ($70fd6868680e912c$var$N("FirestoreClient", "Using default OnlineComponentProvider"), await $70fd6868680e912c$var$ka(t, new $70fd6868680e912c$var$Pa))), t._onlineComponents;
}
function $70fd6868680e912c$var$Fa(t) {
    return $70fd6868680e912c$var$$a(t).then((t)=>t.persistence);
}
function $70fd6868680e912c$var$Ba(t) {
    return $70fd6868680e912c$var$$a(t).then((t)=>t.localStore);
}
function $70fd6868680e912c$var$La(t) {
    return $70fd6868680e912c$var$Oa(t).then((t)=>t.remoteStore);
}
function $70fd6868680e912c$var$qa(t) {
    return $70fd6868680e912c$var$Oa(t).then((t)=>t.syncEngine);
}
function $70fd6868680e912c$var$Ua(t) {
    return $70fd6868680e912c$var$Oa(t).then((t)=>t.datastore);
}
async function $70fd6868680e912c$var$Ka(t) {
    const e = await $70fd6868680e912c$var$Oa(t), n = e.eventManager;
    return n.onListen = $70fd6868680e912c$var$Gc.bind(null, e.syncEngine), n.onUnlisten = $70fd6868680e912c$var$jc.bind(null, e.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $70fd6868680e912c$var$Ga(t) {
    return t.asyncQueue.enqueue(async ()=>{
        const e = await $70fd6868680e912c$var$Fa(t), n = await $70fd6868680e912c$var$La(t);
        return e.setNetworkEnabled(!0), function(t) {
            const e = $70fd6868680e912c$var$L(t);
            return e.vu.delete(0 /* OfflineCause.UserDisabled */ ), $70fd6868680e912c$var$zu(e);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $70fd6868680e912c$var$Qa(t) {
    return t.asyncQueue.enqueue(async ()=>{
        const e = await $70fd6868680e912c$var$Fa(t), n = await $70fd6868680e912c$var$La(t);
        return e.setNetworkEnabled(!1), async function(t) {
            const e = $70fd6868680e912c$var$L(t);
            e.vu.add(0 /* OfflineCause.UserDisabled */ ), await $70fd6868680e912c$var$Wu(e), // Set the OnlineState to Offline so get()s return from cache, etc.
            e.bu.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $70fd6868680e912c$var$ja(t, e) {
    const n = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueueAndForget(async ()=>(async function(t, e, n) {
            try {
                const s = await function(t, e) {
                    const n = $70fd6868680e912c$var$L(t);
                    return n.persistence.runTransaction("read document", "readonly", (t)=>n.localDocuments.getDocument(t, e));
                }(t, e);
                s.isFoundDocument() ? n.resolve(s) : s.isNoDocument() ? n.resolve(null) : n.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (t) {
                const s = $70fd6868680e912c$var$Ec(t, `Failed to get document '${e} from cache`);
                n.reject(s);
            }
        })(await $70fd6868680e912c$var$Ba(t), e, n)), n.promise;
}
function $70fd6868680e912c$var$za(t, e, n = {}) {
    const s = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e, n, s, i) {
            const r = new $70fd6868680e912c$var$Va({
                next: (r)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    e.enqueueAndForget(()=>$70fd6868680e912c$var$Sc(t, o));
                    const u = r.docs.has(n);
                    !u && r.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, "Failed to get document because the client is offline.")) : u && r.fromCache && s && "server" === s.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(r);
                },
                error: (t)=>i.reject(t)
            }), o = new $70fd6868680e912c$var$Nc($70fd6868680e912c$var$Gn(n.path), r, {
                includeMetadataChanges: !0,
                Ku: !0
            });
            return $70fd6868680e912c$var$Vc(t, o);
        })(await $70fd6868680e912c$var$Ka(t), t.asyncQueue, e, n, s)), s.promise;
}
function $70fd6868680e912c$var$Wa(t, e) {
    const n = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueueAndForget(async ()=>(async function(t, e, n) {
            try {
                const s = await $70fd6868680e912c$var$fu(t, e, /* usePreviousResults= */ !0), i = new $70fd6868680e912c$var$Lc(e, s.ir), r = i.sc(s.documents), o = i.applyChanges(r, /* updateLimboDocuments= */ !1);
                n.resolve(o.snapshot);
            } catch (t) {
                const s = $70fd6868680e912c$var$Ec(t, `Failed to execute query '${e} against cache`);
                n.reject(s);
            }
        })(await $70fd6868680e912c$var$Ba(t), e, n)), n.promise;
}
function $70fd6868680e912c$var$Ha(t, e, n = {}) {
    const s = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e, n, s, i) {
            const r = new $70fd6868680e912c$var$Va({
                next: (n)=>{
                    // Remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    e.enqueueAndForget(()=>$70fd6868680e912c$var$Sc(t, o)), n.fromCache && "server" === s.source ? i.reject(new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (t)=>i.reject(t)
            }), o = new $70fd6868680e912c$var$Nc(n, r, {
                includeMetadataChanges: !0,
                Ku: !0
            });
            return $70fd6868680e912c$var$Vc(t, o);
        })(await $70fd6868680e912c$var$Ka(t), t.asyncQueue, e, n, s)), s.promise;
}
function $70fd6868680e912c$var$Ja(t, e) {
    const n = new $70fd6868680e912c$var$Va(e);
    return t.asyncQueue.enqueueAndForget(async ()=>(function(t, e) {
            $70fd6868680e912c$var$L(t).ku.add(e), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            e.next();
        })(await $70fd6868680e912c$var$Ka(t), n)), ()=>{
        n.Dc(), t.asyncQueue.enqueueAndForget(async ()=>(function(t, e) {
                $70fd6868680e912c$var$L(t).ku.delete(e);
            })(await $70fd6868680e912c$var$Ka(t), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $70fd6868680e912c$var$Ya(t, e, n, s) {
    const i = function(t, e) {
        let n;
        n = "string" == typeof t ? $70fd6868680e912c$var$hi().encode(t) : t;
        return function(t, e) {
            return new $70fd6868680e912c$var$Sa(t, e);
        }(function(t, e) {
            if (t instanceof Uint8Array) return $70fd6868680e912c$var$ba(t, e);
            if (t instanceof ArrayBuffer) return $70fd6868680e912c$var$ba(new Uint8Array(t), e);
            if (t instanceof ReadableStream) return t.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), e);
    }(n, $70fd6868680e912c$var$Fu(e));
    t.asyncQueue.enqueueAndForget(async ()=>{
        $70fd6868680e912c$var$Ta(await $70fd6868680e912c$var$qa(t), i, s);
    });
}
function $70fd6868680e912c$var$Xa(t, e) {
    return t.asyncQueue.enqueue(async ()=>(function(t, e) {
            const n = $70fd6868680e912c$var$L(t);
            return n.persistence.runTransaction("Get named query", "readonly", (t)=>n.qs.getNamedQuery(t, e));
        })(await $70fd6868680e912c$var$Ba(t), e));
}
function $70fd6868680e912c$var$Za(t, e) {
    return t.asyncQueue.enqueue(async ()=>(async function(t, e) {
            const n = $70fd6868680e912c$var$L(t), s = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (t)=>s.getFieldIndexes(t).next((n)=>/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ (function(t, e, n, s, i) {
                        t = [
                            ...t
                        ], e = [
                            ...e
                        ], t.sort(n), e.sort(n);
                        const r = t.length, o = e.length;
                        let u = 0, c = 0;
                        for(; u < o && c < r;){
                            const r = n(t[c], e[u]);
                            r < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(t[c++]) : r > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            s(e[u++]) : (u++, c++);
                        }
                        for(; u < o;)s(e[u++]);
                        for(; c < r;)i(t[c++]);
                    })(n, e, $70fd6868680e912c$var$wt, (e)=>{
                        i.push(s.addFieldIndex(t, e));
                    }, (e)=>{
                        i.push(s.deleteFieldIndex(t, e));
                    })).next(()=>$70fd6868680e912c$var$Rt.waitFor(i)));
        })(await $70fd6868680e912c$var$Ba(t), e));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $70fd6868680e912c$var$th(t) {
    const e = {};
    return void 0 !== t.timeoutSeconds && (e.timeoutSeconds = t.timeoutSeconds), e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$eh = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$nh(t, e, n) {
    if (!n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Function ${t}() cannot be called with an empty ${e}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $70fd6868680e912c$export$8731e8d1617cddb1(t, e, n, s) {
    if (!0 === e && !0 === s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `${t} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $70fd6868680e912c$var$ih(t) {
    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${t} has ${t.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $70fd6868680e912c$var$rh(t) {
    if ($70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${t} has ${t.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $70fd6868680e912c$var$oh(t) {
    if (void 0 === t) return "undefined";
    if (null === t) return "null";
    if ("string" == typeof t) return t.length > 20 && (t = `${t.substring(0, 20)}...`), JSON.stringify(t);
    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
    if ("object" == typeof t) {
        if (t instanceof Array) return "an array";
        {
            const e = /** try to get the constructor name for an object. */ function(t) {
                if (t.constructor) return t.constructor.name;
                return null;
            }(t);
            return e ? `a custom ${e} object` : "an object";
        }
    }
    return "function" == typeof t ? "a function" : $70fd6868680e912c$var$O();
}
function $70fd6868680e912c$export$572106fb5803752c(t, // eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    if ("_delegate" in t && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (t = t._delegate), !(t instanceof e)) {
        if (e.name === t.constructor.name) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $70fd6868680e912c$var$oh(t);
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Expected type '${e.name}', but it was: ${n}`);
        }
    }
    return t;
}
function $70fd6868680e912c$var$ch(t, e) {
    if (e <= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Function ${t}() requires a positive number, but it was: ${e}.`);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $70fd6868680e912c$var$ah {
    constructor(t){
        var e, n;
        if (void 0 === t.host) {
            if (void 0 !== t.ssl) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = t.host, this.ssl = null === (e = t.ssl) || void 0 === e || e;
        if (this.credentials = t.credentials, this.ignoreUndefinedProperties = !!t.ignoreUndefinedProperties, this.cache = t.localCache, void 0 === t.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = t.cacheSizeBytes;
        }
        $70fd6868680e912c$export$8731e8d1617cddb1("experimentalForceLongPolling", t.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", t.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!t.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === t.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!t.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $70fd6868680e912c$var$th(null !== (n = t.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function(t) {
            if (void 0 !== t.timeoutSeconds) {
                if (isNaN(t.timeoutSeconds)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `invalid long polling timeout: ${t.timeoutSeconds} (must not be NaN)`);
                if (t.timeoutSeconds < 5) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `invalid long polling timeout: ${t.timeoutSeconds} (minimum allowed value is 5)`);
                if (t.timeoutSeconds > 30) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `invalid long polling timeout: ${t.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!t.useFetchStreams;
    }
    isEqual(t) {
        var e, n;
        return this.host === t.host && this.ssl === t.ssl && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.experimentalForceLongPolling === t.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === t.experimentalAutoDetectLongPolling && (e = this.experimentalLongPollingOptions, n = t.experimentalLongPollingOptions, e.timeoutSeconds === n.timeoutSeconds) && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties && this.useFetchStreams === t.useFetchStreams;
    }
}
class $70fd6868680e912c$var$hh {
    /** @hideconstructor */ constructor(t, e, n, s){
        this._authCredentials = t, this._appCheckCredentials = e, this._databaseId = n, this._app = s, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $70fd6868680e912c$var$ah({}), this._settingsFrozen = !1;
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return void 0 !== this._terminateTask;
    }
    _setSettings(t) {
        if (this._settingsFrozen) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $70fd6868680e912c$var$ah(t), void 0 !== t.credentials && (this._authCredentials = function(t) {
            if (!t) return new $70fd6868680e912c$export$65ffa50b6039c992;
            switch(t.type){
                case "firstParty":
                    return new $70fd6868680e912c$var$H(t.sessionIndex || "0", t.iamToken || null, t.authTokenFactory || null);
                case "provider":
                    return t.client;
                default:
                    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(t.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function(t) {
            const e = $70fd6868680e912c$var$eh.get(t);
            e && ($70fd6868680e912c$var$N("ComponentProvider", "Removing Datastore"), $70fd6868680e912c$var$eh.delete(t), e.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $70fd6868680e912c$export$966a03d25297d115(t, e, n, s = {}) {
    var i;
    const r = (t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$var$hh))._getSettings(), o = `${e}:${n}`;
    if ("firestore.googleapis.com" !== r.host && r.host !== o && $70fd6868680e912c$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), t._setSettings(Object.assign(Object.assign({}, r), {
        host: o,
        ssl: !1
    })), s.mockUserToken) {
        let e, n;
        if ("string" == typeof s.mockUserToken) e = s.mockUserToken, n = $70fd6868680e912c$var$V.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            e = (0, $c38e0f42709c826a$export$367bf224123348f1)(s.mockUserToken, null === (i = t._app) || void 0 === i ? void 0 : i.options.projectId);
            const r = s.mockUserToken.sub || s.mockUserToken.user_id;
            if (!r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $70fd6868680e912c$var$V(r);
        }
        t._authCredentials = new $70fd6868680e912c$var$j(new $70fd6868680e912c$var$G(e, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $70fd6868680e912c$export$6be62b059fb12175 {
    /** @hideconstructor */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n){
        this.converter = e, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = t;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, t, this._key);
    }
}
/**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $70fd6868680e912c$export$62297b13309008b2 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(t, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ e, n){
        this.converter = e, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = t;
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$62297b13309008b2(this.firestore, t, this._query);
    }
}
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $70fd6868680e912c$export$ab5a1a47940a200e extends $70fd6868680e912c$export$62297b13309008b2 {
    /** @hideconstructor */ constructor(t, e, n){
        super(t, e, $70fd6868680e912c$var$Gn(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const t = this._path.popLast();
        return t.isEmpty() ? null : new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(t));
    }
    withConverter(t) {
        return new $70fd6868680e912c$export$ab5a1a47940a200e(this.firestore, t, this._path);
    }
}
function $70fd6868680e912c$export$bf5175b0c24981cd(t, e, ...n) {
    if (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), $70fd6868680e912c$var$nh("collection", "path", e), t instanceof $70fd6868680e912c$var$hh) {
        const s = $70fd6868680e912c$var$ut.fromString(e, ...n);
        return $70fd6868680e912c$var$rh(s), new $70fd6868680e912c$export$ab5a1a47940a200e(t, /* converter= */ null, s);
    }
    {
        if (!(t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const s = t._path.child($70fd6868680e912c$var$ut.fromString(e, ...n));
        return $70fd6868680e912c$var$rh(s), new $70fd6868680e912c$export$ab5a1a47940a200e(t.firestore, /* converter= */ null, s);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $70fd6868680e912c$export$473d82a73f88c107(t, e) {
    if (t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$var$hh), $70fd6868680e912c$var$nh("collectionGroup", "collection id", e), e.indexOf("/") >= 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid collection ID '${e}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $70fd6868680e912c$export$62297b13309008b2(t, /* converter= */ null, function(t) {
        return new $70fd6868680e912c$var$Un($70fd6868680e912c$var$ut.emptyPath(), t);
    }(e));
}
function $70fd6868680e912c$export$2a111da947c407d2(t, e, ...n) {
    if (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (e = $70fd6868680e912c$var$tt.A()), $70fd6868680e912c$var$nh("doc", "path", e), t instanceof $70fd6868680e912c$var$hh) {
        const s = $70fd6868680e912c$var$ut.fromString(e, ...n);
        return $70fd6868680e912c$var$ih(s), new $70fd6868680e912c$export$6be62b059fb12175(t, /* converter= */ null, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
    {
        if (!(t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const s = t._path.child($70fd6868680e912c$var$ut.fromString(e, ...n));
        return $70fd6868680e912c$var$ih(s), new $70fd6868680e912c$export$6be62b059fb12175(t.firestore, t instanceof $70fd6868680e912c$export$ab5a1a47940a200e ? t.converter : null, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$62a32f2da6187d11(t, e) {
    return t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), (t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && (e instanceof $70fd6868680e912c$export$6be62b059fb12175 || e instanceof $70fd6868680e912c$export$ab5a1a47940a200e) && t.firestore === e.firestore && t.path === e.path && t.converter === e.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $70fd6868680e912c$export$49b1d0de6ba30f41(t, e) {
    return t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t), e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e), t instanceof $70fd6868680e912c$export$62297b13309008b2 && e instanceof $70fd6868680e912c$export$62297b13309008b2 && t.firestore === e.firestore && $70fd6868680e912c$var$Zn(t._query, e._query) && t.converter === e.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $70fd6868680e912c$var$Ih {
    constructor(){
        // The last promise in the queue.
        this.Gc = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Qc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.jc = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.zc = [], // visible for testing
        this.Wc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Hc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Jc = !1, // List of TimerIds to fast-forward delays for.
        this.Yc = [], // Backoff timer used to schedule retries for retryable operations
        this.qo = new $70fd6868680e912c$var$Bu(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.Xc = ()=>{
            const t = $70fd6868680e912c$var$Ou();
            t && $70fd6868680e912c$var$N("AsyncQueue", "Visibility state changed to " + t.visibilityState), this.qo.Mo();
        };
        const t = $70fd6868680e912c$var$Ou();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.Xc);
    }
    get isShuttingDown() {
        return this.jc;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(t) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(t);
    }
    enqueueAndForgetEvenWhileRestricted(t) {
        this.Zc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.ta(t);
    }
    enterRestrictedMode(t) {
        if (!this.jc) {
            this.jc = !0, this.Jc = t || !1;
            const e = $70fd6868680e912c$var$Ou();
            e && "function" == typeof e.removeEventListener && e.removeEventListener("visibilitychange", this.Xc);
        }
    }
    enqueue(t) {
        if (this.Zc(), this.jc) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const e = new $70fd6868680e912c$var$K;
        return this.ta(()=>this.jc && this.Jc ? Promise.resolve() : (t().then(e.resolve, e.reject), e.promise)).then(()=>e.promise);
    }
    enqueueRetryable(t) {
        this.enqueueAndForget(()=>(this.Qc.push(t), this.ea()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async ea() {
        if (0 !== this.Qc.length) {
            try {
                await this.Qc[0](), this.Qc.shift(), this.qo.reset();
            } catch (t) {
                if (!$70fd6868680e912c$var$Dt(t)) throw t;
                // Failure will be handled by AsyncQueue
                $70fd6868680e912c$var$N("AsyncQueue", "Operation failed with retryable error: " + t);
            }
            this.Qc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.qo.No(()=>this.ea());
        }
    }
    ta(t) {
        const e = this.Gc.then(()=>(this.Hc = !0, t().catch((t)=>{
                this.Wc = t, this.Hc = !1;
                const e = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function(t) {
                    let e = t.message || "";
                    t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack);
                    return e;
                }(t);
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $70fd6868680e912c$var$k("INTERNAL UNHANDLED ERROR: ", e), t;
            }).then((t)=>(this.Hc = !1, t))));
        return this.Gc = e, e;
    }
    enqueueAfterDelay(t, e, n) {
        this.Zc(), // Fast-forward delays for timerIds that have been overriden.
        this.Yc.indexOf(t) > -1 && (e = 0);
        const s = $70fd6868680e912c$var$Tc.createAndSchedule(this, t, e, n, (t)=>this.na(t));
        return this.zc.push(s), s;
    }
    Zc() {
        this.Wc && $70fd6868680e912c$var$O();
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async sa() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let t;
        do t = this.Gc, await t;
        while (t !== this.Gc);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ ia(t) {
        for (const e of this.zc)if (e.timerId === t) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ ra(t) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.sa().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            this.zc.sort((t, e)=>t.targetTimeMs - e.targetTimeMs);
            for (const e of this.zc)if (e.skipDelay(), "all" /* TimerId.All */  !== t && e.timerId === t) break;
            return this.sa();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ oa(t) {
        this.Yc.push(t);
    }
    /** Called once a DelayedOperation is run or canceled. */ na(t) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const e = this.zc.indexOf(t);
        this.zc.splice(e, 1);
    }
}
function $70fd6868680e912c$var$Th(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
class $70fd6868680e912c$export$6cac12425252ec14 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $70fd6868680e912c$var$K, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(t, e, n) {
        this._progressObserver = {
            next: t,
            error: e,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(t) {
        return this._taskCompletionResolver.promise.catch(t);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(t, e) {
        return this._taskCompletionResolver.promise.then(t, e);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(t) {
        this._updateProgress(t), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(t);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(t) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(t), this._taskCompletionResolver.reject(t);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(t) {
        this._lastProgress = t, this._progressObserver.next && this._progressObserver.next(t);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $70fd6868680e912c$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $70fd6868680e912c$export$d0e2b3272814ce82 extends $70fd6868680e912c$var$hh {
    /** @hideconstructor */ constructor(t, e, n, s){
        super(t, e, n, s), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $70fd6868680e912c$var$Ih, this._persistenceKey = (null == s ? void 0 : s.name) || "[DEFAULT]";
    }
    _terminate() {
        return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
        // usage throws an exception.
        $70fd6868680e912c$var$Vh(this), this._firestoreClient.terminate();
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $70fd6868680e912c$export$9061557f3e3b42f9(t, e, n) {
    n || (n = "(default)");
    const s = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(t, "firestore");
    if (s.isInitialized(n)) {
        const t = s.getImmediate({
            identifier: n
        }), i = s.getOptions(n);
        if ((0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(i, e)) return t;
        throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== e.cacheSizeBytes && void 0 !== e.localCache) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== e.cacheSizeBytes && -1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return s.initialize({
        options: e,
        instanceIdentifier: n
    });
}
function $70fd6868680e912c$export$f06a05d14c3a6678(e, n) {
    const s = "object" == typeof e ? e : (0, $57d436074e210fb5$export$f9962582c9e66d99)(), i = "string" == typeof e ? e : n || "(default)", r = (0, $57d436074e210fb5$export$fa0d6da0f5838f50)(s, "firestore").getImmediate({
        identifier: i
    });
    if (!r._initialized) {
        const t = (0, $c38e0f42709c826a$export$a3febcf1f14a3a0c)("firestore");
        t && $70fd6868680e912c$export$966a03d25297d115(r, ...t);
    }
    return r;
}
/**
 * @internal
 */ function $70fd6868680e912c$export$8da5fbea04405656(t) {
    return t._firestoreClient || $70fd6868680e912c$var$Vh(t), t._firestoreClient.verifyNotTerminated(), t._firestoreClient;
}
function $70fd6868680e912c$var$Vh(t) {
    var e, n, s;
    const i = t._freezeSettings(), r = function(t, e, n, s) {
        return new $70fd6868680e912c$var$$e(t, e, n, s.host, s.ssl, s.experimentalForceLongPolling, s.experimentalAutoDetectLongPolling, $70fd6868680e912c$var$th(s.experimentalLongPollingOptions), s.useFetchStreams);
    }(t._databaseId, (null === (e = t._app) || void 0 === e ? void 0 : e.options.appId) || "", t._persistenceKey, i);
    t._firestoreClient = new $70fd6868680e912c$var$xa(t._authCredentials, t._appCheckCredentials, t._queue, r), (null === (n = i.cache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (s = i.cache) || void 0 === s ? void 0 : s._onlineComponentProvider) && (t._firestoreClient._uninitializedComponentsProvider = {
        _offlineKind: i.cache.kind,
        _offline: i.cache._offlineComponentProvider,
        _online: i.cache._onlineComponentProvider
    });
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * Must be called before any other functions (other than
 * {@link initializeFirestore}, {@link (getFirestore:1)} or
 * {@link clearIndexedDbPersistence}.
 *
 * If this fails, `enableIndexedDbPersistence()` will reject the promise it
 * returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * Persistence cannot be used in a Node.js environment.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.cache` to an instance of `IndexedDbLocalCache` to
 * turn on IndexedDb cache. Calling this function when `FirestoreSettings.cache`
 * is already specified will throw an exception.
 */ function $70fd6868680e912c$export$cebe3b626a79c5f3(t, e) {
    $70fd6868680e912c$var$Bh(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    const n = $70fd6868680e912c$export$8da5fbea04405656(t);
    if (n._uninitializedComponentsProvider) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "SDK cache is already specified.");
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const s = t._freezeSettings(), i = new $70fd6868680e912c$var$Pa;
    return $70fd6868680e912c$var$Ch(n, i, new $70fd6868680e912c$var$va(i, s.cacheSizeBytes, null == e ? void 0 : e.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * If this fails, `enableMultiTabIndexedDbPersistence()` will reject the promise
 * it returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.cache` to an instance of `IndexedDbLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.cache`
 * is already specified will throw an exception.
 */ function $70fd6868680e912c$export$6d4c055e91302ab9(t) {
    $70fd6868680e912c$var$Bh(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    const e = $70fd6868680e912c$export$8da5fbea04405656(t);
    if (e._uninitializedComponentsProvider) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "SDK cache is already specified.");
    $70fd6868680e912c$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = t._freezeSettings(), s = new $70fd6868680e912c$var$Pa;
    return $70fd6868680e912c$var$Ch(e, s, new $70fd6868680e912c$var$Ra(s, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $70fd6868680e912c$var$Ch(t, e, n) {
    const s = new $70fd6868680e912c$var$K;
    return t.asyncQueue.enqueue(async ()=>{
        try {
            await $70fd6868680e912c$var$Na(t, n), await $70fd6868680e912c$var$ka(t, e), s.resolve();
        } catch (t) {
            const e = t;
            if (!$70fd6868680e912c$var$Ma(e)) throw e;
            $70fd6868680e912c$export$86cd73f49cc6e0bb("Error enabling indexeddb cache. Falling back to memory cache: " + e), s.reject(e);
        }
    }).then(()=>s.promise);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $70fd6868680e912c$export$b4f5899b4e28cf7b(t) {
    if (t._initialized && !t._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const e = new $70fd6868680e912c$var$K;
    return t._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function(t) {
                if (!$70fd6868680e912c$var$bt.D()) return Promise.resolve();
                const e = t + "main";
                await $70fd6868680e912c$var$bt.delete(e);
            }($70fd6868680e912c$var$Zo(t._databaseId, t._persistenceKey)), e.resolve();
        } catch (t) {
            e.reject(t);
        }
    }), e.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $70fd6868680e912c$export$50b5113fd6653025(t) {
    return function(t) {
        const e = new $70fd6868680e912c$var$K;
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$Zc(await $70fd6868680e912c$var$qa(t), e)), e.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $70fd6868680e912c$export$ee6bdee8287ecc5f(t) {
    return $70fd6868680e912c$var$Ga($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $70fd6868680e912c$export$f35b708ad73d52eb(t) {
    return $70fd6868680e912c$var$Qa($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $70fd6868680e912c$export$9aff22d1ec357a14(t) {
    return (0, $57d436074e210fb5$export$48d18de2ff1c45a5)(t.app, "firestore", t._databaseId.database), t._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $70fd6868680e912c$export$4b8b93c690c9810b(t, e) {
    const n = $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), s = new $70fd6868680e912c$export$6cac12425252ec14;
    return $70fd6868680e912c$var$Ya(n, t._databaseId, e, s), s;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $70fd6868680e912c$export$169d2c6fe0f7f4ea(t, e) {
    return $70fd6868680e912c$var$Xa($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), e).then((e)=>e ? new $70fd6868680e912c$export$62297b13309008b2(t, null, e.query) : null);
}
function $70fd6868680e912c$var$Bh(t) {
    if (t._initialized || t._terminated) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $70fd6868680e912c$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param _aggregateType Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(// TODO (sum/avg) make aggregateType public when the feature is supported
    t = "count", e){
        this._aggregateType = t, this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField";
    }
}
/**
 * The results of executing an aggregation query.
 */ class $70fd6868680e912c$export$40257fef64be808b {
    /** @hideconstructor */ constructor(t, e, n){
        this._userDataWriter = e, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $70fd6868680e912c$export$9f55f2e2bf8c2fc1 {
    /** @hideconstructor */ constructor(t){
        this._byteString = t;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(t) {
        try {
            return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$var$Ve.fromBase64String(t));
        } catch (t) {
            throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + t);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1($70fd6868680e912c$var$Ve.fromUint8Array(t));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(t) {
        return this._byteString.isEqual(t._byteString);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $70fd6868680e912c$export$a1a8fea822d17659 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...t){
        for(let e = 0; e < t.length; ++e)if (0 === t[e].length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $70fd6868680e912c$export$b7871852b967eaf1(t);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(t) {
        return this._internalPath.isEqual(t._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $70fd6868680e912c$export$bf6e62266977b8eb() {
    return new $70fd6868680e912c$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $70fd6868680e912c$export$c58bc8ee7ecc248d {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(t){
        this._methodName = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $70fd6868680e912c$export$f9f719d1b6419c4 {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(t, e){
        if (!isFinite(t) || t < -90 || t > 90) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
        if (!isFinite(e) || e < -180 || e > 180) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
        this._lat = t, this._long = e;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(t) {
        return this._lat === t._lat && this._long === t._long;
    }
    /** Returns a JSON-serializable representation of this GeoPoint. */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long
        };
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(t) {
        return $70fd6868680e912c$var$et(this._lat, t._lat) || $70fd6868680e912c$var$et(this._long, t._long);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$zh = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $70fd6868680e912c$var$Wh {
    constructor(t, e, n){
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
    toMutation(t, e) {
        return null !== this.fieldMask ? new $70fd6868680e912c$var$zs(t, this.data, this.fieldMask, e, this.fieldTransforms) : new $70fd6868680e912c$var$js(t, this.data, e, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $70fd6868680e912c$var$Hh {
    constructor(t, // The fieldMask does not include document transforms.
    e, n){
        this.data = t, this.fieldMask = e, this.fieldTransforms = n;
    }
    toMutation(t, e) {
        return new $70fd6868680e912c$var$zs(t, this.data, this.fieldMask, e, this.fieldTransforms);
    }
}
function $70fd6868680e912c$var$Jh(t) {
    switch(t){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $70fd6868680e912c$var$O();
    }
}
/** A "context" object passed around while parsing user data. */ class $70fd6868680e912c$var$Yh {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(t, e, n, s, i, r){
        this.settings = t, this.databaseId = e, this.serializer = n, this.ignoreUndefinedProperties = s, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.ua(), this.fieldTransforms = i || [], this.fieldMask = r || [];
    }
    get path() {
        return this.settings.path;
    }
    get ca() {
        return this.settings.ca;
    }
    /** Returns a new context with the specified settings overwritten. */ aa(t) {
        return new $70fd6868680e912c$var$Yh(Object.assign(Object.assign({}, this.settings), t), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    ha(t) {
        var e;
        const n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), s = this.aa({
            path: n,
            la: !1
        });
        return s.fa(t), s;
    }
    da(t) {
        var e;
        const n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), s = this.aa({
            path: n,
            la: !1
        });
        return s.ua(), s;
    }
    wa(t) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.aa({
            path: void 0,
            la: !0
        });
    }
    _a(t) {
        return $70fd6868680e912c$var$gl(t, this.settings.methodName, this.settings.ma || !1, this.path, this.settings.ga);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(t) {
        return void 0 !== this.fieldMask.find((e)=>t.isPrefixOf(e)) || void 0 !== this.fieldTransforms.find((e)=>t.isPrefixOf(e.field));
    }
    ua() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let t = 0; t < this.path.length; t++)this.fa(this.path.get(t));
    }
    fa(t) {
        if (0 === t.length) throw this._a("Document fields must not be empty");
        if ($70fd6868680e912c$var$Jh(this.ca) && $70fd6868680e912c$var$zh.test(t)) throw this._a('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $70fd6868680e912c$var$Xh {
    constructor(t, e, n){
        this.databaseId = t, this.ignoreUndefinedProperties = e, this.serializer = n || $70fd6868680e912c$var$Fu(t);
    }
    /** Creates a new top-level parse context. */ ya(t, e, n, s = !1) {
        return new $70fd6868680e912c$var$Yh({
            ca: t,
            methodName: e,
            ga: n,
            path: $70fd6868680e912c$export$b7871852b967eaf1.emptyPath(),
            la: !1,
            ma: s
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $70fd6868680e912c$var$Zh(t) {
    const e = t._freezeSettings(), n = $70fd6868680e912c$var$Fu(t._databaseId);
    return new $70fd6868680e912c$var$Xh(t._databaseId, !!e.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $70fd6868680e912c$var$tl(t, e, n, s, i, r = {}) {
    const o = t.ya(r.merge || r.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , e, n, i);
    $70fd6868680e912c$var$dl("Data must be an object, but it was:", o, s);
    const u = $70fd6868680e912c$var$ll(s, o);
    let c, a;
    if (r.merge) c = new $70fd6868680e912c$var$Re(o.fieldMask), a = o.fieldTransforms;
    else if (r.mergeFields) {
        const t = [];
        for (const s of r.mergeFields){
            const i = $70fd6868680e912c$var$wl(e, s, n);
            if (!o.contains(i)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $70fd6868680e912c$var$yl(t, i) || t.push(i);
        }
        c = new $70fd6868680e912c$var$Re(t), a = o.fieldTransforms.filter((t)=>c.covers(t.field));
    } else c = null, a = o.fieldTransforms;
    return new $70fd6868680e912c$var$Wh(new $70fd6868680e912c$var$un(u), c, a);
}
class $70fd6868680e912c$var$el extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        if (2 /* UserDataSource.MergeSet */  !== t.ca) throw 1 /* UserDataSource.Update */  === t.ca ? t._a(`${this._methodName}() can only appear at the top level of your update data`) : t._a(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return t.fieldMask.push(t.path), null;
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$el;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $70fd6868680e912c$var$nl(t, e, n) {
    return new $70fd6868680e912c$var$Yh({
        ca: 3 /* UserDataSource.Argument */ ,
        ga: e.settings.ga,
        methodName: t._methodName,
        la: n
    }, e.databaseId, e.serializer, e.ignoreUndefinedProperties);
}
class $70fd6868680e912c$var$sl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    _toFieldTransform(t) {
        return new $70fd6868680e912c$var$Ms(t.path, new $70fd6868680e912c$var$bs);
    }
    isEqual(t) {
        return t instanceof $70fd6868680e912c$var$sl;
    }
}
class $70fd6868680e912c$var$il extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.pa = e;
    }
    _toFieldTransform(t) {
        const e = $70fd6868680e912c$var$nl(this, t, /*array=*/ !0), n = this.pa.map((t)=>$70fd6868680e912c$var$hl(t, e)), s = new $70fd6868680e912c$var$Vs(n);
        return new $70fd6868680e912c$var$Ms(t.path, s);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
class $70fd6868680e912c$var$rl extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.pa = e;
    }
    _toFieldTransform(t) {
        const e = $70fd6868680e912c$var$nl(this, t, /*array=*/ !0), n = this.pa.map((t)=>$70fd6868680e912c$var$hl(t, e)), s = new $70fd6868680e912c$var$Ds(n);
        return new $70fd6868680e912c$var$Ms(t.path, s);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
class $70fd6868680e912c$var$ol extends $70fd6868680e912c$export$c58bc8ee7ecc248d {
    constructor(t, e){
        super(t), this.Ia = e;
    }
    _toFieldTransform(t) {
        const e = new $70fd6868680e912c$var$xs(t.serializer, $70fd6868680e912c$var$Es(t.serializer, this.Ia));
        return new $70fd6868680e912c$var$Ms(t.path, e);
    }
    isEqual(t) {
        // TODO(mrschmidt): Implement isEquals
        return this === t;
    }
}
/** Parse update data from an update() call. */ function $70fd6868680e912c$var$ul(t, e, n, s) {
    const i = t.ya(1 /* UserDataSource.Update */ , e, n);
    $70fd6868680e912c$var$dl("Data must be an object, but it was:", i, s);
    const r = [], o = $70fd6868680e912c$var$un.empty();
    $70fd6868680e912c$var$ge(s, (t, s)=>{
        const u = $70fd6868680e912c$var$ml(e, t, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        s = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(s);
        const c = i.da(u);
        if (s instanceof $70fd6868680e912c$var$el) // Add it to the field mask, but don't add anything to updateData.
        r.push(u);
        else {
            const t = $70fd6868680e912c$var$hl(s, c);
            null != t && (r.push(u), o.set(u, t));
        }
    });
    const u = new $70fd6868680e912c$var$Re(r);
    return new $70fd6868680e912c$var$Hh(o, u, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $70fd6868680e912c$var$cl(t, e, n, s, i, r) {
    const o = t.ya(1 /* UserDataSource.Update */ , e, n), u = [
        $70fd6868680e912c$var$wl(e, s, n)
    ], c = [
        i
    ];
    if (r.length % 2 != 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Function ${e}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let t = 0; t < r.length; t += 2)u.push($70fd6868680e912c$var$wl(e, r[t])), c.push(r[t + 1]);
    const a = [], h = $70fd6868680e912c$var$un.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let t = u.length - 1; t >= 0; --t)if (!$70fd6868680e912c$var$yl(a, u[t])) {
        const e = u[t];
        let n = c[t];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n);
        const s = o.da(e);
        if (n instanceof $70fd6868680e912c$var$el) // Add it to the field mask, but don't add anything to updateData.
        a.push(e);
        else {
            const t = $70fd6868680e912c$var$hl(n, s);
            null != t && (a.push(e), h.set(e, t));
        }
    }
    const l = new $70fd6868680e912c$var$Re(a);
    return new $70fd6868680e912c$var$Hh(h, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $70fd6868680e912c$var$al(t, e, n, s = !1) {
    return $70fd6868680e912c$var$hl(n, t.ya(s ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , e));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $70fd6868680e912c$var$hl(t, e) {
    if ($70fd6868680e912c$var$fl(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t))) return $70fd6868680e912c$var$dl("Unsupported field value:", e, t), $70fd6868680e912c$var$ll(t, e);
    if (t instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function(t, e) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$70fd6868680e912c$var$Jh(e.ca)) throw e._a(`${t._methodName}() can only be used with update() and set()`);
        if (!e.path) throw e._a(`${t._methodName}() is not currently supported inside arrays`);
        const n = t._toFieldTransform(e);
        n && e.fieldTransforms.push(n);
    }(t, e), null;
    if (void 0 === t && e.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    e.path && e.fieldMask.push(e.path), t instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (e.settings.la && 4 /* UserDataSource.ArrayArgument */  !== e.ca) throw e._a("Nested arrays are not supported");
        return function(t, e) {
            const n = [];
            let s = 0;
            for (const i of t){
                let t = $70fd6868680e912c$var$hl(i, e.wa(s));
                null == t && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (t = {
                    nullValue: "NULL_VALUE"
                }), n.push(t), s++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(t, e);
    }
    return function(t, e) {
        if (null === (t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof t) return $70fd6868680e912c$var$Es(e.serializer, t);
        if ("boolean" == typeof t) return {
            booleanValue: t
        };
        if ("string" == typeof t) return {
            stringValue: t
        };
        if (t instanceof Date) {
            const n = $70fd6868680e912c$export$d9bcbd5e1ff81430.fromDate(t);
            return {
                timestampValue: $70fd6868680e912c$var$Di(e.serializer, n)
            };
        }
        if (t instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $70fd6868680e912c$export$d9bcbd5e1ff81430(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
            return {
                timestampValue: $70fd6868680e912c$var$Di(e.serializer, n)
            };
        }
        if (t instanceof $70fd6868680e912c$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: t.latitude,
                longitude: t.longitude
            }
        };
        if (t instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $70fd6868680e912c$var$Ci(e.serializer, t._byteString)
        };
        if (t instanceof $70fd6868680e912c$export$6be62b059fb12175) {
            const n = e.databaseId, s = t.firestore._databaseId;
            if (!s.isEqual(n)) throw e._a(`Document reference is for database ${s.projectId}/${s.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $70fd6868680e912c$var$ki(t.firestore._databaseId || e.databaseId, t._key.path)
            };
        }
        throw e._a(`Unsupported field value: ${$70fd6868680e912c$var$oh(t)}`);
    }(t, e);
}
function $70fd6868680e912c$var$ll(t, e) {
    const n = {};
    return $70fd6868680e912c$var$ye(t) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    e.path && e.path.length > 0 && e.fieldMask.push(e.path) : $70fd6868680e912c$var$ge(t, (t, s)=>{
        const i = $70fd6868680e912c$var$hl(s, e.ha(t));
        null != i && (n[t] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $70fd6868680e912c$var$fl(t) {
    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof $70fd6868680e912c$export$d9bcbd5e1ff81430 || t instanceof $70fd6868680e912c$export$f9f719d1b6419c4 || t instanceof $70fd6868680e912c$export$9f55f2e2bf8c2fc1 || t instanceof $70fd6868680e912c$export$6be62b059fb12175 || t instanceof $70fd6868680e912c$export$c58bc8ee7ecc248d);
}
function $70fd6868680e912c$var$dl(t, e, n) {
    if (!$70fd6868680e912c$var$fl(n) || !function(t) {
        return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
    }(n)) {
        const s = $70fd6868680e912c$var$oh(n);
        throw "an object" === s ? e._a(t + " a custom object") : e._a(t + " " + s);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $70fd6868680e912c$var$wl(t, e, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) instanceof $70fd6868680e912c$export$a1a8fea822d17659) return e._internalPath;
    if ("string" == typeof e) return $70fd6868680e912c$var$ml(t, e);
    throw $70fd6868680e912c$var$gl("Field path arguments must be of type string or ", t, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $70fd6868680e912c$var$_l = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $70fd6868680e912c$var$ml(t, e, n) {
    if (e.search($70fd6868680e912c$var$_l) >= 0) throw $70fd6868680e912c$var$gl(`Invalid field path (${e}). Paths must not contain '~', '*', '/', '[', or ']'`, t, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $70fd6868680e912c$export$a1a8fea822d17659(...e.split("."))._internalPath;
    } catch (s) {
        throw $70fd6868680e912c$var$gl(`Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, t, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $70fd6868680e912c$var$gl(t, e, n, s, i) {
    const r = s && !s.isEmpty(), o = void 0 !== i;
    let u = `Function ${e}() called with invalid data`;
    n && (u += " (via `toFirestore()`)"), u += ". ";
    let c = "";
    return (r || o) && (c += " (found", r && (c += ` in field ${s}`), o && (c += ` in document ${i}`), c += ")"), new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, u + t + c);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $70fd6868680e912c$var$yl(t, e) {
    return t.some((t)=>t.isEqual(e));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$var$pl {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, s, i){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = s, this._converter = i;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new $70fd6868680e912c$export$6be62b059fb12175(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $70fd6868680e912c$var$Il(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field($70fd6868680e912c$var$Tl("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$var$Il extends $70fd6868680e912c$var$pl {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $70fd6868680e912c$var$Tl(t, e) {
    return "string" == typeof e ? $70fd6868680e912c$var$ml(t, e) : e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? e._internalPath : e._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$var$El(t) {
    if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $70fd6868680e912c$var$Al {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $70fd6868680e912c$export$b0e86f2c7431df4e extends $70fd6868680e912c$var$Al {
}
function $70fd6868680e912c$export$2fa187e846a241c4(t, e, ...n) {
    let s = [];
    e instanceof $70fd6868680e912c$var$Al && s.push(e), s = s.concat(n), function(t) {
        const e = t.filter((t)=>t instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2).length, n = t.filter((t)=>t instanceof $70fd6868680e912c$export$f765fc5789dfd439).length;
        if (e > 1 || e > 0 && n > 0) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(s);
    for (const e of s)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $70fd6868680e912c$export$f765fc5789dfd439 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e, n){
        super(), this._field = t, this._op = e, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, n) {
        return new $70fd6868680e912c$export$f765fc5789dfd439(t, e, n);
    }
    _apply(t) {
        const e = this._parse(t);
        return $70fd6868680e912c$var$Ql(t._query, e), new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, $70fd6868680e912c$var$Yn(t._query, e));
    }
    _parse(t) {
        const e = $70fd6868680e912c$var$Zh(t.firestore), n = function(t, e, n, s, i, r, o) {
            let u;
            if (i.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === r || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === r) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid Query. You can't perform '${r}' queries on documentId().`);
                if ("in" /* Operator.IN */  === r || "not-in" /* Operator.NOT_IN */  === r) {
                    $70fd6868680e912c$var$Gl(o, r);
                    const e = [];
                    for (const n of o)e.push($70fd6868680e912c$var$Kl(s, t, n));
                    u = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else u = $70fd6868680e912c$var$Kl(s, t, o);
            } else "in" /* Operator.IN */  !== r && "not-in" /* Operator.NOT_IN */  !== r && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== r || $70fd6868680e912c$var$Gl(o, r), u = $70fd6868680e912c$var$al(n, e, o, /* allowArrays= */ "in" /* Operator.IN */  === r || "not-in" /* Operator.NOT_IN */  === r);
            return $70fd6868680e912c$var$mn.create(i, r, u);
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $70fd6868680e912c$export$9c59b80dda569a6e(t, e, n) {
    const s = e, i = $70fd6868680e912c$var$Tl("where", t);
    return $70fd6868680e912c$export$f765fc5789dfd439._create(i, s, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $70fd6868680e912c$export$6bbc7aef0717f3d2 extends $70fd6868680e912c$var$Al {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new $70fd6868680e912c$export$6bbc7aef0717f3d2(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : $70fd6868680e912c$var$gn.create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function(t, e) {
            let n = t;
            const s = e.getFlattenedFilters();
            for (const t of s)$70fd6868680e912c$var$Ql(n, t), n = $70fd6868680e912c$var$Yn(n, t);
        }(t._query, e), new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, $70fd6868680e912c$var$Yn(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$252bb8b3bbdf6749(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$70fd6868680e912c$var$zl("or", t)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $70fd6868680e912c$export$21c0ac7fe1cef1b8(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$70fd6868680e912c$var$zl("and", t)), $70fd6868680e912c$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $70fd6868680e912c$export$65a9ba8bbd6ed9e3 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new $70fd6868680e912c$export$65a9ba8bbd6ed9e3(t, e);
    }
    _apply(t) {
        const e = function(t, e, n) {
            if (null !== t.startAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const s = new $70fd6868680e912c$var$dn(e, n);
            return function(t, e) {
                if (null === $70fd6868680e912c$var$jn(t)) {
                    // This is the first order by. It must match any inequality.
                    const n = $70fd6868680e912c$var$zn(t);
                    null !== n && $70fd6868680e912c$var$jl(t, n, e.field);
                }
            }(t, s), s;
        }(t._query, this._field, this._direction);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            // TODO(dimond): validate that orderBy does not list the same key twice.
            const n = t.explicitOrderBy.concat([
                e
            ]);
            return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, n, t.filters.slice(), t.limit, t.limitType, t.startAt, t.endAt);
        }(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $70fd6868680e912c$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, s = $70fd6868680e912c$var$Tl("orderBy", t);
    return $70fd6868680e912c$export$65a9ba8bbd6ed9e3._create(s, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $70fd6868680e912c$export$49bb5356ca788047 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._limit = e, this._limitType = n;
    }
    static _create(t, e, n) {
        return new $70fd6868680e912c$export$49bb5356ca788047(t, e, n);
    }
    _apply(t) {
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, $70fd6868680e912c$var$Xn(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$ee37e834aaad6f7e(t) {
    return $70fd6868680e912c$var$ch("limit", t), $70fd6868680e912c$export$49bb5356ca788047._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $70fd6868680e912c$export$f823b3589f69d3b8(t) {
    return $70fd6868680e912c$var$ch("limitToLast", t), $70fd6868680e912c$export$49bb5356ca788047._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $70fd6868680e912c$export$d92e2830aca1d816 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $70fd6868680e912c$export$d92e2830aca1d816(t, e, n);
    }
    _apply(t) {
        const e = $70fd6868680e912c$var$Ul(t, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, e, t.endAt);
        }(t._query, e));
    }
}
function $70fd6868680e912c$export$859941c5fc8eba6b(...t) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAt", t, /*inclusive=*/ !0);
}
function $70fd6868680e912c$export$dd8dee5f7b804673(...t) {
    return $70fd6868680e912c$export$d92e2830aca1d816._create("startAfter", t, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $70fd6868680e912c$export$fd1782fd870d1e06 extends $70fd6868680e912c$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $70fd6868680e912c$export$fd1782fd870d1e06(t, e, n);
    }
    _apply(t) {
        const e = $70fd6868680e912c$var$Ul(t, this.type, this._docOrFields, this._inclusive);
        return new $70fd6868680e912c$export$62297b13309008b2(t.firestore, t.converter, function(t, e) {
            return new $70fd6868680e912c$var$Un(t.path, t.collectionGroup, t.explicitOrderBy.slice(), t.filters.slice(), t.limit, t.limitType, t.startAt, e);
        }(t._query, e));
    }
}
function $70fd6868680e912c$export$57203950645b8b11(...t) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endBefore", t, /*inclusive=*/ !1);
}
function $70fd6868680e912c$export$28ec54a8428bdb3f(...t) {
    return $70fd6868680e912c$export$fd1782fd870d1e06._create("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $70fd6868680e912c$var$Ul(t, e, n, s) {
    if (n[0] = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $70fd6868680e912c$var$pl) return function(t, e, n, s, i) {
        if (!s) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const r = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of $70fd6868680e912c$var$Hn(t))if (n.field.isKeyField()) r.push($70fd6868680e912c$var$We(e, s.key));
        else {
            const t = s.data.field(n.field);
            if ($70fd6868680e912c$var$Ne(t)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            r.push(t);
        }
        return new $70fd6868680e912c$var$hn(r, i);
    }(t._query, t.firestore._databaseId, e, n[0]._document, s);
    {
        const i = $70fd6868680e912c$var$Zh(t.firestore);
        return function(t, e, n, s, i, r) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (i.length > o.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Too many arguments provided to ${s}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const u = [];
            for(let r = 0; r < i.length; r++){
                const c = i[r];
                if (o[r].field.isKeyField()) {
                    if ("string" != typeof c) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${s}(), but got a ${typeof c}`);
                    if (!$70fd6868680e912c$var$Wn(t) && -1 !== c.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${s}() must be a plain document ID, but '${c}' contains a slash.`);
                    const n = t.path.child($70fd6868680e912c$var$ut.fromString(c));
                    if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(n)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${s}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const i = new $70fd6868680e912c$export$afc2e57c475b7810(n);
                    u.push($70fd6868680e912c$var$We(e, i));
                } else {
                    const t = $70fd6868680e912c$var$al(n, s, c);
                    u.push(t);
                }
            }
            return new $70fd6868680e912c$var$hn(u, r);
        }(t._query, t.firestore._databaseId, i, e, n, s);
    }
}
function $70fd6868680e912c$var$Kl(t, e, n) {
    if ("string" == typeof (n = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$70fd6868680e912c$var$Wn(e) && -1 !== n.indexOf("/")) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const s = e.path.child($70fd6868680e912c$var$ut.fromString(n));
        if (!$70fd6868680e912c$export$afc2e57c475b7810.isDocumentKey(s)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${s}' is not because it has an odd number of segments (${s.length}).`);
        return $70fd6868680e912c$var$We(t, new $70fd6868680e912c$export$afc2e57c475b7810(s));
    }
    if (n instanceof $70fd6868680e912c$export$6be62b059fb12175) return $70fd6868680e912c$var$We(t, n._key);
    throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${$70fd6868680e912c$var$oh(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $70fd6868680e912c$var$Gl(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $70fd6868680e912c$var$Ql(t, e) {
    if (e.isInequality()) {
        const n = $70fd6868680e912c$var$zn(t), s = e.field;
        if (null !== n && !n.isEqual(s)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. All where filters with an inequality (<, <=, !=, not-in, >, or >=) must be on the same field. But you have inequality filters on '${n.toString()}' and '${s.toString()}'`);
        const i = $70fd6868680e912c$var$jn(t);
        null !== i && $70fd6868680e912c$var$jl(t, s, i);
    }
    const n = function(t, e) {
        for (const n of t)for (const t of n.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === e.op ? new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $70fd6868680e912c$var$jl(t, e, n) {
    if (!n.isEqual(e)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Invalid query. You have a where filter with an inequality (<, <=, !=, not-in, >, or >=) on field '${e.toString()}' and so you must also use '${e.toString()}' as your first argument to orderBy(), but your first orderBy() is on field '${n.toString()}' instead.`);
}
function $70fd6868680e912c$var$zl(t, e) {
    if (!(e instanceof $70fd6868680e912c$export$f765fc5789dfd439 || e instanceof $70fd6868680e912c$export$6bbc7aef0717f3d2)) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
class $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    convertValue(t, e = "none") {
        switch($70fd6868680e912c$var$Le(t)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return t.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $70fd6868680e912c$var$Ce(t.integerValue || t.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(t.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(t, e);
            case 5 /* TypeOrder.StringValue */ :
                return t.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($70fd6868680e912c$var$xe(t.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(t.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(t.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(t.arrayValue, e);
            case 10 /* TypeOrder.ObjectValue */ :
                return this.convertObject(t.mapValue, e);
            default:
                throw $70fd6868680e912c$var$O();
        }
    }
    convertObject(t, e) {
        return this.convertObjectMap(t.fields, e);
    }
    /**
     * @internal
     */ convertObjectMap(t, e = "none") {
        const n = {};
        return $70fd6868680e912c$var$ge(t, (t, s)=>{
            n[t] = this.convertValue(s, e);
        }), n;
    }
    convertGeoPoint(t) {
        return new $70fd6868680e912c$export$f9f719d1b6419c4($70fd6868680e912c$var$Ce(t.latitude), $70fd6868680e912c$var$Ce(t.longitude));
    }
    convertArray(t, e) {
        return (t.values || []).map((t)=>this.convertValue(t, e));
    }
    convertServerTimestamp(t, e) {
        switch(e){
            case "previous":
                const n = $70fd6868680e912c$var$ke(t);
                return null == n ? null : this.convertValue(n, e);
            case "estimate":
                return this.convertTimestamp($70fd6868680e912c$var$Me(t));
            default:
                return null;
        }
    }
    convertTimestamp(t) {
        const e = $70fd6868680e912c$var$De(t);
        return new $70fd6868680e912c$export$d9bcbd5e1ff81430(e.seconds, e.nanos);
    }
    convertDocumentKey(t, e) {
        const n = $70fd6868680e912c$var$ut.fromString(t);
        $70fd6868680e912c$var$F($70fd6868680e912c$var$ur(n));
        const s = new $70fd6868680e912c$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $70fd6868680e912c$export$afc2e57c475b7810(n.popFirst(5));
        return s.isEqual(e) || // TODO(b/64130202): Somehow support foreign references.
        $70fd6868680e912c$var$k(`Document ${i} contains a document reference within a different database (${s.projectId}/${s.database}) which is not supported. It will be treated as a reference in the current database (${e.projectId}/${e.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $70fd6868680e912c$var$Hl(t, e, n) {
    let s;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return s = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, s;
}
class $70fd6868680e912c$var$Jl extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$8a63f25cc62965f1(t) {
    return new $70fd6868680e912c$export$fada2345be8928cf("sum", $70fd6868680e912c$var$wl("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$cc6710ee5f037d57(t) {
    return new $70fd6868680e912c$export$fada2345be8928cf("avg", $70fd6868680e912c$var$wl("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$85b9a36db797e02b() {
    return new $70fd6868680e912c$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$31fa8ec66e0239ad(t, e) {
    var n, s;
    return t instanceof $70fd6868680e912c$export$fada2345be8928cf && e instanceof $70fd6868680e912c$export$fada2345be8928cf && t._aggregateType === e._aggregateType && (null === (n = t._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (s = e._internalFieldPath) || void 0 === s ? void 0 : s.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $70fd6868680e912c$export$104f59389a332076(t, e) {
    return $70fd6868680e912c$export$49b1d0de6ba30f41(t.query, e.query) && (0, $c38e0f42709c826a$export$9cb4719e2e525b7a)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $70fd6868680e912c$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $70fd6868680e912c$export$acab0e6ef25eb301 extends $70fd6868680e912c$var$pl {
    /** @hideconstructor protected */ constructor(t, e, n, s, i, r){
        super(t, e, n, s, r), this._firestore = t, this._firestoreImpl = t, this.metadata = i;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field($70fd6868680e912c$var$Tl("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $70fd6868680e912c$export$6d4d04e42af6b03c extends $70fd6868680e912c$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $70fd6868680e912c$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e, n, s){
        this._firestore = t, this._userDataWriter = e, this._snapshot = s, this.metadata = new $70fd6868680e912c$export$99d61448206ab5cd(s.hasPendingWrites, s.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $70fd6868680e912c$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $70fd6868680e912c$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>{
                    const s = new $70fd6868680e912c$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $70fd6868680e912c$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: s,
                        oldIndex: -1,
                        newIndex: e++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* ChangeType.Metadata */  !== t.type).map((e)=>{
                    const s = new $70fd6868680e912c$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $70fd6868680e912c$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let i = -1, r = -1;
                    return 0 /* ChangeType.Added */  !== e.type && (i = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* ChangeType.Removed */  !== e.type && (n = n.add(e.doc), r = n.indexOf(e.doc.key)), {
                        type: $70fd6868680e912c$var$uf(e.type),
                        doc: s,
                        oldIndex: i,
                        newIndex: r
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
}
function $70fd6868680e912c$var$uf(t) {
    switch(t){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $70fd6868680e912c$var$O();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $70fd6868680e912c$export$f243a5d948512846(t, e) {
    return t instanceof $70fd6868680e912c$export$acab0e6ef25eb301 && e instanceof $70fd6868680e912c$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $70fd6868680e912c$export$8f21149d8133945c && e instanceof $70fd6868680e912c$export$8f21149d8133945c && t._firestore === e._firestore && $70fd6868680e912c$export$49b1d0de6ba30f41(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$11eb3b5ef9574821(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$za($70fd6868680e912c$export$8da5fbea04405656(e), t._key).then((n)=>$70fd6868680e912c$var$Af(e, t, n));
}
class $70fd6868680e912c$var$hf extends $70fd6868680e912c$export$2cd31cfe6f6866e9 {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new $70fd6868680e912c$export$9f55f2e2bf8c2fc1(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new $70fd6868680e912c$export$6be62b059fb12175(this.firestore, /* converter= */ null, e);
    }
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$a58bd92642f7fb58(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$hf(e);
    return $70fd6868680e912c$var$ja(n, t._key).then((n)=>new $70fd6868680e912c$export$acab0e6ef25eb301(e, s, t._key, n, new $70fd6868680e912c$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $70fd6868680e912c$export$35dd759aed9686b4(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82);
    return $70fd6868680e912c$var$za($70fd6868680e912c$export$8da5fbea04405656(e), t._key, {
        source: "server"
    }).then((n)=>$70fd6868680e912c$var$Af(e, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$81d3477bd73c86ef(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$hf(e);
    return $70fd6868680e912c$var$El(t._query), $70fd6868680e912c$var$Ha(n, t._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$3fd010f18eac1dd(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$hf(e);
    return $70fd6868680e912c$var$Wa(n, t._query).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $70fd6868680e912c$export$ec7d9e44f349c77b(t) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
    const e = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), n = $70fd6868680e912c$export$8da5fbea04405656(e), s = new $70fd6868680e912c$var$hf(e);
    return $70fd6868680e912c$var$Ha(n, t._query, {
        source: "server"
    }).then((n)=>new $70fd6868680e912c$export$8f21149d8133945c(e, s, t, n));
}
function $70fd6868680e912c$export$5ff77ddaff3c9e12(t, e, n) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const s = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), i = $70fd6868680e912c$var$Hl(t.converter, e, n);
    return $70fd6868680e912c$export$1945f8fec9dda613(s, [
        $70fd6868680e912c$var$tl($70fd6868680e912c$var$Zh(s), "setDoc", t._key, i, null !== t.converter, n).toMutation(t._key, $70fd6868680e912c$var$Fs.none())
    ]);
}
function $70fd6868680e912c$export$22d1fdd1e73faff2(t, e, n, ...s) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$6be62b059fb12175);
    const i = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), r = $70fd6868680e912c$var$Zh(i);
    let o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$cl(r, "updateDoc", t._key, e, n, s) : $70fd6868680e912c$var$ul(r, "updateDoc", t._key, e);
    return $70fd6868680e912c$export$1945f8fec9dda613(i, [
        o.toMutation(t._key, $70fd6868680e912c$var$Fs.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a4f20481fae8f78b(t) {
    return $70fd6868680e912c$export$1945f8fec9dda613($70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), [
        new $70fd6868680e912c$var$Ys(t._key, $70fd6868680e912c$var$Fs.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $70fd6868680e912c$export$a13890143fb1c2dd(t, e) {
    const n = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), s = $70fd6868680e912c$export$2a111da947c407d2(t), i = $70fd6868680e912c$var$Hl(t.converter, e);
    return $70fd6868680e912c$export$1945f8fec9dda613(n, [
        $70fd6868680e912c$var$tl($70fd6868680e912c$var$Zh(t.firestore), "addDoc", s._key, i, null !== t.converter, {}).toMutation(s._key, $70fd6868680e912c$var$Fs.exists(!1))
    ]).then(()=>s);
}
function $70fd6868680e912c$export$d36370812fb26935(t, ...e) {
    var n, s, i;
    t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t);
    let r = {
        includeMetadataChanges: !1
    }, o = 0;
    "object" != typeof e[o] || $70fd6868680e912c$var$Th(e[o]) || (r = e[o], o++);
    const u = {
        includeMetadataChanges: r.includeMetadataChanges
    };
    if ($70fd6868680e912c$var$Th(e[o])) {
        const t = e[o];
        e[o] = null === (n = t.next) || void 0 === n ? void 0 : n.bind(t), e[o + 1] = null === (s = t.error) || void 0 === s ? void 0 : s.bind(t), e[o + 2] = null === (i = t.complete) || void 0 === i ? void 0 : i.bind(t);
    }
    let c, a, h;
    if (t instanceof $70fd6868680e912c$export$6be62b059fb12175) a = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), h = $70fd6868680e912c$var$Gn(t._key.path), c = {
        next: (n)=>{
            e[o] && e[o]($70fd6868680e912c$var$Af(a, t, n));
        },
        error: e[o + 1],
        complete: e[o + 2]
    };
    else {
        const n = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$62297b13309008b2);
        a = $70fd6868680e912c$export$572106fb5803752c(n.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), h = n._query;
        const s = new $70fd6868680e912c$var$hf(a);
        c = {
            next: (t)=>{
                e[o] && e[o](new $70fd6868680e912c$export$8f21149d8133945c(a, s, n, t));
            },
            error: e[o + 1],
            complete: e[o + 2]
        }, $70fd6868680e912c$var$El(t._query);
    }
    return function(t, e, n, s) {
        const i = new $70fd6868680e912c$var$Va(s), r = new $70fd6868680e912c$var$Nc(e, i, n);
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$Vc(await $70fd6868680e912c$var$Ka(t), r)), ()=>{
            i.Dc(), t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$Sc(await $70fd6868680e912c$var$Ka(t), r));
        };
    }($70fd6868680e912c$export$8da5fbea04405656(a), h, u, c);
}
function $70fd6868680e912c$export$9dff4f5aba83e348(t, e) {
    return $70fd6868680e912c$var$Ja($70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), $70fd6868680e912c$var$Th(e) ? e : {
        next: e
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $70fd6868680e912c$export$1945f8fec9dda613(t, e) {
    return function(t, e) {
        const n = new $70fd6868680e912c$var$K;
        return t.asyncQueue.enqueueAndForget(async ()=>$70fd6868680e912c$var$zc(await $70fd6868680e912c$var$qa(t), e, n)), n.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(t), e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $70fd6868680e912c$var$Af(t, e, n) {
    const s = n.docs.get(e._key), i = new $70fd6868680e912c$var$hf(t);
    return new $70fd6868680e912c$export$acab0e6ef25eb301(t, i, e._key, s, new $70fd6868680e912c$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query,
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can even
 * count the documents if the result set would be prohibitively large to
 * download entirely (e.g. thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used: every request using this source necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size to calculate.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $70fd6868680e912c$export$b1de1b12889d0afb(t) {
    return $70fd6868680e912c$export$a51511de2fae49b3(t, {
        count: $70fd6868680e912c$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query, without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, is downloaded. This
 * function can even perform aggregations of the documents if the result set
 * would be prohibitively large to download entirely (e.g. thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used: every request using this source necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set to aggregate over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 * @internal TODO (sum/avg) remove when public
 */ function $70fd6868680e912c$export$a51511de2fae49b3(t, e) {
    const n = $70fd6868680e912c$export$572106fb5803752c(t.firestore, $70fd6868680e912c$export$d0e2b3272814ce82), s = $70fd6868680e912c$export$8da5fbea04405656(n), i = function(t, e) {
        const n = [];
        for(const s in t)Object.prototype.hasOwnProperty.call(t, s) && n.push(e(t[s], s, t));
        return n;
    }(e, (t, e)=>new $70fd6868680e912c$var$ni(e, t._aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return (function(t, e, n) {
        const s = new $70fd6868680e912c$var$K;
        return t.asyncQueue.enqueueAndForget(async ()=>{
            // TODO (sum/avg) should we update this to use the event manager?
            // Implement and call executeAggregateQueryViaSnapshotListener, similar
            // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
            // above
            try {
                // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
                const i = await $70fd6868680e912c$var$Ua(t);
                s.resolve($70fd6868680e912c$var$Gu(i, e, n));
            } catch (t) {
                s.reject(t);
            }
        }), s.promise;
    })(s, t._query, i).then((e)=>/**
 * Converts the core aggregration result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ (function(t, e, n) {
            const s = new $70fd6868680e912c$var$hf(t);
            return new $70fd6868680e912c$export$40257fef64be808b(e, s, n);
        })(n, t, e));
}
class $70fd6868680e912c$var$Pf {
    constructor(t){
        this.kind = "memory", this._onlineComponentProvider = new $70fd6868680e912c$var$Pa, (null == t ? void 0 : t.garbageCollector) ? this._offlineComponentProvider = t.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = new $70fd6868680e912c$var$Ea;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$bf {
    constructor(t){
        let e;
        this.kind = "persistent", (null == t ? void 0 : t.tabManager) ? (t.tabManager._initialize(t), e = t.tabManager) : (e = $70fd6868680e912c$export$d5f96a3c009e86ac(void 0), e._initialize(t)), this._onlineComponentProvider = e._onlineComponentProvider, this._offlineComponentProvider = e._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$Vf {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = new $70fd6868680e912c$var$Ea;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $70fd6868680e912c$var$Sf {
    constructor(t){
        this.kind = "memoryLru", this._offlineComponentProvider = new $70fd6868680e912c$var$Aa(t);
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $70fd6868680e912c$export$574728f3be606189() {
    return new $70fd6868680e912c$var$Vf;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $70fd6868680e912c$export$2340f88905cc0c23(t) {
    return new $70fd6868680e912c$var$Sf(null == t ? void 0 : t.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $70fd6868680e912c$export$72ef71adb739a32c(t) {
    return new $70fd6868680e912c$var$Pf(t);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $70fd6868680e912c$export$51b321e43d5331d5(t) {
    return new $70fd6868680e912c$var$bf(t);
}
class $70fd6868680e912c$var$kf {
    constructor(t){
        this.forceOwnership = t, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = new $70fd6868680e912c$var$Pa, this._offlineComponentProvider = new $70fd6868680e912c$var$va(this._onlineComponentProvider, null == t ? void 0 : t.cacheSizeBytes, this.forceOwnership);
    }
}
class $70fd6868680e912c$var$Mf {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = new $70fd6868680e912c$var$Pa, this._offlineComponentProvider = new $70fd6868680e912c$var$Ra(this._onlineComponentProvider, null == t ? void 0 : t.cacheSizeBytes);
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $70fd6868680e912c$export$d5f96a3c009e86ac(t) {
    return new $70fd6868680e912c$var$kf(null == t ? void 0 : t.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $70fd6868680e912c$export$57e9d290b0b4dc04() {
    return new $70fd6868680e912c$var$Mf;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $70fd6868680e912c$var$Ff = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $70fd6868680e912c$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = $70fd6868680e912c$var$Zh(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const s = $70fd6868680e912c$var$Lf(t, this._firestore), i = $70fd6868680e912c$var$Hl(s.converter, e, n), r = $70fd6868680e912c$var$tl(this._dataReader, "WriteBatch.set", s._key, i, null !== s.converter, n);
        return this._mutations.push(r.toMutation(s._key, $70fd6868680e912c$var$Fs.none())), this;
    }
    update(t, e, n, ...s) {
        this._verifyNotCommitted();
        const i = $70fd6868680e912c$var$Lf(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let r;
        return r = "string" == typeof (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$cl(this._dataReader, "WriteBatch.update", i._key, e, n, s) : $70fd6868680e912c$var$ul(this._dataReader, "WriteBatch.update", i._key, e), this._mutations.push(r.toMutation(i._key, $70fd6868680e912c$var$Fs.exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $70fd6868680e912c$var$Lf(t, this._firestore);
        return this._mutations = this._mutations.concat(new $70fd6868680e912c$var$Ys(e._key, $70fd6868680e912c$var$Fs.none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $70fd6868680e912c$var$Lf(t, e) {
    if ((t = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(t)).firestore !== e) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $70fd6868680e912c$export$febc5573c75cefb0 extends class {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = $70fd6868680e912c$var$Zh(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $70fd6868680e912c$var$Lf(t, this._firestore), n = new $70fd6868680e912c$var$Jl(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return $70fd6868680e912c$var$O();
            const s = t[0];
            if (s.isFoundDocument()) return new $70fd6868680e912c$var$pl(this._firestore, n, s.key, s, e.converter);
            if (s.isNoDocument()) return new $70fd6868680e912c$var$pl(this._firestore, n, e._key, null, e.converter);
            throw $70fd6868680e912c$var$O();
        });
    }
    set(t, e, n) {
        const s = $70fd6868680e912c$var$Lf(t, this._firestore), i = $70fd6868680e912c$var$Hl(s.converter, e, n), r = $70fd6868680e912c$var$tl(this._dataReader, "Transaction.set", s._key, i, null !== s.converter, n);
        return this._transaction.set(s._key, r), this;
    }
    update(t, e, n, ...s) {
        const i = $70fd6868680e912c$var$Lf(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let r;
        return r = "string" == typeof (e = (0, $c38e0f42709c826a$export$4befe9b5fa509a1b)(e)) || e instanceof $70fd6868680e912c$export$a1a8fea822d17659 ? $70fd6868680e912c$var$cl(this._dataReader, "Transaction.update", i._key, e, n, s) : $70fd6868680e912c$var$ul(this._dataReader, "Transaction.update", i._key, e), this._transaction.update(i._key, r), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $70fd6868680e912c$var$Lf(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
} {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $70fd6868680e912c$var$Lf(t, this._firestore), n = new $70fd6868680e912c$var$hf(this._firestore);
        return super.get(t).then((t)=>new $70fd6868680e912c$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $70fd6868680e912c$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $70fd6868680e912c$export$3c54e006bf9c93b7(t, e, n) {
    t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82);
    const s = Object.assign(Object.assign({}, $70fd6868680e912c$var$Ff), n);
    !function(t) {
        if (t.maxAttempts < 1) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(s);
    return function(t, e, n) {
        const s = new $70fd6868680e912c$var$K;
        return t.asyncQueue.enqueueAndForget(async ()=>{
            const i = await $70fd6868680e912c$var$Ua(t);
            new $70fd6868680e912c$var$Ca(t.asyncQueue, i, n, e, s).run();
        }), s.promise;
    }($70fd6868680e912c$export$8da5fbea04405656(t), (n)=>e(new $70fd6868680e912c$export$febc5573c75cefb0(t, n)), s);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $70fd6868680e912c$export$2bbad96c62fdba3e() {
    return new $70fd6868680e912c$var$el("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $70fd6868680e912c$export$3ff8e7e00c3264b7() {
    return new $70fd6868680e912c$var$sl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $70fd6868680e912c$export$f62af892fd92610c(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$il("arrayUnion", t);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$30a014203d0d7e4f(...t) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $70fd6868680e912c$var$rl("arrayRemove", t);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $70fd6868680e912c$export$a2647aa13413c947(t) {
    return new $70fd6868680e912c$var$ol("increment", t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $70fd6868680e912c$export$44cd1c9d57edd9b1(t) {
    return $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82)), new $70fd6868680e912c$export$d94ed661b1cfd435(t, (e)=>$70fd6868680e912c$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $70fd6868680e912c$export$ff1663c0c1304f1a(t, e) {
    var n;
    const s = $70fd6868680e912c$export$8da5fbea04405656(t = $70fd6868680e912c$export$572106fb5803752c(t, $70fd6868680e912c$export$d0e2b3272814ce82));
    if (!s._uninitializedComponentsProvider || "memory" === (null === (n = s._uninitializedComponentsProvider) || void 0 === n ? void 0 : n._offlineKind)) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $70fd6868680e912c$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const i = function(t) {
        const e = "string" == typeof t ? function(t) {
            try {
                return JSON.parse(t);
            } catch (t) {
                throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == t ? void 0 : t.message));
            }
        }(t) : t, n = [];
        if (Array.isArray(e.indexes)) for (const t of e.indexes){
            const e = $70fd6868680e912c$var$Jf(t, "collectionGroup"), s = [];
            if (Array.isArray(t.fields)) for (const e of t.fields){
                const t = $70fd6868680e912c$var$ml("setIndexConfiguration", $70fd6868680e912c$var$Jf(e, "fieldPath"));
                "CONTAINS" === e.arrayConfig ? s.push(new $70fd6868680e912c$var$_t(t, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === e.order ? s.push(new $70fd6868680e912c$var$_t(t, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === e.order && s.push(new $70fd6868680e912c$var$_t(t, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new $70fd6868680e912c$var$lt($70fd6868680e912c$var$lt.UNKNOWN_ID, e, s, $70fd6868680e912c$var$gt.empty()));
        }
        return n;
    }(e);
    return $70fd6868680e912c$var$Za(s, i);
}
function $70fd6868680e912c$var$Jf(t, e) {
    if ("string" != typeof t[e]) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function(t, e = !0) {
    !function(t) {
        $70fd6868680e912c$var$S = t;
    }((0, $57d436074e210fb5$export$31499a9cd224b78c)), (0, $57d436074e210fb5$export$c930050e7bb63965)(new (0, $a83e7ccd68ca8d4e$export$16fa2f45be04daa8)("firestore", (t, { instanceIdentifier: n, options: s })=>{
        const i = t.getProvider("app").getImmediate(), r = new $70fd6868680e912c$export$d0e2b3272814ce82(new $70fd6868680e912c$var$z(t.getProvider("auth-internal")), new $70fd6868680e912c$var$Y(t.getProvider("app-check-internal")), function(t, e) {
            if (!Object.prototype.hasOwnProperty.apply(t.options, [
                "projectId"
            ])) throw new $70fd6868680e912c$export$8fada0bf726bf278($70fd6868680e912c$var$q.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $70fd6868680e912c$export$4c3ccc07620ae30a(t.options.projectId, e);
        }(i, n), i);
        return s = Object.assign({
            useFetchStreams: e
        }, s), r._setSettings(s), r;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $57d436074e210fb5$export$d29d5299a7137abc)($70fd6868680e912c$var$b, "3.13.0", t), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $57d436074e210fb5$export$d29d5299a7137abc)($70fd6868680e912c$var$b, "3.13.0", "esm2017");
}();




// import { getAnalytics } from "firebase/analytics"
// https://firebase.google.com/docs/web/setup#available-libraries
const $607f619b4631e0ae$var$firebaseConfig = {
    apiKey: "AIzaSyDhfTomFg03nXW2cD1RIysGXydVHHUNC0c",
    authDomain: "nisb-website.firebaseapp.com",
    projectId: "nisb-website",
    storageBucket: "nisb-website.appspot.com",
    messagingSenderId: "30096523025",
    appId: "1:30096523025:web:8485960da3344cf73cd6b0",
    measurementId: "G-5RMDTP6Q8R"
};
// Initialize Firebase
const $607f619b4631e0ae$var$app = (0, $57d436074e210fb5$export$c55cfd413944906d)($607f619b4631e0ae$var$firebaseConfig) // eslint-disable-line no-unused-vars
;
const $607f619b4631e0ae$var$db = (0, $70fd6868680e912c$export$f06a05d14c3a6678)();
var $607f619b4631e0ae$var$location = null;
fetch("https://ipapi.co/json/").then((response)=>response.json()).then((data)=>$607f619b4631e0ae$var$location = data).catch((err)=>console.error(err));
const $607f619b4631e0ae$var$OpenLink = (e)=>{
    (0, $70fd6868680e912c$export$a13890143fb1c2dd)((0, $70fd6868680e912c$export$bf5175b0c24981cd)($607f619b4631e0ae$var$db, "analytics"), {
        name: e.target.getAttribute("data-name"),
        link: e.target.getAttribute("data-url"),
        time: new Date(),
        loc: $607f619b4631e0ae$var$location
    });
    let linkDoc = (0, $70fd6868680e912c$export$2a111da947c407d2)($607f619b4631e0ae$var$db, "social-links", e.target.getAttribute("data-id"));
    (0, $70fd6868680e912c$export$22d1fdd1e73faff2)(linkDoc, {
        count: (0, $70fd6868680e912c$export$a2647aa13413c947)(1)
    });
    window.open(e.target.getAttribute("data-url"), "_blank");
};
var $607f619b4631e0ae$var$elements = document.getElementsByClassName("link");
for(var $607f619b4631e0ae$var$i = 0; $607f619b4631e0ae$var$i < $607f619b4631e0ae$var$elements.length; $607f619b4631e0ae$var$i++)$607f619b4631e0ae$var$elements[$607f619b4631e0ae$var$i].addEventListener("click", $607f619b4631e0ae$var$OpenLink, false);


//# sourceMappingURL=nisb_social.a9675b23.js.map
